export const data_city_geo = [
    {
        "ibgeId": 1100015,
        "nome": "Alta Floresta D'Oeste",
        "latitude": -12.4701,
        "longitude": -62.2747,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100023,
        "nome": "Ariquemes",
        "latitude": -9.9519,
        "longitude": -62.9572,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100031,
        "nome": "Cabixi",
        "latitude": -13.4749,
        "longitude": -60.6398,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100049,
        "nome": "Cacoal",
        "latitude": -11.3013,
        "longitude": -61.3247,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100056,
        "nome": "Cerejeiras",
        "latitude": -13.2036,
        "longitude": -61.261,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100064,
        "nome": "Colorado do Oeste",
        "latitude": -13.1592,
        "longitude": -60.5502,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100072,
        "nome": "Corumbiara",
        "latitude": -12.9266,
        "longitude": -61.0916,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100080,
        "nome": "Costa Marques",
        "latitude": -12.1473,
        "longitude": -64.0588,
        "mesorregiaoNome": "Madeira-Guaporé",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100098,
        "nome": "Espigão D'Oeste",
        "latitude": -11.3513,
        "longitude": -60.7848,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100106,
        "nome": "Guajará-Mirim",
        "latitude": -11.3056,
        "longitude": -64.5376,
        "mesorregiaoNome": "Madeira-Guaporé",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100114,
        "nome": "Jaru",
        "latitude": -10.5924,
        "longitude": -62.5849,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100122,
        "nome": "Ji-Paraná",
        "latitude": -10.4622,
        "longitude": -61.7573,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100130,
        "nome": "Machadinho D'Oeste",
        "latitude": -9.2041,
        "longitude": -62.0104,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100148,
        "nome": "Nova Brasilândia D'Oeste",
        "latitude": -11.6431,
        "longitude": -62.2802,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100155,
        "nome": "Ouro Preto do Oeste",
        "latitude": -10.6106,
        "longitude": -62.1725,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100189,
        "nome": "Pimenta Bueno",
        "latitude": -11.8945,
        "longitude": -60.8304,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100205,
        "nome": "Porto Velho",
        "latitude": -9.1536,
        "longitude": -64.3068,
        "mesorregiaoNome": "Madeira-Guaporé",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100254,
        "nome": "Presidente Médici",
        "latitude": -11.1663,
        "longitude": -61.878,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100262,
        "nome": "Rio Crespo",
        "latitude": -9.6452,
        "longitude": -62.7901,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100288,
        "nome": "Rolim de Moura",
        "latitude": -11.7326,
        "longitude": -61.7716,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100296,
        "nome": "Santa Luzia D'Oeste",
        "latitude": -12.027,
        "longitude": -61.7011,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100304,
        "nome": "Vilhena",
        "latitude": -12.096,
        "longitude": -60.2486,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100320,
        "nome": "São Miguel do Guaporé",
        "latitude": -11.6122,
        "longitude": -62.9877,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100338,
        "nome": "Nova Mamoré",
        "latitude": -10.3822,
        "longitude": -64.6291,
        "mesorregiaoNome": "Madeira-Guaporé",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100346,
        "nome": "Alvorada D'Oeste",
        "latitude": -11.3114,
        "longitude": -62.545,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100379,
        "nome": "Alto Alegre dos Parecis",
        "latitude": -12.5937,
        "longitude": -61.8808,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100403,
        "nome": "Alto Paraíso",
        "latitude": -9.6493,
        "longitude": -63.3943,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100452,
        "nome": "Buritis",
        "latitude": -10.0521,
        "longitude": -63.9412,
        "mesorregiaoNome": "Madeira-Guaporé",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100502,
        "nome": "Novo Horizonte do Oeste",
        "latitude": -11.6811,
        "longitude": -62.0832,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100601,
        "nome": "Cacaulândia",
        "latitude": -10.3316,
        "longitude": -62.9872,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100700,
        "nome": "Campo Novo de Rondônia",
        "latitude": -10.4849,
        "longitude": -63.7997,
        "mesorregiaoNome": "Madeira-Guaporé",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100809,
        "nome": "Candeias do Jamari",
        "latitude": -8.887,
        "longitude": -63.3256,
        "mesorregiaoNome": "Madeira-Guaporé",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100908,
        "nome": "Castanheiras",
        "latitude": -11.4708,
        "longitude": -61.8801,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100924,
        "nome": "Chupinguaia",
        "latitude": -12.5372,
        "longitude": -60.8991,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1100940,
        "nome": "Cujubim",
        "latitude": -9.1711,
        "longitude": -62.5653,
        "mesorregiaoNome": "Madeira-Guaporé",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101005,
        "nome": "Governador Jorge Teixeira",
        "latitude": -10.748,
        "longitude": -63.184,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101104,
        "nome": "Itapuã do Oeste",
        "latitude": -9.1702,
        "longitude": -63.0449,
        "mesorregiaoNome": "Madeira-Guaporé",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101203,
        "nome": "Ministro Andreazza",
        "latitude": -11.1603,
        "longitude": -61.569,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101302,
        "nome": "Mirante da Serra",
        "latitude": -11.0768,
        "longitude": -62.848,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101401,
        "nome": "Monte Negro",
        "latitude": -10.2108,
        "longitude": -63.3724,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101435,
        "nome": "Nova União",
        "latitude": -10.8893,
        "longitude": -62.5324,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101450,
        "nome": "Parecis",
        "latitude": -12.2623,
        "longitude": -61.4154,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101468,
        "nome": "Pimenteiras do Oeste",
        "latitude": -13.1739,
        "longitude": -61.5453,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101476,
        "nome": "Primavera de Rondônia",
        "latitude": -11.8787,
        "longitude": -61.3153,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101484,
        "nome": "São Felipe D'Oeste",
        "latitude": -11.905,
        "longitude": -61.4671,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101492,
        "nome": "São Francisco do Guaporé",
        "latitude": -12.3684,
        "longitude": -63.1221,
        "mesorregiaoNome": "Madeira-Guaporé",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101500,
        "nome": "Seringueiras",
        "latitude": -11.7825,
        "longitude": -63.1865,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101559,
        "nome": "Teixeirópolis",
        "latitude": -10.9435,
        "longitude": -62.2798,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101609,
        "nome": "Theobroma",
        "latitude": -10.1218,
        "longitude": -62.3425,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101708,
        "nome": "Urupá",
        "latitude": -11.104,
        "longitude": -62.4244,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101757,
        "nome": "Vale do Anari",
        "latitude": -9.7324,
        "longitude": -61.9391,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1101807,
        "nome": "Vale do Paraíso",
        "latitude": -10.3843,
        "longitude": -62.094,
        "mesorregiaoNome": "Leste Rondoniense",
        "UFSigla": "RO",
        "UFNome": "Rondônia"
    },
    {
        "ibgeId": 1200013,
        "nome": "Acrelândia",
        "latitude": -9.9339,
        "longitude": -66.9502,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200054,
        "nome": "Assis Brasil",
        "latitude": -10.7797,
        "longitude": -70.0038,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200104,
        "nome": "Brasiléia",
        "latitude": -10.7474,
        "longitude": -69.2075,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200138,
        "nome": "Bujari",
        "latitude": -9.6141,
        "longitude": -68.1737,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200179,
        "nome": "Capixaba",
        "latitude": -10.4743,
        "longitude": -67.8359,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200203,
        "nome": "Cruzeiro do Sul",
        "latitude": -7.9722,
        "longitude": -72.7557,
        "mesorregiaoNome": "Vale do Juruá",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200252,
        "nome": "Epitaciolândia",
        "latitude": -10.8892,
        "longitude": -68.6182,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200302,
        "nome": "Feijó",
        "latitude": -8.9234,
        "longitude": -70.744,
        "mesorregiaoNome": "Vale do Juruá",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200328,
        "nome": "Jordão",
        "latitude": -9.2417,
        "longitude": -71.9055,
        "mesorregiaoNome": "Vale do Juruá",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200336,
        "nome": "Mâncio Lima",
        "latitude": -7.5048,
        "longitude": -73.4358,
        "mesorregiaoNome": "Vale do Juruá",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200344,
        "nome": "Manoel Urbano",
        "latitude": -9.3769,
        "longitude": -69.85,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200351,
        "nome": "Marechal Thaumaturgo",
        "latitude": -9.0961,
        "longitude": -72.5588,
        "mesorregiaoNome": "Vale do Juruá",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200385,
        "nome": "Plácido de Castro",
        "latitude": -10.2491,
        "longitude": -67.3403,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200393,
        "nome": "Porto Walter",
        "latitude": -8.4921,
        "longitude": -72.7341,
        "mesorregiaoNome": "Vale do Juruá",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200401,
        "nome": "Rio Branco",
        "latitude": -10.0661,
        "longitude": -68.3711,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200427,
        "nome": "Rodrigues Alves",
        "latitude": -7.844,
        "longitude": -73.2243,
        "mesorregiaoNome": "Vale do Juruá",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200435,
        "nome": "Santa Rosa do Purus",
        "latitude": -9.4121,
        "longitude": -70.3974,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200450,
        "nome": "Senador Guiomard",
        "latitude": -9.9973,
        "longitude": -67.4277,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200500,
        "nome": "Sena Madureira",
        "latitude": -9.7705,
        "longitude": -69.3803,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200609,
        "nome": "Tarauacá",
        "latitude": -8.2395,
        "longitude": -71.445,
        "mesorregiaoNome": "Vale do Juruá",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200708,
        "nome": "Xapuri",
        "latitude": -10.5756,
        "longitude": -68.5047,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1200807,
        "nome": "Porto Acre",
        "latitude": -9.6295,
        "longitude": -67.6984,
        "mesorregiaoNome": "Vale do Acre",
        "UFSigla": "AC",
        "UFNome": "Acre"
    },
    {
        "ibgeId": 1300029,
        "nome": "Alvarães",
        "latitude": -3.6947,
        "longitude": -65.3245,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300060,
        "nome": "Amaturá",
        "latitude": -3.4184,
        "longitude": -68.2865,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300086,
        "nome": "Anamã",
        "latitude": -3.5019,
        "longitude": -61.718,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300102,
        "nome": "Anori",
        "latitude": -4.1987,
        "longitude": -62.0954,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300144,
        "nome": "Apuí",
        "latitude": -7.76,
        "longitude": -59.4321,
        "mesorregiaoNome": "Sul Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300201,
        "nome": "Atalaia do Norte",
        "latitude": -5.7112,
        "longitude": -71.7412,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300300,
        "nome": "Autazes",
        "latitude": -3.7872,
        "longitude": -59.5255,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300409,
        "nome": "Barcelos",
        "latitude": -0.4654,
        "longitude": -63.4346,
        "mesorregiaoNome": "Norte Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300508,
        "nome": "Barreirinha",
        "latitude": -3.129,
        "longitude": -57.1724,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300607,
        "nome": "Benjamin Constant",
        "latitude": -5.427,
        "longitude": -70.2764,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300631,
        "nome": "Beruri",
        "latitude": -4.6062,
        "longitude": -61.8044,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300680,
        "nome": "Boa Vista do Ramos",
        "latitude": -3.1378,
        "longitude": -57.6701,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300706,
        "nome": "Boca do Acre",
        "latitude": -8.7732,
        "longitude": -68.0476,
        "mesorregiaoNome": "Sul Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300805,
        "nome": "Borba",
        "latitude": -4.9576,
        "longitude": -59.5347,
        "mesorregiaoNome": "Sul Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300839,
        "nome": "Caapiranga",
        "latitude": -3.082,
        "longitude": -61.8778,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1300904,
        "nome": "Canutama",
        "latitude": -7.3008,
        "longitude": -64.0619,
        "mesorregiaoNome": "Sul Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301001,
        "nome": "Carauari",
        "latitude": -5.1185,
        "longitude": -67.3375,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301100,
        "nome": "Careiro",
        "latitude": -3.7705,
        "longitude": -60.1833,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301159,
        "nome": "Careiro da Várzea",
        "latitude": -3.286,
        "longitude": -59.5987,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301209,
        "nome": "Coari",
        "latitude": -4.4364,
        "longitude": -64.1253,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301308,
        "nome": "Codajás",
        "latitude": -3.289,
        "longitude": -62.9733,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301407,
        "nome": "Eirunepé",
        "latitude": -7.022,
        "longitude": -70.2182,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301506,
        "nome": "Envira",
        "latitude": -7.5733,
        "longitude": -70.0551,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301605,
        "nome": "Fonte Boa",
        "latitude": -2.491,
        "longitude": -66.3576,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301654,
        "nome": "Guajará",
        "latitude": -7.2298,
        "longitude": -72.8446,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301704,
        "nome": "Humaitá",
        "latitude": -7.3612,
        "longitude": -62.4864,
        "mesorregiaoNome": "Sul Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301803,
        "nome": "Ipixuna",
        "latitude": -7.1805,
        "longitude": -71.4129,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301852,
        "nome": "Iranduba",
        "latitude": -3.0952,
        "longitude": -60.4797,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301902,
        "nome": "Itacoatiara",
        "latitude": -3.1741,
        "longitude": -58.7753,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1301951,
        "nome": "Itamarati",
        "latitude": -6.6828,
        "longitude": -68.1128,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1302009,
        "nome": "Itapiranga",
        "latitude": -2.4972,
        "longitude": -58.6133,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1302108,
        "nome": "Japurá",
        "latitude": -1.6982,
        "longitude": -68.3197,
        "mesorregiaoNome": "Norte Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1302207,
        "nome": "Juruá",
        "latitude": -3.5246,
        "longitude": -66.3079,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1302306,
        "nome": "Jutaí",
        "latitude": -4.7152,
        "longitude": -68.4063,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1302405,
        "nome": "Lábrea",
        "latitude": -8.3756,
        "longitude": -65.8117,
        "mesorregiaoNome": "Sul Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1302504,
        "nome": "Manacapuru",
        "latitude": -3.2915,
        "longitude": -60.9588,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1302553,
        "nome": "Manaquiri",
        "latitude": -3.7791,
        "longitude": -60.6973,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1302603,
        "nome": "Manaus",
        "latitude": -2.6259,
        "longitude": -60.2596,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1302702,
        "nome": "Manicoré",
        "latitude": -6.46,
        "longitude": -61.4468,
        "mesorregiaoNome": "Sul Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1302801,
        "nome": "Maraã",
        "latitude": -2.4268,
        "longitude": -65.0396,
        "mesorregiaoNome": "Norte Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1302900,
        "nome": "Maués",
        "latitude": -4.9848,
        "longitude": -58.0609,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1303007,
        "nome": "Nhamundá",
        "latitude": -1.6806,
        "longitude": -57.6562,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1303106,
        "nome": "Nova Olinda do Norte",
        "latitude": -3.9895,
        "longitude": -58.5998,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1303205,
        "nome": "Novo Airão",
        "latitude": -2.0482,
        "longitude": -61.7034,
        "mesorregiaoNome": "Norte Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1303304,
        "nome": "Novo Aripuanã",
        "latitude": -6.824,
        "longitude": -60.4772,
        "mesorregiaoNome": "Sul Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1303403,
        "nome": "Parintins",
        "latitude": -2.6881,
        "longitude": -56.8546,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1303502,
        "nome": "Pauini",
        "latitude": -7.7578,
        "longitude": -68.1971,
        "mesorregiaoNome": "Sul Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1303536,
        "nome": "Presidente Figueiredo",
        "latitude": -1.3709,
        "longitude": -59.9896,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1303569,
        "nome": "Rio Preto da Eva",
        "latitude": -2.5298,
        "longitude": -59.6384,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1303601,
        "nome": "Santa Isabel do Rio Negro",
        "latitude": -0.3183,
        "longitude": -65.5215,
        "mesorregiaoNome": "Norte Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1303700,
        "nome": "Santo Antônio do Içá",
        "latitude": -3.0529,
        "longitude": -69.0902,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1303809,
        "nome": "São Gabriel da Cachoeira",
        "latitude": 0.3683,
        "longitude": -67.9994,
        "mesorregiaoNome": "Norte Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1303908,
        "nome": "São Paulo de Olivença",
        "latitude": -4.5014,
        "longitude": -69.4511,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1303957,
        "nome": "São Sebastião do Uatumã",
        "latitude": -1.9418,
        "longitude": -58.7053,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1304005,
        "nome": "Silves",
        "latitude": -2.8205,
        "longitude": -58.5371,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1304062,
        "nome": "Tabatinga",
        "latitude": -4.0282,
        "longitude": -69.6776,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1304104,
        "nome": "Tapauá",
        "latitude": -6.0937,
        "longitude": -64.9558,
        "mesorregiaoNome": "Sul Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1304203,
        "nome": "Tefé",
        "latitude": -4.4701,
        "longitude": -65.5315,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1304237,
        "nome": "Tonantins",
        "latitude": -2.6918,
        "longitude": -67.826,
        "mesorregiaoNome": "Sudoeste Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1304260,
        "nome": "Uarini",
        "latitude": -3.1656,
        "longitude": -65.4108,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1304302,
        "nome": "Urucará",
        "latitude": -0.895,
        "longitude": -59.0289,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1304401,
        "nome": "Urucurituba",
        "latitude": -2.8149,
        "longitude": -57.7734,
        "mesorregiaoNome": "Centro Amazonense",
        "UFSigla": "AM",
        "UFNome": "Amazonas"
    },
    {
        "ibgeId": 1400027,
        "nome": "Amajari",
        "latitude": 3.7324,
        "longitude": -62.4325,
        "mesorregiaoNome": "Norte de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400050,
        "nome": "Alto Alegre",
        "latitude": 3.0716,
        "longitude": -62.7407,
        "mesorregiaoNome": "Norte de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400100,
        "nome": "Boa Vista",
        "latitude": 3.1179,
        "longitude": -60.718,
        "mesorregiaoNome": "Norte de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400159,
        "nome": "Bonfim",
        "latitude": 2.7876,
        "longitude": -60.1006,
        "mesorregiaoNome": "Norte de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400175,
        "nome": "Cantá",
        "latitude": 2.2728,
        "longitude": -60.5423,
        "mesorregiaoNome": "Norte de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400209,
        "nome": "Caracaraí",
        "latitude": 0.9908,
        "longitude": -61.4714,
        "mesorregiaoNome": "Sul de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400233,
        "nome": "Caroebe",
        "latitude": 0.9146,
        "longitude": -59.3382,
        "mesorregiaoNome": "Sul de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400282,
        "nome": "Iracema",
        "latitude": 2.1819,
        "longitude": -62.4023,
        "mesorregiaoNome": "Sul de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400308,
        "nome": "Mucajaí",
        "latitude": 2.511,
        "longitude": -61.9968,
        "mesorregiaoNome": "Sul de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400407,
        "nome": "Normandia",
        "latitude": 3.8789,
        "longitude": -60.0654,
        "mesorregiaoNome": "Norte de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400456,
        "nome": "Pacaraima",
        "latitude": 4.1683,
        "longitude": -60.8391,
        "mesorregiaoNome": "Norte de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400472,
        "nome": "Rorainópolis",
        "latitude": 0.038,
        "longitude": -61.0112,
        "mesorregiaoNome": "Sul de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400506,
        "nome": "São João da Baliza",
        "latitude": 0.6358,
        "longitude": -59.845,
        "mesorregiaoNome": "Sul de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400605,
        "nome": "São Luiz",
        "latitude": 0.8844,
        "longitude": -60.1518,
        "mesorregiaoNome": "Sul de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1400704,
        "nome": "Uiramutã",
        "latitude": 4.6848,
        "longitude": -60.2786,
        "mesorregiaoNome": "Norte de Roraima",
        "UFSigla": "RR",
        "UFNome": "Roraima"
    },
    {
        "ibgeId": 1500107,
        "nome": "Abaetetuba",
        "latitude": -1.7303,
        "longitude": -48.8831,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1500131,
        "nome": "Abel Figueiredo",
        "latitude": -4.9573,
        "longitude": -48.4246,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1500206,
        "nome": "Acará",
        "latitude": -2.0354,
        "longitude": -48.4115,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1500305,
        "nome": "Afuá",
        "latitude": -0.2628,
        "longitude": -50.7259,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1500347,
        "nome": "Água Azul do Norte",
        "latitude": -6.773,
        "longitude": -50.4302,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1500404,
        "nome": "Alenquer",
        "latitude": -0.6046,
        "longitude": -55.0392,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1500503,
        "nome": "Almeirim",
        "latitude": 0.2848,
        "longitude": -53.8937,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1500602,
        "nome": "Altamira",
        "latitude": -6.4862,
        "longitude": -53.8867,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1500701,
        "nome": "Anajás",
        "latitude": -0.8271,
        "longitude": -49.9614,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1500800,
        "nome": "Ananindeua",
        "latitude": -1.3341,
        "longitude": -48.3835,
        "mesorregiaoNome": "Metropolitana de Belém",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1500859,
        "nome": "Anapu",
        "latitude": -3.9972,
        "longitude": -51.3013,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1500909,
        "nome": "Augusto Corrêa",
        "latitude": -1.1069,
        "longitude": -46.5082,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1500958,
        "nome": "Aurora do Pará",
        "latitude": -2.2312,
        "longitude": -47.7264,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501006,
        "nome": "Aveiro",
        "latitude": -3.6672,
        "longitude": -56.0163,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501105,
        "nome": "Bagre",
        "latitude": -2.3731,
        "longitude": -50.1818,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501204,
        "nome": "Baião",
        "latitude": -3.1298,
        "longitude": -49.699,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501253,
        "nome": "Bannach",
        "latitude": -7.4864,
        "longitude": -50.6344,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501303,
        "nome": "Barcarena",
        "latitude": -1.4986,
        "longitude": -48.6342,
        "mesorregiaoNome": "Metropolitana de Belém",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501402,
        "nome": "Belém",
        "latitude": -1.2407,
        "longitude": -48.4599,
        "mesorregiaoNome": "Metropolitana de Belém",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501451,
        "nome": "Belterra",
        "latitude": -3.1911,
        "longitude": -54.9928,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501501,
        "nome": "Benevides",
        "latitude": -1.3396,
        "longitude": -48.2756,
        "mesorregiaoNome": "Metropolitana de Belém",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501576,
        "nome": "Bom Jesus do Tocantins",
        "latitude": -5.0543,
        "longitude": -48.7635,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501600,
        "nome": "Bonito",
        "latitude": -1.3873,
        "longitude": -47.3023,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501709,
        "nome": "Bragança",
        "latitude": -1.1932,
        "longitude": -46.7636,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501725,
        "nome": "Brasil Novo",
        "latitude": -3.2921,
        "longitude": -52.6854,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501758,
        "nome": "Brejo Grande do Araguaia",
        "latitude": -5.7355,
        "longitude": -48.4319,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501782,
        "nome": "Breu Branco",
        "latitude": -3.7335,
        "longitude": -49.3712,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501808,
        "nome": "Breves",
        "latitude": -1.1209,
        "longitude": -50.6281,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501907,
        "nome": "Bujaru",
        "latitude": -1.633,
        "longitude": -48.0899,
        "mesorregiaoNome": "Metropolitana de Belém",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1501956,
        "nome": "Cachoeira do Piriá",
        "latitude": -1.9887,
        "longitude": -46.4432,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502004,
        "nome": "Cachoeira do Arari",
        "latitude": -0.8694,
        "longitude": -48.8772,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502103,
        "nome": "Cametá",
        "latitude": -2.253,
        "longitude": -49.5135,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502152,
        "nome": "Canaã dos Carajás",
        "latitude": -6.4242,
        "longitude": -50.0857,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502202,
        "nome": "Capanema",
        "latitude": -1.1421,
        "longitude": -47.1179,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502301,
        "nome": "Capitão Poço",
        "latitude": -2.0422,
        "longitude": -47.2334,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502400,
        "nome": "Castanhal",
        "latitude": -1.2685,
        "longitude": -47.877,
        "mesorregiaoNome": "Metropolitana de Belém",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502509,
        "nome": "Chaves",
        "latitude": -0.0332,
        "longitude": -49.8434,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502608,
        "nome": "Colares",
        "latitude": -0.9358,
        "longitude": -48.2737,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502707,
        "nome": "Conceição do Araguaia",
        "latitude": -8.1825,
        "longitude": -49.5127,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502756,
        "nome": "Concórdia do Pará",
        "latitude": -1.8817,
        "longitude": -47.9747,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502764,
        "nome": "Cumaru do Norte",
        "latitude": -8.4582,
        "longitude": -51.221,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502772,
        "nome": "Curionópolis",
        "latitude": -6.2289,
        "longitude": -49.6246,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502806,
        "nome": "Curralinho",
        "latitude": -1.5835,
        "longitude": -49.988,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502855,
        "nome": "Curuá",
        "latitude": -1.8458,
        "longitude": -55.1135,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502905,
        "nome": "Curuçá",
        "latitude": -0.7436,
        "longitude": -47.8634,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502939,
        "nome": "Dom Eliseu",
        "latitude": -4.1866,
        "longitude": -47.8981,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1502954,
        "nome": "Eldorado do Carajás",
        "latitude": -6.0696,
        "longitude": -49.2454,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503002,
        "nome": "Faro",
        "latitude": -1.1592,
        "longitude": -57.8059,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503044,
        "nome": "Floresta do Araguaia",
        "latitude": -7.5483,
        "longitude": -49.576,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503077,
        "nome": "Garrafão do Norte",
        "latitude": -2.1683,
        "longitude": -47.076,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503093,
        "nome": "Goianésia do Pará",
        "latitude": -4.0272,
        "longitude": -49.0057,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503101,
        "nome": "Gurupá",
        "latitude": -1.1494,
        "longitude": -51.5539,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503200,
        "nome": "Igarapé-Açu",
        "latitude": -1.145,
        "longitude": -47.566,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503309,
        "nome": "Igarapé-Miri",
        "latitude": -2.0627,
        "longitude": -49.1307,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503408,
        "nome": "Inhangapi",
        "latitude": -1.4647,
        "longitude": -47.9227,
        "mesorregiaoNome": "Metropolitana de Belém",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503457,
        "nome": "Ipixuna do Pará",
        "latitude": -2.8058,
        "longitude": -47.9215,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503507,
        "nome": "Irituia",
        "latitude": -1.8115,
        "longitude": -47.3999,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503606,
        "nome": "Itaituba",
        "latitude": -5.8711,
        "longitude": -56.4967,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503705,
        "nome": "Itupiranga",
        "latitude": -5.1148,
        "longitude": -49.8697,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503754,
        "nome": "Jacareacanga",
        "latitude": -7.4453,
        "longitude": -57.3027,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503804,
        "nome": "Jacundá",
        "latitude": -4.5985,
        "longitude": -49.1812,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1503903,
        "nome": "Juruti",
        "latitude": -2.6228,
        "longitude": -56.2213,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504000,
        "nome": "Limoeiro do Ajuru",
        "latitude": -1.8642,
        "longitude": -49.4692,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504059,
        "nome": "Mãe do Rio",
        "latitude": -1.991,
        "longitude": -47.5128,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504109,
        "nome": "Magalhães Barata",
        "latitude": -0.8099,
        "longitude": -47.6352,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504208,
        "nome": "Marabá",
        "latitude": -5.6298,
        "longitude": -50.017,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504307,
        "nome": "Maracanã",
        "latitude": -0.8101,
        "longitude": -47.4974,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504406,
        "nome": "Marapanim",
        "latitude": -0.8374,
        "longitude": -47.7098,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504422,
        "nome": "Marituba",
        "latitude": -1.3975,
        "longitude": -48.3198,
        "mesorregiaoNome": "Metropolitana de Belém",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504455,
        "nome": "Medicilândia",
        "latitude": -3.1602,
        "longitude": -53.195,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504505,
        "nome": "Melgaço",
        "latitude": -1.6076,
        "longitude": -51.1039,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504604,
        "nome": "Mocajuba",
        "latitude": -2.5767,
        "longitude": -49.4664,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504703,
        "nome": "Moju",
        "latitude": -2.6839,
        "longitude": -49.074,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504752,
        "nome": "Mojuí dos Campos",
        "latitude": -3.0704,
        "longitude": -54.5752,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504802,
        "nome": "Monte Alegre",
        "latitude": -1.0743,
        "longitude": -54.3531,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504901,
        "nome": "Muaná",
        "latitude": -1.3557,
        "longitude": -49.3093,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504950,
        "nome": "Nova Esperança do Piriá",
        "latitude": -2.3926,
        "longitude": -46.9,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1504976,
        "nome": "Nova Ipixuna",
        "latitude": -4.9811,
        "longitude": -49.2308,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505007,
        "nome": "Nova Timboteua",
        "latitude": -1.1564,
        "longitude": -47.3921,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505031,
        "nome": "Novo Progresso",
        "latitude": -8.0623,
        "longitude": -55.612,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505064,
        "nome": "Novo Repartimento",
        "latitude": -4.5028,
        "longitude": -50.2716,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505106,
        "nome": "Óbidos",
        "latitude": -0.1696,
        "longitude": -55.6749,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505205,
        "nome": "Oeiras do Pará",
        "latitude": -2.2789,
        "longitude": -49.9023,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505304,
        "nome": "Oriximiná",
        "latitude": 0.2542,
        "longitude": -57.1499,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505403,
        "nome": "Ourém",
        "latitude": -1.4959,
        "longitude": -47.1392,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505437,
        "nome": "Ourilândia do Norte",
        "latitude": -7.5205,
        "longitude": -51.4309,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505486,
        "nome": "Pacajá",
        "latitude": -3.6841,
        "longitude": -50.6317,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505494,
        "nome": "Palestina do Pará",
        "latitude": -5.9273,
        "longitude": -48.3702,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505502,
        "nome": "Paragominas",
        "latitude": -3.2035,
        "longitude": -47.6032,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505536,
        "nome": "Parauapebas",
        "latitude": -6.1517,
        "longitude": -50.4898,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505551,
        "nome": "Pau D'Arco",
        "latitude": -7.737,
        "longitude": -50.1236,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505601,
        "nome": "Peixe-Boi",
        "latitude": -1.1307,
        "longitude": -47.272,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505635,
        "nome": "Piçarra",
        "latitude": -6.541,
        "longitude": -49.0118,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505650,
        "nome": "Placas",
        "latitude": -3.8898,
        "longitude": -54.5007,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505700,
        "nome": "Ponta de Pedras",
        "latitude": -1.1175,
        "longitude": -49.0773,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505809,
        "nome": "Portel",
        "latitude": -2.5654,
        "longitude": -50.9556,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1505908,
        "nome": "Porto de Moz",
        "latitude": -2.1846,
        "longitude": -52.5477,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506005,
        "nome": "Prainha",
        "latitude": -2.1203,
        "longitude": -53.6602,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506104,
        "nome": "Primavera",
        "latitude": -0.9524,
        "longitude": -47.1314,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506112,
        "nome": "Quatipuru",
        "latitude": -0.8601,
        "longitude": -47.0155,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506138,
        "nome": "Redenção",
        "latitude": -8.0693,
        "longitude": -50.1981,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506161,
        "nome": "Rio Maria",
        "latitude": -7.3406,
        "longitude": -49.8951,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506187,
        "nome": "Rondon do Pará",
        "latitude": -4.5169,
        "longitude": -48.46,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506195,
        "nome": "Rurópolis",
        "latitude": -4.241,
        "longitude": -55.2107,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506203,
        "nome": "Salinópolis",
        "latitude": -0.684,
        "longitude": -47.3517,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506302,
        "nome": "Salvaterra",
        "latitude": -0.7966,
        "longitude": -48.63,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506351,
        "nome": "Santa Bárbara do Pará",
        "latitude": -1.1943,
        "longitude": -48.2505,
        "mesorregiaoNome": "Metropolitana de Belém",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506401,
        "nome": "Santa Cruz do Arari",
        "latitude": -0.5834,
        "longitude": -49.3139,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506500,
        "nome": "Santa Izabel do Pará",
        "latitude": -1.3652,
        "longitude": -48.1293,
        "mesorregiaoNome": "Metropolitana de Belém",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506559,
        "nome": "Santa Luzia do Pará",
        "latitude": -1.6566,
        "longitude": -46.9269,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506583,
        "nome": "Santa Maria das Barreiras",
        "latitude": -8.6338,
        "longitude": -50.3144,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506609,
        "nome": "Santa Maria do Pará",
        "latitude": -1.3745,
        "longitude": -47.5216,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506708,
        "nome": "Santana do Araguaia",
        "latitude": -9.3641,
        "longitude": -50.6113,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506807,
        "nome": "Santarém",
        "latitude": -2.6793,
        "longitude": -55.2384,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1506906,
        "nome": "Santarém Novo",
        "latitude": -0.9133,
        "longitude": -47.3329,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507003,
        "nome": "Santo Antônio do Tauá",
        "latitude": -1.0933,
        "longitude": -48.1828,
        "mesorregiaoNome": "Metropolitana de Belém",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507102,
        "nome": "São Caetano de Odivelas",
        "latitude": -0.8661,
        "longitude": -48.0258,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507151,
        "nome": "São Domingos do Araguaia",
        "latitude": -5.6576,
        "longitude": -48.7306,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507201,
        "nome": "São Domingos do Capim",
        "latitude": -1.8826,
        "longitude": -47.7715,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507300,
        "nome": "São Félix do Xingu",
        "latitude": -7.2334,
        "longitude": -52.2527,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507409,
        "nome": "São Francisco do Pará",
        "latitude": -1.206,
        "longitude": -47.7468,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507458,
        "nome": "São Geraldo do Araguaia",
        "latitude": -6.1893,
        "longitude": -48.7482,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507466,
        "nome": "São João da Ponta",
        "latitude": -0.8705,
        "longitude": -47.9645,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507474,
        "nome": "São João de Pirabas",
        "latitude": -0.7838,
        "longitude": -47.2179,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507508,
        "nome": "São João do Araguaia",
        "latitude": -5.4473,
        "longitude": -48.6968,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507607,
        "nome": "São Miguel do Guamá",
        "latitude": -1.5515,
        "longitude": -47.6108,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507706,
        "nome": "São Sebastião da Boa Vista",
        "latitude": -1.4341,
        "longitude": -49.6803,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507755,
        "nome": "Sapucaia",
        "latitude": -6.8389,
        "longitude": -49.5698,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507805,
        "nome": "Senador José Porfírio",
        "latitude": -4.3241,
        "longitude": -51.7638,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507904,
        "nome": "Soure",
        "latitude": -0.4483,
        "longitude": -48.6977,
        "mesorregiaoNome": "Marajó",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507953,
        "nome": "Tailândia",
        "latitude": -2.9078,
        "longitude": -48.7367,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507961,
        "nome": "Terra Alta",
        "latitude": -1.0026,
        "longitude": -47.8483,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1507979,
        "nome": "Terra Santa",
        "latitude": -1.9515,
        "longitude": -56.4584,
        "mesorregiaoNome": "Baixo Amazonas",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1508001,
        "nome": "Tomé-Açu",
        "latitude": -2.6361,
        "longitude": -48.2676,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1508035,
        "nome": "Tracuateua",
        "latitude": -1.041,
        "longitude": -46.939,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1508050,
        "nome": "Trairão",
        "latitude": -5.1302,
        "longitude": -56.0035,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1508084,
        "nome": "Tucumã",
        "latitude": -6.8202,
        "longitude": -51.3914,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1508100,
        "nome": "Tucuruí",
        "latitude": -3.8563,
        "longitude": -49.8211,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1508126,
        "nome": "Ulianópolis",
        "latitude": -3.8098,
        "longitude": -47.4936,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1508159,
        "nome": "Uruará",
        "latitude": -3.5836,
        "longitude": -53.8073,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1508209,
        "nome": "Vigia",
        "latitude": -0.9334,
        "longitude": -48.1049,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1508308,
        "nome": "Viseu",
        "latitude": -1.5256,
        "longitude": -46.4538,
        "mesorregiaoNome": "Nordeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1508357,
        "nome": "Vitória do Xingu",
        "latitude": -3.1353,
        "longitude": -51.974,
        "mesorregiaoNome": "Sudoeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1508407,
        "nome": "Xinguara",
        "latitude": -6.9178,
        "longitude": -49.6353,
        "mesorregiaoNome": "Sudeste Paraense",
        "UFSigla": "PA",
        "UFNome": "Pará"
    },
    {
        "ibgeId": 1600055,
        "nome": "Serra do Navio",
        "latitude": 1.6517,
        "longitude": -52.2681,
        "mesorregiaoNome": "Sul do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600105,
        "nome": "Amapá",
        "latitude": 1.7299,
        "longitude": -50.6024,
        "mesorregiaoNome": "Norte do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600154,
        "nome": "Pedra Branca do Amapari",
        "latitude": 1.1576,
        "longitude": -52.5196,
        "mesorregiaoNome": "Sul do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600204,
        "nome": "Calçoene",
        "latitude": 2.4238,
        "longitude": -51.4066,
        "mesorregiaoNome": "Norte do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600212,
        "nome": "Cutias",
        "latitude": 1.0356,
        "longitude": -50.4871,
        "mesorregiaoNome": "Sul do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600238,
        "nome": "Ferreira Gomes",
        "latitude": 0.9571,
        "longitude": -51.4174,
        "mesorregiaoNome": "Sul do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600253,
        "nome": "Itaubal",
        "latitude": 0.5384,
        "longitude": -50.6403,
        "mesorregiaoNome": "Sul do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600279,
        "nome": "Laranjal do Jari",
        "latitude": 1.0926,
        "longitude": -53.3039,
        "mesorregiaoNome": "Sul do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600303,
        "nome": "Macapá",
        "latitude": 0.5628,
        "longitude": -50.6918,
        "mesorregiaoNome": "Sul do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600402,
        "nome": "Mazagão",
        "latitude": -0.0668,
        "longitude": -51.9512,
        "mesorregiaoNome": "Sul do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600501,
        "nome": "Oiapoque",
        "latitude": 3.1106,
        "longitude": -51.9001,
        "mesorregiaoNome": "Norte do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600535,
        "nome": "Porto Grande",
        "latitude": 0.5856,
        "longitude": -51.67,
        "mesorregiaoNome": "Sul do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600550,
        "nome": "Pracuúba",
        "latitude": 1.6258,
        "longitude": -51.2785,
        "mesorregiaoNome": "Norte do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600600,
        "nome": "Santana",
        "latitude": 0.1298,
        "longitude": -51.3784,
        "mesorregiaoNome": "Sul do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600709,
        "nome": "Tartarugalzinho",
        "latitude": 1.2976,
        "longitude": -50.9926,
        "mesorregiaoNome": "Norte do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1600808,
        "nome": "Vitória do Jari",
        "latitude": -0.9964,
        "longitude": -52.0612,
        "mesorregiaoNome": "Sul do Amapá",
        "UFSigla": "AP",
        "UFNome": "Amapá"
    },
    {
        "ibgeId": 1700251,
        "nome": "Abreulândia",
        "latitude": -9.4788,
        "longitude": -49.3113,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1700301,
        "nome": "Aguiarnópolis",
        "latitude": -6.4886,
        "longitude": -47.5134,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1700350,
        "nome": "Aliança do Tocantins",
        "latitude": -11.3312,
        "longitude": -48.9083,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1700400,
        "nome": "Almas",
        "latitude": -11.4295,
        "longitude": -47.211,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1700707,
        "nome": "Alvorada",
        "latitude": -12.4075,
        "longitude": -49.1118,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1701002,
        "nome": "Ananás",
        "latitude": -6.2327,
        "longitude": -48.1866,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1701051,
        "nome": "Angico",
        "latitude": -6.4358,
        "longitude": -47.9132,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1701101,
        "nome": "Aparecida do Rio Negro",
        "latitude": -9.9866,
        "longitude": -48,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1701309,
        "nome": "Aragominas",
        "latitude": -6.9455,
        "longitude": -48.6323,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1701903,
        "nome": "Araguacema",
        "latitude": -8.9391,
        "longitude": -49.5055,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1702000,
        "nome": "Araguaçu",
        "latitude": -12.8399,
        "longitude": -49.6964,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1702109,
        "nome": "Araguaína",
        "latitude": -7.3313,
        "longitude": -48.5878,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1702158,
        "nome": "Araguanã",
        "latitude": -6.791,
        "longitude": -48.5245,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1702208,
        "nome": "Araguatins",
        "latitude": -5.6658,
        "longitude": -48.1048,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1702307,
        "nome": "Arapoema",
        "latitude": -7.7234,
        "longitude": -48.9998,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1702406,
        "nome": "Arraias",
        "latitude": -12.8172,
        "longitude": -47.0478,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1702554,
        "nome": "Augustinópolis",
        "latitude": -5.4978,
        "longitude": -47.9282,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1702703,
        "nome": "Aurora do Tocantins",
        "latitude": -12.6466,
        "longitude": -46.4329,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1702901,
        "nome": "Axixá do Tocantins",
        "latitude": -5.6494,
        "longitude": -47.7661,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703008,
        "nome": "Babaçulândia",
        "latitude": -7.1745,
        "longitude": -47.8568,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703057,
        "nome": "Bandeirantes do Tocantins",
        "latitude": -7.903,
        "longitude": -48.6755,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703073,
        "nome": "Barra do Ouro",
        "latitude": -7.7178,
        "longitude": -47.5786,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703107,
        "nome": "Barrolândia",
        "latitude": -9.8658,
        "longitude": -48.7912,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703206,
        "nome": "Bernardo Sayão",
        "latitude": -7.9835,
        "longitude": -48.9691,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703305,
        "nome": "Bom Jesus do Tocantins",
        "latitude": -9.0124,
        "longitude": -47.8792,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703602,
        "nome": "Brasilândia do Tocantins",
        "latitude": -8.2899,
        "longitude": -48.4428,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703701,
        "nome": "Brejinho de Nazaré",
        "latitude": -11.0293,
        "longitude": -48.6241,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703800,
        "nome": "Buriti do Tocantins",
        "latitude": -5.3377,
        "longitude": -48.1363,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703826,
        "nome": "Cachoeirinha",
        "latitude": -6.09,
        "longitude": -47.8413,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703842,
        "nome": "Campos Lindos",
        "latitude": -8.2038,
        "longitude": -46.8046,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703867,
        "nome": "Cariri do Tocantins",
        "latitude": -11.933,
        "longitude": -49.2028,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703883,
        "nome": "Carmolândia",
        "latitude": -7.0451,
        "longitude": -48.3745,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703891,
        "nome": "Carrasco Bonito",
        "latitude": -5.3372,
        "longitude": -48.0099,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1703909,
        "nome": "Caseara",
        "latitude": -9.4017,
        "longitude": -49.8486,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1704105,
        "nome": "Centenário",
        "latitude": -9.0738,
        "longitude": -47.4448,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1704600,
        "nome": "Chapada de Areia",
        "latitude": -10.1657,
        "longitude": -49.1957,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1705102,
        "nome": "Chapada da Natividade",
        "latitude": -11.5411,
        "longitude": -47.8464,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1705508,
        "nome": "Colinas do Tocantins",
        "latitude": -8.0764,
        "longitude": -48.5301,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1705557,
        "nome": "Combinado",
        "latitude": -12.8463,
        "longitude": -46.5037,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1705607,
        "nome": "Conceição do Tocantins",
        "latitude": -12.171,
        "longitude": -47.3037,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1706001,
        "nome": "Couto Magalhães",
        "latitude": -8.4367,
        "longitude": -49.1624,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1706100,
        "nome": "Cristalândia",
        "latitude": -10.6364,
        "longitude": -49.3124,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1706258,
        "nome": "Crixás do Tocantins",
        "latitude": -11.1719,
        "longitude": -49.0727,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1706506,
        "nome": "Darcinópolis",
        "latitude": -6.7634,
        "longitude": -47.7679,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1707009,
        "nome": "Dianópolis",
        "latitude": -11.6948,
        "longitude": -46.7958,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1707108,
        "nome": "Divinópolis do Tocantins",
        "latitude": -9.6951,
        "longitude": -49.3548,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1707207,
        "nome": "Dois Irmãos do Tocantins",
        "latitude": -9.2709,
        "longitude": -49.0669,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1707306,
        "nome": "Dueré",
        "latitude": -11.4272,
        "longitude": -49.3913,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1707405,
        "nome": "Esperantina",
        "latitude": -5.3263,
        "longitude": -48.5403,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1707553,
        "nome": "Fátima",
        "latitude": -10.8098,
        "longitude": -48.8723,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1707652,
        "nome": "Figueirópolis",
        "latitude": -12.2635,
        "longitude": -49.2828,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1707702,
        "nome": "Filadélfia",
        "latitude": -7.4967,
        "longitude": -47.7937,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1708205,
        "nome": "Formoso do Araguaia",
        "latitude": -11.9583,
        "longitude": -50.0981,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1708254,
        "nome": "Tabocão",
        "latitude": -9.0714,
        "longitude": -48.546,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1708304,
        "nome": "Goianorte",
        "latitude": -8.8732,
        "longitude": -49.0112,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1709005,
        "nome": "Goiatins",
        "latitude": -8.0942,
        "longitude": -47.4815,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1709302,
        "nome": "Guaraí",
        "latitude": -8.7301,
        "longitude": -48.4251,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1709500,
        "nome": "Gurupi",
        "latitude": -11.6516,
        "longitude": -48.8874,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1709807,
        "nome": "Ipueiras",
        "latitude": -11.1351,
        "longitude": -48.4035,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1710508,
        "nome": "Itacajá",
        "latitude": -8.5715,
        "longitude": -47.6693,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1710706,
        "nome": "Itaguatins",
        "latitude": -5.8027,
        "longitude": -47.5951,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1710904,
        "nome": "Itapiratins",
        "latitude": -8.3163,
        "longitude": -48.0333,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1711100,
        "nome": "Itaporã do Tocantins",
        "latitude": -8.4512,
        "longitude": -48.7526,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1711506,
        "nome": "Jaú do Tocantins",
        "latitude": -12.7477,
        "longitude": -48.6455,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1711803,
        "nome": "Juarina",
        "latitude": -8.1408,
        "longitude": -49.1103,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1711902,
        "nome": "Lagoa da Confusão",
        "latitude": -11.035,
        "longitude": -50.1607,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1711951,
        "nome": "Lagoa do Tocantins",
        "latitude": -10.3419,
        "longitude": -47.4811,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1712009,
        "nome": "Lajeado",
        "latitude": -9.8506,
        "longitude": -48.291,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1712157,
        "nome": "Lavandeira",
        "latitude": -12.8126,
        "longitude": -46.4105,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1712405,
        "nome": "Lizarda",
        "latitude": -9.5248,
        "longitude": -46.939,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1712454,
        "nome": "Luzinópolis",
        "latitude": -6.206,
        "longitude": -47.8307,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1712504,
        "nome": "Marianópolis do Tocantins",
        "latitude": -9.7876,
        "longitude": -49.7,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1712702,
        "nome": "Mateiros",
        "latitude": -10.583,
        "longitude": -46.5026,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1712801,
        "nome": "Maurilândia do Tocantins",
        "latitude": -6.0232,
        "longitude": -47.5899,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1713205,
        "nome": "Miracema do Tocantins",
        "latitude": -9.7542,
        "longitude": -48.5515,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1713304,
        "nome": "Miranorte",
        "latitude": -9.4163,
        "longitude": -48.6838,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1713601,
        "nome": "Monte do Carmo",
        "latitude": -10.7476,
        "longitude": -48.0172,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1713700,
        "nome": "Monte Santo do Tocantins",
        "latitude": -9.9995,
        "longitude": -49.0673,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1713809,
        "nome": "Palmeiras do Tocantins",
        "latitude": -6.6002,
        "longitude": -47.6427,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1713957,
        "nome": "Muricilândia",
        "latitude": -7.0033,
        "longitude": -48.7865,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1714203,
        "nome": "Natividade",
        "latitude": -11.7983,
        "longitude": -47.6488,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1714302,
        "nome": "Nazaré",
        "latitude": -6.3303,
        "longitude": -47.7815,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1714880,
        "nome": "Nova Olinda",
        "latitude": -7.6379,
        "longitude": -48.3607,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1715002,
        "nome": "Nova Rosalândia",
        "latitude": -10.55,
        "longitude": -48.9733,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1715101,
        "nome": "Novo Acordo",
        "latitude": -10.155,
        "longitude": -47.383,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1715150,
        "nome": "Novo Alegre",
        "latitude": -12.9143,
        "longitude": -46.5596,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1715259,
        "nome": "Novo Jardim",
        "latitude": -11.779,
        "longitude": -46.5704,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1715507,
        "nome": "Oliveira de Fátima",
        "latitude": -10.6745,
        "longitude": -48.8758,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1715705,
        "nome": "Palmeirante",
        "latitude": -7.8859,
        "longitude": -48.1563,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1715754,
        "nome": "Palmeirópolis",
        "latitude": -13.0198,
        "longitude": -48.3488,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1716109,
        "nome": "Paraíso do Tocantins",
        "latitude": -10.2182,
        "longitude": -48.8273,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1716208,
        "nome": "Paranã",
        "latitude": -12.6965,
        "longitude": -47.8135,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1716307,
        "nome": "Pau D'Arco",
        "latitude": -7.5449,
        "longitude": -48.9884,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1716505,
        "nome": "Pedro Afonso",
        "latitude": -9.2269,
        "longitude": -48.0342,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1716604,
        "nome": "Peixe",
        "latitude": -11.9968,
        "longitude": -48.5552,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1716653,
        "nome": "Pequizeiro",
        "latitude": -8.3798,
        "longitude": -48.9172,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1716703,
        "nome": "Colméia",
        "latitude": -8.8374,
        "longitude": -48.7486,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1717008,
        "nome": "Pindorama do Tocantins",
        "latitude": -11.1597,
        "longitude": -47.5589,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1717206,
        "nome": "Piraquê",
        "latitude": -6.7386,
        "longitude": -48.2394,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1717503,
        "nome": "Pium",
        "latitude": -10.2095,
        "longitude": -49.8719,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1717800,
        "nome": "Ponte Alta do Bom Jesus",
        "latitude": -12.0576,
        "longitude": -46.5933,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1717909,
        "nome": "Ponte Alta do Tocantins",
        "latitude": -10.7495,
        "longitude": -47.3246,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718006,
        "nome": "Porto Alegre do Tocantins",
        "latitude": -11.5108,
        "longitude": -47.0467,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718204,
        "nome": "Porto Nacional",
        "latitude": -10.5437,
        "longitude": -48.4965,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718303,
        "nome": "Praia Norte",
        "latitude": -5.4748,
        "longitude": -47.7819,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718402,
        "nome": "Presidente Kennedy",
        "latitude": -8.4619,
        "longitude": -48.4616,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718451,
        "nome": "Pugmil",
        "latitude": -10.4225,
        "longitude": -48.8824,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718501,
        "nome": "Recursolândia",
        "latitude": -8.6974,
        "longitude": -47.1131,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718550,
        "nome": "Riachinho",
        "latitude": -6.4599,
        "longitude": -48.1362,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718659,
        "nome": "Rio da Conceição",
        "latitude": -11.337,
        "longitude": -46.7377,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718709,
        "nome": "Rio dos Bois",
        "latitude": -9.2359,
        "longitude": -48.4525,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718758,
        "nome": "Rio Sono",
        "latitude": -9.6474,
        "longitude": -47.496,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718808,
        "nome": "Sampaio",
        "latitude": -5.3296,
        "longitude": -47.9188,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718840,
        "nome": "Sandolândia",
        "latitude": -12.401,
        "longitude": -49.8761,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718865,
        "nome": "Santa Fé do Araguaia",
        "latitude": -7.0931,
        "longitude": -48.975,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718881,
        "nome": "Santa Maria do Tocantins",
        "latitude": -8.8247,
        "longitude": -47.8483,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718899,
        "nome": "Santa Rita do Tocantins",
        "latitude": -10.97,
        "longitude": -49.295,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1718907,
        "nome": "Santa Rosa do Tocantins",
        "latitude": -11.3973,
        "longitude": -48.1084,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1719004,
        "nome": "Santa Tereza do Tocantins",
        "latitude": -10.299,
        "longitude": -47.7415,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1720002,
        "nome": "Santa Terezinha do Tocantins",
        "latitude": -6.4727,
        "longitude": -47.7511,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1720101,
        "nome": "São Bento do Tocantins",
        "latitude": -5.976,
        "longitude": -47.9399,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1720150,
        "nome": "São Félix do Tocantins",
        "latitude": -10.0686,
        "longitude": -46.6779,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1720200,
        "nome": "São Miguel do Tocantins",
        "latitude": -5.5434,
        "longitude": -47.5978,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1720259,
        "nome": "São Salvador do Tocantins",
        "latitude": -12.5776,
        "longitude": -48.3642,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1720309,
        "nome": "São Sebastião do Tocantins",
        "latitude": -5.241,
        "longitude": -48.3317,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1720499,
        "nome": "São Valério",
        "latitude": -11.804,
        "longitude": -48.1697,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1720655,
        "nome": "Silvanópolis",
        "latitude": -11.1308,
        "longitude": -48.005,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1720804,
        "nome": "Sítio Novo do Tocantins",
        "latitude": -5.6351,
        "longitude": -47.6841,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1720853,
        "nome": "Sucupira",
        "latitude": -12.1133,
        "longitude": -48.8343,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1720903,
        "nome": "Taguatinga",
        "latitude": -12.3873,
        "longitude": -46.5657,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1720937,
        "nome": "Taipas do Tocantins",
        "latitude": -12.1397,
        "longitude": -46.9937,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1720978,
        "nome": "Talismã",
        "latitude": -12.6822,
        "longitude": -49.0485,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1721000,
        "nome": "Palmas",
        "latitude": -10.2202,
        "longitude": -48.1521,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1721109,
        "nome": "Tocantínia",
        "latitude": -9.6034,
        "longitude": -48.1409,
        "mesorregiaoNome": "Oriental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1721208,
        "nome": "Tocantinópolis",
        "latitude": -6.2568,
        "longitude": -47.5381,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1721257,
        "nome": "Tupirama",
        "latitude": -8.9386,
        "longitude": -48.2596,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1721307,
        "nome": "Tupiratins",
        "latitude": -8.3566,
        "longitude": -48.2107,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1722081,
        "nome": "Wanderlândia",
        "latitude": -6.9101,
        "longitude": -48.002,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 1722107,
        "nome": "Xambioá",
        "latitude": -6.5454,
        "longitude": -48.451,
        "mesorregiaoNome": "Ocidental do Tocantins",
        "UFSigla": "TO",
        "UFNome": "Tocantins"
    },
    {
        "ibgeId": 2100055,
        "nome": "Açailândia",
        "latitude": -4.7858,
        "longitude": -47.3324,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100105,
        "nome": "Afonso Cunha",
        "latitude": -4.2148,
        "longitude": -43.2974,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100154,
        "nome": "Água Doce do Maranhão",
        "latitude": -2.9464,
        "longitude": -42.1662,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100204,
        "nome": "Alcântara",
        "latitude": -2.3793,
        "longitude": -44.54,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100303,
        "nome": "Aldeias Altas",
        "latitude": -4.5029,
        "longitude": -43.3835,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100402,
        "nome": "Altamira do Maranhão",
        "latitude": -4.167,
        "longitude": -45.5028,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100436,
        "nome": "Alto Alegre do Maranhão",
        "latitude": -4.2106,
        "longitude": -44.3958,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100477,
        "nome": "Alto Alegre do Pindaré",
        "latitude": -3.8703,
        "longitude": -46.0018,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100501,
        "nome": "Alto Parnaíba",
        "latitude": -9.5085,
        "longitude": -46.2133,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100550,
        "nome": "Amapá do Maranhão",
        "latitude": -1.6729,
        "longitude": -45.9498,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100600,
        "nome": "Amarante do Maranhão",
        "latitude": -5.2783,
        "longitude": -46.5821,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100709,
        "nome": "Anajatuba",
        "latitude": -3.2556,
        "longitude": -44.5992,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100808,
        "nome": "Anapurus",
        "latitude": -3.5439,
        "longitude": -43.1078,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100832,
        "nome": "Apicum-Açu",
        "latitude": -1.5473,
        "longitude": -45.0856,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100873,
        "nome": "Araguanã",
        "latitude": -3.0791,
        "longitude": -45.7873,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100907,
        "nome": "Araioses",
        "latitude": -2.9723,
        "longitude": -42.017,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2100956,
        "nome": "Arame",
        "latitude": -5.0277,
        "longitude": -45.946,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101004,
        "nome": "Arari",
        "latitude": -3.5333,
        "longitude": -44.7273,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101103,
        "nome": "Axixá",
        "latitude": -2.8439,
        "longitude": -44.0987,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101202,
        "nome": "Bacabal",
        "latitude": -4.1711,
        "longitude": -44.7619,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101251,
        "nome": "Bacabeira",
        "latitude": -2.9363,
        "longitude": -44.358,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101301,
        "nome": "Bacuri",
        "latitude": -1.6818,
        "longitude": -45.1652,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101350,
        "nome": "Bacurituba",
        "latitude": -2.6996,
        "longitude": -44.6952,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101400,
        "nome": "Balsas",
        "latitude": -8.2376,
        "longitude": -46.3428,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101509,
        "nome": "Barão de Grajaú",
        "latitude": -6.5929,
        "longitude": -43.1881,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101608,
        "nome": "Barra do Corda",
        "latitude": -5.5041,
        "longitude": -45.1831,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101707,
        "nome": "Barreirinhas",
        "latitude": -2.8398,
        "longitude": -42.9101,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101731,
        "nome": "Belágua",
        "latitude": -3.1013,
        "longitude": -43.4624,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101772,
        "nome": "Bela Vista do Maranhão",
        "latitude": -3.7578,
        "longitude": -45.266,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101806,
        "nome": "Benedito Leite",
        "latitude": -7.1205,
        "longitude": -44.5683,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101905,
        "nome": "Bequimão",
        "latitude": -2.4309,
        "longitude": -44.7857,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101939,
        "nome": "Bernardo do Mearim",
        "latitude": -4.6801,
        "longitude": -44.6878,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2101970,
        "nome": "Boa Vista do Gurupi",
        "latitude": -1.7621,
        "longitude": -46.1789,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102002,
        "nome": "Bom Jardim",
        "latitude": -3.9001,
        "longitude": -46.4183,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102036,
        "nome": "Bom Jesus das Selvas",
        "latitude": -4.6008,
        "longitude": -46.6886,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102077,
        "nome": "Bom Lugar",
        "latitude": -4.3466,
        "longitude": -45.021,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102101,
        "nome": "Brejo",
        "latitude": -3.687,
        "longitude": -42.8285,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102150,
        "nome": "Brejo de Areia",
        "latitude": -4.3651,
        "longitude": -45.6501,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102200,
        "nome": "Buriti",
        "latitude": -3.9005,
        "longitude": -43.0015,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102309,
        "nome": "Buriti Bravo",
        "latitude": -5.7892,
        "longitude": -43.8304,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102325,
        "nome": "Buriticupu",
        "latitude": -4.4924,
        "longitude": -46.3425,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102358,
        "nome": "Buritirana",
        "latitude": -5.5183,
        "longitude": -47.0618,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102374,
        "nome": "Cachoeira Grande",
        "latitude": -3.1201,
        "longitude": -43.9309,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102408,
        "nome": "Cajapió",
        "latitude": -2.8882,
        "longitude": -44.5398,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102507,
        "nome": "Cajari",
        "latitude": -3.3906,
        "longitude": -45.0527,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102556,
        "nome": "Campestre do Maranhão",
        "latitude": -6.1762,
        "longitude": -47.2638,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102606,
        "nome": "Cândido Mendes",
        "latitude": -1.6235,
        "longitude": -45.6786,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102705,
        "nome": "Cantanhede",
        "latitude": -3.6216,
        "longitude": -44.2627,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102754,
        "nome": "Capinzal do Norte",
        "latitude": -4.6821,
        "longitude": -44.3062,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102804,
        "nome": "Carolina",
        "latitude": -7.3764,
        "longitude": -47.2112,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2102903,
        "nome": "Carutapera",
        "latitude": -1.3502,
        "longitude": -46.0295,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103000,
        "nome": "Caxias",
        "latitude": -4.8665,
        "longitude": -43.2992,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103109,
        "nome": "Cedral",
        "latitude": -1.9774,
        "longitude": -44.5938,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103125,
        "nome": "Central do Maranhão",
        "latitude": -2.2549,
        "longitude": -44.8579,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103158,
        "nome": "Centro do Guilherme",
        "latitude": -2.4325,
        "longitude": -46.1204,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103174,
        "nome": "Centro Novo do Maranhão",
        "latitude": -3.0707,
        "longitude": -46.5336,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103208,
        "nome": "Chapadinha",
        "latitude": -3.8486,
        "longitude": -43.4538,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103257,
        "nome": "Cidelândia",
        "latitude": -5.0572,
        "longitude": -47.8298,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103307,
        "nome": "Codó",
        "latitude": -4.6073,
        "longitude": -43.886,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103406,
        "nome": "Coelho Neto",
        "latitude": -4.2481,
        "longitude": -43.1119,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103505,
        "nome": "Colinas",
        "latitude": -6.0557,
        "longitude": -44.1814,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103554,
        "nome": "Conceição do Lago-Açu",
        "latitude": -3.7969,
        "longitude": -44.8387,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103604,
        "nome": "Coroatá",
        "latitude": -4.1022,
        "longitude": -44.1453,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103703,
        "nome": "Cururupu",
        "latitude": -1.7742,
        "longitude": -44.7861,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103752,
        "nome": "Davinópolis",
        "latitude": -5.5987,
        "longitude": -47.3005,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103802,
        "nome": "Dom Pedro",
        "latitude": -5.0213,
        "longitude": -44.3971,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2103901,
        "nome": "Duque Bacelar",
        "latitude": -4.0991,
        "longitude": -43.0099,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104008,
        "nome": "Esperantinópolis",
        "latitude": -4.8991,
        "longitude": -44.8905,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104057,
        "nome": "Estreito",
        "latitude": -6.7825,
        "longitude": -47.2012,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104073,
        "nome": "Feira Nova do Maranhão",
        "latitude": -7.0187,
        "longitude": -46.6267,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104081,
        "nome": "Fernando Falcão",
        "latitude": -6.1738,
        "longitude": -45.3062,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104099,
        "nome": "Formosa da Serra Negra",
        "latitude": -6.5142,
        "longitude": -46.1863,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104107,
        "nome": "Fortaleza dos Nogueiras",
        "latitude": -6.9419,
        "longitude": -46.0819,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104206,
        "nome": "Fortuna",
        "latitude": -5.6344,
        "longitude": -44.0146,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104305,
        "nome": "Godofredo Viana",
        "latitude": -1.3771,
        "longitude": -45.7663,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104404,
        "nome": "Gonçalves Dias",
        "latitude": -5.1523,
        "longitude": -44.172,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104503,
        "nome": "Governador Archer",
        "latitude": -4.9995,
        "longitude": -44.2215,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104552,
        "nome": "Governador Edison Lobão",
        "latitude": -5.7185,
        "longitude": -47.3248,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104602,
        "nome": "Governador Eugênio Barros",
        "latitude": -5.3668,
        "longitude": -44.0959,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104628,
        "nome": "Governador Luiz Rocha",
        "latitude": -5.5283,
        "longitude": -44.0902,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104651,
        "nome": "Governador Newton Bello",
        "latitude": -3.4191,
        "longitude": -45.9259,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104677,
        "nome": "Governador Nunes Freire",
        "latitude": -2.0623,
        "longitude": -45.8212,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104701,
        "nome": "Graça Aranha",
        "latitude": -5.4148,
        "longitude": -44.3181,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104800,
        "nome": "Grajaú",
        "latitude": -5.8402,
        "longitude": -46.0149,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2104909,
        "nome": "Guimarães",
        "latitude": -2.1464,
        "longitude": -44.6628,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105005,
        "nome": "Humberto de Campos",
        "latitude": -2.721,
        "longitude": -43.5628,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105104,
        "nome": "Icatu",
        "latitude": -2.6533,
        "longitude": -43.863,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105153,
        "nome": "Igarapé do Meio",
        "latitude": -3.6565,
        "longitude": -45.1239,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105203,
        "nome": "Igarapé Grande",
        "latitude": -4.5921,
        "longitude": -44.8262,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105302,
        "nome": "Imperatriz",
        "latitude": -5.3398,
        "longitude": -47.5752,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105351,
        "nome": "Itaipava do Grajaú",
        "latitude": -5.1851,
        "longitude": -45.6781,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105401,
        "nome": "Itapecuru Mirim",
        "latitude": -3.3873,
        "longitude": -44.2777,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105427,
        "nome": "Itinga do Maranhão",
        "latitude": -4.2713,
        "longitude": -47.2605,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105450,
        "nome": "Jatobá",
        "latitude": -5.8522,
        "longitude": -44.294,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105476,
        "nome": "Jenipapo dos Vieiras",
        "latitude": -5.3924,
        "longitude": -45.5758,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105500,
        "nome": "João Lisboa",
        "latitude": -5.2295,
        "longitude": -47.1268,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105609,
        "nome": "Joselândia",
        "latitude": -5.016,
        "longitude": -44.7556,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105658,
        "nome": "Junco do Maranhão",
        "latitude": -1.9185,
        "longitude": -46.1179,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105708,
        "nome": "Lago da Pedra",
        "latitude": -4.739,
        "longitude": -45.2053,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105807,
        "nome": "Lago do Junco",
        "latitude": -4.5226,
        "longitude": -44.9766,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105906,
        "nome": "Lago Verde",
        "latitude": -3.9895,
        "longitude": -44.8821,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105922,
        "nome": "Lagoa do Mato",
        "latitude": -6.0322,
        "longitude": -43.4956,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105948,
        "nome": "Lago dos Rodrigues",
        "latitude": -4.5886,
        "longitude": -44.9309,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105963,
        "nome": "Lagoa Grande do Maranhão",
        "latitude": -4.9297,
        "longitude": -45.403,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2105989,
        "nome": "Lajeado Novo",
        "latitude": -6.1035,
        "longitude": -46.9295,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106003,
        "nome": "Lima Campos",
        "latitude": -4.5569,
        "longitude": -44.4647,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106102,
        "nome": "Loreto",
        "latitude": -7.2208,
        "longitude": -45.2198,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106201,
        "nome": "Luís Domingues",
        "latitude": -1.3901,
        "longitude": -45.8917,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106300,
        "nome": "Magalhães de Almeida",
        "latitude": -3.2994,
        "longitude": -42.1835,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106326,
        "nome": "Maracaçumé",
        "latitude": -1.9843,
        "longitude": -45.994,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106359,
        "nome": "Marajá do Sena",
        "latitude": -4.705,
        "longitude": -45.6285,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106375,
        "nome": "Maranhãozinho",
        "latitude": -2.4109,
        "longitude": -45.9484,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106409,
        "nome": "Mata Roma",
        "latitude": -3.6259,
        "longitude": -43.2274,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106508,
        "nome": "Matinha",
        "latitude": -3.0714,
        "longitude": -45.0018,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106607,
        "nome": "Matões",
        "latitude": -5.3887,
        "longitude": -43.3072,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106631,
        "nome": "Matões do Norte",
        "latitude": -3.7566,
        "longitude": -44.4777,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106672,
        "nome": "Milagres do Maranhão",
        "latitude": -3.4965,
        "longitude": -42.7949,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106706,
        "nome": "Mirador",
        "latitude": -6.4539,
        "longitude": -44.9511,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106755,
        "nome": "Miranda do Norte",
        "latitude": -3.5314,
        "longitude": -44.5269,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106805,
        "nome": "Mirinzal",
        "latitude": -2.0587,
        "longitude": -44.8433,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2106904,
        "nome": "Monção",
        "latitude": -3.4907,
        "longitude": -45.3211,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2107001,
        "nome": "Montes Altos",
        "latitude": -5.8579,
        "longitude": -47.0415,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2107100,
        "nome": "Morros",
        "latitude": -2.9741,
        "longitude": -43.7767,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2107209,
        "nome": "Nina Rodrigues",
        "latitude": -3.4288,
        "longitude": -43.8129,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2107258,
        "nome": "Nova Colinas",
        "latitude": -7.1443,
        "longitude": -46.2645,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2107308,
        "nome": "Nova Iorque",
        "latitude": -6.75,
        "longitude": -44.04,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2107357,
        "nome": "Nova Olinda do Maranhão",
        "latitude": -2.896,
        "longitude": -45.9553,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2107407,
        "nome": "Olho d'Água das Cunhãs",
        "latitude": -4.0946,
        "longitude": -45.1203,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2107456,
        "nome": "Olinda Nova do Maranhão",
        "latitude": -2.9756,
        "longitude": -45.0089,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2107506,
        "nome": "Paço do Lumiar",
        "latitude": -2.5052,
        "longitude": -44.1241,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2107605,
        "nome": "Palmeirândia",
        "latitude": -2.692,
        "longitude": -45.0234,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2107704,
        "nome": "Paraibano",
        "latitude": -6.4038,
        "longitude": -43.924,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2107803,
        "nome": "Parnarama",
        "latitude": -5.6378,
        "longitude": -43.463,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2107902,
        "nome": "Passagem Franca",
        "latitude": -6.1527,
        "longitude": -43.7584,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2108009,
        "nome": "Pastos Bons",
        "latitude": -6.6322,
        "longitude": -44.1806,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2108058,
        "nome": "Paulino Neves",
        "latitude": -2.8547,
        "longitude": -42.6109,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2108108,
        "nome": "Paulo Ramos",
        "latitude": -4.5219,
        "longitude": -45.3944,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2108207,
        "nome": "Pedreiras",
        "latitude": -4.6178,
        "longitude": -44.5813,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2108256,
        "nome": "Pedro do Rosário",
        "latitude": -2.989,
        "longitude": -45.4308,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2108306,
        "nome": "Penalva",
        "latitude": -3.2516,
        "longitude": -45.2978,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2108405,
        "nome": "Peri Mirim",
        "latitude": -2.5706,
        "longitude": -44.8958,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2108454,
        "nome": "Peritoró",
        "latitude": -4.4198,
        "longitude": -44.2812,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2108504,
        "nome": "Pindaré-Mirim",
        "latitude": -3.6933,
        "longitude": -45.4402,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2108603,
        "nome": "Pinheiro",
        "latitude": -2.4981,
        "longitude": -45.1269,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2108702,
        "nome": "Pio XII",
        "latitude": -3.8515,
        "longitude": -45.0931,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2108801,
        "nome": "Pirapemas",
        "latitude": -3.7829,
        "longitude": -44.1726,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2108900,
        "nome": "Poção de Pedras",
        "latitude": -4.7868,
        "longitude": -44.9118,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109007,
        "nome": "Porto Franco",
        "latitude": -6.3688,
        "longitude": -47.18,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109056,
        "nome": "Porto Rico do Maranhão",
        "latitude": -1.8839,
        "longitude": -44.6331,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109106,
        "nome": "Presidente Dutra",
        "latitude": -5.2831,
        "longitude": -44.4571,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109205,
        "nome": "Presidente Juscelino",
        "latitude": -3.0897,
        "longitude": -44.0779,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109239,
        "nome": "Presidente Médici",
        "latitude": -2.319,
        "longitude": -45.7734,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109270,
        "nome": "Presidente Sarney",
        "latitude": -2.5867,
        "longitude": -45.3615,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109304,
        "nome": "Presidente Vargas",
        "latitude": -3.3461,
        "longitude": -43.9559,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109403,
        "nome": "Primeira Cruz",
        "latitude": -2.7092,
        "longitude": -43.3628,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109452,
        "nome": "Raposa",
        "latitude": -2.4376,
        "longitude": -44.0897,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109502,
        "nome": "Riachão",
        "latitude": -7.5979,
        "longitude": -46.6594,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109551,
        "nome": "Ribamar Fiquene",
        "latitude": -5.9584,
        "longitude": -47.3161,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109601,
        "nome": "Rosário",
        "latitude": -2.9563,
        "longitude": -44.2019,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109700,
        "nome": "Sambaíba",
        "latitude": -7.4318,
        "longitude": -45.5562,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109759,
        "nome": "Santa Filomena do Maranhão",
        "latitude": -5.519,
        "longitude": -44.6185,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109809,
        "nome": "Santa Helena",
        "latitude": -2.419,
        "longitude": -45.3711,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2109908,
        "nome": "Santa Inês",
        "latitude": -3.8735,
        "longitude": -45.4368,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110005,
        "nome": "Santa Luzia",
        "latitude": -4.2699,
        "longitude": -45.9316,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110039,
        "nome": "Santa Luzia do Paruá",
        "latitude": -2.5399,
        "longitude": -45.7723,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110104,
        "nome": "Santa Quitéria do Maranhão",
        "latitude": -3.3452,
        "longitude": -42.88,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110203,
        "nome": "Santa Rita",
        "latitude": -3.1595,
        "longitude": -44.3287,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110237,
        "nome": "Santana do Maranhão",
        "latitude": -3.1972,
        "longitude": -42.6147,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110278,
        "nome": "Santo Amaro do Maranhão",
        "latitude": -2.6232,
        "longitude": -43.1841,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110302,
        "nome": "Santo Antônio dos Lopes",
        "latitude": -4.8264,
        "longitude": -44.4812,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110401,
        "nome": "São Benedito do Rio Preto",
        "latitude": -3.3753,
        "longitude": -43.6185,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110500,
        "nome": "São Bento",
        "latitude": -2.7981,
        "longitude": -44.9993,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110609,
        "nome": "São Bernardo",
        "latitude": -3.312,
        "longitude": -42.4061,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110658,
        "nome": "São Domingos do Azeitão",
        "latitude": -6.8332,
        "longitude": -44.6174,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110708,
        "nome": "São Domingos do Maranhão",
        "latitude": -5.6382,
        "longitude": -44.3366,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110807,
        "nome": "São Félix de Balsas",
        "latitude": -7.0918,
        "longitude": -44.8835,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110856,
        "nome": "São Francisco do Brejão",
        "latitude": -5.1585,
        "longitude": -47.3537,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2110906,
        "nome": "São Francisco do Maranhão",
        "latitude": -6.2087,
        "longitude": -43.1139,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111003,
        "nome": "São João Batista",
        "latitude": -3.006,
        "longitude": -44.7646,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111029,
        "nome": "São João do Carú",
        "latitude": -3.5108,
        "longitude": -46.3791,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111052,
        "nome": "São João do Paraíso",
        "latitude": -6.4634,
        "longitude": -46.9004,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111078,
        "nome": "São João do Soter",
        "latitude": -5.0402,
        "longitude": -43.7666,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111102,
        "nome": "São João dos Patos",
        "latitude": -6.5594,
        "longitude": -43.6381,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111201,
        "nome": "São José de Ribamar",
        "latitude": -2.5743,
        "longitude": -44.1305,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111250,
        "nome": "São José dos Basílios",
        "latitude": -5.0398,
        "longitude": -44.5684,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111300,
        "nome": "São Luís",
        "latitude": -2.6339,
        "longitude": -44.2807,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111409,
        "nome": "São Luís Gonzaga do Maranhão",
        "latitude": -4.3774,
        "longitude": -44.6231,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111508,
        "nome": "São Mateus do Maranhão",
        "latitude": -3.9902,
        "longitude": -44.5277,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111532,
        "nome": "São Pedro da Água Branca",
        "latitude": -5.1335,
        "longitude": -48.369,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111573,
        "nome": "São Pedro dos Crentes",
        "latitude": -6.8195,
        "longitude": -46.7073,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111607,
        "nome": "São Raimundo das Mangabeiras",
        "latitude": -7.0139,
        "longitude": -45.6909,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111631,
        "nome": "São Raimundo do Doca Bezerra",
        "latitude": -5.0897,
        "longitude": -45.1462,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111672,
        "nome": "São Roberto",
        "latitude": -5.0188,
        "longitude": -45.0347,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111706,
        "nome": "São Vicente Ferrer",
        "latitude": -2.8772,
        "longitude": -44.9415,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111722,
        "nome": "Satubinha",
        "latitude": -3.9386,
        "longitude": -45.2592,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111748,
        "nome": "Senador Alexandre Costa",
        "latitude": -5.261,
        "longitude": -43.9847,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111763,
        "nome": "Senador La Rocque",
        "latitude": -5.3887,
        "longitude": -47.1447,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111789,
        "nome": "Serrano do Maranhão",
        "latitude": -1.871,
        "longitude": -45.0175,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111805,
        "nome": "Sítio Novo",
        "latitude": -6.2279,
        "longitude": -46.5956,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111904,
        "nome": "Sucupira do Norte",
        "latitude": -6.5099,
        "longitude": -44.339,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2111953,
        "nome": "Sucupira do Riachão",
        "latitude": -6.4068,
        "longitude": -43.4852,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112001,
        "nome": "Tasso Fragoso",
        "latitude": -8.332,
        "longitude": -45.8863,
        "mesorregiaoNome": "Sul Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112100,
        "nome": "Timbiras",
        "latitude": -4.153,
        "longitude": -43.8135,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112209,
        "nome": "Timon",
        "latitude": -5.1856,
        "longitude": -42.9811,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112233,
        "nome": "Trizidela do Vale",
        "latitude": -4.5393,
        "longitude": -44.6818,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112274,
        "nome": "Tufilândia",
        "latitude": -3.7581,
        "longitude": -45.5813,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112308,
        "nome": "Tuntum",
        "latitude": -5.6104,
        "longitude": -44.7306,
        "mesorregiaoNome": "Centro Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112407,
        "nome": "Turiaçu",
        "latitude": -1.7657,
        "longitude": -45.4631,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112456,
        "nome": "Turilândia",
        "latitude": -2.1589,
        "longitude": -45.4375,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112506,
        "nome": "Tutóia",
        "latitude": -2.9231,
        "longitude": -42.3906,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112605,
        "nome": "Urbano Santos",
        "latitude": -3.2601,
        "longitude": -43.2808,
        "mesorregiaoNome": "Leste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112704,
        "nome": "Vargem Grande",
        "latitude": -3.7109,
        "longitude": -43.8538,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112803,
        "nome": "Viana",
        "latitude": -3.1563,
        "longitude": -45.0025,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112852,
        "nome": "Vila Nova dos Martírios",
        "latitude": -5.0748,
        "longitude": -48.0805,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2112902,
        "nome": "Vitória do Mearim",
        "latitude": -3.5679,
        "longitude": -44.9221,
        "mesorregiaoNome": "Norte Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2113009,
        "nome": "Vitorino Freire",
        "latitude": -4.2437,
        "longitude": -45.3125,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2114007,
        "nome": "Zé Doca",
        "latitude": -3.2599,
        "longitude": -45.9126,
        "mesorregiaoNome": "Oeste Maranhense",
        "UFSigla": "MA",
        "UFNome": "Maranhão"
    },
    {
        "ibgeId": 2200053,
        "nome": "Acauã",
        "latitude": -8.306,
        "longitude": -41.0017,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2200103,
        "nome": "Agricolândia",
        "latitude": -5.7682,
        "longitude": -42.6824,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2200202,
        "nome": "Água Branca",
        "latitude": -5.9141,
        "longitude": -42.6281,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2200251,
        "nome": "Alagoinha do Piauí",
        "latitude": -6.9293,
        "longitude": -40.9197,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2200277,
        "nome": "Alegrete do Piauí",
        "latitude": -7.2005,
        "longitude": -40.7975,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2200301,
        "nome": "Alto Longá",
        "latitude": -5.3794,
        "longitude": -42.1547,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2200400,
        "nome": "Altos",
        "latitude": -5.0148,
        "longitude": -42.4697,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2200459,
        "nome": "Alvorada do Gurguéia",
        "latitude": -8.456,
        "longitude": -43.9684,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2200509,
        "nome": "Amarante",
        "latitude": -6.3703,
        "longitude": -42.7878,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2200608,
        "nome": "Angical do Piauí",
        "latitude": -6.1069,
        "longitude": -42.7504,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2200707,
        "nome": "Anísio de Abreu",
        "latitude": -9.2141,
        "longitude": -43.042,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2200806,
        "nome": "Antônio Almeida",
        "latitude": -7.2194,
        "longitude": -44.2027,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2200905,
        "nome": "Aroazes",
        "latitude": -6.1245,
        "longitude": -41.8303,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2200954,
        "nome": "Aroeiras do Itaim",
        "latitude": -7.2503,
        "longitude": -41.5343,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201002,
        "nome": "Arraial",
        "latitude": -6.6181,
        "longitude": -42.5203,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201051,
        "nome": "Assunção do Piauí",
        "latitude": -5.88,
        "longitude": -41.0688,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201101,
        "nome": "Avelino Lopes",
        "latitude": -10.1797,
        "longitude": -43.9424,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201150,
        "nome": "Baixa Grande do Ribeiro",
        "latitude": -8.5058,
        "longitude": -45.161,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201176,
        "nome": "Barra D'Alcântara",
        "latitude": -6.5296,
        "longitude": -42.1065,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201200,
        "nome": "Barras",
        "latitude": -4.1899,
        "longitude": -42.3681,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201309,
        "nome": "Barreiras do Piauí",
        "latitude": -10.0035,
        "longitude": -45.7104,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201408,
        "nome": "Barro Duro",
        "latitude": -5.8019,
        "longitude": -42.5028,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201507,
        "nome": "Batalha",
        "latitude": -4.0176,
        "longitude": -42.0579,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201556,
        "nome": "Bela Vista do Piauí",
        "latitude": -7.9961,
        "longitude": -41.8557,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201572,
        "nome": "Belém do Piauí",
        "latitude": -7.39,
        "longitude": -40.9824,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201606,
        "nome": "Beneditinos",
        "latitude": -5.4994,
        "longitude": -42.3999,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201705,
        "nome": "Bertolínia",
        "latitude": -7.745,
        "longitude": -43.8772,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201739,
        "nome": "Betânia do Piauí",
        "latitude": -8.1135,
        "longitude": -40.7512,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201770,
        "nome": "Boa Hora",
        "latitude": -4.3542,
        "longitude": -42.106,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201804,
        "nome": "Bocaina",
        "latitude": -6.906,
        "longitude": -41.3042,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201903,
        "nome": "Bom Jesus",
        "latitude": -9.2457,
        "longitude": -44.5402,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201919,
        "nome": "Bom Princípio do Piauí",
        "latitude": -3.1574,
        "longitude": -41.6306,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201929,
        "nome": "Bonfim do Piauí",
        "latitude": -9.1714,
        "longitude": -42.8758,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201945,
        "nome": "Boqueirão do Piauí",
        "latitude": -4.5402,
        "longitude": -42.1115,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201960,
        "nome": "Brasileira",
        "latitude": -4.1208,
        "longitude": -41.6366,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2201988,
        "nome": "Brejo do Piauí",
        "latitude": -8.3824,
        "longitude": -42.7909,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202000,
        "nome": "Buriti dos Lopes",
        "latitude": -3.2392,
        "longitude": -41.8042,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202026,
        "nome": "Buriti dos Montes",
        "latitude": -5.1623,
        "longitude": -41.1999,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202059,
        "nome": "Cabeceiras do Piauí",
        "latitude": -4.432,
        "longitude": -42.3337,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202075,
        "nome": "Cajazeiras do Piauí",
        "latitude": -6.7819,
        "longitude": -42.4593,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202083,
        "nome": "Cajueiro da Praia",
        "latitude": -2.9927,
        "longitude": -41.3616,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202091,
        "nome": "Caldeirão Grande do Piauí",
        "latitude": -7.308,
        "longitude": -40.6228,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202109,
        "nome": "Campinas do Piauí",
        "latitude": -7.6565,
        "longitude": -41.8714,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202117,
        "nome": "Campo Alegre do Fidalgo",
        "latitude": -8.2828,
        "longitude": -41.8215,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202133,
        "nome": "Campo Grande do Piauí",
        "latitude": -7.1832,
        "longitude": -41.0653,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202174,
        "nome": "Campo Largo do Piauí",
        "latitude": -3.881,
        "longitude": -42.546,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202208,
        "nome": "Campo Maior",
        "latitude": -4.877,
        "longitude": -42.145,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202251,
        "nome": "Canavieira",
        "latitude": -7.5577,
        "longitude": -43.5586,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202307,
        "nome": "Canto do Buriti",
        "latitude": -8.3426,
        "longitude": -43.3376,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202406,
        "nome": "Capitão de Campos",
        "latitude": -4.5227,
        "longitude": -41.9011,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202455,
        "nome": "Capitão Gervásio Oliveira",
        "latitude": -8.5293,
        "longitude": -41.9012,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202505,
        "nome": "Caracol",
        "latitude": -9.0891,
        "longitude": -43.3467,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202539,
        "nome": "Caraúbas do Piauí",
        "latitude": -3.5648,
        "longitude": -41.8243,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202554,
        "nome": "Caridade do Piauí",
        "latitude": -7.7036,
        "longitude": -40.9558,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202604,
        "nome": "Castelo do Piauí",
        "latitude": -5.3266,
        "longitude": -41.567,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202653,
        "nome": "Caxingó",
        "latitude": -3.3919,
        "longitude": -41.8506,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202703,
        "nome": "Cocal",
        "latitude": -3.4537,
        "longitude": -41.5423,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202711,
        "nome": "Cocal de Telha",
        "latitude": -4.6168,
        "longitude": -41.9576,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202729,
        "nome": "Cocal dos Alves",
        "latitude": -3.6303,
        "longitude": -41.4208,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202737,
        "nome": "Coivaras",
        "latitude": -5.0999,
        "longitude": -42.2843,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202752,
        "nome": "Colônia do Gurguéia",
        "latitude": -8.1813,
        "longitude": -43.6962,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202778,
        "nome": "Colônia do Piauí",
        "latitude": -7.2939,
        "longitude": -42.187,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202802,
        "nome": "Conceição do Canindé",
        "latitude": -7.9146,
        "longitude": -41.5809,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202851,
        "nome": "Coronel José Dias",
        "latitude": -8.8973,
        "longitude": -42.3342,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2202901,
        "nome": "Corrente",
        "latitude": -10.3916,
        "longitude": -45.1397,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203008,
        "nome": "Cristalândia do Piauí",
        "latitude": -10.7419,
        "longitude": -45.1136,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203107,
        "nome": "Cristino Castro",
        "latitude": -8.7822,
        "longitude": -43.9615,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203206,
        "nome": "Curimatá",
        "latitude": -9.9407,
        "longitude": -44.3065,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203230,
        "nome": "Currais",
        "latitude": -8.8225,
        "longitude": -44.6733,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203255,
        "nome": "Curralinhos",
        "latitude": -5.6161,
        "longitude": -42.8467,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203271,
        "nome": "Curral Novo do Piauí",
        "latitude": -7.8877,
        "longitude": -40.7709,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203305,
        "nome": "Demerval Lobão",
        "latitude": -5.3393,
        "longitude": -42.6716,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203354,
        "nome": "Dirceu Arcoverde",
        "latitude": -9.3298,
        "longitude": -42.4601,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203404,
        "nome": "Dom Expedito Lopes",
        "latitude": -6.9601,
        "longitude": -41.6983,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203420,
        "nome": "Domingos Mourão",
        "latitude": -4.2552,
        "longitude": -41.3099,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203453,
        "nome": "Dom Inocêncio",
        "latitude": -8.9179,
        "longitude": -41.9225,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203503,
        "nome": "Elesbão Veloso",
        "latitude": -6.1848,
        "longitude": -42.1935,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203602,
        "nome": "Eliseu Martins",
        "latitude": -7.9702,
        "longitude": -43.6593,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203701,
        "nome": "Esperantina",
        "latitude": -3.8234,
        "longitude": -42.1897,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203750,
        "nome": "Fartura do Piauí",
        "latitude": -9.4757,
        "longitude": -42.784,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203800,
        "nome": "Flores do Piauí",
        "latitude": -7.673,
        "longitude": -42.8609,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203859,
        "nome": "Floresta do Piauí",
        "latitude": -7.4731,
        "longitude": -41.8044,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2203909,
        "nome": "Floriano",
        "latitude": -7.0058,
        "longitude": -43.0794,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204006,
        "nome": "Francinópolis",
        "latitude": -6.423,
        "longitude": -42.234,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204105,
        "nome": "Francisco Ayres",
        "latitude": -6.6692,
        "longitude": -42.7215,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204154,
        "nome": "Francisco Macedo",
        "latitude": -7.3208,
        "longitude": -40.7839,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204204,
        "nome": "Francisco Santos",
        "latitude": -7.0129,
        "longitude": -41.1471,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204303,
        "nome": "Fronteiras",
        "latitude": -7.0772,
        "longitude": -40.5837,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204352,
        "nome": "Geminiano",
        "latitude": -7.1877,
        "longitude": -41.3329,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204402,
        "nome": "Gilbués",
        "latitude": -9.6219,
        "longitude": -45.4078,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204501,
        "nome": "Guadalupe",
        "latitude": -6.8424,
        "longitude": -43.7047,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204550,
        "nome": "Guaribas",
        "latitude": -9.0633,
        "longitude": -43.6709,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204600,
        "nome": "Hugo Napoleão",
        "latitude": -6.0357,
        "longitude": -42.4981,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204659,
        "nome": "Ilha Grande",
        "latitude": -2.8289,
        "longitude": -41.8142,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204709,
        "nome": "Inhuma",
        "latitude": -6.6727,
        "longitude": -41.686,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204808,
        "nome": "Ipiranga do Piauí",
        "latitude": -6.819,
        "longitude": -41.791,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2204907,
        "nome": "Isaías Coelho",
        "latitude": -7.6503,
        "longitude": -41.6498,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205003,
        "nome": "Itainópolis",
        "latitude": -7.4101,
        "longitude": -41.4815,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205102,
        "nome": "Itaueira",
        "latitude": -7.505,
        "longitude": -43.1337,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205151,
        "nome": "Jacobina do Piauí",
        "latitude": -7.8967,
        "longitude": -41.2525,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205201,
        "nome": "Jaicós",
        "latitude": -7.3915,
        "longitude": -41.2067,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205250,
        "nome": "Jardim do Mulato",
        "latitude": -6.1458,
        "longitude": -42.527,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205276,
        "nome": "Jatobá do Piauí",
        "latitude": -4.8415,
        "longitude": -41.9183,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205300,
        "nome": "Jerumenha",
        "latitude": -7.115,
        "longitude": -43.5016,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205359,
        "nome": "João Costa",
        "latitude": -8.5417,
        "longitude": -42.4817,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205409,
        "nome": "Joaquim Pires",
        "latitude": -3.5396,
        "longitude": -42.0825,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205458,
        "nome": "Joca Marques",
        "latitude": -3.5457,
        "longitude": -42.4261,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205508,
        "nome": "José de Freitas",
        "latitude": -4.7139,
        "longitude": -42.5249,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205516,
        "nome": "Juazeiro do Piauí",
        "latitude": -4.9583,
        "longitude": -41.5896,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205524,
        "nome": "Júlio Borges",
        "latitude": -10.4254,
        "longitude": -44.1746,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205532,
        "nome": "Jurema",
        "latitude": -9.0145,
        "longitude": -43.1656,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205540,
        "nome": "Lagoinha do Piauí",
        "latitude": -5.8201,
        "longitude": -42.6274,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205557,
        "nome": "Lagoa Alegre",
        "latitude": -4.4898,
        "longitude": -42.5649,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205565,
        "nome": "Lagoa do Barro do Piauí",
        "latitude": -8.5685,
        "longitude": -41.5998,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205573,
        "nome": "Lagoa de São Francisco",
        "latitude": -4.364,
        "longitude": -41.5814,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205581,
        "nome": "Lagoa do Piauí",
        "latitude": -5.4613,
        "longitude": -42.6076,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205599,
        "nome": "Lagoa do Sítio",
        "latitude": -6.4901,
        "longitude": -41.4864,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205607,
        "nome": "Landri Sales",
        "latitude": -7.2958,
        "longitude": -43.9278,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205706,
        "nome": "Luís Correia",
        "latitude": -3.0822,
        "longitude": -41.4817,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205805,
        "nome": "Luzilândia",
        "latitude": -3.6068,
        "longitude": -42.3639,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205854,
        "nome": "Madeiro",
        "latitude": -3.565,
        "longitude": -42.5292,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205904,
        "nome": "Manoel Emídio",
        "latitude": -8.2063,
        "longitude": -44.0077,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2205953,
        "nome": "Marcolândia",
        "latitude": -7.4295,
        "longitude": -40.7361,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206001,
        "nome": "Marcos Parente",
        "latitude": -7.0763,
        "longitude": -43.8946,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206050,
        "nome": "Massapê do Piauí",
        "latitude": -7.5358,
        "longitude": -41.0954,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206100,
        "nome": "Matias Olímpio",
        "latitude": -3.7074,
        "longitude": -42.5844,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206209,
        "nome": "Miguel Alves",
        "latitude": -4.2405,
        "longitude": -42.7736,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206308,
        "nome": "Miguel Leão",
        "latitude": -5.701,
        "longitude": -42.7013,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206357,
        "nome": "Milton Brandão",
        "latitude": -4.6988,
        "longitude": -41.49,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206407,
        "nome": "Monsenhor Gil",
        "latitude": -5.611,
        "longitude": -42.6097,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206506,
        "nome": "Monsenhor Hipólito",
        "latitude": -6.9185,
        "longitude": -41.038,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206605,
        "nome": "Monte Alegre do Piauí",
        "latitude": -9.6042,
        "longitude": -45.0304,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206654,
        "nome": "Morro Cabeça no Tempo",
        "latitude": -9.8111,
        "longitude": -43.9221,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206670,
        "nome": "Morro do Chapéu do Piauí",
        "latitude": -3.7056,
        "longitude": -42.2635,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206696,
        "nome": "Murici dos Portelas",
        "latitude": -3.3567,
        "longitude": -42.0124,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206704,
        "nome": "Nazaré do Piauí",
        "latitude": -7.0523,
        "longitude": -42.7456,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206720,
        "nome": "Nazária",
        "latitude": -5.4455,
        "longitude": -42.8678,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206753,
        "nome": "Nossa Senhora de Nazaré",
        "latitude": -4.6436,
        "longitude": -42.1889,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206803,
        "nome": "Nossa Senhora dos Remédios",
        "latitude": -4.0262,
        "longitude": -42.6061,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206902,
        "nome": "Novo Oriente do Piauí",
        "latitude": -6.5011,
        "longitude": -41.9769,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2206951,
        "nome": "Novo Santo Antônio",
        "latitude": -5.2786,
        "longitude": -41.9227,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207009,
        "nome": "Oeiras",
        "latitude": -6.9663,
        "longitude": -42.165,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207108,
        "nome": "Olho D'Água do Piauí",
        "latitude": -5.8577,
        "longitude": -42.5521,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207207,
        "nome": "Padre Marcos",
        "latitude": -7.3778,
        "longitude": -40.881,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207306,
        "nome": "Paes Landim",
        "latitude": -7.8127,
        "longitude": -42.2852,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207355,
        "nome": "Pajeú do Piauí",
        "latitude": -7.904,
        "longitude": -42.8335,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207405,
        "nome": "Palmeira do Piauí",
        "latitude": -8.5568,
        "longitude": -44.4645,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207504,
        "nome": "Palmeirais",
        "latitude": -5.8833,
        "longitude": -42.9558,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207553,
        "nome": "Paquetá",
        "latitude": -7.1315,
        "longitude": -41.6856,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207603,
        "nome": "Parnaguá",
        "latitude": -10.3157,
        "longitude": -44.5684,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207702,
        "nome": "Parnaíba",
        "latitude": -2.9592,
        "longitude": -41.7534,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207751,
        "nome": "Passagem Franca do Piauí",
        "latitude": -5.873,
        "longitude": -42.4133,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207777,
        "nome": "Patos do Piauí",
        "latitude": -7.6738,
        "longitude": -41.2961,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207793,
        "nome": "Pau D'Arco do Piauí",
        "latitude": -5.245,
        "longitude": -42.4709,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207801,
        "nome": "Paulistana",
        "latitude": -8.1104,
        "longitude": -41.145,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207850,
        "nome": "Pavussu",
        "latitude": -7.9253,
        "longitude": -43.3372,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207900,
        "nome": "Pedro II",
        "latitude": -4.4954,
        "longitude": -41.397,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207934,
        "nome": "Pedro Laurentino",
        "latitude": -8.0732,
        "longitude": -42.2653,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2207959,
        "nome": "Nova Santa Rita",
        "latitude": -8.1195,
        "longitude": -42.0237,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208007,
        "nome": "Picos",
        "latitude": -7.0589,
        "longitude": -41.5223,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208106,
        "nome": "Pimenteiras",
        "latitude": -6.3447,
        "longitude": -41.1664,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208205,
        "nome": "Pio IX",
        "latitude": -6.7903,
        "longitude": -40.7181,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208304,
        "nome": "Piracuruca",
        "latitude": -3.8536,
        "longitude": -41.6145,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208403,
        "nome": "Piripiri",
        "latitude": -4.331,
        "longitude": -41.7714,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208502,
        "nome": "Porto",
        "latitude": -3.95,
        "longitude": -42.7076,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208551,
        "nome": "Porto Alegre do Piauí",
        "latitude": -6.9563,
        "longitude": -44.0572,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208601,
        "nome": "Prata do Piauí",
        "latitude": -5.7253,
        "longitude": -42.1666,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208650,
        "nome": "Queimada Nova",
        "latitude": -8.5161,
        "longitude": -41.351,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208700,
        "nome": "Redenção do Gurguéia",
        "latitude": -9.5244,
        "longitude": -44.4549,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208809,
        "nome": "Regeneração",
        "latitude": -6.3525,
        "longitude": -42.4905,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208858,
        "nome": "Riacho Frio",
        "latitude": -9.9306,
        "longitude": -44.8129,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208874,
        "nome": "Ribeira do Piauí",
        "latitude": -7.9278,
        "longitude": -42.6136,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2208908,
        "nome": "Ribeiro Gonçalves",
        "latitude": -7.9742,
        "longitude": -45.3456,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209005,
        "nome": "Rio Grande do Piauí",
        "latitude": -7.7711,
        "longitude": -43.1522,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209104,
        "nome": "Santa Cruz do Piauí",
        "latitude": -7.2371,
        "longitude": -41.7745,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209153,
        "nome": "Santa Cruz dos Milagres",
        "latitude": -5.908,
        "longitude": -41.8686,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209203,
        "nome": "Santa Filomena",
        "latitude": -8.9905,
        "longitude": -45.6756,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209302,
        "nome": "Santa Luz",
        "latitude": -9.0452,
        "longitude": -44.1054,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209351,
        "nome": "Santana do Piauí",
        "latitude": -6.9407,
        "longitude": -41.4951,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209377,
        "nome": "Santa Rosa do Piauí",
        "latitude": -6.8094,
        "longitude": -42.2275,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209401,
        "nome": "Santo Antônio de Lisboa",
        "latitude": -6.9068,
        "longitude": -41.2074,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209450,
        "nome": "Santo Antônio dos Milagres",
        "latitude": -6.0501,
        "longitude": -42.7027,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209500,
        "nome": "Santo Inácio do Piauí",
        "latitude": -7.4582,
        "longitude": -42.0143,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209559,
        "nome": "São Braz do Piauí",
        "latitude": -8.9628,
        "longitude": -43.0079,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209609,
        "nome": "São Félix do Piauí",
        "latitude": -5.9356,
        "longitude": -42.1029,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209658,
        "nome": "São Francisco de Assis do Piauí",
        "latitude": -8.1934,
        "longitude": -41.5835,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209708,
        "nome": "São Francisco do Piauí",
        "latitude": -7.1986,
        "longitude": -42.501,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209757,
        "nome": "São Gonçalo do Gurguéia",
        "latitude": -10.0883,
        "longitude": -45.3217,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209807,
        "nome": "São Gonçalo do Piauí",
        "latitude": -6.0028,
        "longitude": -42.6522,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209856,
        "nome": "São João da Canabrava",
        "latitude": -6.6919,
        "longitude": -41.3916,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209872,
        "nome": "São João da Fronteira",
        "latitude": -3.9923,
        "longitude": -41.2838,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209906,
        "nome": "São João da Serra",
        "latitude": -5.5425,
        "longitude": -41.8778,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209955,
        "nome": "São João da Varjota",
        "latitude": -6.9565,
        "longitude": -41.8822,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2209971,
        "nome": "São João do Arraial",
        "latitude": -3.8189,
        "longitude": -42.4494,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210003,
        "nome": "São João do Piauí",
        "latitude": -8.3204,
        "longitude": -42.2574,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210052,
        "nome": "São José do Divino",
        "latitude": -3.7745,
        "longitude": -41.861,
        "mesorregiaoNome": "Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210102,
        "nome": "São José do Peixe",
        "latitude": -7.4824,
        "longitude": -42.5823,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210201,
        "nome": "São José do Piauí",
        "latitude": -6.815,
        "longitude": -41.491,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210300,
        "nome": "São Julião",
        "latitude": -7.0816,
        "longitude": -40.8206,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210359,
        "nome": "São Lourenço do Piauí",
        "latitude": -9.1717,
        "longitude": -42.5355,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210375,
        "nome": "São Luis do Piauí",
        "latitude": -6.7645,
        "longitude": -41.2634,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210383,
        "nome": "São Miguel da Baixa Grande",
        "latitude": -5.8188,
        "longitude": -42.273,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210391,
        "nome": "São Miguel do Fidalgo",
        "latitude": -7.5968,
        "longitude": -42.3327,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210409,
        "nome": "São Miguel do Tapuio",
        "latitude": -5.741,
        "longitude": -41.4398,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210508,
        "nome": "São Pedro do Piauí",
        "latitude": -5.8182,
        "longitude": -42.7866,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210607,
        "nome": "São Raimundo Nonato",
        "latitude": -8.9657,
        "longitude": -42.7156,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210623,
        "nome": "Sebastião Barros",
        "latitude": -10.6544,
        "longitude": -44.8334,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210631,
        "nome": "Sebastião Leal",
        "latitude": -7.745,
        "longitude": -44.0926,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210656,
        "nome": "Sigefredo Pacheco",
        "latitude": -4.9756,
        "longitude": -41.8051,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210706,
        "nome": "Simões",
        "latitude": -7.671,
        "longitude": -40.7417,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210805,
        "nome": "Simplício Mendes",
        "latitude": -7.7989,
        "longitude": -42.0214,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210904,
        "nome": "Socorro do Piauí",
        "latitude": -7.8967,
        "longitude": -42.4764,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210938,
        "nome": "Sussuapara",
        "latitude": -7.019,
        "longitude": -41.3562,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210953,
        "nome": "Tamboril do Piauí",
        "latitude": -8.4858,
        "longitude": -43.0821,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2210979,
        "nome": "Tanque do Piauí",
        "latitude": -6.6621,
        "longitude": -42.2662,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2211001,
        "nome": "Teresina",
        "latitude": -5.1027,
        "longitude": -42.7406,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2211100,
        "nome": "União",
        "latitude": -4.5953,
        "longitude": -42.795,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2211209,
        "nome": "Uruçuí",
        "latitude": -7.7919,
        "longitude": -44.5695,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2211308,
        "nome": "Valença do Piauí",
        "latitude": -6.3671,
        "longitude": -41.799,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2211357,
        "nome": "Várzea Branca",
        "latitude": -9.3227,
        "longitude": -42.9216,
        "mesorregiaoNome": "Sudoeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2211407,
        "nome": "Várzea Grande",
        "latitude": -6.5536,
        "longitude": -42.2254,
        "mesorregiaoNome": "Centro-Norte Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2211506,
        "nome": "Vera Mendes",
        "latitude": -7.5977,
        "longitude": -41.5186,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2211605,
        "nome": "Vila Nova do Piauí",
        "latitude": -7.2021,
        "longitude": -40.9361,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2211704,
        "nome": "Wall Ferraz",
        "latitude": -7.2656,
        "longitude": -41.8777,
        "mesorregiaoNome": "Sudeste Piauiense",
        "UFSigla": "PI",
        "UFNome": "Piauí"
    },
    {
        "ibgeId": 2300101,
        "nome": "Abaiara",
        "latitude": -7.3606,
        "longitude": -39.0368,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2300150,
        "nome": "Acarape",
        "latitude": -4.2171,
        "longitude": -38.6628,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2300200,
        "nome": "Acaraú",
        "latitude": -2.9679,
        "longitude": -40.0881,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2300309,
        "nome": "Acopiara",
        "latitude": -6.122,
        "longitude": -39.4938,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2300408,
        "nome": "Aiuaba",
        "latitude": -6.6051,
        "longitude": -40.2986,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2300507,
        "nome": "Alcântaras",
        "latitude": -3.5923,
        "longitude": -40.543,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2300606,
        "nome": "Altaneira",
        "latitude": -6.9856,
        "longitude": -39.6993,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2300705,
        "nome": "Alto Santo",
        "latitude": -5.5162,
        "longitude": -38.2409,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2300754,
        "nome": "Amontada",
        "latitude": -3.2396,
        "longitude": -39.7852,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2300804,
        "nome": "Antonina do Norte",
        "latitude": -6.7565,
        "longitude": -39.9813,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2300903,
        "nome": "Apuiarés",
        "latitude": -3.9683,
        "longitude": -39.3307,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2301000,
        "nome": "Aquiraz",
        "latitude": -3.9766,
        "longitude": -38.3941,
        "mesorregiaoNome": "Metropolitana de Fortaleza",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2301109,
        "nome": "Aracati",
        "latitude": -4.681,
        "longitude": -37.6855,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2301208,
        "nome": "Aracoiaba",
        "latitude": -4.483,
        "longitude": -38.7135,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2301257,
        "nome": "Ararendá",
        "latitude": -4.773,
        "longitude": -40.7462,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2301307,
        "nome": "Araripe",
        "latitude": -7.2393,
        "longitude": -40.0765,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2301406,
        "nome": "Aratuba",
        "latitude": -4.4173,
        "longitude": -39.025,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2301505,
        "nome": "Arneiroz",
        "latitude": -6.2394,
        "longitude": -40.1549,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2301604,
        "nome": "Assaré",
        "latitude": -6.9096,
        "longitude": -39.8692,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2301703,
        "nome": "Aurora",
        "latitude": -6.9889,
        "longitude": -38.9691,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2301802,
        "nome": "Baixio",
        "latitude": -6.7114,
        "longitude": -38.753,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2301851,
        "nome": "Banabuiú",
        "latitude": -5.2622,
        "longitude": -38.9036,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2301901,
        "nome": "Barbalha",
        "latitude": -7.4037,
        "longitude": -39.3446,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2301950,
        "nome": "Barreira",
        "latitude": -4.3219,
        "longitude": -38.6202,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2302008,
        "nome": "Barro",
        "latitude": -7.1255,
        "longitude": -38.7939,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2302057,
        "nome": "Barroquinha",
        "latitude": -2.9706,
        "longitude": -41.1736,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2302107,
        "nome": "Baturité",
        "latitude": -4.3834,
        "longitude": -38.851,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2302206,
        "nome": "Beberibe",
        "latitude": -4.4017,
        "longitude": -38.1129,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2302305,
        "nome": "Bela Cruz",
        "latitude": -3.0535,
        "longitude": -40.308,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2302404,
        "nome": "Boa Viagem",
        "latitude": -5.0878,
        "longitude": -39.8079,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2302503,
        "nome": "Brejo Santo",
        "latitude": -7.5557,
        "longitude": -38.9213,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2302602,
        "nome": "Camocim",
        "latitude": -2.9498,
        "longitude": -40.8009,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2302701,
        "nome": "Campos Sales",
        "latitude": -6.9367,
        "longitude": -40.2713,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2302800,
        "nome": "Canindé",
        "latitude": -4.4021,
        "longitude": -39.4304,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2302909,
        "nome": "Capistrano",
        "latitude": -4.4678,
        "longitude": -38.9079,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2303006,
        "nome": "Caridade",
        "latitude": -4.2038,
        "longitude": -39.1099,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2303105,
        "nome": "Cariré",
        "latitude": -3.9519,
        "longitude": -40.5217,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2303204,
        "nome": "Caririaçu",
        "latitude": -7.0218,
        "longitude": -39.2749,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2303303,
        "nome": "Cariús",
        "latitude": -6.642,
        "longitude": -39.4641,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2303402,
        "nome": "Carnaubal",
        "latitude": -4.1301,
        "longitude": -41.0102,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2303501,
        "nome": "Cascavel",
        "latitude": -4.2391,
        "longitude": -38.2971,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2303600,
        "nome": "Catarina",
        "latitude": -6.2528,
        "longitude": -39.9097,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2303659,
        "nome": "Catunda",
        "latitude": -4.6296,
        "longitude": -40.175,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2303709,
        "nome": "Caucaia",
        "latitude": -3.7836,
        "longitude": -38.8097,
        "mesorregiaoNome": "Metropolitana de Fortaleza",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2303808,
        "nome": "Cedro",
        "latitude": -6.5697,
        "longitude": -39.0932,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2303907,
        "nome": "Chaval",
        "latitude": -3.0926,
        "longitude": -41.2326,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2303931,
        "nome": "Choró",
        "latitude": -4.7723,
        "longitude": -39.1911,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2303956,
        "nome": "Chorozinho",
        "latitude": -4.3023,
        "longitude": -38.4683,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304004,
        "nome": "Coreaú",
        "latitude": -3.6415,
        "longitude": -40.7264,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304103,
        "nome": "Crateús",
        "latitude": -5.1993,
        "longitude": -40.7196,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304202,
        "nome": "Crato",
        "latitude": -7.2356,
        "longitude": -39.4899,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304236,
        "nome": "Croatá",
        "latitude": -4.3877,
        "longitude": -40.9751,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304251,
        "nome": "Cruz",
        "latitude": -2.8965,
        "longitude": -40.3233,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304269,
        "nome": "Deputado Irapuan Pinheiro",
        "latitude": -5.887,
        "longitude": -39.2662,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304277,
        "nome": "Ereré",
        "latitude": -5.9864,
        "longitude": -38.3087,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304285,
        "nome": "Eusébio",
        "latitude": -3.876,
        "longitude": -38.4576,
        "mesorregiaoNome": "Metropolitana de Fortaleza",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304301,
        "nome": "Farias Brito",
        "latitude": -6.9095,
        "longitude": -39.5491,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304350,
        "nome": "Forquilha",
        "latitude": -3.8224,
        "longitude": -40.2255,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304400,
        "nome": "Fortaleza",
        "latitude": -3.7858,
        "longitude": -38.528,
        "mesorregiaoNome": "Metropolitana de Fortaleza",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304459,
        "nome": "Fortim",
        "latitude": -4.4644,
        "longitude": -37.8737,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304509,
        "nome": "Frecheirinha",
        "latitude": -3.7108,
        "longitude": -40.8228,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304608,
        "nome": "General Sampaio",
        "latitude": -4.0639,
        "longitude": -39.4511,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304657,
        "nome": "Graça",
        "latitude": -4.0457,
        "longitude": -40.774,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304707,
        "nome": "Granja",
        "latitude": -3.2306,
        "longitude": -41.0017,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304806,
        "nome": "Granjeiro",
        "latitude": -6.9117,
        "longitude": -39.2522,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304905,
        "nome": "Groaíras",
        "latitude": -3.9124,
        "longitude": -40.3653,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2304954,
        "nome": "Guaiúba",
        "latitude": -4.1023,
        "longitude": -38.6698,
        "mesorregiaoNome": "Metropolitana de Fortaleza",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305001,
        "nome": "Guaraciaba do Norte",
        "latitude": -4.2328,
        "longitude": -40.9154,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305100,
        "nome": "Guaramiranga",
        "latitude": -4.2466,
        "longitude": -38.9566,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305209,
        "nome": "Hidrolândia",
        "latitude": -4.4326,
        "longitude": -40.4051,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305233,
        "nome": "Horizonte",
        "latitude": -4.1022,
        "longitude": -38.465,
        "mesorregiaoNome": "Metropolitana de Fortaleza",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305266,
        "nome": "Ibaretama",
        "latitude": -4.78,
        "longitude": -38.7248,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305308,
        "nome": "Ibiapina",
        "latitude": -3.9511,
        "longitude": -41.0062,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305332,
        "nome": "Ibicuitinga",
        "latitude": -4.9746,
        "longitude": -38.5569,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305357,
        "nome": "Icapuí",
        "latitude": -4.7386,
        "longitude": -37.4106,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305407,
        "nome": "Icó",
        "latitude": -6.389,
        "longitude": -38.7834,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305506,
        "nome": "Iguatu",
        "latitude": -6.36,
        "longitude": -39.2821,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305605,
        "nome": "Independência",
        "latitude": -5.4745,
        "longitude": -40.3425,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305654,
        "nome": "Ipaporanga",
        "latitude": -4.9097,
        "longitude": -40.8042,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305704,
        "nome": "Ipaumirim",
        "latitude": -6.8092,
        "longitude": -38.743,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305803,
        "nome": "Ipu",
        "latitude": -4.3697,
        "longitude": -40.6691,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2305902,
        "nome": "Ipueiras",
        "latitude": -4.5728,
        "longitude": -40.8769,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2306009,
        "nome": "Iracema",
        "latitude": -5.7779,
        "longitude": -38.3382,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2306108,
        "nome": "Irauçuba",
        "latitude": -3.8658,
        "longitude": -39.8176,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2306207,
        "nome": "Itaiçaba",
        "latitude": -4.7176,
        "longitude": -37.8472,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2306256,
        "nome": "Itaitinga",
        "latitude": -3.998,
        "longitude": -38.55,
        "mesorregiaoNome": "Metropolitana de Fortaleza",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2306306,
        "nome": "Itapajé",
        "latitude": -3.7318,
        "longitude": -39.5755,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2306405,
        "nome": "Itapipoca",
        "latitude": -3.3946,
        "longitude": -39.5982,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2306504,
        "nome": "Itapiúna",
        "latitude": -4.5955,
        "longitude": -38.9521,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2306553,
        "nome": "Itarema",
        "latitude": -3.0498,
        "longitude": -39.8891,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2306603,
        "nome": "Itatira",
        "latitude": -4.6255,
        "longitude": -39.5782,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2306702,
        "nome": "Jaguaretama",
        "latitude": -5.4918,
        "longitude": -38.7479,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2306801,
        "nome": "Jaguaribara",
        "latitude": -5.611,
        "longitude": -38.525,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2306900,
        "nome": "Jaguaribe",
        "latitude": -5.9613,
        "longitude": -38.705,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2307007,
        "nome": "Jaguaruana",
        "latitude": -4.8657,
        "longitude": -37.7467,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2307106,
        "nome": "Jardim",
        "latitude": -7.5903,
        "longitude": -39.248,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2307205,
        "nome": "Jati",
        "latitude": -7.692,
        "longitude": -38.9923,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2307254,
        "nome": "Jijoca de Jericoacoara",
        "latitude": -2.8778,
        "longitude": -40.4953,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2307304,
        "nome": "Juazeiro do Norte",
        "latitude": -7.1828,
        "longitude": -39.2862,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2307403,
        "nome": "Jucás",
        "latitude": -6.458,
        "longitude": -39.6073,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2307502,
        "nome": "Lavras da Mangabeira",
        "latitude": -6.778,
        "longitude": -38.9946,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2307601,
        "nome": "Limoeiro do Norte",
        "latitude": -5.1502,
        "longitude": -38.0562,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2307635,
        "nome": "Madalena",
        "latitude": -4.8579,
        "longitude": -39.509,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2307650,
        "nome": "Maracanaú",
        "latitude": -3.8745,
        "longitude": -38.6271,
        "mesorregiaoNome": "Metropolitana de Fortaleza",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2307700,
        "nome": "Maranguape",
        "latitude": -4.0067,
        "longitude": -38.8121,
        "mesorregiaoNome": "Metropolitana de Fortaleza",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2307809,
        "nome": "Marco",
        "latitude": -3.1896,
        "longitude": -40.2618,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2307908,
        "nome": "Martinópole",
        "latitude": -3.1696,
        "longitude": -40.6488,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2308005,
        "nome": "Massapê",
        "latitude": -3.4843,
        "longitude": -40.3876,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2308104,
        "nome": "Mauriti",
        "latitude": -7.3977,
        "longitude": -38.7174,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2308203,
        "nome": "Meruoca",
        "latitude": -3.5786,
        "longitude": -40.4509,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2308302,
        "nome": "Milagres",
        "latitude": -7.2721,
        "longitude": -38.9429,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2308351,
        "nome": "Milhã",
        "latitude": -5.6408,
        "longitude": -39.1711,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2308377,
        "nome": "Miraíma",
        "latitude": -3.5606,
        "longitude": -39.9086,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2308401,
        "nome": "Missão Velha",
        "latitude": -7.3065,
        "longitude": -39.1529,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2308500,
        "nome": "Mombaça",
        "latitude": -5.7891,
        "longitude": -39.7482,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2308609,
        "nome": "Monsenhor Tabosa",
        "latitude": -4.9147,
        "longitude": -40.0446,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2308708,
        "nome": "Morada Nova",
        "latitude": -5.0254,
        "longitude": -38.4353,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2308807,
        "nome": "Moraújo",
        "latitude": -3.4611,
        "longitude": -40.6795,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2308906,
        "nome": "Morrinhos",
        "latitude": -3.2841,
        "longitude": -40.0892,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2309003,
        "nome": "Mucambo",
        "latitude": -3.8978,
        "longitude": -40.7559,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2309102,
        "nome": "Mulungu",
        "latitude": -4.3194,
        "longitude": -38.9932,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2309201,
        "nome": "Nova Olinda",
        "latitude": -7.0931,
        "longitude": -39.6651,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2309300,
        "nome": "Nova Russas",
        "latitude": -4.6799,
        "longitude": -40.5288,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2309409,
        "nome": "Novo Oriente",
        "latitude": -5.5924,
        "longitude": -40.7709,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2309458,
        "nome": "Ocara",
        "latitude": -4.5265,
        "longitude": -38.5073,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2309508,
        "nome": "Orós",
        "latitude": -6.2442,
        "longitude": -38.9448,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2309607,
        "nome": "Pacajus",
        "latitude": -4.1838,
        "longitude": -38.4983,
        "mesorregiaoNome": "Metropolitana de Fortaleza",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2309706,
        "nome": "Pacatuba",
        "latitude": -3.9523,
        "longitude": -38.5972,
        "mesorregiaoNome": "Metropolitana de Fortaleza",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2309805,
        "nome": "Pacoti",
        "latitude": -4.1989,
        "longitude": -38.9021,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2309904,
        "nome": "Pacujá",
        "latitude": -4.0059,
        "longitude": -40.6856,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2310001,
        "nome": "Palhano",
        "latitude": -4.7084,
        "longitude": -38.0281,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2310100,
        "nome": "Palmácia",
        "latitude": -4.1258,
        "longitude": -38.842,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2310209,
        "nome": "Paracuru",
        "latitude": -3.4808,
        "longitude": -39.0388,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2310258,
        "nome": "Paraipaba",
        "latitude": -3.4223,
        "longitude": -39.1793,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2310308,
        "nome": "Parambu",
        "latitude": -6.304,
        "longitude": -40.6277,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2310407,
        "nome": "Paramoti",
        "latitude": -4.1598,
        "longitude": -39.3771,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2310506,
        "nome": "Pedra Branca",
        "latitude": -5.4959,
        "longitude": -39.844,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2310605,
        "nome": "Penaforte",
        "latitude": -7.7804,
        "longitude": -39.054,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2310704,
        "nome": "Pentecoste",
        "latitude": -3.8538,
        "longitude": -39.146,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2310803,
        "nome": "Pereiro",
        "latitude": -6.038,
        "longitude": -38.4858,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2310852,
        "nome": "Pindoretama",
        "latitude": -4.0546,
        "longitude": -38.3053,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2310902,
        "nome": "Piquet Carneiro",
        "latitude": -5.863,
        "longitude": -39.4517,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2310951,
        "nome": "Pires Ferreira",
        "latitude": -4.2591,
        "longitude": -40.5843,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311009,
        "nome": "Poranga",
        "latitude": -4.7995,
        "longitude": -41.0774,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311108,
        "nome": "Porteiras",
        "latitude": -7.542,
        "longitude": -39.1068,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311207,
        "nome": "Potengi",
        "latitude": -7.0727,
        "longitude": -40.0364,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311231,
        "nome": "Potiretama",
        "latitude": -5.7496,
        "longitude": -38.1676,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311264,
        "nome": "Quiterianópolis",
        "latitude": -5.8752,
        "longitude": -40.7622,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311306,
        "nome": "Quixadá",
        "latitude": -4.9545,
        "longitude": -38.947,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311355,
        "nome": "Quixelô",
        "latitude": -6.1775,
        "longitude": -39.1242,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311405,
        "nome": "Quixeramobim",
        "latitude": -5.2445,
        "longitude": -39.3315,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311504,
        "nome": "Quixeré",
        "latitude": -5.0872,
        "longitude": -37.8639,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311603,
        "nome": "Redenção",
        "latitude": -4.2456,
        "longitude": -38.7624,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311702,
        "nome": "Reriutaba",
        "latitude": -4.1209,
        "longitude": -40.6133,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311801,
        "nome": "Russas",
        "latitude": -4.8486,
        "longitude": -38.1295,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311900,
        "nome": "Saboeiro",
        "latitude": -6.4843,
        "longitude": -39.8886,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2311959,
        "nome": "Salitre",
        "latitude": -7.2048,
        "longitude": -40.3664,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2312007,
        "nome": "Santana do Acaraú",
        "latitude": -3.461,
        "longitude": -40.1647,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2312106,
        "nome": "Santana do Cariri",
        "latitude": -7.2219,
        "longitude": -39.7565,
        "mesorregiaoNome": "Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2312205,
        "nome": "Santa Quitéria",
        "latitude": -4.3407,
        "longitude": -40.0419,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2312304,
        "nome": "São Benedito",
        "latitude": -4.0408,
        "longitude": -40.9695,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2312403,
        "nome": "São Gonçalo do Amarante",
        "latitude": -3.6005,
        "longitude": -39.0605,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2312502,
        "nome": "São João do Jaguaribe",
        "latitude": -5.326,
        "longitude": -38.2733,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2312601,
        "nome": "São Luís do Curu",
        "latitude": -3.6463,
        "longitude": -39.2645,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2312700,
        "nome": "Senador Pompeu",
        "latitude": -5.5869,
        "longitude": -39.4335,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2312809,
        "nome": "Senador Sá",
        "latitude": -3.2701,
        "longitude": -40.461,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2312908,
        "nome": "Sobral",
        "latitude": -3.811,
        "longitude": -40.2279,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313005,
        "nome": "Solonópole",
        "latitude": -5.7765,
        "longitude": -39.0024,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313104,
        "nome": "Tabuleiro do Norte",
        "latitude": -5.3611,
        "longitude": -38.0272,
        "mesorregiaoNome": "Jaguaribe",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313203,
        "nome": "Tamboril",
        "latitude": -4.9196,
        "longitude": -40.3357,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313252,
        "nome": "Tarrafas",
        "latitude": -6.7302,
        "longitude": -39.7378,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313302,
        "nome": "Tauá",
        "latitude": -5.9368,
        "longitude": -40.2589,
        "mesorregiaoNome": "Sertões Cearenses",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313351,
        "nome": "Tejuçuoca",
        "latitude": -3.932,
        "longitude": -39.5833,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313401,
        "nome": "Tianguá",
        "latitude": -3.7361,
        "longitude": -41.055,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313500,
        "nome": "Trairi",
        "latitude": -3.3374,
        "longitude": -39.3536,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313559,
        "nome": "Tururu",
        "latitude": -3.5491,
        "longitude": -39.4049,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313609,
        "nome": "Ubajara",
        "latitude": -3.8666,
        "longitude": -41.0045,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313708,
        "nome": "Umari",
        "latitude": -6.6233,
        "longitude": -38.7303,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313757,
        "nome": "Umirim",
        "latitude": -3.687,
        "longitude": -39.3847,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313807,
        "nome": "Uruburetama",
        "latitude": -3.6224,
        "longitude": -39.5118,
        "mesorregiaoNome": "Norte Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313906,
        "nome": "Uruoca",
        "latitude": -3.3209,
        "longitude": -40.6804,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2313955,
        "nome": "Varjota",
        "latitude": -4.1679,
        "longitude": -40.4939,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2314003,
        "nome": "Várzea Alegre",
        "latitude": -6.7718,
        "longitude": -39.2979,
        "mesorregiaoNome": "Centro-Sul Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2314102,
        "nome": "Viçosa do Ceará",
        "latitude": -3.5462,
        "longitude": -41.1361,
        "mesorregiaoNome": "Noroeste Cearense",
        "UFSigla": "CE",
        "UFNome": "Ceará"
    },
    {
        "ibgeId": 2400109,
        "nome": "Acari",
        "latitude": -6.4094,
        "longitude": -36.6501,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2400208,
        "nome": "Açu",
        "latitude": -5.5266,
        "longitude": -37.0141,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2400307,
        "nome": "Afonso Bezerra",
        "latitude": -5.4714,
        "longitude": -36.5999,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2400406,
        "nome": "Água Nova",
        "latitude": -6.2086,
        "longitude": -38.3086,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2400505,
        "nome": "Alexandria",
        "latitude": -6.3645,
        "longitude": -37.9892,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2400604,
        "nome": "Almino Afonso",
        "latitude": -6.1545,
        "longitude": -37.763,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2400703,
        "nome": "Alto do Rodrigues",
        "latitude": -5.3623,
        "longitude": -36.7236,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2400802,
        "nome": "Angicos",
        "latitude": -5.6463,
        "longitude": -36.5572,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2400901,
        "nome": "Antônio Martins",
        "latitude": -6.2196,
        "longitude": -37.9248,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2401008,
        "nome": "Apodi",
        "latitude": -5.6226,
        "longitude": -37.8365,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2401107,
        "nome": "Areia Branca",
        "latitude": -5.0012,
        "longitude": -37.0463,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2401206,
        "nome": "Arês",
        "latitude": -6.1937,
        "longitude": -35.2082,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2401305,
        "nome": "Campo Grande",
        "latitude": -5.8803,
        "longitude": -37.3243,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2401404,
        "nome": "Baía Formosa",
        "latitude": -6.4347,
        "longitude": -35.0449,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2401453,
        "nome": "Baraúna",
        "latitude": -5.0928,
        "longitude": -37.6183,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2401503,
        "nome": "Barcelona",
        "latitude": -5.9611,
        "longitude": -35.922,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2401602,
        "nome": "Bento Fernandes",
        "latitude": -5.6759,
        "longitude": -35.8119,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2401651,
        "nome": "Bodó",
        "latitude": -5.9629,
        "longitude": -36.4417,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2401701,
        "nome": "Bom Jesus",
        "latitude": -6.0008,
        "longitude": -35.5908,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2401800,
        "nome": "Brejinho",
        "latitude": -6.2182,
        "longitude": -35.3836,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2401859,
        "nome": "Caiçara do Norte",
        "latitude": -5.1918,
        "longitude": -36.0833,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2401909,
        "nome": "Caiçara do Rio do Vento",
        "latitude": -5.7661,
        "longitude": -36.0265,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2402006,
        "nome": "Caicó",
        "latitude": -6.4676,
        "longitude": -37.0379,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2402105,
        "nome": "Campo Redondo",
        "latitude": -6.2377,
        "longitude": -36.2089,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2402204,
        "nome": "Canguaretama",
        "latitude": -6.3951,
        "longitude": -35.1485,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2402303,
        "nome": "Caraúbas",
        "latitude": -5.7674,
        "longitude": -37.5837,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2402402,
        "nome": "Carnaúba dos Dantas",
        "latitude": -6.5533,
        "longitude": -36.5488,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2402501,
        "nome": "Carnaubais",
        "latitude": -5.2641,
        "longitude": -36.8573,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2402600,
        "nome": "Ceará-Mirim",
        "latitude": -5.5955,
        "longitude": -35.3952,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2402709,
        "nome": "Cerro Corá",
        "latitude": -5.9894,
        "longitude": -36.3272,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2402808,
        "nome": "Coronel Ezequiel",
        "latitude": -6.3572,
        "longitude": -36.1959,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2402907,
        "nome": "Coronel João Pessoa",
        "latitude": -6.2555,
        "longitude": -38.4228,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2403004,
        "nome": "Cruzeta",
        "latitude": -6.3559,
        "longitude": -36.825,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2403103,
        "nome": "Currais Novos",
        "latitude": -6.2236,
        "longitude": -36.4436,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2403202,
        "nome": "Doutor Severiano",
        "latitude": -6.1154,
        "longitude": -38.4014,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2403251,
        "nome": "Parnamirim",
        "latitude": -5.9143,
        "longitude": -35.2301,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2403301,
        "nome": "Encanto",
        "latitude": -6.1342,
        "longitude": -38.3064,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2403400,
        "nome": "Equador",
        "latitude": -6.882,
        "longitude": -36.6661,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2403509,
        "nome": "Espírito Santo",
        "latitude": -6.3057,
        "longitude": -35.3045,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2403608,
        "nome": "Extremoz",
        "latitude": -5.681,
        "longitude": -35.2687,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2403707,
        "nome": "Felipe Guerra",
        "latitude": -5.5342,
        "longitude": -37.6531,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2403756,
        "nome": "Fernando Pedroza",
        "latitude": -5.7605,
        "longitude": -36.3921,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2403806,
        "nome": "Florânia",
        "latitude": -6.1697,
        "longitude": -36.8184,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2403905,
        "nome": "Francisco Dantas",
        "latitude": -6.053,
        "longitude": -38.1086,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2404002,
        "nome": "Frutuoso Gomes",
        "latitude": -6.161,
        "longitude": -37.839,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2404101,
        "nome": "Galinhos",
        "latitude": -5.1757,
        "longitude": -36.208,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2404200,
        "nome": "Goianinha",
        "latitude": -6.2878,
        "longitude": -35.2138,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2404309,
        "nome": "Governador Dix-Sept Rosado",
        "latitude": -5.394,
        "longitude": -37.5353,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2404408,
        "nome": "Grossos",
        "latitude": -4.9476,
        "longitude": -37.2105,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2404507,
        "nome": "Guamaré",
        "latitude": -5.1748,
        "longitude": -36.3439,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2404606,
        "nome": "Ielmo Marinho",
        "latitude": -5.7841,
        "longitude": -35.5504,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2404705,
        "nome": "Ipanguaçu",
        "latitude": -5.5382,
        "longitude": -36.8027,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2404804,
        "nome": "Ipueira",
        "latitude": -6.7742,
        "longitude": -37.1864,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2404853,
        "nome": "Itajá",
        "latitude": -5.69,
        "longitude": -36.808,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2404903,
        "nome": "Itaú",
        "latitude": -5.8185,
        "longitude": -37.9165,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2405009,
        "nome": "Jaçanã",
        "latitude": -6.4109,
        "longitude": -36.2146,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2405108,
        "nome": "Jandaíra",
        "latitude": -5.357,
        "longitude": -36.1382,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2405207,
        "nome": "Janduís",
        "latitude": -5.9962,
        "longitude": -37.4749,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2405306,
        "nome": "Januário Cicco",
        "latitude": -6.1525,
        "longitude": -35.6,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2405405,
        "nome": "Japi",
        "latitude": -6.4328,
        "longitude": -35.8991,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2405504,
        "nome": "Jardim de Angicos",
        "latitude": -5.6137,
        "longitude": -35.9868,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2405603,
        "nome": "Jardim de Piranhas",
        "latitude": -6.3345,
        "longitude": -37.2859,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2405702,
        "nome": "Jardim do Seridó",
        "latitude": -6.5877,
        "longitude": -36.8066,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2405801,
        "nome": "João Câmara",
        "latitude": -5.4754,
        "longitude": -35.8739,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2405900,
        "nome": "João Dias",
        "latitude": -6.2879,
        "longitude": -37.8379,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2406007,
        "nome": "José da Penha",
        "latitude": -6.3406,
        "longitude": -38.2831,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2406106,
        "nome": "Jucurutu",
        "latitude": -6.058,
        "longitude": -37.0214,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2406155,
        "nome": "Jundiá",
        "latitude": -6.2563,
        "longitude": -35.3404,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2406205,
        "nome": "Lagoa d'Anta",
        "latitude": -6.3842,
        "longitude": -35.6263,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2406304,
        "nome": "Lagoa de Pedras",
        "latitude": -6.1924,
        "longitude": -35.4508,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2406403,
        "nome": "Lagoa de Velhos",
        "latitude": -6.0105,
        "longitude": -35.8444,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2406502,
        "nome": "Lagoa Nova",
        "latitude": -6.0925,
        "longitude": -36.5191,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2406601,
        "nome": "Lagoa Salgada",
        "latitude": -6.1472,
        "longitude": -35.505,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2406700,
        "nome": "Lajes",
        "latitude": -5.6982,
        "longitude": -36.1806,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2406809,
        "nome": "Lajes Pintadas",
        "latitude": -6.1481,
        "longitude": -36.1342,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2406908,
        "nome": "Lucrécia",
        "latitude": -6.1036,
        "longitude": -37.8244,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2407005,
        "nome": "Luís Gomes",
        "latitude": -6.3734,
        "longitude": -38.4026,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2407104,
        "nome": "Macaíba",
        "latitude": -5.9269,
        "longitude": -35.4288,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2407203,
        "nome": "Macau",
        "latitude": -5.196,
        "longitude": -36.5235,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2407252,
        "nome": "Major Sales",
        "latitude": -6.4051,
        "longitude": -38.3176,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2407302,
        "nome": "Marcelino Vieira",
        "latitude": -6.2803,
        "longitude": -38.1573,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2407401,
        "nome": "Martins",
        "latitude": -6.0802,
        "longitude": -37.9059,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2407500,
        "nome": "Maxaranguape",
        "latitude": -5.4516,
        "longitude": -35.3545,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2407609,
        "nome": "Messias Targino",
        "latitude": -6.0899,
        "longitude": -37.4802,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2407708,
        "nome": "Montanhas",
        "latitude": -6.5049,
        "longitude": -35.2909,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2407807,
        "nome": "Monte Alegre",
        "latitude": -6.0988,
        "longitude": -35.4051,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2407906,
        "nome": "Monte das Gameleiras",
        "latitude": -6.4299,
        "longitude": -35.809,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2408003,
        "nome": "Mossoró",
        "latitude": -5.1758,
        "longitude": -37.3255,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2408102,
        "nome": "Natal",
        "latitude": -5.8032,
        "longitude": -35.2288,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2408201,
        "nome": "Nísia Floresta",
        "latitude": -6.0549,
        "longitude": -35.1732,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2408300,
        "nome": "Nova Cruz",
        "latitude": -6.4486,
        "longitude": -35.4288,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2408409,
        "nome": "Olho d'Água do Borges",
        "latitude": -5.9809,
        "longitude": -37.7093,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2408508,
        "nome": "Ouro Branco",
        "latitude": -6.6835,
        "longitude": -36.9211,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2408607,
        "nome": "Paraná",
        "latitude": -6.451,
        "longitude": -38.2842,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2408706,
        "nome": "Paraú",
        "latitude": -5.7844,
        "longitude": -37.1106,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2408805,
        "nome": "Parazinho",
        "latitude": -5.2858,
        "longitude": -35.9362,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2408904,
        "nome": "Parelhas",
        "latitude": -6.7138,
        "longitude": -36.6195,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2408953,
        "nome": "Rio do Fogo",
        "latitude": -5.3773,
        "longitude": -35.4,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2409100,
        "nome": "Passa e Fica",
        "latitude": -6.4422,
        "longitude": -35.6145,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2409209,
        "nome": "Passagem",
        "latitude": -6.2838,
        "longitude": -35.3957,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2409308,
        "nome": "Patu",
        "latitude": -6.0869,
        "longitude": -37.6213,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2409332,
        "nome": "Santa Maria",
        "latitude": -5.7889,
        "longitude": -35.7205,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2409407,
        "nome": "Pau dos Ferros",
        "latitude": -6.1174,
        "longitude": -38.1698,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2409506,
        "nome": "Pedra Grande",
        "latitude": -5.146,
        "longitude": -35.8735,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2409605,
        "nome": "Pedra Preta",
        "latitude": -5.5245,
        "longitude": -36.0795,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2409704,
        "nome": "Pedro Avelino",
        "latitude": -5.475,
        "longitude": -36.3316,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2409803,
        "nome": "Pedro Velho",
        "latitude": -6.4652,
        "longitude": -35.2245,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2409902,
        "nome": "Pendências",
        "latitude": -5.2929,
        "longitude": -36.624,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2410009,
        "nome": "Pilões",
        "latitude": -6.2866,
        "longitude": -38.0292,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2410108,
        "nome": "Poço Branco",
        "latitude": -5.5715,
        "longitude": -35.6944,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2410207,
        "nome": "Portalegre",
        "latitude": -6.0329,
        "longitude": -38.015,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2410256,
        "nome": "Porto do Mangue",
        "latitude": -5.0883,
        "longitude": -36.8415,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2410306,
        "nome": "Serra Caiada",
        "latitude": -6.1078,
        "longitude": -35.722,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2410405,
        "nome": "Pureza",
        "latitude": -5.4073,
        "longitude": -35.5821,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2410504,
        "nome": "Rafael Fernandes",
        "latitude": -6.1968,
        "longitude": -38.2237,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2410603,
        "nome": "Rafael Godeiro",
        "latitude": -6.0691,
        "longitude": -37.7302,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2410702,
        "nome": "Riacho da Cruz",
        "latitude": -5.9236,
        "longitude": -37.9664,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2410801,
        "nome": "Riacho de Santana",
        "latitude": -6.277,
        "longitude": -38.3361,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2410900,
        "nome": "Riachuelo",
        "latitude": -5.7984,
        "longitude": -35.8496,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2411007,
        "nome": "Rodolfo Fernandes",
        "latitude": -5.8585,
        "longitude": -38.0809,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2411056,
        "nome": "Tibau",
        "latitude": -4.8884,
        "longitude": -37.321,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2411106,
        "nome": "Ruy Barbosa",
        "latitude": -5.8569,
        "longitude": -35.9405,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2411205,
        "nome": "Santa Cruz",
        "latitude": -6.2482,
        "longitude": -36.0065,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2411403,
        "nome": "Santana do Matos",
        "latitude": -5.9043,
        "longitude": -36.6346,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2411429,
        "nome": "Santana do Seridó",
        "latitude": -6.7322,
        "longitude": -36.7651,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2411502,
        "nome": "Santo Antônio",
        "latitude": -6.3395,
        "longitude": -35.5054,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2411601,
        "nome": "São Bento do Norte",
        "latitude": -5.1441,
        "longitude": -35.9891,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2411700,
        "nome": "São Bento do Trairí",
        "latitude": -6.3832,
        "longitude": -36.0485,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2411809,
        "nome": "São Fernando",
        "latitude": -6.3213,
        "longitude": -37.1512,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2411908,
        "nome": "São Francisco do Oeste",
        "latitude": -5.9852,
        "longitude": -38.1838,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2412005,
        "nome": "São Gonçalo do Amarante",
        "latitude": -5.7877,
        "longitude": -35.3648,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2412104,
        "nome": "São João do Sabugi",
        "latitude": -6.6904,
        "longitude": -37.1885,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2412203,
        "nome": "São José de Mipibu",
        "latitude": -6.064,
        "longitude": -35.2894,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2412302,
        "nome": "São José do Campestre",
        "latitude": -6.3011,
        "longitude": -35.7402,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2412401,
        "nome": "São José do Seridó",
        "latitude": -6.4866,
        "longitude": -36.8585,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2412500,
        "nome": "São Miguel",
        "latitude": -6.2144,
        "longitude": -38.4743,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2412559,
        "nome": "São Miguel do Gostoso",
        "latitude": -5.194,
        "longitude": -35.7372,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2412609,
        "nome": "São Paulo do Potengi",
        "latitude": -5.934,
        "longitude": -35.7544,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2412708,
        "nome": "São Pedro",
        "latitude": -5.8926,
        "longitude": -35.6303,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2412807,
        "nome": "São Rafael",
        "latitude": -5.8374,
        "longitude": -36.8785,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2412906,
        "nome": "São Tomé",
        "latitude": -5.9882,
        "longitude": -36.1286,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2413003,
        "nome": "São Vicente",
        "latitude": -6.2077,
        "longitude": -36.6598,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2413102,
        "nome": "Senador Elói de Souza",
        "latitude": -6.0399,
        "longitude": -35.6799,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2413201,
        "nome": "Senador Georgino Avelino",
        "latitude": -6.1579,
        "longitude": -35.1214,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2413300,
        "nome": "Serra de São Bento",
        "latitude": -6.4286,
        "longitude": -35.719,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2413359,
        "nome": "Serra do Mel",
        "latitude": -5.1713,
        "longitude": -37.0242,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2413409,
        "nome": "Serra Negra do Norte",
        "latitude": -6.5874,
        "longitude": -37.36,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2413508,
        "nome": "Serrinha",
        "latitude": -6.2551,
        "longitude": -35.5744,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2413557,
        "nome": "Serrinha dos Pintos",
        "latitude": -6.1445,
        "longitude": -37.9931,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2413607,
        "nome": "Severiano Melo",
        "latitude": -5.7692,
        "longitude": -37.9727,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2413706,
        "nome": "Sítio Novo",
        "latitude": -6.088,
        "longitude": -35.9273,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2413805,
        "nome": "Taboleiro Grande",
        "latitude": -5.9358,
        "longitude": -38.0512,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2413904,
        "nome": "Taipu",
        "latitude": -5.5967,
        "longitude": -35.5852,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2414001,
        "nome": "Tangará",
        "latitude": -6.217,
        "longitude": -35.8353,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2414100,
        "nome": "Tenente Ananias",
        "latitude": -6.4406,
        "longitude": -38.1639,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2414159,
        "nome": "Tenente Laurentino Cruz",
        "latitude": -6.1591,
        "longitude": -36.7227,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2414209,
        "nome": "Tibau do Sul",
        "latitude": -6.2417,
        "longitude": -35.0998,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2414308,
        "nome": "Timbaúba dos Batistas",
        "latitude": -6.4777,
        "longitude": -37.2472,
        "mesorregiaoNome": "Central Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2414407,
        "nome": "Touros",
        "latitude": -5.281,
        "longitude": -35.608,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2414456,
        "nome": "Triunfo Potiguar",
        "latitude": -5.9184,
        "longitude": -37.1516,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2414506,
        "nome": "Umarizal",
        "latitude": -5.9815,
        "longitude": -37.8273,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2414605,
        "nome": "Upanema",
        "latitude": -5.6101,
        "longitude": -37.292,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2414704,
        "nome": "Várzea",
        "latitude": -6.3515,
        "longitude": -35.3684,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2414753,
        "nome": "Venha-Ver",
        "latitude": -6.3207,
        "longitude": -38.5268,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2414803,
        "nome": "Vera Cruz",
        "latitude": -6.0372,
        "longitude": -35.4355,
        "mesorregiaoNome": "Agreste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2414902,
        "nome": "Viçosa",
        "latitude": -5.9871,
        "longitude": -37.955,
        "mesorregiaoNome": "Oeste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2415008,
        "nome": "Vila Flor",
        "latitude": -6.3028,
        "longitude": -35.0871,
        "mesorregiaoNome": "Leste Potiguar",
        "UFSigla": "RN",
        "UFNome": "Rio Grande do Norte"
    },
    {
        "ibgeId": 2500106,
        "nome": "Água Branca",
        "latitude": -7.4705,
        "longitude": -37.6626,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2500205,
        "nome": "Aguiar",
        "latitude": -7.0741,
        "longitude": -38.2138,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2500304,
        "nome": "Alagoa Grande",
        "latitude": -7.0591,
        "longitude": -35.6028,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2500403,
        "nome": "Alagoa Nova",
        "latitude": -7.0616,
        "longitude": -35.7669,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2500502,
        "nome": "Alagoinha",
        "latitude": -6.962,
        "longitude": -35.5222,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2500536,
        "nome": "Alcantil",
        "latitude": -7.6899,
        "longitude": -36.0467,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2500577,
        "nome": "Algodão de Jandaíra",
        "latitude": -6.8879,
        "longitude": -35.9723,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2500601,
        "nome": "Alhandra",
        "latitude": -7.3486,
        "longitude": -34.9333,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2500700,
        "nome": "São João do Rio do Peixe",
        "latitude": -6.7327,
        "longitude": -38.4178,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2500734,
        "nome": "Amparo",
        "latitude": -7.5607,
        "longitude": -37.0394,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2500775,
        "nome": "Aparecida",
        "latitude": -6.7893,
        "longitude": -38.068,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2500809,
        "nome": "Araçagi",
        "latitude": -6.8612,
        "longitude": -35.3545,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2500908,
        "nome": "Arara",
        "latitude": -6.8581,
        "longitude": -35.7313,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501005,
        "nome": "Araruna",
        "latitude": -6.5242,
        "longitude": -35.7551,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501104,
        "nome": "Areia",
        "latitude": -6.9503,
        "longitude": -35.7054,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501153,
        "nome": "Areia de Baraúnas",
        "latitude": -7.1119,
        "longitude": -36.9619,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501203,
        "nome": "Areial",
        "latitude": -7.0492,
        "longitude": -35.9315,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501302,
        "nome": "Aroeiras",
        "latitude": -7.5356,
        "longitude": -35.6909,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501351,
        "nome": "Assunção",
        "latitude": -7.0736,
        "longitude": -36.7103,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501401,
        "nome": "Baía da Traição",
        "latitude": -6.6631,
        "longitude": -34.9888,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501500,
        "nome": "Bananeiras",
        "latitude": -6.7002,
        "longitude": -35.5963,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501534,
        "nome": "Baraúna",
        "latitude": -6.6206,
        "longitude": -36.2614,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501575,
        "nome": "Barra de Santana",
        "latitude": -7.5648,
        "longitude": -35.9661,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501609,
        "nome": "Barra de Santa Rosa",
        "latitude": -6.7912,
        "longitude": -36.076,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501708,
        "nome": "Barra de São Miguel",
        "latitude": -7.7004,
        "longitude": -36.2866,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501807,
        "nome": "Bayeux",
        "latitude": -7.1317,
        "longitude": -34.9219,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2501906,
        "nome": "Belém",
        "latitude": -6.7053,
        "longitude": -35.4982,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2502003,
        "nome": "Belém do Brejo do Cruz",
        "latitude": -6.149,
        "longitude": -37.3659,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2502052,
        "nome": "Bernardino Batista",
        "latitude": -6.4811,
        "longitude": -38.5558,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2502102,
        "nome": "Boa Ventura",
        "latitude": -7.4311,
        "longitude": -38.1883,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2502151,
        "nome": "Boa Vista",
        "latitude": -7.2717,
        "longitude": -36.2187,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2502201,
        "nome": "Bom Jesus",
        "latitude": -6.8228,
        "longitude": -38.6302,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2502300,
        "nome": "Bom Sucesso",
        "latitude": -6.4748,
        "longitude": -37.9478,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2502409,
        "nome": "Bonito de Santa Fé",
        "latitude": -7.2893,
        "longitude": -38.4782,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2502508,
        "nome": "Boqueirão",
        "latitude": -7.5066,
        "longitude": -36.1499,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2502607,
        "nome": "Igaracy",
        "latitude": -7.1552,
        "longitude": -38.1246,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2502706,
        "nome": "Borborema",
        "latitude": -6.7941,
        "longitude": -35.6012,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2502805,
        "nome": "Brejo do Cruz",
        "latitude": -6.3297,
        "longitude": -37.497,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2502904,
        "nome": "Brejo dos Santos",
        "latitude": -6.3984,
        "longitude": -37.8466,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2503001,
        "nome": "Caaporã",
        "latitude": -7.4868,
        "longitude": -34.9189,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2503100,
        "nome": "Cabaceiras",
        "latitude": -7.451,
        "longitude": -36.2989,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2503209,
        "nome": "Cabedelo",
        "latitude": -7.0359,
        "longitude": -34.845,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2503308,
        "nome": "Cachoeira dos Índios",
        "latitude": -6.946,
        "longitude": -38.6957,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2503407,
        "nome": "Cacimba de Areia",
        "latitude": -7.1387,
        "longitude": -37.1736,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2503506,
        "nome": "Cacimba de Dentro",
        "latitude": -6.6246,
        "longitude": -35.8137,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2503555,
        "nome": "Cacimbas",
        "latitude": -7.2095,
        "longitude": -37.0904,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2503605,
        "nome": "Caiçara",
        "latitude": -6.6063,
        "longitude": -35.4117,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2503704,
        "nome": "Cajazeiras",
        "latitude": -6.9199,
        "longitude": -38.541,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2503753,
        "nome": "Cajazeirinhas",
        "latitude": -6.959,
        "longitude": -37.8034,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2503803,
        "nome": "Caldas Brandão",
        "latitude": -7.1211,
        "longitude": -35.3392,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2503902,
        "nome": "Camalaú",
        "latitude": -7.8998,
        "longitude": -36.7972,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504009,
        "nome": "Campina Grande",
        "latitude": -7.2636,
        "longitude": -35.9657,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504033,
        "nome": "Capim",
        "latitude": -6.9008,
        "longitude": -35.1687,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504074,
        "nome": "Caraúbas",
        "latitude": -7.7741,
        "longitude": -36.5025,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504108,
        "nome": "Carrapateira",
        "latitude": -7.0445,
        "longitude": -38.3375,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504157,
        "nome": "Casserengue",
        "latitude": -6.755,
        "longitude": -35.8432,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504207,
        "nome": "Catingueira",
        "latitude": -7.1385,
        "longitude": -37.5908,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504306,
        "nome": "Catolé do Rocha",
        "latitude": -6.3211,
        "longitude": -37.7045,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504355,
        "nome": "Caturité",
        "latitude": -7.416,
        "longitude": -36.0577,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504405,
        "nome": "Conceição",
        "latitude": -7.5038,
        "longitude": -38.5283,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504504,
        "nome": "Condado",
        "latitude": -6.905,
        "longitude": -37.6155,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504603,
        "nome": "Conde",
        "latitude": -7.282,
        "longitude": -34.8607,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504702,
        "nome": "Congo",
        "latitude": -7.795,
        "longitude": -36.6465,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504801,
        "nome": "Coremas",
        "latitude": -7.0505,
        "longitude": -37.9753,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504850,
        "nome": "Coxixola",
        "latitude": -7.6452,
        "longitude": -36.6342,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2504900,
        "nome": "Cruz do Espírito Santo",
        "latitude": -7.149,
        "longitude": -35.1027,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2505006,
        "nome": "Cubati",
        "latitude": -6.8605,
        "longitude": -36.3267,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2505105,
        "nome": "Cuité",
        "latitude": -6.5486,
        "longitude": -36.0783,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2505204,
        "nome": "Cuitegi",
        "latitude": -6.8992,
        "longitude": -35.5228,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2505238,
        "nome": "Cuité de Mamanguape",
        "latitude": -6.906,
        "longitude": -35.2521,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2505279,
        "nome": "Curral de Cima",
        "latitude": -6.7338,
        "longitude": -35.2847,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2505303,
        "nome": "Curral Velho",
        "latitude": -7.5378,
        "longitude": -38.1679,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2505352,
        "nome": "Damião",
        "latitude": -6.6433,
        "longitude": -35.9301,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2505402,
        "nome": "Desterro",
        "latitude": -7.3001,
        "longitude": -37.0929,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2505501,
        "nome": "Vista Serrana",
        "latitude": -6.757,
        "longitude": -37.5755,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2505600,
        "nome": "Diamante",
        "latitude": -7.4237,
        "longitude": -38.3155,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2505709,
        "nome": "Dona Inês",
        "latitude": -6.6094,
        "longitude": -35.6483,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2505808,
        "nome": "Duas Estradas",
        "latitude": -6.7208,
        "longitude": -35.3956,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2505907,
        "nome": "Emas",
        "latitude": -7.0866,
        "longitude": -37.745,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2506004,
        "nome": "Esperança",
        "latitude": -6.9982,
        "longitude": -35.8903,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2506103,
        "nome": "Fagundes",
        "latitude": -7.3912,
        "longitude": -35.7801,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2506202,
        "nome": "Frei Martinho",
        "latitude": -6.4145,
        "longitude": -36.4497,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2506251,
        "nome": "Gado Bravo",
        "latitude": -7.5898,
        "longitude": -35.8124,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2506301,
        "nome": "Guarabira",
        "latitude": -6.8778,
        "longitude": -35.448,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2506400,
        "nome": "Gurinhém",
        "latitude": -7.1496,
        "longitude": -35.4359,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2506509,
        "nome": "Gurjão",
        "latitude": -7.2615,
        "longitude": -36.4578,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2506608,
        "nome": "Ibiara",
        "latitude": -7.4919,
        "longitude": -38.4039,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2506707,
        "nome": "Imaculada",
        "latitude": -7.3709,
        "longitude": -37.5582,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2506806,
        "nome": "Ingá",
        "latitude": -7.2785,
        "longitude": -35.6211,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2506905,
        "nome": "Itabaiana",
        "latitude": -7.3484,
        "longitude": -35.3543,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2507002,
        "nome": "Itaporanga",
        "latitude": -7.2865,
        "longitude": -38.1864,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2507101,
        "nome": "Itapororoca",
        "latitude": -6.8102,
        "longitude": -35.2571,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2507200,
        "nome": "Itatuba",
        "latitude": -7.4051,
        "longitude": -35.6471,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2507309,
        "nome": "Jacaraú",
        "latitude": -6.5958,
        "longitude": -35.2683,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2507408,
        "nome": "Jericó",
        "latitude": -6.5087,
        "longitude": -37.8172,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2507507,
        "nome": "João Pessoa",
        "latitude": -7.1655,
        "longitude": -34.8695,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2507606,
        "nome": "Juarez Távora",
        "latitude": -7.1592,
        "longitude": -35.5706,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2507705,
        "nome": "Juazeirinho",
        "latitude": -7.0549,
        "longitude": -36.5585,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2507804,
        "nome": "Junco do Seridó",
        "latitude": -6.9913,
        "longitude": -36.7745,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2507903,
        "nome": "Juripiranga",
        "latitude": -7.355,
        "longitude": -35.2136,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2508000,
        "nome": "Juru",
        "latitude": -7.5018,
        "longitude": -37.8032,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2508109,
        "nome": "Lagoa",
        "latitude": -6.5876,
        "longitude": -37.8882,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2508208,
        "nome": "Lagoa de Dentro",
        "latitude": -6.6789,
        "longitude": -35.3613,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2508307,
        "nome": "Lagoa Seca",
        "latitude": -7.1462,
        "longitude": -35.8663,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2508406,
        "nome": "Lastro",
        "latitude": -6.5526,
        "longitude": -38.18,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2508505,
        "nome": "Livramento",
        "latitude": -7.3406,
        "longitude": -36.931,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2508554,
        "nome": "Logradouro",
        "latitude": -6.5544,
        "longitude": -35.4272,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2508604,
        "nome": "Lucena",
        "latitude": -6.9189,
        "longitude": -34.9122,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2508703,
        "nome": "Mãe d'Água",
        "latitude": -7.2481,
        "longitude": -37.4399,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2508802,
        "nome": "Malta",
        "latitude": -6.8837,
        "longitude": -37.5301,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2508901,
        "nome": "Mamanguape",
        "latitude": -6.7207,
        "longitude": -35.1559,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509008,
        "nome": "Manaíra",
        "latitude": -7.7249,
        "longitude": -38.2048,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509057,
        "nome": "Marcação",
        "latitude": -6.7475,
        "longitude": -35.0056,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509107,
        "nome": "Mari",
        "latitude": -7.0375,
        "longitude": -35.3059,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509156,
        "nome": "Marizópolis",
        "latitude": -6.8216,
        "longitude": -38.3367,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509206,
        "nome": "Massaranduba",
        "latitude": -7.2008,
        "longitude": -35.756,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509305,
        "nome": "Mataraca",
        "latitude": -6.5563,
        "longitude": -35.0439,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509339,
        "nome": "Matinhas",
        "latitude": -7.1184,
        "longitude": -35.7717,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509370,
        "nome": "Mato Grosso",
        "latitude": -6.5481,
        "longitude": -37.7373,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509396,
        "nome": "Maturéia",
        "latitude": -7.2843,
        "longitude": -37.3588,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509404,
        "nome": "Mogeiro",
        "latitude": -7.2948,
        "longitude": -35.4971,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509503,
        "nome": "Montadas",
        "latitude": -7.0903,
        "longitude": -35.9435,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509602,
        "nome": "Monte Horebe",
        "latitude": -7.2063,
        "longitude": -38.5377,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509701,
        "nome": "Monteiro",
        "latitude": -7.9078,
        "longitude": -37.0917,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509800,
        "nome": "Mulungu",
        "latitude": -6.9994,
        "longitude": -35.4209,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2509909,
        "nome": "Natuba",
        "latitude": -7.5602,
        "longitude": -35.5629,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2510006,
        "nome": "Nazarezinho",
        "latitude": -6.951,
        "longitude": -38.3266,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2510105,
        "nome": "Nova Floresta",
        "latitude": -6.4764,
        "longitude": -36.2062,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2510204,
        "nome": "Nova Olinda",
        "latitude": -7.4735,
        "longitude": -38.0185,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2510303,
        "nome": "Nova Palmeira",
        "latitude": -6.6762,
        "longitude": -36.4264,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2510402,
        "nome": "Olho d'Água",
        "latitude": -7.2844,
        "longitude": -37.754,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2510501,
        "nome": "Olivedos",
        "latitude": -6.9771,
        "longitude": -36.2491,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2510600,
        "nome": "Ouro Velho",
        "latitude": -7.6098,
        "longitude": -37.1381,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2510659,
        "nome": "Parari",
        "latitude": -7.3273,
        "longitude": -36.6688,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2510709,
        "nome": "Passagem",
        "latitude": -7.1183,
        "longitude": -37.0412,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2510808,
        "nome": "Patos",
        "latitude": -6.9955,
        "longitude": -37.3169,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2510907,
        "nome": "Paulista",
        "latitude": -6.627,
        "longitude": -37.6088,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2511004,
        "nome": "Pedra Branca",
        "latitude": -7.4586,
        "longitude": -38.0808,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2511103,
        "nome": "Pedra Lavrada",
        "latitude": -6.7729,
        "longitude": -36.3879,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2511202,
        "nome": "Pedras de Fogo",
        "latitude": -7.3362,
        "longitude": -35.0746,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2511301,
        "nome": "Piancó",
        "latitude": -7.2013,
        "longitude": -37.9422,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2511400,
        "nome": "Picuí",
        "latitude": -6.4931,
        "longitude": -36.3371,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2511509,
        "nome": "Pilar",
        "latitude": -7.2789,
        "longitude": -35.2667,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2511608,
        "nome": "Pilões",
        "latitude": -6.8832,
        "longitude": -35.6084,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2511707,
        "nome": "Pilõezinhos",
        "latitude": -6.8462,
        "longitude": -35.549,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2511806,
        "nome": "Pirpirituba",
        "latitude": -6.7907,
        "longitude": -35.4959,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2511905,
        "nome": "Pitimbu",
        "latitude": -7.4309,
        "longitude": -34.8418,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512002,
        "nome": "Pocinhos",
        "latitude": -7.0627,
        "longitude": -36.0937,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512036,
        "nome": "Poço Dantas",
        "latitude": -6.3897,
        "longitude": -38.5199,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512077,
        "nome": "Poço de José de Moura",
        "latitude": -6.5937,
        "longitude": -38.4989,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512101,
        "nome": "Pombal",
        "latitude": -6.7725,
        "longitude": -37.8509,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512200,
        "nome": "Prata",
        "latitude": -7.6947,
        "longitude": -37.0858,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512309,
        "nome": "Princesa Isabel",
        "latitude": -7.6537,
        "longitude": -38.005,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512408,
        "nome": "Puxinanã",
        "latitude": -7.1488,
        "longitude": -35.9616,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512507,
        "nome": "Queimadas",
        "latitude": -7.3994,
        "longitude": -35.9137,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512606,
        "nome": "Quixaba",
        "latitude": -7.0407,
        "longitude": -37.1355,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512705,
        "nome": "Remígio",
        "latitude": -6.9268,
        "longitude": -35.8488,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512721,
        "nome": "Pedro Régis",
        "latitude": -6.6681,
        "longitude": -35.2911,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512747,
        "nome": "Riachão",
        "latitude": -6.5418,
        "longitude": -35.6474,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512754,
        "nome": "Riachão do Bacamarte",
        "latitude": -7.2396,
        "longitude": -35.6692,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512762,
        "nome": "Riachão do Poço",
        "latitude": -7.1549,
        "longitude": -35.2899,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512788,
        "nome": "Riacho de Santo Antônio",
        "latitude": -7.6829,
        "longitude": -36.1378,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512804,
        "nome": "Riacho dos Cavalos",
        "latitude": -6.4782,
        "longitude": -37.6355,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2512903,
        "nome": "Rio Tinto",
        "latitude": -6.7969,
        "longitude": -35.0361,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513000,
        "nome": "Salgadinho",
        "latitude": -7.0987,
        "longitude": -36.8421,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513109,
        "nome": "Salgado de São Félix",
        "latitude": -7.4147,
        "longitude": -35.4636,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513158,
        "nome": "Santa Cecília",
        "latitude": -7.7289,
        "longitude": -35.9215,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513208,
        "nome": "Santa Cruz",
        "latitude": -6.5488,
        "longitude": -38.0528,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513307,
        "nome": "Santa Helena",
        "latitude": -6.7305,
        "longitude": -38.5841,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513356,
        "nome": "Santa Inês",
        "latitude": -7.6664,
        "longitude": -38.5774,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513406,
        "nome": "Santa Luzia",
        "latitude": -6.9172,
        "longitude": -36.9065,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513505,
        "nome": "Santana de Mangueira",
        "latitude": -7.6282,
        "longitude": -38.331,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513604,
        "nome": "Santana dos Garrotes",
        "latitude": -7.3879,
        "longitude": -37.96,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513653,
        "nome": "Joca Claudino",
        "latitude": -6.4771,
        "longitude": -38.4809,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513703,
        "nome": "Santa Rita",
        "latitude": -7.0673,
        "longitude": -35.0001,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513802,
        "nome": "Santa Teresinha",
        "latitude": -7.0911,
        "longitude": -37.4454,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513851,
        "nome": "Santo André",
        "latitude": -7.2211,
        "longitude": -36.6147,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513901,
        "nome": "São Bento",
        "latitude": -6.4589,
        "longitude": -37.4713,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513927,
        "nome": "São Bentinho",
        "latitude": -6.8738,
        "longitude": -37.7072,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513943,
        "nome": "São Domingos do Cariri",
        "latitude": -7.5881,
        "longitude": -36.4048,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513968,
        "nome": "São Domingos",
        "latitude": -6.804,
        "longitude": -37.9508,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2513984,
        "nome": "São Francisco",
        "latitude": -6.6352,
        "longitude": -38.0597,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2514008,
        "nome": "São João do Cariri",
        "latitude": -7.4513,
        "longitude": -36.494,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2514107,
        "nome": "São João do Tigre",
        "latitude": -8.0889,
        "longitude": -36.7874,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2514206,
        "nome": "São José da Lagoa Tapada",
        "latitude": -6.9413,
        "longitude": -38.1396,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2514305,
        "nome": "São José de Caiana",
        "latitude": -7.2606,
        "longitude": -38.3266,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2514404,
        "nome": "São José de Espinharas",
        "latitude": -6.8138,
        "longitude": -37.3798,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2514453,
        "nome": "São José dos Ramos",
        "latitude": -7.2419,
        "longitude": -35.3464,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2514503,
        "nome": "São José de Piranhas",
        "latitude": -7.1007,
        "longitude": -38.4921,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2514552,
        "nome": "São José de Princesa",
        "latitude": -7.7025,
        "longitude": -38.0964,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2514602,
        "nome": "São José do Bonfim",
        "latitude": -7.1493,
        "longitude": -37.3009,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2514651,
        "nome": "São José do Brejo do Cruz",
        "latitude": -6.2354,
        "longitude": -37.3581,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2514701,
        "nome": "São José do Sabugi",
        "latitude": -6.8172,
        "longitude": -36.8234,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2514800,
        "nome": "São José dos Cordeiros",
        "latitude": -7.4291,
        "longitude": -36.8624,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2514909,
        "nome": "São Mamede",
        "latitude": -6.9277,
        "longitude": -37.0848,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2515005,
        "nome": "São Miguel de Taipu",
        "latitude": -7.2407,
        "longitude": -35.1988,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2515104,
        "nome": "São Sebastião de Lagoa de Roça",
        "latitude": -7.0892,
        "longitude": -35.8539,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2515203,
        "nome": "São Sebastião do Umbuzeiro",
        "latitude": -8.1582,
        "longitude": -37.015,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2515302,
        "nome": "Sapé",
        "latitude": -7.0554,
        "longitude": -35.1971,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2515401,
        "nome": "São Vicente do Seridó",
        "latitude": -6.909,
        "longitude": -36.4503,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2515500,
        "nome": "Serra Branca",
        "latitude": -7.5353,
        "longitude": -36.7079,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2515609,
        "nome": "Serra da Raiz",
        "latitude": -6.7052,
        "longitude": -35.4528,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2515708,
        "nome": "Serra Grande",
        "latitude": -7.2292,
        "longitude": -38.3795,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2515807,
        "nome": "Serra Redonda",
        "latitude": -7.1715,
        "longitude": -35.6633,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2515906,
        "nome": "Serraria",
        "latitude": -6.8332,
        "longitude": -35.6441,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2515930,
        "nome": "Sertãozinho",
        "latitude": -6.7424,
        "longitude": -35.4214,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2515971,
        "nome": "Sobrado",
        "latitude": -7.1798,
        "longitude": -35.256,
        "mesorregiaoNome": "Mata Paraibana",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2516003,
        "nome": "Solânea",
        "latitude": -6.7522,
        "longitude": -35.7249,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2516102,
        "nome": "Soledade",
        "latitude": -7.1004,
        "longitude": -36.3706,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2516151,
        "nome": "Sossêgo",
        "latitude": -6.7237,
        "longitude": -36.2099,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2516201,
        "nome": "Sousa",
        "latitude": -6.7397,
        "longitude": -38.2252,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2516300,
        "nome": "Sumé",
        "latitude": -7.6784,
        "longitude": -36.9006,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2516409,
        "nome": "Tacima",
        "latitude": -6.5378,
        "longitude": -35.5182,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2516508,
        "nome": "Taperoá",
        "latitude": -7.2208,
        "longitude": -36.8307,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2516607,
        "nome": "Tavares",
        "latitude": -7.5998,
        "longitude": -37.8921,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2516706,
        "nome": "Teixeira",
        "latitude": -7.2455,
        "longitude": -37.2403,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2516755,
        "nome": "Tenório",
        "latitude": -6.9613,
        "longitude": -36.6265,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2516805,
        "nome": "Triunfo",
        "latitude": -6.6056,
        "longitude": -38.5723,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2516904,
        "nome": "Uiraúna",
        "latitude": -6.5108,
        "longitude": -38.3916,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2517001,
        "nome": "Umbuzeiro",
        "latitude": -7.6809,
        "longitude": -35.7378,
        "mesorregiaoNome": "Agreste Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2517100,
        "nome": "Várzea",
        "latitude": -6.7885,
        "longitude": -37.0314,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2517209,
        "nome": "Vieirópolis",
        "latitude": -6.5602,
        "longitude": -38.2682,
        "mesorregiaoNome": "Sertão Paraibano",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2517407,
        "nome": "Zabelê",
        "latitude": -8.0766,
        "longitude": -37.0963,
        "mesorregiaoNome": "Borborema",
        "UFSigla": "PB",
        "UFNome": "Paraíba"
    },
    {
        "ibgeId": 2600054,
        "nome": "Abreu e Lima",
        "latitude": -7.8797,
        "longitude": -35.0191,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2600104,
        "nome": "Afogados da Ingazeira",
        "latitude": -7.7373,
        "longitude": -37.6183,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2600203,
        "nome": "Afrânio",
        "latitude": -8.6189,
        "longitude": -41.0054,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2600302,
        "nome": "Agrestina",
        "latitude": -8.4566,
        "longitude": -35.9452,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2600401,
        "nome": "Água Preta",
        "latitude": -8.7293,
        "longitude": -35.4818,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2600500,
        "nome": "Águas Belas",
        "latitude": -9.087,
        "longitude": -37.0386,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2600609,
        "nome": "Alagoinha",
        "latitude": -8.4947,
        "longitude": -36.7581,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2600708,
        "nome": "Aliança",
        "latitude": -7.6026,
        "longitude": -35.193,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2600807,
        "nome": "Altinho",
        "latitude": -8.4905,
        "longitude": -36.099,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2600906,
        "nome": "Amaraji",
        "latitude": -8.365,
        "longitude": -35.4655,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2601003,
        "nome": "Angelim",
        "latitude": -8.8913,
        "longitude": -36.2767,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2601052,
        "nome": "Araçoiaba",
        "latitude": -7.7932,
        "longitude": -35.0761,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2601102,
        "nome": "Araripina",
        "latitude": -7.6079,
        "longitude": -40.4848,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2601201,
        "nome": "Arcoverde",
        "latitude": -8.3839,
        "longitude": -37.0055,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2601300,
        "nome": "Barra de Guabiraba",
        "latitude": -8.4182,
        "longitude": -35.6338,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2601409,
        "nome": "Barreiros",
        "latitude": -8.8202,
        "longitude": -35.2586,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2601508,
        "nome": "Belém de Maria",
        "latitude": -8.6032,
        "longitude": -35.817,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2601607,
        "nome": "Belém do São Francisco",
        "latitude": -8.5836,
        "longitude": -38.9819,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2601706,
        "nome": "Belo Jardim",
        "latitude": -8.2589,
        "longitude": -36.4051,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2601805,
        "nome": "Betânia",
        "latitude": -8.2656,
        "longitude": -37.9863,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2601904,
        "nome": "Bezerros",
        "latitude": -8.2187,
        "longitude": -35.7829,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2602001,
        "nome": "Bodocó",
        "latitude": -7.6564,
        "longitude": -39.9651,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2602100,
        "nome": "Bom Conselho",
        "latitude": -9.2029,
        "longitude": -36.6842,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2602209,
        "nome": "Bom Jardim",
        "latitude": -7.7855,
        "longitude": -35.5863,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2602308,
        "nome": "Bonito",
        "latitude": -8.495,
        "longitude": -35.7088,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2602407,
        "nome": "Brejão",
        "latitude": -9.0267,
        "longitude": -36.5299,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2602506,
        "nome": "Brejinho",
        "latitude": -7.3367,
        "longitude": -37.3209,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2602605,
        "nome": "Brejo da Madre de Deus",
        "latitude": -8.0757,
        "longitude": -36.2815,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2602704,
        "nome": "Buenos Aires",
        "latitude": -7.7379,
        "longitude": -35.3472,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2602803,
        "nome": "Buíque",
        "latitude": -8.65,
        "longitude": -37.1227,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2602902,
        "nome": "Cabo de Santo Agostinho",
        "latitude": -8.2692,
        "longitude": -35.0859,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2603009,
        "nome": "Cabrobó",
        "latitude": -8.3865,
        "longitude": -39.3294,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2603108,
        "nome": "Cachoeirinha",
        "latitude": -8.4849,
        "longitude": -36.2909,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2603207,
        "nome": "Caetés",
        "latitude": -8.804,
        "longitude": -36.6592,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2603306,
        "nome": "Calçado",
        "latitude": -8.7503,
        "longitude": -36.3219,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2603405,
        "nome": "Calumbi",
        "latitude": -8.0039,
        "longitude": -38.0787,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2603454,
        "nome": "Camaragibe",
        "latitude": -7.9868,
        "longitude": -34.9958,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2603504,
        "nome": "Camocim de São Félix",
        "latitude": -8.35,
        "longitude": -35.7721,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2603603,
        "nome": "Camutanga",
        "latitude": -7.4339,
        "longitude": -35.2992,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2603702,
        "nome": "Canhotinho",
        "latitude": -8.8931,
        "longitude": -36.1769,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2603801,
        "nome": "Capoeiras",
        "latitude": -8.6867,
        "longitude": -36.5992,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2603900,
        "nome": "Carnaíba",
        "latitude": -7.7952,
        "longitude": -37.7268,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2603926,
        "nome": "Carnaubeira da Penha",
        "latitude": -8.4091,
        "longitude": -38.7216,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2604007,
        "nome": "Carpina",
        "latitude": -7.8192,
        "longitude": -35.3061,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2604106,
        "nome": "Caruaru",
        "latitude": -8.1799,
        "longitude": -36.0174,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2604155,
        "nome": "Casinhas",
        "latitude": -7.756,
        "longitude": -35.7204,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2604205,
        "nome": "Catende",
        "latitude": -8.6755,
        "longitude": -35.7309,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2604304,
        "nome": "Cedro",
        "latitude": -7.7438,
        "longitude": -39.2037,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2604403,
        "nome": "Chã de Alegria",
        "latitude": -7.9994,
        "longitude": -35.2222,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2604502,
        "nome": "Chã Grande",
        "latitude": -8.2296,
        "longitude": -35.474,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2604601,
        "nome": "Condado",
        "latitude": -7.5963,
        "longitude": -35.0987,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2604700,
        "nome": "Correntes",
        "latitude": -9.1147,
        "longitude": -36.3387,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2604809,
        "nome": "Cortês",
        "latitude": -8.4332,
        "longitude": -35.5303,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2604908,
        "nome": "Cumaru",
        "latitude": -8.0401,
        "longitude": -35.7207,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2605004,
        "nome": "Cupira",
        "latitude": -8.583,
        "longitude": -35.9314,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2605103,
        "nome": "Custódia",
        "latitude": -8.1705,
        "longitude": -37.6793,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2605152,
        "nome": "Dormentes",
        "latitude": -8.4962,
        "longitude": -40.6201,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2605202,
        "nome": "Escada",
        "latitude": -8.3698,
        "longitude": -35.2645,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2605301,
        "nome": "Exu",
        "latitude": -7.516,
        "longitude": -39.7482,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2605400,
        "nome": "Feira Nova",
        "latitude": -7.9529,
        "longitude": -35.3832,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2605459,
        "nome": "Fernando de Noronha",
        "latitude": -3.857,
        "longitude": -32.4265,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2605509,
        "nome": "Ferreiros",
        "latitude": -7.4785,
        "longitude": -35.2446,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2605608,
        "nome": "Flores",
        "latitude": -7.9399,
        "longitude": -37.8948,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2605707,
        "nome": "Floresta",
        "latitude": -8.5663,
        "longitude": -38.3053,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2605806,
        "nome": "Frei Miguelinho",
        "latitude": -7.9354,
        "longitude": -35.8851,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2605905,
        "nome": "Gameleira",
        "latitude": -8.6125,
        "longitude": -35.3931,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2606002,
        "nome": "Garanhuns",
        "latitude": -8.929,
        "longitude": -36.5011,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2606101,
        "nome": "Glória do Goitá",
        "latitude": -8.0128,
        "longitude": -35.3383,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2606200,
        "nome": "Goiana",
        "latitude": -7.5969,
        "longitude": -34.9425,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2606309,
        "nome": "Granito",
        "latitude": -7.7885,
        "longitude": -39.6943,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2606408,
        "nome": "Gravatá",
        "latitude": -8.1994,
        "longitude": -35.5636,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2606507,
        "nome": "Iati",
        "latitude": -9.1435,
        "longitude": -36.9011,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2606606,
        "nome": "Ibimirim",
        "latitude": -8.5889,
        "longitude": -37.5959,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2606705,
        "nome": "Ibirajuba",
        "latitude": -8.6134,
        "longitude": -36.2014,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2606804,
        "nome": "Igarassu",
        "latitude": -7.8175,
        "longitude": -34.9603,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2606903,
        "nome": "Iguaracy",
        "latitude": -7.8458,
        "longitude": -37.4028,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2607000,
        "nome": "Inajá",
        "latitude": -8.8035,
        "longitude": -37.8393,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2607109,
        "nome": "Ingazeira",
        "latitude": -7.7136,
        "longitude": -37.4156,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2607208,
        "nome": "Ipojuca",
        "latitude": -8.4373,
        "longitude": -35.0893,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2607307,
        "nome": "Ipubi",
        "latitude": -7.4979,
        "longitude": -40.2174,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2607406,
        "nome": "Itacuruba",
        "latitude": -8.7488,
        "longitude": -38.7273,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2607505,
        "nome": "Itaíba",
        "latitude": -8.9868,
        "longitude": -37.2917,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2607604,
        "nome": "Ilha de Itamaracá",
        "latitude": -7.7595,
        "longitude": -34.8544,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2607653,
        "nome": "Itambé",
        "latitude": -7.4499,
        "longitude": -35.1343,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2607703,
        "nome": "Itapetim",
        "latitude": -7.3987,
        "longitude": -37.143,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2607752,
        "nome": "Itapissuma",
        "latitude": -7.7451,
        "longitude": -34.9068,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2607802,
        "nome": "Itaquitinga",
        "latitude": -7.6864,
        "longitude": -35.0326,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2607901,
        "nome": "Jaboatão dos Guararapes",
        "latitude": -8.1522,
        "longitude": -35.0033,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2607950,
        "nome": "Jaqueira",
        "latitude": -8.7433,
        "longitude": -35.8078,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608008,
        "nome": "Jataúba",
        "latitude": -8.0552,
        "longitude": -36.5339,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608057,
        "nome": "Jatobá",
        "latitude": -9.2078,
        "longitude": -38.2138,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608107,
        "nome": "João Alfredo",
        "latitude": -7.861,
        "longitude": -35.5924,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608206,
        "nome": "Joaquim Nabuco",
        "latitude": -8.5624,
        "longitude": -35.5451,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608255,
        "nome": "Jucati",
        "latitude": -8.7439,
        "longitude": -36.4596,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608305,
        "nome": "Jupi",
        "latitude": -8.7154,
        "longitude": -36.394,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608404,
        "nome": "Jurema",
        "latitude": -8.7554,
        "longitude": -36.1427,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608453,
        "nome": "Lagoa do Carro",
        "latitude": -7.8524,
        "longitude": -35.3369,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608503,
        "nome": "Lagoa de Itaenga",
        "latitude": -7.9089,
        "longitude": -35.2947,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608602,
        "nome": "Lagoa do Ouro",
        "latitude": -9.1621,
        "longitude": -36.4655,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608701,
        "nome": "Lagoa dos Gatos",
        "latitude": -8.6824,
        "longitude": -35.8956,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608750,
        "nome": "Lagoa Grande",
        "latitude": -8.7772,
        "longitude": -40.223,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608800,
        "nome": "Lajedo",
        "latitude": -8.678,
        "longitude": -36.2863,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2608909,
        "nome": "Limoeiro",
        "latitude": -7.8477,
        "longitude": -35.4479,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2609006,
        "nome": "Macaparana",
        "latitude": -7.5277,
        "longitude": -35.4502,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2609105,
        "nome": "Machados",
        "latitude": -7.7039,
        "longitude": -35.5035,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2609154,
        "nome": "Manari",
        "latitude": -8.8893,
        "longitude": -37.541,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2609204,
        "nome": "Maraial",
        "latitude": -8.8342,
        "longitude": -35.7617,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2609303,
        "nome": "Mirandiba",
        "latitude": -8.1575,
        "longitude": -38.7361,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2609402,
        "nome": "Moreno",
        "latitude": -8.144,
        "longitude": -35.1463,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2609501,
        "nome": "Nazaré da Mata",
        "latitude": -7.7372,
        "longitude": -35.2332,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2609600,
        "nome": "Olinda",
        "latitude": -7.9931,
        "longitude": -34.8664,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2609709,
        "nome": "Orobó",
        "latitude": -7.706,
        "longitude": -35.5985,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2609808,
        "nome": "Orocó",
        "latitude": -8.4721,
        "longitude": -39.5911,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2609907,
        "nome": "Ouricuri",
        "latitude": -7.966,
        "longitude": -40.1645,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2610004,
        "nome": "Palmares",
        "latitude": -8.6565,
        "longitude": -35.6304,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2610103,
        "nome": "Palmeirina",
        "latitude": -9.0114,
        "longitude": -36.2777,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2610202,
        "nome": "Panelas",
        "latitude": -8.6651,
        "longitude": -36.0491,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2610301,
        "nome": "Paranatama",
        "latitude": -8.8939,
        "longitude": -36.7071,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2610400,
        "nome": "Parnamirim",
        "latitude": -8.16,
        "longitude": -39.77,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2610509,
        "nome": "Passira",
        "latitude": -8.0125,
        "longitude": -35.5463,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2610608,
        "nome": "Paudalho",
        "latitude": -7.9056,
        "longitude": -35.1551,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2610707,
        "nome": "Paulista",
        "latitude": -7.9282,
        "longitude": -34.8834,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2610806,
        "nome": "Pedra",
        "latitude": -8.6971,
        "longitude": -36.8999,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2610905,
        "nome": "Pesqueira",
        "latitude": -8.3924,
        "longitude": -36.7352,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2611002,
        "nome": "Petrolândia",
        "latitude": -8.8993,
        "longitude": -38.3079,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2611101,
        "nome": "Petrolina",
        "latitude": -9.0198,
        "longitude": -40.5724,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2611200,
        "nome": "Poção",
        "latitude": -8.2247,
        "longitude": -36.7113,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2611309,
        "nome": "Pombos",
        "latitude": -8.1798,
        "longitude": -35.3962,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2611408,
        "nome": "Primavera",
        "latitude": -8.327,
        "longitude": -35.3908,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2611507,
        "nome": "Quipapá",
        "latitude": -8.8361,
        "longitude": -36.0287,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2611533,
        "nome": "Quixaba",
        "latitude": -7.7176,
        "longitude": -37.8491,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2611606,
        "nome": "Recife",
        "latitude": -8.0393,
        "longitude": -34.9331,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2611705,
        "nome": "Riacho das Almas",
        "latitude": -8.0821,
        "longitude": -35.8827,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2611804,
        "nome": "Ribeirão",
        "latitude": -8.5046,
        "longitude": -35.3665,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2611903,
        "nome": "Rio Formoso",
        "latitude": -8.6751,
        "longitude": -35.2182,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2612000,
        "nome": "Sairé",
        "latitude": -8.3027,
        "longitude": -35.6845,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2612109,
        "nome": "Salgadinho",
        "latitude": -7.9161,
        "longitude": -35.5938,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2612208,
        "nome": "Salgueiro",
        "latitude": -8.1292,
        "longitude": -39.0898,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2612307,
        "nome": "Saloá",
        "latitude": -8.9916,
        "longitude": -36.7389,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2612406,
        "nome": "Sanharó",
        "latitude": -8.3648,
        "longitude": -36.5495,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2612455,
        "nome": "Santa Cruz",
        "latitude": -8.2912,
        "longitude": -40.3023,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2612471,
        "nome": "Santa Cruz da Baixa Verde",
        "latitude": -7.8495,
        "longitude": -38.1757,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2612505,
        "nome": "Santa Cruz do Capibaribe",
        "latitude": -7.8896,
        "longitude": -36.3253,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2612554,
        "nome": "Santa Filomena",
        "latitude": -8.2237,
        "longitude": -40.5715,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2612604,
        "nome": "Santa Maria da Boa Vista",
        "latitude": -8.6297,
        "longitude": -39.9143,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2612703,
        "nome": "Santa Maria do Cambucá",
        "latitude": -7.8247,
        "longitude": -35.8829,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2612802,
        "nome": "Santa Terezinha",
        "latitude": -7.4304,
        "longitude": -37.4365,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2612901,
        "nome": "São Benedito do Sul",
        "latitude": -8.8093,
        "longitude": -35.9067,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2613008,
        "nome": "São Bento do Una",
        "latitude": -8.5359,
        "longitude": -36.4506,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2613107,
        "nome": "São Caitano",
        "latitude": -8.3288,
        "longitude": -36.148,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2613206,
        "nome": "São João",
        "latitude": -8.8799,
        "longitude": -36.3776,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2613305,
        "nome": "São Joaquim do Monte",
        "latitude": -8.4538,
        "longitude": -35.8438,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2613404,
        "nome": "São José da Coroa Grande",
        "latitude": -8.8655,
        "longitude": -35.1852,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2613503,
        "nome": "São José do Belmonte",
        "latitude": -7.8658,
        "longitude": -38.7457,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2613602,
        "nome": "São José do Egito",
        "latitude": -7.5265,
        "longitude": -37.2742,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2613701,
        "nome": "São Lourenço da Mata",
        "latitude": -8.0231,
        "longitude": -35.1039,
        "mesorregiaoNome": "Metropolitana de Recife",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2613800,
        "nome": "São Vicente Férrer",
        "latitude": -7.6054,
        "longitude": -35.4899,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2613909,
        "nome": "Serra Talhada",
        "latitude": -8.0361,
        "longitude": -38.3697,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2614006,
        "nome": "Serrita",
        "latitude": -7.85,
        "longitude": -39.3816,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2614105,
        "nome": "Sertânia",
        "latitude": -8.2102,
        "longitude": -37.3359,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2614204,
        "nome": "Sirinhaém",
        "latitude": -8.5719,
        "longitude": -35.1722,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2614303,
        "nome": "Moreilândia",
        "latitude": -7.6181,
        "longitude": -39.5226,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2614402,
        "nome": "Solidão",
        "latitude": -7.5847,
        "longitude": -37.6514,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2614501,
        "nome": "Surubim",
        "latitude": -7.8919,
        "longitude": -35.7544,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2614600,
        "nome": "Tabira",
        "latitude": -7.5773,
        "longitude": -37.5129,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2614709,
        "nome": "Tacaimbó",
        "latitude": -8.348,
        "longitude": -36.2702,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2614808,
        "nome": "Tacaratu",
        "latitude": -8.9568,
        "longitude": -38.0765,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2614857,
        "nome": "Tamandaré",
        "latitude": -8.7457,
        "longitude": -35.23,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2615003,
        "nome": "Taquaritinga do Norte",
        "latitude": -7.8694,
        "longitude": -36.1305,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2615102,
        "nome": "Terezinha",
        "latitude": -9.0772,
        "longitude": -36.6312,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2615201,
        "nome": "Terra Nova",
        "latitude": -8.1577,
        "longitude": -39.3975,
        "mesorregiaoNome": "São Francisco Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2615300,
        "nome": "Timbaúba",
        "latitude": -7.5345,
        "longitude": -35.3415,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2615409,
        "nome": "Toritama",
        "latitude": -7.999,
        "longitude": -36.0557,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2615508,
        "nome": "Tracunhaém",
        "latitude": -7.7598,
        "longitude": -35.1611,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2615607,
        "nome": "Trindade",
        "latitude": -7.7278,
        "longitude": -40.295,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2615706,
        "nome": "Triunfo",
        "latitude": -7.8499,
        "longitude": -38.0666,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2615805,
        "nome": "Tupanatinga",
        "latitude": -8.6801,
        "longitude": -37.2692,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2615904,
        "nome": "Tuparetama",
        "latitude": -7.6866,
        "longitude": -37.2629,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2616001,
        "nome": "Venturosa",
        "latitude": -8.6164,
        "longitude": -36.805,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2616100,
        "nome": "Verdejante",
        "latitude": -7.9759,
        "longitude": -38.9891,
        "mesorregiaoNome": "Sertão Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2616183,
        "nome": "Vertente do Lério",
        "latitude": -7.7776,
        "longitude": -35.8155,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2616209,
        "nome": "Vertentes",
        "latitude": -7.8901,
        "longitude": -35.9823,
        "mesorregiaoNome": "Agreste Pernambucano",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2616308,
        "nome": "Vicência",
        "latitude": -7.6595,
        "longitude": -35.3572,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2616407,
        "nome": "Vitória de Santo Antão",
        "latitude": -8.154,
        "longitude": -35.292,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2616506,
        "nome": "Xexéu",
        "latitude": -8.8362,
        "longitude": -35.6533,
        "mesorregiaoNome": "Mata Pernambucana",
        "UFSigla": "PE",
        "UFNome": "Pernambuco"
    },
    {
        "ibgeId": 2700102,
        "nome": "Água Branca",
        "latitude": -9.265,
        "longitude": -37.8987,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2700201,
        "nome": "Anadia",
        "latitude": -9.663,
        "longitude": -36.3135,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2700300,
        "nome": "Arapiraca",
        "latitude": -9.7492,
        "longitude": -36.6409,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2700409,
        "nome": "Atalaia",
        "latitude": -9.5047,
        "longitude": -36.0725,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2700508,
        "nome": "Barra de Santo Antônio",
        "latitude": -9.382,
        "longitude": -35.5646,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2700607,
        "nome": "Barra de São Miguel",
        "latitude": -9.8124,
        "longitude": -35.9469,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2700706,
        "nome": "Batalha",
        "latitude": -9.7086,
        "longitude": -37.1006,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2700805,
        "nome": "Belém",
        "latitude": -9.5574,
        "longitude": -36.4918,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2700904,
        "nome": "Belo Monte",
        "latitude": -9.8177,
        "longitude": -37.1927,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2701001,
        "nome": "Boca da Mata",
        "latitude": -9.6689,
        "longitude": -36.1783,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2701100,
        "nome": "Branquinha",
        "latitude": -9.223,
        "longitude": -36.0421,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2701209,
        "nome": "Cacimbinhas",
        "latitude": -9.4468,
        "longitude": -36.9218,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2701308,
        "nome": "Cajueiro",
        "latitude": -9.3904,
        "longitude": -36.1578,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2701357,
        "nome": "Campestre",
        "latitude": -8.8928,
        "longitude": -35.5412,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2701407,
        "nome": "Campo Alegre",
        "latitude": -9.8149,
        "longitude": -36.2829,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2701506,
        "nome": "Campo Grande",
        "latitude": -9.9672,
        "longitude": -36.7463,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2701605,
        "nome": "Canapi",
        "latitude": -9.1247,
        "longitude": -37.5281,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2701704,
        "nome": "Capela",
        "latitude": -9.3451,
        "longitude": -36.0917,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2701803,
        "nome": "Carneiros",
        "latitude": -9.462,
        "longitude": -37.3658,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2701902,
        "nome": "Chã Preta",
        "latitude": -9.2424,
        "longitude": -36.2818,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2702009,
        "nome": "Coité do Nóia",
        "latitude": -9.6296,
        "longitude": -36.5822,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2702108,
        "nome": "Colônia Leopoldina",
        "latitude": -8.9389,
        "longitude": -35.7615,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2702207,
        "nome": "Coqueiro Seco",
        "latitude": -9.6423,
        "longitude": -35.8087,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2702306,
        "nome": "Coruripe",
        "latitude": -10.0825,
        "longitude": -36.2307,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2702355,
        "nome": "Craíbas",
        "latitude": -9.6294,
        "longitude": -36.7877,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2702405,
        "nome": "Delmiro Gouveia",
        "latitude": -9.3976,
        "longitude": -38.0471,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2702504,
        "nome": "Dois Riachos",
        "latitude": -9.3813,
        "longitude": -37.069,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2702553,
        "nome": "Estrela de Alagoas",
        "latitude": -9.3934,
        "longitude": -36.7702,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2702603,
        "nome": "Feira Grande",
        "latitude": -9.8893,
        "longitude": -36.6629,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2702702,
        "nome": "Feliz Deserto",
        "latitude": -10.2833,
        "longitude": -36.3359,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2702801,
        "nome": "Flexeiras",
        "latitude": -9.2451,
        "longitude": -35.7639,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2702900,
        "nome": "Girau do Ponciano",
        "latitude": -9.7927,
        "longitude": -36.8505,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2703007,
        "nome": "Ibateguara",
        "latitude": -8.9542,
        "longitude": -35.8962,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2703106,
        "nome": "Igaci",
        "latitude": -9.5434,
        "longitude": -36.682,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2703205,
        "nome": "Igreja Nova",
        "latitude": -10.1383,
        "longitude": -36.6191,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2703304,
        "nome": "Inhapi",
        "latitude": -9.2718,
        "longitude": -37.6922,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2703403,
        "nome": "Jacaré dos Homens",
        "latitude": -9.6521,
        "longitude": -37.2279,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2703502,
        "nome": "Jacuípe",
        "latitude": -8.8839,
        "longitude": -35.4473,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2703601,
        "nome": "Japaratinga",
        "latitude": -9.0835,
        "longitude": -35.2983,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2703700,
        "nome": "Jaramataia",
        "latitude": -9.6579,
        "longitude": -36.9938,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2703759,
        "nome": "Jequiá da Praia",
        "latitude": -9.9215,
        "longitude": -36.0973,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2703809,
        "nome": "Joaquim Gomes",
        "latitude": -9.0789,
        "longitude": -35.7778,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2703908,
        "nome": "Jundiá",
        "latitude": -8.9623,
        "longitude": -35.5367,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2704005,
        "nome": "Junqueiro",
        "latitude": -9.8563,
        "longitude": -36.4406,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2704104,
        "nome": "Lagoa da Canoa",
        "latitude": -9.7999,
        "longitude": -36.736,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2704203,
        "nome": "Limoeiro de Anadia",
        "latitude": -9.7324,
        "longitude": -36.4677,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2704302,
        "nome": "Maceió",
        "latitude": -9.5224,
        "longitude": -35.7114,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2704401,
        "nome": "Major Isidoro",
        "latitude": -9.542,
        "longitude": -37.0092,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2704500,
        "nome": "Maragogi",
        "latitude": -8.9517,
        "longitude": -35.2691,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2704609,
        "nome": "Maravilha",
        "latitude": -9.2441,
        "longitude": -37.3998,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2704708,
        "nome": "Marechal Deodoro",
        "latitude": -9.7153,
        "longitude": -35.9096,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2704807,
        "nome": "Maribondo",
        "latitude": -9.5593,
        "longitude": -36.2956,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2704906,
        "nome": "Mar Vermelho",
        "latitude": -9.4729,
        "longitude": -36.4031,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2705002,
        "nome": "Mata Grande",
        "latitude": -9.0518,
        "longitude": -37.7557,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2705101,
        "nome": "Matriz de Camaragibe",
        "latitude": -9.1045,
        "longitude": -35.5816,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2705200,
        "nome": "Messias",
        "latitude": -9.3436,
        "longitude": -35.8124,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2705309,
        "nome": "Minador do Negrão",
        "latitude": -9.3369,
        "longitude": -36.8635,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2705408,
        "nome": "Monteirópolis",
        "latitude": -9.6006,
        "longitude": -37.2961,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2705507,
        "nome": "Murici",
        "latitude": -9.2909,
        "longitude": -35.924,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2705606,
        "nome": "Novo Lino",
        "latitude": -8.9644,
        "longitude": -35.6306,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2705705,
        "nome": "Olho d'Água das Flores",
        "latitude": -9.533,
        "longitude": -37.2573,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2705804,
        "nome": "Olho d'Água do Casado",
        "latitude": -9.4358,
        "longitude": -37.8131,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2705903,
        "nome": "Olho d'Água Grande",
        "latitude": -10.0565,
        "longitude": -36.7926,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2706000,
        "nome": "Olivença",
        "latitude": -9.4896,
        "longitude": -37.1779,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2706109,
        "nome": "Ouro Branco",
        "latitude": -9.1278,
        "longitude": -37.3637,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2706208,
        "nome": "Palestina",
        "latitude": -9.6893,
        "longitude": -37.3025,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2706307,
        "nome": "Palmeira dos Índios",
        "latitude": -9.4182,
        "longitude": -36.6057,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2706406,
        "nome": "Pão de Açúcar",
        "latitude": -9.6706,
        "longitude": -37.4855,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2706422,
        "nome": "Pariconha",
        "latitude": -9.2405,
        "longitude": -38.0475,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2706448,
        "nome": "Paripueira",
        "latitude": -9.4356,
        "longitude": -35.5937,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2706505,
        "nome": "Passo de Camaragibe",
        "latitude": -9.256,
        "longitude": -35.5,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2706604,
        "nome": "Paulo Jacinto",
        "latitude": -9.3776,
        "longitude": -36.4094,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2706703,
        "nome": "Penedo",
        "latitude": -10.2314,
        "longitude": -36.4825,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2706802,
        "nome": "Piaçabuçu",
        "latitude": -10.3869,
        "longitude": -36.4017,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2706901,
        "nome": "Pilar",
        "latitude": -9.6153,
        "longitude": -36.0046,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2707008,
        "nome": "Pindoba",
        "latitude": -9.4758,
        "longitude": -36.2858,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2707107,
        "nome": "Piranhas",
        "latitude": -9.5261,
        "longitude": -37.7251,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2707206,
        "nome": "Poço das Trincheiras",
        "latitude": -9.2988,
        "longitude": -37.32,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2707305,
        "nome": "Porto Calvo",
        "latitude": -9.026,
        "longitude": -35.4268,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2707404,
        "nome": "Porto de Pedras",
        "latitude": -9.1437,
        "longitude": -35.4069,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2707503,
        "nome": "Porto Real do Colégio",
        "latitude": -10.1211,
        "longitude": -36.7362,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2707602,
        "nome": "Quebrangulo",
        "latitude": -9.3033,
        "longitude": -36.4612,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2707701,
        "nome": "Rio Largo",
        "latitude": -9.48,
        "longitude": -35.8644,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2707800,
        "nome": "Roteiro",
        "latitude": -9.8688,
        "longitude": -35.9804,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2707909,
        "nome": "Santa Luzia do Norte",
        "latitude": -9.6121,
        "longitude": -35.8299,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2708006,
        "nome": "Santana do Ipanema",
        "latitude": -9.359,
        "longitude": -37.2111,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2708105,
        "nome": "Santana do Mundaú",
        "latitude": -9.131,
        "longitude": -36.1913,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2708204,
        "nome": "São Brás",
        "latitude": -10.1087,
        "longitude": -36.8622,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2708303,
        "nome": "São José da Laje",
        "latitude": -8.9875,
        "longitude": -36.04,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2708402,
        "nome": "São José da Tapera",
        "latitude": -9.5331,
        "longitude": -37.4899,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2708501,
        "nome": "São Luís do Quitunde",
        "latitude": -9.2497,
        "longitude": -35.6342,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2708600,
        "nome": "São Miguel dos Campos",
        "latitude": -9.7728,
        "longitude": -36.1008,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2708709,
        "nome": "São Miguel dos Milagres",
        "latitude": -9.2308,
        "longitude": -35.4069,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2708808,
        "nome": "São Sebastião",
        "latitude": -9.9624,
        "longitude": -36.5502,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2708907,
        "nome": "Satuba",
        "latitude": -9.5781,
        "longitude": -35.8455,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2708956,
        "nome": "Senador Rui Palmeira",
        "latitude": -9.3907,
        "longitude": -37.5129,
        "mesorregiaoNome": "Sertão Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2709004,
        "nome": "Tanque d'Arca",
        "latitude": -9.5577,
        "longitude": -36.4229,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2709103,
        "nome": "Taquarana",
        "latitude": -9.6247,
        "longitude": -36.4953,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2709152,
        "nome": "Teotônio Vilela",
        "latitude": -9.9647,
        "longitude": -36.3715,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2709202,
        "nome": "Traipu",
        "latitude": -9.8976,
        "longitude": -36.9692,
        "mesorregiaoNome": "Agreste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2709301,
        "nome": "União dos Palmares",
        "latitude": -9.1203,
        "longitude": -36.0144,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2709400,
        "nome": "Viçosa",
        "latitude": -9.359,
        "longitude": -36.2655,
        "mesorregiaoNome": "Leste Alagoano",
        "UFSigla": "AL",
        "UFNome": "Alagoas"
    },
    {
        "ibgeId": 2800100,
        "nome": "Amparo do São Francisco",
        "latitude": -10.1656,
        "longitude": -36.9215,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2800209,
        "nome": "Aquidabã",
        "latitude": -10.2608,
        "longitude": -37.0641,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2800308,
        "nome": "Aracaju",
        "latitude": -10.9942,
        "longitude": -37.0949,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2800407,
        "nome": "Arauá",
        "latitude": -11.2604,
        "longitude": -37.5897,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2800506,
        "nome": "Areia Branca",
        "latitude": -10.7872,
        "longitude": -37.3315,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2800605,
        "nome": "Barra dos Coqueiros",
        "latitude": -10.8511,
        "longitude": -36.9694,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2800670,
        "nome": "Boquim",
        "latitude": -11.1203,
        "longitude": -37.597,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2800704,
        "nome": "Brejo Grande",
        "latitude": -10.4773,
        "longitude": -36.4739,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2801009,
        "nome": "Campo do Brito",
        "latitude": -10.7663,
        "longitude": -37.5007,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2801108,
        "nome": "Canhoba",
        "latitude": -10.1484,
        "longitude": -37.0007,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2801207,
        "nome": "Canindé de São Francisco",
        "latitude": -9.7129,
        "longitude": -37.8991,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2801306,
        "nome": "Capela",
        "latitude": -10.4688,
        "longitude": -37.0363,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2801405,
        "nome": "Carira",
        "latitude": -10.3637,
        "longitude": -37.7106,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2801504,
        "nome": "Carmópolis",
        "latitude": -10.6646,
        "longitude": -36.9661,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2801603,
        "nome": "Cedro de São João",
        "latitude": -10.2665,
        "longitude": -36.8992,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2801702,
        "nome": "Cristinápolis",
        "latitude": -11.482,
        "longitude": -37.7329,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2801900,
        "nome": "Cumbe",
        "latitude": -10.3484,
        "longitude": -37.1958,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2802007,
        "nome": "Divina Pastora",
        "latitude": -10.6759,
        "longitude": -37.1566,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2802106,
        "nome": "Estância",
        "latitude": -11.2495,
        "longitude": -37.3979,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2802205,
        "nome": "Feira Nova",
        "latitude": -10.2819,
        "longitude": -37.3301,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2802304,
        "nome": "Frei Paulo",
        "latitude": -10.5225,
        "longitude": -37.5899,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2802403,
        "nome": "Gararu",
        "latitude": -10.0279,
        "longitude": -37.2043,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2802502,
        "nome": "General Maynard",
        "latitude": -10.693,
        "longitude": -36.9711,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2802601,
        "nome": "Graccho Cardoso",
        "latitude": -10.2225,
        "longitude": -37.2193,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2802700,
        "nome": "Ilha das Flores",
        "latitude": -10.4566,
        "longitude": -36.5551,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2802809,
        "nome": "Indiaroba",
        "latitude": -11.4755,
        "longitude": -37.5289,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2802908,
        "nome": "Itabaiana",
        "latitude": -10.6856,
        "longitude": -37.4216,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2803005,
        "nome": "Itabaianinha",
        "latitude": -11.2587,
        "longitude": -37.7792,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2803104,
        "nome": "Itabi",
        "latitude": -10.1059,
        "longitude": -37.1439,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2803203,
        "nome": "Itaporanga d'Ajuda",
        "latitude": -11.0577,
        "longitude": -37.3182,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2803302,
        "nome": "Japaratuba",
        "latitude": -10.5532,
        "longitude": -36.903,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2803401,
        "nome": "Japoatã",
        "latitude": -10.4361,
        "longitude": -36.7887,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2803500,
        "nome": "Lagarto",
        "latitude": -10.9027,
        "longitude": -37.6644,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2803609,
        "nome": "Laranjeiras",
        "latitude": -10.8045,
        "longitude": -37.1862,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2803708,
        "nome": "Macambira",
        "latitude": -10.66,
        "longitude": -37.5969,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2803807,
        "nome": "Malhada dos Bois",
        "latitude": -10.3292,
        "longitude": -36.9444,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2803906,
        "nome": "Malhador",
        "latitude": -10.6729,
        "longitude": -37.2878,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2804003,
        "nome": "Maruim",
        "latitude": -10.7304,
        "longitude": -37.1052,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2804102,
        "nome": "Moita Bonita",
        "latitude": -10.5935,
        "longitude": -37.3404,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2804201,
        "nome": "Monte Alegre de Sergipe",
        "latitude": -10.0645,
        "longitude": -37.6163,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2804300,
        "nome": "Muribeca",
        "latitude": -10.384,
        "longitude": -36.959,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2804409,
        "nome": "Neópolis",
        "latitude": -10.3483,
        "longitude": -36.6604,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2804458,
        "nome": "Nossa Senhora Aparecida",
        "latitude": -10.3581,
        "longitude": -37.5049,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2804508,
        "nome": "Nossa Senhora da Glória",
        "latitude": -10.1783,
        "longitude": -37.5293,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2804607,
        "nome": "Nossa Senhora das Dores",
        "latitude": -10.4666,
        "longitude": -37.2404,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2804706,
        "nome": "Nossa Senhora de Lourdes",
        "latitude": -10.0768,
        "longitude": -37.0145,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2804805,
        "nome": "Nossa Senhora do Socorro",
        "latitude": -10.8638,
        "longitude": -37.1456,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2804904,
        "nome": "Pacatuba",
        "latitude": -10.5191,
        "longitude": -36.647,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2805000,
        "nome": "Pedra Mole",
        "latitude": -10.6248,
        "longitude": -37.6801,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2805109,
        "nome": "Pedrinhas",
        "latitude": -11.2044,
        "longitude": -37.6582,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2805208,
        "nome": "Pinhão",
        "latitude": -10.5633,
        "longitude": -37.7581,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2805307,
        "nome": "Pirambu",
        "latitude": -10.6539,
        "longitude": -36.805,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2805406,
        "nome": "Poço Redondo",
        "latitude": -9.8654,
        "longitude": -37.6993,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2805505,
        "nome": "Poço Verde",
        "latitude": -10.8007,
        "longitude": -38.1271,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2805604,
        "nome": "Porto da Folha",
        "latitude": -9.9137,
        "longitude": -37.4224,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2805703,
        "nome": "Propriá",
        "latitude": -10.2449,
        "longitude": -36.8031,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2805802,
        "nome": "Riachão do Dantas",
        "latitude": -11.034,
        "longitude": -37.8004,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2805901,
        "nome": "Riachuelo",
        "latitude": -10.7306,
        "longitude": -37.2253,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2806008,
        "nome": "Ribeirópolis",
        "latitude": -10.504,
        "longitude": -37.4294,
        "mesorregiaoNome": "Sertão Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2806107,
        "nome": "Rosário do Catete",
        "latitude": -10.6825,
        "longitude": -37.0355,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2806206,
        "nome": "Salgado",
        "latitude": -11.0627,
        "longitude": -37.4806,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2806305,
        "nome": "Santa Luzia do Itanhy",
        "latitude": -11.3616,
        "longitude": -37.5066,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2806404,
        "nome": "Santana do São Francisco",
        "latitude": -10.287,
        "longitude": -36.6367,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2806503,
        "nome": "Santa Rosa de Lima",
        "latitude": -10.632,
        "longitude": -37.2361,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2806602,
        "nome": "Santo Amaro das Brotas",
        "latitude": -10.7737,
        "longitude": -36.9826,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2806701,
        "nome": "São Cristóvão",
        "latitude": -10.9622,
        "longitude": -37.2204,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2806800,
        "nome": "São Domingos",
        "latitude": -10.7824,
        "longitude": -37.5748,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2806909,
        "nome": "São Francisco",
        "latitude": -10.3352,
        "longitude": -36.8669,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2807006,
        "nome": "São Miguel do Aleixo",
        "latitude": -10.4039,
        "longitude": -37.3623,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2807105,
        "nome": "Simão Dias",
        "latitude": -10.7565,
        "longitude": -37.8283,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2807204,
        "nome": "Siriri",
        "latitude": -10.5749,
        "longitude": -37.1252,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2807303,
        "nome": "Telha",
        "latitude": -10.1931,
        "longitude": -36.8895,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2807402,
        "nome": "Tobias Barreto",
        "latitude": -11.0423,
        "longitude": -38.0032,
        "mesorregiaoNome": "Agreste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2807501,
        "nome": "Tomar do Geru",
        "latitude": -11.3699,
        "longitude": -37.8752,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2807600,
        "nome": "Umbaúba",
        "latitude": -11.3999,
        "longitude": -37.6624,
        "mesorregiaoNome": "Leste Sergipano",
        "UFSigla": "SE",
        "UFNome": "Sergipe"
    },
    {
        "ibgeId": 2900108,
        "nome": "Abaíra",
        "latitude": -13.2966,
        "longitude": -41.7429,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2900207,
        "nome": "Abaré",
        "latitude": -8.8335,
        "longitude": -39.3177,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2900306,
        "nome": "Acajutiba",
        "latitude": -11.6632,
        "longitude": -38.0005,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2900355,
        "nome": "Adustina",
        "latitude": -10.5623,
        "longitude": -38.0376,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2900405,
        "nome": "Água Fria",
        "latitude": -11.8232,
        "longitude": -38.7105,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2900504,
        "nome": "Érico Cardoso",
        "latitude": -13.4002,
        "longitude": -42.0673,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2900603,
        "nome": "Aiquara",
        "latitude": -14.0918,
        "longitude": -39.8809,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2900702,
        "nome": "Alagoinhas",
        "latitude": -12.1131,
        "longitude": -38.4022,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2900801,
        "nome": "Alcobaça",
        "latitude": -17.4692,
        "longitude": -39.4096,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2900900,
        "nome": "Almadina",
        "latitude": -14.7013,
        "longitude": -39.6641,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2901007,
        "nome": "Amargosa",
        "latitude": -13.0409,
        "longitude": -39.6263,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2901106,
        "nome": "Amélia Rodrigues",
        "latitude": -12.4212,
        "longitude": -38.7205,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2901155,
        "nome": "América Dourada",
        "latitude": -11.4062,
        "longitude": -41.5229,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2901205,
        "nome": "Anagé",
        "latitude": -14.5899,
        "longitude": -40.9277,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2901304,
        "nome": "Andaraí",
        "latitude": -12.7336,
        "longitude": -41.215,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2901353,
        "nome": "Andorinha",
        "latitude": -10.2808,
        "longitude": -39.8719,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2901403,
        "nome": "Angical",
        "latitude": -11.9966,
        "longitude": -44.6478,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2901502,
        "nome": "Anguera",
        "latitude": -12.183,
        "longitude": -39.1928,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2901601,
        "nome": "Antas",
        "latitude": -10.3967,
        "longitude": -38.3004,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2901700,
        "nome": "Antônio Cardoso",
        "latitude": -12.3798,
        "longitude": -39.1471,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2901809,
        "nome": "Antônio Gonçalves",
        "latitude": -10.6015,
        "longitude": -40.3624,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2901908,
        "nome": "Aporá",
        "latitude": -11.7316,
        "longitude": -38.1938,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2901957,
        "nome": "Apuarema",
        "latitude": -13.82,
        "longitude": -39.7516,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2902005,
        "nome": "Aracatu",
        "latitude": -14.3712,
        "longitude": -41.3745,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2902054,
        "nome": "Araçás",
        "latitude": -12.1729,
        "longitude": -38.2125,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2902104,
        "nome": "Araci",
        "latitude": -11.2125,
        "longitude": -39.0645,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2902203,
        "nome": "Aramari",
        "latitude": -12.0507,
        "longitude": -38.525,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2902252,
        "nome": "Arataca",
        "latitude": -15.2433,
        "longitude": -39.4122,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2902302,
        "nome": "Aratuípe",
        "latitude": -13.0846,
        "longitude": -39.0694,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2902401,
        "nome": "Aurelino Leal",
        "latitude": -14.3621,
        "longitude": -39.4783,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2902500,
        "nome": "Baianópolis",
        "latitude": -12.6572,
        "longitude": -44.4403,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2902609,
        "nome": "Baixa Grande",
        "latitude": -11.9648,
        "longitude": -40.1528,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2902658,
        "nome": "Banzaê",
        "latitude": -10.6165,
        "longitude": -38.6543,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2902708,
        "nome": "Barra",
        "latitude": -11.0306,
        "longitude": -43.3661,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2902807,
        "nome": "Barra da Estiva",
        "latitude": -13.6505,
        "longitude": -41.0981,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2902906,
        "nome": "Barra do Choça",
        "latitude": -14.9131,
        "longitude": -40.5813,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2903003,
        "nome": "Barra do Mendes",
        "latitude": -11.95,
        "longitude": -42.1095,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2903102,
        "nome": "Barra do Rocha",
        "latitude": -14.1025,
        "longitude": -39.5879,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2903201,
        "nome": "Barreiras",
        "latitude": -12.0128,
        "longitude": -45.5423,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2903235,
        "nome": "Barro Alto",
        "latitude": -11.848,
        "longitude": -41.8368,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2903276,
        "nome": "Barrocas",
        "latitude": -11.538,
        "longitude": -39.0949,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2903300,
        "nome": "Barro Preto",
        "latitude": -14.7759,
        "longitude": -39.4447,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2903409,
        "nome": "Belmonte",
        "latitude": -15.9365,
        "longitude": -39.1738,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2903508,
        "nome": "Belo Campo",
        "latitude": -14.9985,
        "longitude": -41.2038,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2903607,
        "nome": "Biritinga",
        "latitude": -11.5853,
        "longitude": -38.7926,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2903706,
        "nome": "Boa Nova",
        "latitude": -14.3602,
        "longitude": -40.23,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2903805,
        "nome": "Boa Vista do Tupim",
        "latitude": -12.7702,
        "longitude": -40.6702,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2903904,
        "nome": "Bom Jesus da Lapa",
        "latitude": -13.2771,
        "longitude": -43.2934,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2903953,
        "nome": "Bom Jesus da Serra",
        "latitude": -14.3899,
        "longitude": -40.5773,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2904001,
        "nome": "Boninal",
        "latitude": -12.7767,
        "longitude": -41.8025,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2904050,
        "nome": "Bonito",
        "latitude": -11.9693,
        "longitude": -41.3204,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2904100,
        "nome": "Boquira",
        "latitude": -12.7411,
        "longitude": -42.7223,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2904209,
        "nome": "Botuporã",
        "latitude": -13.3262,
        "longitude": -42.5347,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2904308,
        "nome": "Brejões",
        "latitude": -13.0754,
        "longitude": -39.8508,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2904407,
        "nome": "Brejolândia",
        "latitude": -12.4994,
        "longitude": -43.8248,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2904506,
        "nome": "Brotas de Macaúbas",
        "latitude": -12.0893,
        "longitude": -42.447,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2904605,
        "nome": "Brumado",
        "latitude": -14.1679,
        "longitude": -41.6891,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2904704,
        "nome": "Buerarema",
        "latitude": -14.9964,
        "longitude": -39.2696,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2904753,
        "nome": "Buritirama",
        "latitude": -10.5881,
        "longitude": -43.6676,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2904803,
        "nome": "Caatiba",
        "latitude": -14.9958,
        "longitude": -40.3641,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2904852,
        "nome": "Cabaceiras do Paraguaçu",
        "latitude": -12.5643,
        "longitude": -39.1925,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2904902,
        "nome": "Cachoeira",
        "latitude": -12.6467,
        "longitude": -38.8849,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2905008,
        "nome": "Caculé",
        "latitude": -14.4829,
        "longitude": -42.285,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2905107,
        "nome": "Caém",
        "latitude": -11.1431,
        "longitude": -40.2911,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2905156,
        "nome": "Caetanos",
        "latitude": -14.3137,
        "longitude": -40.9267,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2905206,
        "nome": "Caetité",
        "latitude": -13.948,
        "longitude": -42.4766,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2905305,
        "nome": "Cafarnaum",
        "latitude": -11.7338,
        "longitude": -41.5014,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2905404,
        "nome": "Cairu",
        "latitude": -13.5069,
        "longitude": -38.9834,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2905503,
        "nome": "Caldeirão Grande",
        "latitude": -11.0399,
        "longitude": -40.2218,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2905602,
        "nome": "Camacan",
        "latitude": -15.4444,
        "longitude": -39.5187,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2905701,
        "nome": "Camaçari",
        "latitude": -12.666,
        "longitude": -38.2063,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2905800,
        "nome": "Camamu",
        "latitude": -14.0126,
        "longitude": -39.1642,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2905909,
        "nome": "Campo Alegre de Lourdes",
        "latitude": -9.5616,
        "longitude": -43.1589,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906006,
        "nome": "Campo Formoso",
        "latitude": -10.2511,
        "longitude": -40.7289,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906105,
        "nome": "Canápolis",
        "latitude": -13.0966,
        "longitude": -44.2036,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906204,
        "nome": "Canarana",
        "latitude": -11.7529,
        "longitude": -41.6996,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906303,
        "nome": "Canavieiras",
        "latitude": -15.6515,
        "longitude": -39.1088,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906402,
        "nome": "Candeal",
        "latitude": -11.8711,
        "longitude": -39.1908,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906501,
        "nome": "Candeias",
        "latitude": -12.6785,
        "longitude": -38.4812,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906600,
        "nome": "Candiba",
        "latitude": -14.4042,
        "longitude": -42.8317,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906709,
        "nome": "Cândido Sales",
        "latitude": -15.3551,
        "longitude": -41.2695,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906808,
        "nome": "Cansanção",
        "latitude": -10.7269,
        "longitude": -39.4727,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906824,
        "nome": "Canudos",
        "latitude": -10.0059,
        "longitude": -38.9945,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906857,
        "nome": "Capela do Alto Alegre",
        "latitude": -11.6723,
        "longitude": -39.825,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906873,
        "nome": "Capim Grosso",
        "latitude": -11.3063,
        "longitude": -39.9959,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906899,
        "nome": "Caraíbas",
        "latitude": -14.6256,
        "longitude": -41.2837,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2906907,
        "nome": "Caravelas",
        "latitude": -17.6574,
        "longitude": -39.6893,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2907004,
        "nome": "Cardeal da Silva",
        "latitude": -12.043,
        "longitude": -37.9384,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2907103,
        "nome": "Carinhanha",
        "latitude": -14.0205,
        "longitude": -43.8489,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2907202,
        "nome": "Casa Nova",
        "latitude": -9.2403,
        "longitude": -41.3365,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2907301,
        "nome": "Castro Alves",
        "latitude": -12.7316,
        "longitude": -39.364,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2907400,
        "nome": "Catolândia",
        "latitude": -12.2734,
        "longitude": -44.6971,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2907509,
        "nome": "Catu",
        "latitude": -12.3306,
        "longitude": -38.4129,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2907558,
        "nome": "Caturama",
        "latitude": -13.2335,
        "longitude": -42.3194,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2907608,
        "nome": "Central",
        "latitude": -11.1513,
        "longitude": -42.1124,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2907707,
        "nome": "Chorrochó",
        "latitude": -9.2717,
        "longitude": -39.1891,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2907806,
        "nome": "Cícero Dantas",
        "latitude": -10.5064,
        "longitude": -38.4547,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2907905,
        "nome": "Cipó",
        "latitude": -11.1078,
        "longitude": -38.5231,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2908002,
        "nome": "Coaraci",
        "latitude": -14.6318,
        "longitude": -39.5932,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2908101,
        "nome": "Cocos",
        "latitude": -14.497,
        "longitude": -45.2201,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2908200,
        "nome": "Conceição da Feira",
        "latitude": -12.5049,
        "longitude": -38.9998,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2908309,
        "nome": "Conceição do Almeida",
        "latitude": -12.8599,
        "longitude": -39.2456,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2908408,
        "nome": "Conceição do Coité",
        "latitude": -11.5241,
        "longitude": -39.2498,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2908507,
        "nome": "Conceição do Jacuípe",
        "latitude": -12.3372,
        "longitude": -38.7422,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2908606,
        "nome": "Conde",
        "latitude": -11.8277,
        "longitude": -37.6776,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2908705,
        "nome": "Condeúba",
        "latitude": -14.9215,
        "longitude": -42.0511,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2908804,
        "nome": "Contendas do Sincorá",
        "latitude": -13.8383,
        "longitude": -41.0937,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2908903,
        "nome": "Coração de Maria",
        "latitude": -12.2106,
        "longitude": -38.7831,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2909000,
        "nome": "Cordeiros",
        "latitude": -15.041,
        "longitude": -41.9082,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2909109,
        "nome": "Coribe",
        "latitude": -13.8145,
        "longitude": -44.3764,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2909208,
        "nome": "Coronel João Sá",
        "latitude": -10.2802,
        "longitude": -37.9363,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2909307,
        "nome": "Correntina",
        "latitude": -13.4672,
        "longitude": -45.3959,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2909406,
        "nome": "Cotegipe",
        "latitude": -11.7111,
        "longitude": -44.328,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2909505,
        "nome": "Cravolândia",
        "latitude": -13.424,
        "longitude": -39.7845,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2909604,
        "nome": "Crisópolis",
        "latitude": -11.5181,
        "longitude": -38.1726,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2909703,
        "nome": "Cristópolis",
        "latitude": -12.194,
        "longitude": -44.2588,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2909802,
        "nome": "Cruz das Almas",
        "latitude": -12.683,
        "longitude": -39.1179,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2909901,
        "nome": "Curaçá",
        "latitude": -9.2225,
        "longitude": -39.6515,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910008,
        "nome": "Dário Meira",
        "latitude": -14.405,
        "longitude": -39.988,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910057,
        "nome": "Dias d'Ávila",
        "latitude": -12.6013,
        "longitude": -38.2824,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910107,
        "nome": "Dom Basílio",
        "latitude": -13.8563,
        "longitude": -41.7122,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910206,
        "nome": "Dom Macedo Costa",
        "latitude": -12.9124,
        "longitude": -39.174,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910305,
        "nome": "Elísio Medrado",
        "latitude": -12.9349,
        "longitude": -39.5263,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910404,
        "nome": "Encruzilhada",
        "latitude": -15.5949,
        "longitude": -40.9999,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910503,
        "nome": "Entre Rios",
        "latitude": -12.0636,
        "longitude": -38.0483,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910602,
        "nome": "Esplanada",
        "latitude": -11.9312,
        "longitude": -37.8853,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910701,
        "nome": "Euclides da Cunha",
        "latitude": -10.4642,
        "longitude": -38.9151,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910727,
        "nome": "Eunápolis",
        "latitude": -16.2988,
        "longitude": -39.6061,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910750,
        "nome": "Fátima",
        "latitude": -10.5965,
        "longitude": -38.2023,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910776,
        "nome": "Feira da Mata",
        "latitude": -14.1317,
        "longitude": -44.2322,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910800,
        "nome": "Feira de Santana",
        "latitude": -12.1931,
        "longitude": -39.034,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910859,
        "nome": "Filadélfia",
        "latitude": -10.7232,
        "longitude": -40.1369,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2910909,
        "nome": "Firmino Alves",
        "latitude": -14.9308,
        "longitude": -39.9113,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2911006,
        "nome": "Floresta Azul",
        "latitude": -14.8419,
        "longitude": -39.7175,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2911105,
        "nome": "Formosa do Rio Preto",
        "latitude": -11.0142,
        "longitude": -45.7453,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2911204,
        "nome": "Gandu",
        "latitude": -13.7887,
        "longitude": -39.4827,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2911253,
        "nome": "Gavião",
        "latitude": -11.5089,
        "longitude": -39.7573,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2911303,
        "nome": "Gentio do Ouro",
        "latitude": -11.4102,
        "longitude": -42.6052,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2911402,
        "nome": "Glória",
        "latitude": -9.2294,
        "longitude": -38.4448,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2911501,
        "nome": "Gongogi",
        "latitude": -14.2806,
        "longitude": -39.5819,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2911600,
        "nome": "Governador Mangabeira",
        "latitude": -12.5834,
        "longitude": -39.0724,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2911659,
        "nome": "Guajeru",
        "latitude": -14.559,
        "longitude": -41.9864,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2911709,
        "nome": "Guanambi",
        "latitude": -14.204,
        "longitude": -42.82,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2911808,
        "nome": "Guaratinga",
        "latitude": -16.5532,
        "longitude": -39.9377,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2911857,
        "nome": "Heliópolis",
        "latitude": -10.7378,
        "longitude": -38.3122,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2911907,
        "nome": "Iaçu",
        "latitude": -12.8135,
        "longitude": -40.1131,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2912004,
        "nome": "Ibiassucê",
        "latitude": -14.2915,
        "longitude": -42.3054,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2912103,
        "nome": "Ibicaraí",
        "latitude": -14.8488,
        "longitude": -39.5685,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2912202,
        "nome": "Ibicoara",
        "latitude": -13.381,
        "longitude": -41.3279,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2912301,
        "nome": "Ibicuí",
        "latitude": -14.6419,
        "longitude": -39.8638,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2912400,
        "nome": "Ibipeba",
        "latitude": -11.5707,
        "longitude": -42.1818,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2912509,
        "nome": "Ibipitanga",
        "latitude": -12.8593,
        "longitude": -42.3597,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2912608,
        "nome": "Ibiquera",
        "latitude": -12.6032,
        "longitude": -40.8848,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2912707,
        "nome": "Ibirapitanga",
        "latitude": -14.0607,
        "longitude": -39.4357,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2912806,
        "nome": "Ibirapuã",
        "latitude": -17.743,
        "longitude": -40.0128,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2912905,
        "nome": "Ibirataia",
        "latitude": -13.976,
        "longitude": -39.6262,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2913002,
        "nome": "Ibitiara",
        "latitude": -12.5759,
        "longitude": -42.2827,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2913101,
        "nome": "Ibititá",
        "latitude": -11.579,
        "longitude": -41.9151,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2913200,
        "nome": "Ibotirama",
        "latitude": -12.0386,
        "longitude": -43.2048,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2913309,
        "nome": "Ichu",
        "latitude": -11.7315,
        "longitude": -39.1523,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2913408,
        "nome": "Igaporã",
        "latitude": -13.8631,
        "longitude": -42.7041,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2913457,
        "nome": "Igrapiúna",
        "latitude": -13.871,
        "longitude": -39.2055,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2913507,
        "nome": "Iguaí",
        "latitude": -14.6324,
        "longitude": -40.0659,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2913606,
        "nome": "Ilhéus",
        "latitude": -14.7527,
        "longitude": -39.1918,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2913705,
        "nome": "Inhambupe",
        "latitude": -11.8051,
        "longitude": -38.4038,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2913804,
        "nome": "Ipecaetá",
        "latitude": -12.3074,
        "longitude": -39.327,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2913903,
        "nome": "Ipiaú",
        "latitude": -14.0549,
        "longitude": -39.7265,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2914000,
        "nome": "Ipirá",
        "latitude": -12.2112,
        "longitude": -39.7771,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2914109,
        "nome": "Ipupiara",
        "latitude": -11.8359,
        "longitude": -42.5018,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2914208,
        "nome": "Irajuba",
        "latitude": -13.2307,
        "longitude": -40.0523,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2914307,
        "nome": "Iramaia",
        "latitude": -13.4686,
        "longitude": -40.9208,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2914406,
        "nome": "Iraquara",
        "latitude": -12.2483,
        "longitude": -41.5831,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2914505,
        "nome": "Irará",
        "latitude": -12.0464,
        "longitude": -38.7539,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2914604,
        "nome": "Irecê",
        "latitude": -11.3094,
        "longitude": -41.839,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2914653,
        "nome": "Itabela",
        "latitude": -16.6629,
        "longitude": -39.5513,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2914703,
        "nome": "Itaberaba",
        "latitude": -12.4991,
        "longitude": -40.2623,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2914802,
        "nome": "Itabuna",
        "latitude": -14.8516,
        "longitude": -39.3128,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2914901,
        "nome": "Itacaré",
        "latitude": -14.3621,
        "longitude": -39.1578,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2915007,
        "nome": "Itaeté",
        "latitude": -13.0918,
        "longitude": -41.0404,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2915106,
        "nome": "Itagi",
        "latitude": -14.1623,
        "longitude": -40.0249,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2915205,
        "nome": "Itagibá",
        "latitude": -14.2526,
        "longitude": -39.8305,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2915304,
        "nome": "Itagimirim",
        "latitude": -16.0963,
        "longitude": -39.738,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2915353,
        "nome": "Itaguaçu da Bahia",
        "latitude": -10.7697,
        "longitude": -42.239,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2915403,
        "nome": "Itaju do Colônia",
        "latitude": -15.1483,
        "longitude": -39.7317,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2915502,
        "nome": "Itajuípe",
        "latitude": -14.6715,
        "longitude": -39.4449,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2915601,
        "nome": "Itamaraju",
        "latitude": -17.0088,
        "longitude": -39.7648,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2915700,
        "nome": "Itamari",
        "latitude": -13.7666,
        "longitude": -39.6671,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2915809,
        "nome": "Itambé",
        "latitude": -15.1582,
        "longitude": -40.4622,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2915908,
        "nome": "Itanagra",
        "latitude": -12.3153,
        "longitude": -38.0426,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2916005,
        "nome": "Itanhém",
        "latitude": -17.1154,
        "longitude": -40.3784,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2916104,
        "nome": "Itaparica",
        "latitude": -12.8922,
        "longitude": -38.655,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2916203,
        "nome": "Itapé",
        "latitude": -14.9544,
        "longitude": -39.4959,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2916302,
        "nome": "Itapebi",
        "latitude": -15.9105,
        "longitude": -39.6509,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2916401,
        "nome": "Itapetinga",
        "latitude": -15.2993,
        "longitude": -40.0575,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2916500,
        "nome": "Itapicuru",
        "latitude": -11.192,
        "longitude": -38.1942,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2916609,
        "nome": "Itapitanga",
        "latitude": -14.4729,
        "longitude": -39.62,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2916708,
        "nome": "Itaquara",
        "latitude": -13.4489,
        "longitude": -39.8985,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2916807,
        "nome": "Itarantim",
        "latitude": -15.6977,
        "longitude": -40.0491,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2916856,
        "nome": "Itatim",
        "latitude": -12.7128,
        "longitude": -39.7347,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2916906,
        "nome": "Itiruçu",
        "latitude": -13.4876,
        "longitude": -40.153,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2917003,
        "nome": "Itiúba",
        "latitude": -10.7314,
        "longitude": -39.8454,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2917102,
        "nome": "Itororó",
        "latitude": -15.0488,
        "longitude": -40.0071,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2917201,
        "nome": "Ituaçu",
        "latitude": -13.8371,
        "longitude": -41.39,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2917300,
        "nome": "Ituberá",
        "latitude": -13.7493,
        "longitude": -39.153,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2917334,
        "nome": "Iuiu",
        "latitude": -14.4665,
        "longitude": -43.5435,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2917359,
        "nome": "Jaborandi",
        "latitude": -14.0319,
        "longitude": -45.4404,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2917409,
        "nome": "Jacaraci",
        "latitude": -14.7848,
        "longitude": -42.3223,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2917508,
        "nome": "Jacobina",
        "latitude": -11.1349,
        "longitude": -40.5685,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2917607,
        "nome": "Jaguaquara",
        "latitude": -13.5539,
        "longitude": -39.957,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2917706,
        "nome": "Jaguarari",
        "latitude": -10.0426,
        "longitude": -40.0683,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2917805,
        "nome": "Jaguaripe",
        "latitude": -13.1213,
        "longitude": -38.9866,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2917904,
        "nome": "Jandaíra",
        "latitude": -11.5984,
        "longitude": -37.5952,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918001,
        "nome": "Jequié",
        "latitude": -13.8776,
        "longitude": -40.1461,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918100,
        "nome": "Jeremoabo",
        "latitude": -9.9814,
        "longitude": -38.4993,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918209,
        "nome": "Jiquiriçá",
        "latitude": -13.3245,
        "longitude": -39.5847,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918308,
        "nome": "Jitaúna",
        "latitude": -13.958,
        "longitude": -39.8667,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918357,
        "nome": "João Dourado",
        "latitude": -11.2202,
        "longitude": -41.5672,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918407,
        "nome": "Juazeiro",
        "latitude": -9.5569,
        "longitude": -40.2747,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918456,
        "nome": "Jucuruçu",
        "latitude": -16.8456,
        "longitude": -40.1008,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918506,
        "nome": "Jussara",
        "latitude": -10.9255,
        "longitude": -41.8803,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918555,
        "nome": "Jussari",
        "latitude": -15.1366,
        "longitude": -39.498,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918605,
        "nome": "Jussiape",
        "latitude": -13.5113,
        "longitude": -41.5989,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918704,
        "nome": "Lafaiete Coutinho",
        "latitude": -13.6416,
        "longitude": -40.2926,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918753,
        "nome": "Lagoa Real",
        "latitude": -14.0473,
        "longitude": -42.2196,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918803,
        "nome": "Laje",
        "latitude": -13.167,
        "longitude": -39.3464,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2918902,
        "nome": "Lajedão",
        "latitude": -17.5596,
        "longitude": -40.3098,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919009,
        "nome": "Lajedinho",
        "latitude": -12.381,
        "longitude": -40.9634,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919058,
        "nome": "Lajedo do Tabocal",
        "latitude": -13.4602,
        "longitude": -40.2823,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919108,
        "nome": "Lamarão",
        "latitude": -11.7859,
        "longitude": -38.91,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919157,
        "nome": "Lapão",
        "latitude": -11.5013,
        "longitude": -41.7767,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919207,
        "nome": "Lauro de Freitas",
        "latitude": -12.8636,
        "longitude": -38.3272,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919306,
        "nome": "Lençóis",
        "latitude": -12.4249,
        "longitude": -41.3373,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919405,
        "nome": "Licínio de Almeida",
        "latitude": -14.586,
        "longitude": -42.4701,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919504,
        "nome": "Livramento de Nossa Senhora",
        "latitude": -13.8107,
        "longitude": -41.9909,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919553,
        "nome": "Luís Eduardo Magalhães",
        "latitude": -12.1982,
        "longitude": -46.0202,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919603,
        "nome": "Macajuba",
        "latitude": -12.1293,
        "longitude": -40.2623,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919702,
        "nome": "Macarani",
        "latitude": -15.5458,
        "longitude": -40.401,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919801,
        "nome": "Macaúbas",
        "latitude": -13.1081,
        "longitude": -42.6929,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919900,
        "nome": "Macururé",
        "latitude": -9.2911,
        "longitude": -38.8967,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919926,
        "nome": "Madre de Deus",
        "latitude": -12.7415,
        "longitude": -38.6423,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2919959,
        "nome": "Maetinga",
        "latitude": -14.6556,
        "longitude": -41.5162,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2920007,
        "nome": "Maiquinique",
        "latitude": -15.674,
        "longitude": -40.2691,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2920106,
        "nome": "Mairi",
        "latitude": -11.7317,
        "longitude": -40.1806,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2920205,
        "nome": "Malhada",
        "latitude": -14.2152,
        "longitude": -43.6459,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2920304,
        "nome": "Malhada de Pedras",
        "latitude": -14.3524,
        "longitude": -41.8452,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2920403,
        "nome": "Manoel Vitorino",
        "latitude": -14.0509,
        "longitude": -40.5476,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2920452,
        "nome": "Mansidão",
        "latitude": -11.1281,
        "longitude": -44.1084,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2920502,
        "nome": "Maracás",
        "latitude": -13.4952,
        "longitude": -40.5552,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2920601,
        "nome": "Maragogipe",
        "latitude": -12.823,
        "longitude": -38.9383,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2920700,
        "nome": "Maraú",
        "latitude": -14.1557,
        "longitude": -39.1505,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2920809,
        "nome": "Marcionílio Souza",
        "latitude": -13.1401,
        "longitude": -40.6753,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2920908,
        "nome": "Mascote",
        "latitude": -15.6661,
        "longitude": -39.4205,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2921005,
        "nome": "Mata de São João",
        "latitude": -12.484,
        "longitude": -38.1489,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2921054,
        "nome": "Matina",
        "latitude": -13.8488,
        "longitude": -42.9401,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2921104,
        "nome": "Medeiros Neto",
        "latitude": -17.3613,
        "longitude": -40.2856,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2921203,
        "nome": "Miguel Calmon",
        "latitude": -11.4206,
        "longitude": -40.6242,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2921302,
        "nome": "Milagres",
        "latitude": -12.8999,
        "longitude": -39.7976,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2921401,
        "nome": "Mirangaba",
        "latitude": -10.777,
        "longitude": -40.7145,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2921450,
        "nome": "Mirante",
        "latitude": -14.1678,
        "longitude": -40.7641,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2921500,
        "nome": "Monte Santo",
        "latitude": -10.383,
        "longitude": -39.4542,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2921609,
        "nome": "Morpará",
        "latitude": -11.7508,
        "longitude": -43.0398,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2921708,
        "nome": "Morro do Chapéu",
        "latitude": -11.4649,
        "longitude": -41.1671,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2921807,
        "nome": "Mortugaba",
        "latitude": -14.9726,
        "longitude": -42.3203,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2921906,
        "nome": "Mucugê",
        "latitude": -13.065,
        "longitude": -41.4749,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922003,
        "nome": "Mucuri",
        "latitude": -18.0592,
        "longitude": -39.867,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922052,
        "nome": "Mulungu do Morro",
        "latitude": -11.9778,
        "longitude": -41.5239,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922102,
        "nome": "Mundo Novo",
        "latitude": -11.9528,
        "longitude": -40.5594,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922201,
        "nome": "Muniz Ferreira",
        "latitude": -13.0025,
        "longitude": -39.0877,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922250,
        "nome": "Muquém do São Francisco",
        "latitude": -12.2118,
        "longitude": -43.4987,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922300,
        "nome": "Muritiba",
        "latitude": -12.6218,
        "longitude": -39.0863,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922409,
        "nome": "Mutuípe",
        "latitude": -13.3119,
        "longitude": -39.5066,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922508,
        "nome": "Nazaré",
        "latitude": -12.9537,
        "longitude": -38.9809,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922607,
        "nome": "Nilo Peçanha",
        "latitude": -13.6601,
        "longitude": -39.1741,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922656,
        "nome": "Nordestina",
        "latitude": -10.8731,
        "longitude": -39.4514,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922706,
        "nome": "Nova Canaã",
        "latitude": -14.8575,
        "longitude": -40.1803,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922730,
        "nome": "Nova Fátima",
        "latitude": -11.6214,
        "longitude": -39.6356,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922755,
        "nome": "Nova Ibiá",
        "latitude": -13.825,
        "longitude": -39.5828,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922805,
        "nome": "Nova Itarana",
        "latitude": -13.0465,
        "longitude": -40.0346,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922854,
        "nome": "Nova Redenção",
        "latitude": -12.8001,
        "longitude": -41.0912,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2922904,
        "nome": "Nova Soure",
        "latitude": -11.312,
        "longitude": -38.5548,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2923001,
        "nome": "Nova Viçosa",
        "latitude": -17.8997,
        "longitude": -39.7154,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2923035,
        "nome": "Novo Horizonte",
        "latitude": -12.8409,
        "longitude": -42.1287,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2923050,
        "nome": "Novo Triunfo",
        "latitude": -10.3593,
        "longitude": -38.4527,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2923100,
        "nome": "Olindina",
        "latitude": -11.4349,
        "longitude": -38.3548,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2923209,
        "nome": "Oliveira dos Brejinhos",
        "latitude": -12.2834,
        "longitude": -42.7349,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2923308,
        "nome": "Ouriçangas",
        "latitude": -12.0093,
        "longitude": -38.6537,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2923357,
        "nome": "Ourolândia",
        "latitude": -10.8479,
        "longitude": -41.1371,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2923407,
        "nome": "Palmas de Monte Alto",
        "latitude": -14.1752,
        "longitude": -43.2176,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2923506,
        "nome": "Palmeiras",
        "latitude": -12.5525,
        "longitude": -41.5539,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2923605,
        "nome": "Paramirim",
        "latitude": -13.5197,
        "longitude": -42.2404,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2923704,
        "nome": "Paratinga",
        "latitude": -12.6907,
        "longitude": -43.0645,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2923803,
        "nome": "Paripiranga",
        "latitude": -10.6143,
        "longitude": -37.8992,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2923902,
        "nome": "Pau Brasil",
        "latitude": -15.4683,
        "longitude": -39.6905,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2924009,
        "nome": "Paulo Afonso",
        "latitude": -9.5396,
        "longitude": -38.2937,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2924058,
        "nome": "Pé de Serra",
        "latitude": -11.872,
        "longitude": -39.6097,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2924108,
        "nome": "Pedrão",
        "latitude": -12.1296,
        "longitude": -38.6405,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2924207,
        "nome": "Pedro Alexandre",
        "latitude": -10.0622,
        "longitude": -37.9407,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2924306,
        "nome": "Piatã",
        "latitude": -13.046,
        "longitude": -41.8774,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2924405,
        "nome": "Pilão Arcado",
        "latitude": -10.0078,
        "longitude": -43.1152,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2924504,
        "nome": "Pindaí",
        "latitude": -14.4716,
        "longitude": -42.6786,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2924603,
        "nome": "Pindobaçu",
        "latitude": -10.7239,
        "longitude": -40.341,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2924652,
        "nome": "Pintadas",
        "latitude": -11.8689,
        "longitude": -39.898,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2924678,
        "nome": "Piraí do Norte",
        "latitude": -13.8054,
        "longitude": -39.3769,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2924702,
        "nome": "Piripá",
        "latitude": -15.0039,
        "longitude": -41.7175,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2924801,
        "nome": "Piritiba",
        "latitude": -11.695,
        "longitude": -40.6054,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2924900,
        "nome": "Planaltino",
        "latitude": -13.1865,
        "longitude": -40.3032,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925006,
        "nome": "Planalto",
        "latitude": -14.7086,
        "longitude": -40.4574,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925105,
        "nome": "Poções",
        "latitude": -14.5364,
        "longitude": -40.3826,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925204,
        "nome": "Pojuca",
        "latitude": -12.3617,
        "longitude": -38.253,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925253,
        "nome": "Ponto Novo",
        "latitude": -10.9589,
        "longitude": -40.1057,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925303,
        "nome": "Porto Seguro",
        "latitude": -16.625,
        "longitude": -39.2791,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925402,
        "nome": "Potiraguá",
        "latitude": -15.6812,
        "longitude": -39.7721,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925501,
        "nome": "Prado",
        "latitude": -17.1304,
        "longitude": -39.3517,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925600,
        "nome": "Presidente Dutra",
        "latitude": -11.3034,
        "longitude": -41.9953,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925709,
        "nome": "Presidente Jânio Quadros",
        "latitude": -14.6966,
        "longitude": -41.7259,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925758,
        "nome": "Presidente Tancredo Neves",
        "latitude": -13.4492,
        "longitude": -39.4176,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925808,
        "nome": "Queimadas",
        "latitude": -11.0567,
        "longitude": -39.7525,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925907,
        "nome": "Quijingue",
        "latitude": -10.7781,
        "longitude": -39.0498,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925931,
        "nome": "Quixabeira",
        "latitude": -11.3925,
        "longitude": -40.1186,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2925956,
        "nome": "Rafael Jambeiro",
        "latitude": -12.4787,
        "longitude": -39.5741,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2926004,
        "nome": "Remanso",
        "latitude": -9.5948,
        "longitude": -42.2453,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2926103,
        "nome": "Retirolândia",
        "latitude": -11.503,
        "longitude": -39.4167,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2926202,
        "nome": "Riachão das Neves",
        "latitude": -11.6228,
        "longitude": -45.2173,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2926301,
        "nome": "Riachão do Jacuípe",
        "latitude": -11.801,
        "longitude": -39.4235,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2926400,
        "nome": "Riacho de Santana",
        "latitude": -13.6332,
        "longitude": -43.0497,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2926509,
        "nome": "Ribeira do Amparo",
        "latitude": -10.9677,
        "longitude": -38.3783,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2926608,
        "nome": "Ribeira do Pombal",
        "latitude": -10.794,
        "longitude": -38.5469,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2926657,
        "nome": "Ribeirão do Largo",
        "latitude": -15.4272,
        "longitude": -40.6518,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2926707,
        "nome": "Rio de Contas",
        "latitude": -13.5816,
        "longitude": -41.7466,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2926806,
        "nome": "Rio do Antônio",
        "latitude": -14.3103,
        "longitude": -42.0841,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2926905,
        "nome": "Rio do Pires",
        "latitude": -13.1348,
        "longitude": -42.1477,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2927002,
        "nome": "Rio Real",
        "latitude": -11.5477,
        "longitude": -37.9127,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2927101,
        "nome": "Rodelas",
        "latitude": -9.1839,
        "longitude": -38.6925,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2927200,
        "nome": "Ruy Barbosa",
        "latitude": -12.2435,
        "longitude": -40.6297,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2927309,
        "nome": "Salinas da Margarida",
        "latitude": -12.8859,
        "longitude": -38.7591,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2927408,
        "nome": "Salvador",
        "latitude": -12.8736,
        "longitude": -38.5146,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2927507,
        "nome": "Santa Bárbara",
        "latitude": -11.9394,
        "longitude": -38.9823,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2927606,
        "nome": "Santa Brígida",
        "latitude": -9.7694,
        "longitude": -38.1694,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2927705,
        "nome": "Santa Cruz Cabrália",
        "latitude": -16.2292,
        "longitude": -39.201,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2927804,
        "nome": "Santa Cruz da Vitória",
        "latitude": -14.8917,
        "longitude": -39.8148,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2927903,
        "nome": "Santa Inês",
        "latitude": -13.2842,
        "longitude": -39.8503,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2928000,
        "nome": "Santaluz",
        "latitude": -11.2202,
        "longitude": -39.4852,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2928059,
        "nome": "Santa Luzia",
        "latitude": -15.4482,
        "longitude": -39.245,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2928109,
        "nome": "Santa Maria da Vitória",
        "latitude": -13.2184,
        "longitude": -44.38,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2928208,
        "nome": "Santana",
        "latitude": -13.0657,
        "longitude": -43.9424,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2928307,
        "nome": "Santanópolis",
        "latitude": -11.9752,
        "longitude": -38.8623,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2928406,
        "nome": "Santa Rita de Cássia",
        "latitude": -11.008,
        "longitude": -44.5558,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2928505,
        "nome": "Santa Terezinha",
        "latitude": -12.7342,
        "longitude": -39.5717,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2928604,
        "nome": "Santo Amaro",
        "latitude": -12.5618,
        "longitude": -38.7644,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2928703,
        "nome": "Santo Antônio de Jesus",
        "latitude": -13.0083,
        "longitude": -39.2266,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2928802,
        "nome": "Santo Estêvão",
        "latitude": -12.4683,
        "longitude": -39.269,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2928901,
        "nome": "São Desidério",
        "latitude": -12.8023,
        "longitude": -45.4928,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2928950,
        "nome": "São Domingos",
        "latitude": -11.4544,
        "longitude": -39.5804,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929008,
        "nome": "São Félix",
        "latitude": -12.675,
        "longitude": -38.999,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929057,
        "nome": "São Félix do Coribe",
        "latitude": -13.5516,
        "longitude": -44.0298,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929107,
        "nome": "São Felipe",
        "latitude": -12.8453,
        "longitude": -39.0947,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929206,
        "nome": "São Francisco do Conde",
        "latitude": -12.6508,
        "longitude": -38.632,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929255,
        "nome": "São Gabriel",
        "latitude": -11.0664,
        "longitude": -41.6983,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929305,
        "nome": "São Gonçalo dos Campos",
        "latitude": -12.4172,
        "longitude": -38.9414,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929354,
        "nome": "São José da Vitória",
        "latitude": -15.0734,
        "longitude": -39.3538,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929370,
        "nome": "São José do Jacuípe",
        "latitude": -11.44,
        "longitude": -39.9103,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929404,
        "nome": "São Miguel das Matas",
        "latitude": -13.0541,
        "longitude": -39.4233,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929503,
        "nome": "São Sebastião do Passé",
        "latitude": -12.5172,
        "longitude": -38.4982,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929602,
        "nome": "Sapeaçu",
        "latitude": -12.7259,
        "longitude": -39.2129,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929701,
        "nome": "Sátiro Dias",
        "latitude": -11.5725,
        "longitude": -38.5901,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929750,
        "nome": "Saubara",
        "latitude": -12.7754,
        "longitude": -38.7693,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929800,
        "nome": "Saúde",
        "latitude": -10.9125,
        "longitude": -40.3813,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2929909,
        "nome": "Seabra",
        "latitude": -12.4177,
        "longitude": -41.8848,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930006,
        "nome": "Sebastião Laranjeiras",
        "latitude": -14.5734,
        "longitude": -43.1273,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930105,
        "nome": "Senhor do Bonfim",
        "latitude": -10.4842,
        "longitude": -40.1152,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930154,
        "nome": "Serra do Ramalho",
        "latitude": -13.4843,
        "longitude": -43.6762,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930204,
        "nome": "Sento Sé",
        "latitude": -10.1081,
        "longitude": -41.6488,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930303,
        "nome": "Serra Dourada",
        "latitude": -12.8063,
        "longitude": -43.7976,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930402,
        "nome": "Serra Preta",
        "latitude": -12.0954,
        "longitude": -39.3786,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930501,
        "nome": "Serrinha",
        "latitude": -11.6657,
        "longitude": -38.9938,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930600,
        "nome": "Serrolândia",
        "latitude": -11.429,
        "longitude": -40.2609,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930709,
        "nome": "Simões Filho",
        "latitude": -12.7677,
        "longitude": -38.4007,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930758,
        "nome": "Sítio do Mato",
        "latitude": -12.8552,
        "longitude": -43.475,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930766,
        "nome": "Sítio do Quinto",
        "latitude": -10.3341,
        "longitude": -38.1392,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930774,
        "nome": "Sobradinho",
        "latitude": -9.657,
        "longitude": -40.8833,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930808,
        "nome": "Souto Soares",
        "latitude": -12.0276,
        "longitude": -41.7896,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2930907,
        "nome": "Tabocas do Brejo Velho",
        "latitude": -12.4799,
        "longitude": -44.1556,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2931004,
        "nome": "Tanhaçu",
        "latitude": -14.146,
        "longitude": -41.1954,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2931053,
        "nome": "Tanque Novo",
        "latitude": -13.556,
        "longitude": -42.5375,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2931103,
        "nome": "Tanquinho",
        "latitude": -11.9583,
        "longitude": -39.0943,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2931202,
        "nome": "Taperoá",
        "latitude": -13.5729,
        "longitude": -39.2278,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2931301,
        "nome": "Tapiramutá",
        "latitude": -11.8762,
        "longitude": -40.7914,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2931350,
        "nome": "Teixeira de Freitas",
        "latitude": -17.4241,
        "longitude": -39.7869,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2931400,
        "nome": "Teodoro Sampaio",
        "latitude": -12.2673,
        "longitude": -38.6151,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2931509,
        "nome": "Teofilândia",
        "latitude": -11.4708,
        "longitude": -38.951,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2931608,
        "nome": "Teolândia",
        "latitude": -13.5544,
        "longitude": -39.4975,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2931707,
        "nome": "Terra Nova",
        "latitude": -12.3964,
        "longitude": -38.6023,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2931806,
        "nome": "Tremedal",
        "latitude": -15.0534,
        "longitude": -41.4725,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2931905,
        "nome": "Tucano",
        "latitude": -11.035,
        "longitude": -38.8115,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2932002,
        "nome": "Uauá",
        "latitude": -9.9062,
        "longitude": -39.4623,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2932101,
        "nome": "Ubaíra",
        "latitude": -13.2764,
        "longitude": -39.6797,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2932200,
        "nome": "Ubaitaba",
        "latitude": -14.2675,
        "longitude": -39.4218,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2932309,
        "nome": "Ubatã",
        "latitude": -14.0964,
        "longitude": -39.5219,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2932408,
        "nome": "Uibaí",
        "latitude": -11.3799,
        "longitude": -42.104,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2932457,
        "nome": "Umburanas",
        "latitude": -10.5758,
        "longitude": -41.2469,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2932507,
        "nome": "Una",
        "latitude": -15.2191,
        "longitude": -39.1514,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2932606,
        "nome": "Urandi",
        "latitude": -14.7366,
        "longitude": -42.684,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2932705,
        "nome": "Uruçuca",
        "latitude": -14.5274,
        "longitude": -39.2316,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2932804,
        "nome": "Utinga",
        "latitude": -12.0522,
        "longitude": -41.069,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2932903,
        "nome": "Valença",
        "latitude": -13.3474,
        "longitude": -39.194,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2933000,
        "nome": "Valente",
        "latitude": -11.3768,
        "longitude": -39.4497,
        "mesorregiaoNome": "Nordeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2933059,
        "nome": "Várzea da Roça",
        "latitude": -11.5985,
        "longitude": -40.0667,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2933109,
        "nome": "Várzea do Poço",
        "latitude": -11.5411,
        "longitude": -40.3157,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2933158,
        "nome": "Várzea Nova",
        "latitude": -11.1231,
        "longitude": -41.0199,
        "mesorregiaoNome": "Centro Norte Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2933174,
        "nome": "Varzedo",
        "latitude": -12.9566,
        "longitude": -39.3918,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2933208,
        "nome": "Vera Cruz",
        "latitude": -13.0071,
        "longitude": -38.697,
        "mesorregiaoNome": "Metropolitana de Salvador",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2933257,
        "nome": "Vereda",
        "latitude": -17.1891,
        "longitude": -39.9601,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2933307,
        "nome": "Vitória da Conquista",
        "latitude": -15.0223,
        "longitude": -40.9132,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2933406,
        "nome": "Wagner",
        "latitude": -12.2314,
        "longitude": -41.146,
        "mesorregiaoNome": "Centro Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2933455,
        "nome": "Wanderley",
        "latitude": -11.8089,
        "longitude": -43.9067,
        "mesorregiaoNome": "Extremo Oeste Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2933505,
        "nome": "Wenceslau Guimarães",
        "latitude": -13.6286,
        "longitude": -39.6193,
        "mesorregiaoNome": "Sul Baiano",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 2933604,
        "nome": "Xique-Xique",
        "latitude": -10.9843,
        "longitude": -42.7801,
        "mesorregiaoNome": "Vale São-Franciscano da Bahia",
        "UFSigla": "BA",
        "UFNome": "Bahia"
    },
    {
        "ibgeId": 3100104,
        "nome": "Abadia dos Dourados",
        "latitude": -18.3533,
        "longitude": -47.459,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3100203,
        "nome": "Abaeté",
        "latitude": -19.1027,
        "longitude": -45.3587,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3100302,
        "nome": "Abre Campo",
        "latitude": -20.2732,
        "longitude": -42.4426,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3100401,
        "nome": "Acaiaca",
        "latitude": -20.3998,
        "longitude": -43.1012,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3100500,
        "nome": "Açucena",
        "latitude": -19.0526,
        "longitude": -42.4507,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3100609,
        "nome": "Água Boa",
        "latitude": -18.0273,
        "longitude": -42.2759,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3100708,
        "nome": "Água Comprida",
        "latitude": -20.0054,
        "longitude": -48.0842,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3100807,
        "nome": "Aguanil",
        "latitude": -20.9738,
        "longitude": -45.422,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3100906,
        "nome": "Águas Formosas",
        "latitude": -17.0416,
        "longitude": -40.9739,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3101003,
        "nome": "Águas Vermelhas",
        "latitude": -15.6832,
        "longitude": -41.5215,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3101102,
        "nome": "Aimorés",
        "latitude": -19.6252,
        "longitude": -41.2139,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3101201,
        "nome": "Aiuruoca",
        "latitude": -21.9546,
        "longitude": -44.6476,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3101300,
        "nome": "Alagoa",
        "latitude": -22.1866,
        "longitude": -44.6606,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3101409,
        "nome": "Albertina",
        "latitude": -22.1985,
        "longitude": -46.6137,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3101508,
        "nome": "Além Paraíba",
        "latitude": -21.8264,
        "longitude": -42.7465,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3101607,
        "nome": "Alfenas",
        "latitude": -21.3887,
        "longitude": -45.9663,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3101631,
        "nome": "Alfredo Vasconcelos",
        "latitude": -21.139,
        "longitude": -43.7125,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3101706,
        "nome": "Almenara",
        "latitude": -16.0911,
        "longitude": -40.7238,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3101805,
        "nome": "Alpercata",
        "latitude": -18.9837,
        "longitude": -42.0192,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3101904,
        "nome": "Alpinópolis",
        "latitude": -20.8595,
        "longitude": -46.3762,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3102001,
        "nome": "Alterosa",
        "latitude": -21.2252,
        "longitude": -46.1536,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3102050,
        "nome": "Alto Caparaó",
        "latitude": -20.4584,
        "longitude": -41.8649,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3102100,
        "nome": "Alto Rio Doce",
        "latitude": -21.0358,
        "longitude": -43.4034,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3102209,
        "nome": "Alvarenga",
        "latitude": -19.4199,
        "longitude": -41.6954,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3102308,
        "nome": "Alvinópolis",
        "latitude": -20.1118,
        "longitude": -43.1525,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3102407,
        "nome": "Alvorada de Minas",
        "latitude": -18.779,
        "longitude": -43.3676,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3102506,
        "nome": "Amparo do Serra",
        "latitude": -20.5282,
        "longitude": -42.8049,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3102605,
        "nome": "Andradas",
        "latitude": -22.0758,
        "longitude": -46.5548,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3102704,
        "nome": "Cachoeira de Pajeú",
        "latitude": -15.9685,
        "longitude": -41.498,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3102803,
        "nome": "Andrelândia",
        "latitude": -21.7389,
        "longitude": -44.2697,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3102852,
        "nome": "Angelândia",
        "latitude": -17.7032,
        "longitude": -42.2828,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3102902,
        "nome": "Antônio Carlos",
        "latitude": -21.4106,
        "longitude": -43.7663,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3103009,
        "nome": "Antônio Dias",
        "latitude": -19.5671,
        "longitude": -42.8764,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3103108,
        "nome": "Antônio Prado de Minas",
        "latitude": -21.0225,
        "longitude": -42.152,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3103207,
        "nome": "Araçaí",
        "latitude": -19.2348,
        "longitude": -44.2184,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3103306,
        "nome": "Aracitaba",
        "latitude": -21.3503,
        "longitude": -43.4038,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3103405,
        "nome": "Araçuaí",
        "latitude": -16.9308,
        "longitude": -41.9932,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3103504,
        "nome": "Araguari",
        "latitude": -18.5771,
        "longitude": -48.222,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3103603,
        "nome": "Arantina",
        "latitude": -21.8969,
        "longitude": -44.2272,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3103702,
        "nome": "Araponga",
        "latitude": -20.6628,
        "longitude": -42.4988,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3103751,
        "nome": "Araporã",
        "latitude": -18.4774,
        "longitude": -49.1272,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3103801,
        "nome": "Arapuá",
        "latitude": -19.0415,
        "longitude": -46.1153,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3103900,
        "nome": "Araújos",
        "latitude": -19.8864,
        "longitude": -45.181,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3104007,
        "nome": "Araxá",
        "latitude": -19.6364,
        "longitude": -46.9721,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3104106,
        "nome": "Arceburgo",
        "latitude": -21.3595,
        "longitude": -46.9419,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3104205,
        "nome": "Arcos",
        "latitude": -20.2597,
        "longitude": -45.5472,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3104304,
        "nome": "Areado",
        "latitude": -21.356,
        "longitude": -46.1423,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3104403,
        "nome": "Argirita",
        "latitude": -21.6353,
        "longitude": -42.8326,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3104452,
        "nome": "Aricanduva",
        "latitude": -17.8811,
        "longitude": -42.6056,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3104502,
        "nome": "Arinos",
        "latitude": -15.7507,
        "longitude": -45.9886,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3104601,
        "nome": "Astolfo Dutra",
        "latitude": -21.3155,
        "longitude": -42.8793,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3104700,
        "nome": "Ataléia",
        "latitude": -18.1634,
        "longitude": -41.1515,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3104809,
        "nome": "Augusto de Lima",
        "latitude": -18.1088,
        "longitude": -44.1981,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3104908,
        "nome": "Baependi",
        "latitude": -22.0168,
        "longitude": -44.8221,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3105004,
        "nome": "Baldim",
        "latitude": -19.2629,
        "longitude": -43.8634,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3105103,
        "nome": "Bambuí",
        "latitude": -20.111,
        "longitude": -45.9989,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3105202,
        "nome": "Bandeira",
        "latitude": -15.8777,
        "longitude": -40.581,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3105301,
        "nome": "Bandeira do Sul",
        "latitude": -21.7241,
        "longitude": -46.3849,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3105400,
        "nome": "Barão de Cocais",
        "latitude": -19.8917,
        "longitude": -43.4955,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3105509,
        "nome": "Barão do Monte Alto",
        "latitude": -21.2648,
        "longitude": -42.2784,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3105608,
        "nome": "Barbacena",
        "latitude": -21.2515,
        "longitude": -43.8006,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3105707,
        "nome": "Barra Longa",
        "latitude": -20.2756,
        "longitude": -43.0662,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3105905,
        "nome": "Barroso",
        "latitude": -21.1832,
        "longitude": -43.9578,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3106002,
        "nome": "Bela Vista de Minas",
        "latitude": -19.7987,
        "longitude": -43.1058,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3106101,
        "nome": "Belmiro Braga",
        "latitude": -21.9858,
        "longitude": -43.4687,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3106200,
        "nome": "Belo Horizonte",
        "latitude": -19.9027,
        "longitude": -43.96,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3106309,
        "nome": "Belo Oriente",
        "latitude": -19.2594,
        "longitude": -42.4504,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3106408,
        "nome": "Belo Vale",
        "latitude": -20.4247,
        "longitude": -44.06,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3106507,
        "nome": "Berilo",
        "latitude": -16.8624,
        "longitude": -42.4943,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3106606,
        "nome": "Bertópolis",
        "latitude": -16.9745,
        "longitude": -40.5742,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3106655,
        "nome": "Berizal",
        "latitude": -15.6841,
        "longitude": -41.7618,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3106705,
        "nome": "Betim",
        "latitude": -19.9475,
        "longitude": -44.1992,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3106804,
        "nome": "Bias Fortes",
        "latitude": -21.6247,
        "longitude": -43.7737,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3106903,
        "nome": "Bicas",
        "latitude": -21.7315,
        "longitude": -43.1048,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3107000,
        "nome": "Biquinhas",
        "latitude": -18.7571,
        "longitude": -45.5395,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3107109,
        "nome": "Boa Esperança",
        "latitude": -21.0486,
        "longitude": -45.6211,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3107208,
        "nome": "Bocaina de Minas",
        "latitude": -22.2157,
        "longitude": -44.4828,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3107307,
        "nome": "Bocaiúva",
        "latitude": -17.2897,
        "longitude": -43.6865,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3107406,
        "nome": "Bom Despacho",
        "latitude": -19.6845,
        "longitude": -45.2861,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3107505,
        "nome": "Bom Jardim de Minas",
        "latitude": -21.9501,
        "longitude": -44.127,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3107604,
        "nome": "Bom Jesus da Penha",
        "latitude": -21.0138,
        "longitude": -46.5291,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3107703,
        "nome": "Bom Jesus do Amparo",
        "latitude": -19.7177,
        "longitude": -43.4686,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3107802,
        "nome": "Bom Jesus do Galho",
        "latitude": -19.7423,
        "longitude": -42.351,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3107901,
        "nome": "Bom Repouso",
        "latitude": -22.4458,
        "longitude": -46.1844,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3108008,
        "nome": "Bom Sucesso",
        "latitude": -21.0264,
        "longitude": -44.7842,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3108107,
        "nome": "Bonfim",
        "latitude": -20.3215,
        "longitude": -44.2148,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3108206,
        "nome": "Bonfinópolis de Minas",
        "latitude": -16.4864,
        "longitude": -46.1904,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3108255,
        "nome": "Bonito de Minas",
        "latitude": -14.9928,
        "longitude": -44.8968,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3108305,
        "nome": "Borda da Mata",
        "latitude": -22.2566,
        "longitude": -46.1518,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3108404,
        "nome": "Botelhos",
        "latitude": -21.6364,
        "longitude": -46.4194,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3108503,
        "nome": "Botumirim",
        "latitude": -16.9378,
        "longitude": -43.0056,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3108552,
        "nome": "Brasilândia de Minas",
        "latitude": -16.957,
        "longitude": -45.9025,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3108602,
        "nome": "Brasília de Minas",
        "latitude": -16.2427,
        "longitude": -44.4391,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3108701,
        "nome": "Brás Pires",
        "latitude": -20.8751,
        "longitude": -43.2275,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3108800,
        "nome": "Braúnas",
        "latitude": -19.0257,
        "longitude": -42.7164,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3108909,
        "nome": "Brazópolis",
        "latitude": -22.4912,
        "longitude": -45.6279,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3109006,
        "nome": "Brumadinho",
        "latitude": -20.1778,
        "longitude": -44.1227,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3109105,
        "nome": "Bueno Brandão",
        "latitude": -22.4861,
        "longitude": -46.3553,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3109204,
        "nome": "Buenópolis",
        "latitude": -17.8805,
        "longitude": -44.0414,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3109253,
        "nome": "Bugre",
        "latitude": -19.3577,
        "longitude": -42.311,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3109303,
        "nome": "Buritis",
        "latitude": -15.4532,
        "longitude": -46.6044,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3109402,
        "nome": "Buritizeiro",
        "latitude": -17.2861,
        "longitude": -45.1918,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3109451,
        "nome": "Cabeceira Grande",
        "latitude": -16.0762,
        "longitude": -47.1237,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3109501,
        "nome": "Cabo Verde",
        "latitude": -21.4816,
        "longitude": -46.3915,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3109600,
        "nome": "Cachoeira da Prata",
        "latitude": -19.517,
        "longitude": -44.472,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3109709,
        "nome": "Cachoeira de Minas",
        "latitude": -22.3625,
        "longitude": -45.7928,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3109808,
        "nome": "Cachoeira Dourada",
        "latitude": -18.6073,
        "longitude": -49.4789,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3109907,
        "nome": "Caetanópolis",
        "latitude": -19.3425,
        "longitude": -44.4034,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3110004,
        "nome": "Caeté",
        "latitude": -19.8678,
        "longitude": -43.6369,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3110103,
        "nome": "Caiana",
        "latitude": -20.7253,
        "longitude": -41.9084,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3110202,
        "nome": "Cajuri",
        "latitude": -20.7853,
        "longitude": -42.7642,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3110301,
        "nome": "Caldas",
        "latitude": -21.8908,
        "longitude": -46.3637,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3110400,
        "nome": "Camacho",
        "latitude": -20.6408,
        "longitude": -45.1322,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3110509,
        "nome": "Camanducaia",
        "latitude": -22.7869,
        "longitude": -46.0748,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3110608,
        "nome": "Cambuí",
        "latitude": -22.5827,
        "longitude": -46.0783,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3110707,
        "nome": "Cambuquira",
        "latitude": -21.859,
        "longitude": -45.2618,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3110806,
        "nome": "Campanário",
        "latitude": -18.284,
        "longitude": -41.7344,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3110905,
        "nome": "Campanha",
        "latitude": -21.8439,
        "longitude": -45.4085,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3111002,
        "nome": "Campestre",
        "latitude": -21.7104,
        "longitude": -46.2215,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3111101,
        "nome": "Campina Verde",
        "latitude": -19.4791,
        "longitude": -49.81,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3111150,
        "nome": "Campo Azul",
        "latitude": -16.5088,
        "longitude": -44.7633,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3111200,
        "nome": "Campo Belo",
        "latitude": -20.9197,
        "longitude": -45.2559,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3111309,
        "nome": "Campo do Meio",
        "latitude": -21.1136,
        "longitude": -45.8496,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3111408,
        "nome": "Campo Florido",
        "latitude": -19.7134,
        "longitude": -48.6478,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3111507,
        "nome": "Campos Altos",
        "latitude": -19.6049,
        "longitude": -46.1971,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3111606,
        "nome": "Campos Gerais",
        "latitude": -21.2588,
        "longitude": -45.7536,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3111705,
        "nome": "Canaã",
        "latitude": -20.6668,
        "longitude": -42.6218,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3111804,
        "nome": "Canápolis",
        "latitude": -18.7579,
        "longitude": -49.2719,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3111903,
        "nome": "Cana Verde",
        "latitude": -21.0331,
        "longitude": -45.1857,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3112000,
        "nome": "Candeias",
        "latitude": -20.7485,
        "longitude": -45.2796,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3112059,
        "nome": "Cantagalo",
        "latitude": -18.5161,
        "longitude": -42.6487,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3112109,
        "nome": "Caparaó",
        "latitude": -20.5272,
        "longitude": -41.9495,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3112208,
        "nome": "Capela Nova",
        "latitude": -20.9173,
        "longitude": -43.6086,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3112307,
        "nome": "Capelinha",
        "latitude": -17.6929,
        "longitude": -42.492,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3112406,
        "nome": "Capetinga",
        "latitude": -20.6573,
        "longitude": -47.0318,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3112505,
        "nome": "Capim Branco",
        "latitude": -19.5701,
        "longitude": -44.1677,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3112604,
        "nome": "Capinópolis",
        "latitude": -18.6872,
        "longitude": -49.5816,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3112653,
        "nome": "Capitão Andrade",
        "latitude": -19.0512,
        "longitude": -41.8222,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3112703,
        "nome": "Capitão Enéas",
        "latitude": -16.1362,
        "longitude": -43.6647,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3112802,
        "nome": "Capitólio",
        "latitude": -20.6127,
        "longitude": -46.1442,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3112901,
        "nome": "Caputira",
        "latitude": -20.1765,
        "longitude": -42.2523,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3113008,
        "nome": "Caraí",
        "latitude": -17.1736,
        "longitude": -41.5835,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3113107,
        "nome": "Caranaíba",
        "latitude": -20.8912,
        "longitude": -43.7207,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3113206,
        "nome": "Carandaí",
        "latitude": -20.9967,
        "longitude": -43.8443,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3113305,
        "nome": "Carangola",
        "latitude": -20.7027,
        "longitude": -42.0875,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3113404,
        "nome": "Caratinga",
        "latitude": -19.7121,
        "longitude": -42.102,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3113503,
        "nome": "Carbonita",
        "latitude": -17.4941,
        "longitude": -43.0577,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3113602,
        "nome": "Careaçu",
        "latitude": -22.0786,
        "longitude": -45.6644,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3113701,
        "nome": "Carlos Chagas",
        "latitude": -17.6742,
        "longitude": -40.842,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3113800,
        "nome": "Carmésia",
        "latitude": -19.0603,
        "longitude": -43.1744,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3113909,
        "nome": "Carmo da Cachoeira",
        "latitude": -21.454,
        "longitude": -45.1964,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3114006,
        "nome": "Carmo da Mata",
        "latitude": -20.5597,
        "longitude": -44.8918,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3114105,
        "nome": "Carmo de Minas",
        "latitude": -22.092,
        "longitude": -45.1615,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3114204,
        "nome": "Carmo do Cajuru",
        "latitude": -20.1965,
        "longitude": -44.7011,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3114303,
        "nome": "Carmo do Paranaíba",
        "latitude": -18.9077,
        "longitude": -46.1852,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3114402,
        "nome": "Carmo do Rio Claro",
        "latitude": -20.9721,
        "longitude": -46.0991,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3114501,
        "nome": "Carmópolis de Minas",
        "latitude": -20.5619,
        "longitude": -44.6479,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3114550,
        "nome": "Carneirinho",
        "latitude": -19.7502,
        "longitude": -50.8298,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3114600,
        "nome": "Carrancas",
        "latitude": -21.4964,
        "longitude": -44.6121,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3114709,
        "nome": "Carvalhópolis",
        "latitude": -21.7728,
        "longitude": -45.8305,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3114808,
        "nome": "Carvalhos",
        "latitude": -22.0226,
        "longitude": -44.4886,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3114907,
        "nome": "Casa Grande",
        "latitude": -20.8362,
        "longitude": -43.938,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3115003,
        "nome": "Cascalho Rico",
        "latitude": -18.5686,
        "longitude": -47.877,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3115102,
        "nome": "Cássia",
        "latitude": -20.5426,
        "longitude": -46.929,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3115201,
        "nome": "Conceição da Barra de Minas",
        "latitude": -21.1451,
        "longitude": -44.4931,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3115300,
        "nome": "Cataguases",
        "latitude": -21.3424,
        "longitude": -42.6741,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3115359,
        "nome": "Catas Altas",
        "latitude": -20.0755,
        "longitude": -43.4078,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3115409,
        "nome": "Catas Altas da Noruega",
        "latitude": -20.6696,
        "longitude": -43.5,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3115458,
        "nome": "Catuji",
        "latitude": -17.3717,
        "longitude": -41.4985,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3115474,
        "nome": "Catuti",
        "latitude": -15.3356,
        "longitude": -43.0974,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3115508,
        "nome": "Caxambu",
        "latitude": -21.9776,
        "longitude": -44.9473,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3115607,
        "nome": "Cedro do Abaeté",
        "latitude": -19.1209,
        "longitude": -45.6986,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3115706,
        "nome": "Central de Minas",
        "latitude": -18.7684,
        "longitude": -41.2949,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3115805,
        "nome": "Centralina",
        "latitude": -18.6325,
        "longitude": -49.1625,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3115904,
        "nome": "Chácara",
        "latitude": -21.6866,
        "longitude": -43.2132,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3116001,
        "nome": "Chalé",
        "latitude": -20.031,
        "longitude": -41.6598,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3116100,
        "nome": "Chapada do Norte",
        "latitude": -17.1474,
        "longitude": -42.4122,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3116159,
        "nome": "Chapada Gaúcha",
        "latitude": -15.4694,
        "longitude": -45.4586,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3116209,
        "nome": "Chiador",
        "latitude": -22.003,
        "longitude": -43.0297,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3116308,
        "nome": "Cipotânea",
        "latitude": -20.924,
        "longitude": -43.3582,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3116407,
        "nome": "Claraval",
        "latitude": -20.3694,
        "longitude": -47.2395,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3116506,
        "nome": "Claro dos Poções",
        "latitude": -17.0687,
        "longitude": -44.2281,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3116605,
        "nome": "Cláudio",
        "latitude": -20.3974,
        "longitude": -44.7759,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3116704,
        "nome": "Coimbra",
        "latitude": -20.8438,
        "longitude": -42.7915,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3116803,
        "nome": "Coluna",
        "latitude": -18.248,
        "longitude": -42.8394,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3116902,
        "nome": "Comendador Gomes",
        "latitude": -19.6722,
        "longitude": -49.0709,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3117009,
        "nome": "Comercinho",
        "latitude": -16.285,
        "longitude": -41.7675,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3117108,
        "nome": "Conceição da Aparecida",
        "latitude": -21.097,
        "longitude": -46.2259,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3117207,
        "nome": "Conceição das Pedras",
        "latitude": -22.147,
        "longitude": -45.4252,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3117306,
        "nome": "Conceição das Alagoas",
        "latitude": -19.9598,
        "longitude": -48.3615,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3117405,
        "nome": "Conceição de Ipanema",
        "latitude": -19.9135,
        "longitude": -41.6867,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3117504,
        "nome": "Conceição do Mato Dentro",
        "latitude": -18.937,
        "longitude": -43.5079,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3117603,
        "nome": "Conceição do Pará",
        "latitude": -19.7857,
        "longitude": -44.8717,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3117702,
        "nome": "Conceição do Rio Verde",
        "latitude": -21.8973,
        "longitude": -45.0908,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3117801,
        "nome": "Conceição dos Ouros",
        "latitude": -22.4477,
        "longitude": -45.7751,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3117836,
        "nome": "Cônego Marinho",
        "latitude": -14.9847,
        "longitude": -44.5964,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3117876,
        "nome": "Confins",
        "latitude": -19.6422,
        "longitude": -43.975,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3117900,
        "nome": "Congonhal",
        "latitude": -22.1434,
        "longitude": -46.0414,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3118007,
        "nome": "Congonhas",
        "latitude": -20.5161,
        "longitude": -43.8616,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3118106,
        "nome": "Congonhas do Norte",
        "latitude": -18.8634,
        "longitude": -43.6872,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3118205,
        "nome": "Conquista",
        "latitude": -19.8836,
        "longitude": -47.6239,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3118304,
        "nome": "Conselheiro Lafaiete",
        "latitude": -20.666,
        "longitude": -43.7887,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3118403,
        "nome": "Conselheiro Pena",
        "latitude": -19.1702,
        "longitude": -41.4567,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3118502,
        "nome": "Consolação",
        "latitude": -22.5365,
        "longitude": -45.9155,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3118601,
        "nome": "Contagem",
        "latitude": -19.8872,
        "longitude": -44.084,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3118700,
        "nome": "Coqueiral",
        "latitude": -21.169,
        "longitude": -45.4153,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3118809,
        "nome": "Coração de Jesus",
        "latitude": -16.6132,
        "longitude": -44.3788,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3118908,
        "nome": "Cordisburgo",
        "latitude": -19.0921,
        "longitude": -44.205,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3119005,
        "nome": "Cordislândia",
        "latitude": -21.7819,
        "longitude": -45.6621,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3119104,
        "nome": "Corinto",
        "latitude": -18.3355,
        "longitude": -44.6175,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3119203,
        "nome": "Coroaci",
        "latitude": -18.6169,
        "longitude": -42.2686,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3119302,
        "nome": "Coromandel",
        "latitude": -18.4131,
        "longitude": -47.1368,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3119401,
        "nome": "Coronel Fabriciano",
        "latitude": -19.4586,
        "longitude": -42.6899,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3119500,
        "nome": "Coronel Murta",
        "latitude": -16.5913,
        "longitude": -42.1763,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3119609,
        "nome": "Coronel Pacheco",
        "latitude": -21.6047,
        "longitude": -43.2931,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3119708,
        "nome": "Coronel Xavier Chaves",
        "latitude": -21.0247,
        "longitude": -44.1966,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3119807,
        "nome": "Córrego Danta",
        "latitude": -19.7816,
        "longitude": -45.9829,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3119906,
        "nome": "Córrego do Bom Jesus",
        "latitude": -22.6345,
        "longitude": -45.9932,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3119955,
        "nome": "Córrego Fundo",
        "latitude": -20.4508,
        "longitude": -45.5321,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3120003,
        "nome": "Córrego Novo",
        "latitude": -19.8305,
        "longitude": -42.4457,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3120102,
        "nome": "Couto de Magalhães de Minas",
        "latitude": -18.0845,
        "longitude": -43.4398,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3120151,
        "nome": "Crisólita",
        "latitude": -17.2401,
        "longitude": -40.9615,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3120201,
        "nome": "Cristais",
        "latitude": -20.8111,
        "longitude": -45.5574,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3120300,
        "nome": "Cristália",
        "latitude": -16.7186,
        "longitude": -42.821,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3120409,
        "nome": "Cristiano Otoni",
        "latitude": -20.8355,
        "longitude": -43.8269,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3120508,
        "nome": "Cristina",
        "latitude": -22.2057,
        "longitude": -45.2894,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3120607,
        "nome": "Crucilândia",
        "latitude": -20.4041,
        "longitude": -44.3598,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3120706,
        "nome": "Cruzeiro da Fortaleza",
        "latitude": -18.9722,
        "longitude": -46.6762,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3120805,
        "nome": "Cruzília",
        "latitude": -21.7307,
        "longitude": -44.7978,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3120839,
        "nome": "Cuparaque",
        "latitude": -19.0093,
        "longitude": -41.1293,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3120870,
        "nome": "Curral de Dentro",
        "latitude": -15.8618,
        "longitude": -41.7648,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3120904,
        "nome": "Curvelo",
        "latitude": -18.8199,
        "longitude": -44.4479,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3121001,
        "nome": "Datas",
        "latitude": -18.4711,
        "longitude": -43.6477,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3121100,
        "nome": "Delfim Moreira",
        "latitude": -22.5071,
        "longitude": -45.2878,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3121209,
        "nome": "Delfinópolis",
        "latitude": -20.3567,
        "longitude": -46.7728,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3121258,
        "nome": "Delta",
        "latitude": -19.9361,
        "longitude": -47.8097,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3121308,
        "nome": "Descoberto",
        "latitude": -21.4468,
        "longitude": -42.9635,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3121407,
        "nome": "Desterro de Entre Rios",
        "latitude": -20.6297,
        "longitude": -44.2713,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3121506,
        "nome": "Desterro do Melo",
        "latitude": -21.1507,
        "longitude": -43.5198,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3121605,
        "nome": "Diamantina",
        "latitude": -17.9938,
        "longitude": -43.6108,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3121704,
        "nome": "Diogo de Vasconcelos",
        "latitude": -20.4813,
        "longitude": -43.1839,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3121803,
        "nome": "Dionísio",
        "latitude": -19.8368,
        "longitude": -42.6791,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3121902,
        "nome": "Divinésia",
        "latitude": -20.9879,
        "longitude": -42.9981,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3122009,
        "nome": "Divino",
        "latitude": -20.59,
        "longitude": -42.1754,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3122108,
        "nome": "Divino das Laranjeiras",
        "latitude": -18.7125,
        "longitude": -41.507,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3122207,
        "nome": "Divinolândia de Minas",
        "latitude": -18.7823,
        "longitude": -42.5734,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3122306,
        "nome": "Divinópolis",
        "latitude": -20.1237,
        "longitude": -44.9307,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3122355,
        "nome": "Divisa Alegre",
        "latitude": -15.6987,
        "longitude": -41.3741,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3122405,
        "nome": "Divisa Nova",
        "latitude": -21.5179,
        "longitude": -46.2451,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3122454,
        "nome": "Divisópolis",
        "latitude": -15.7629,
        "longitude": -40.9123,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3122470,
        "nome": "Dom Bosco",
        "latitude": -16.7403,
        "longitude": -46.2899,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3122504,
        "nome": "Dom Cavati",
        "latitude": -19.386,
        "longitude": -42.0912,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3122603,
        "nome": "Dom Joaquim",
        "latitude": -18.9283,
        "longitude": -43.2592,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3122702,
        "nome": "Dom Silvério",
        "latitude": -20.1346,
        "longitude": -42.9462,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3122801,
        "nome": "Dom Viçoso",
        "latitude": -22.2286,
        "longitude": -45.1428,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3122900,
        "nome": "Dona Euzébia",
        "latitude": -21.3315,
        "longitude": -42.8011,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3123007,
        "nome": "Dores de Campos",
        "latitude": -21.1001,
        "longitude": -43.9896,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3123106,
        "nome": "Dores de Guanhães",
        "latitude": -19.054,
        "longitude": -42.9311,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3123205,
        "nome": "Dores do Indaiá",
        "latitude": -19.4897,
        "longitude": -45.5473,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3123304,
        "nome": "Dores do Turvo",
        "latitude": -21.0239,
        "longitude": -43.1672,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3123403,
        "nome": "Doresópolis",
        "latitude": -20.2917,
        "longitude": -45.8871,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3123502,
        "nome": "Douradoquara",
        "latitude": -18.4374,
        "longitude": -47.6044,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3123528,
        "nome": "Durandé",
        "latitude": -20.1473,
        "longitude": -41.7954,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3123601,
        "nome": "Elói Mendes",
        "latitude": -21.6124,
        "longitude": -45.5973,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3123700,
        "nome": "Engenheiro Caldas",
        "latitude": -19.128,
        "longitude": -42.0193,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3123809,
        "nome": "Engenheiro Navarro",
        "latitude": -17.2965,
        "longitude": -44.014,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3123858,
        "nome": "Entre Folhas",
        "latitude": -19.6552,
        "longitude": -42.2416,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3123908,
        "nome": "Entre Rios de Minas",
        "latitude": -20.7052,
        "longitude": -44.0948,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3124005,
        "nome": "Ervália",
        "latitude": -20.849,
        "longitude": -42.6006,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3124104,
        "nome": "Esmeraldas",
        "latitude": -19.733,
        "longitude": -44.3075,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3124203,
        "nome": "Espera Feliz",
        "latitude": -20.5973,
        "longitude": -41.9299,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3124302,
        "nome": "Espinosa",
        "latitude": -14.859,
        "longitude": -42.9658,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3124401,
        "nome": "Espírito Santo do Dourado",
        "latitude": -22.009,
        "longitude": -45.9868,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3124500,
        "nome": "Estiva",
        "latitude": -22.4583,
        "longitude": -46.014,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3124609,
        "nome": "Estrela Dalva",
        "latitude": -21.7065,
        "longitude": -42.4671,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3124708,
        "nome": "Estrela do Indaiá",
        "latitude": -19.5919,
        "longitude": -45.8083,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3124807,
        "nome": "Estrela do Sul",
        "latitude": -18.7151,
        "longitude": -47.7264,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3124906,
        "nome": "Eugenópolis",
        "latitude": -21.014,
        "longitude": -42.2233,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3125002,
        "nome": "Ewbank da Câmara",
        "latitude": -21.5751,
        "longitude": -43.5605,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3125101,
        "nome": "Extrema",
        "latitude": -22.8252,
        "longitude": -46.2897,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3125200,
        "nome": "Fama",
        "latitude": -21.4653,
        "longitude": -45.8142,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3125309,
        "nome": "Faria Lemos",
        "latitude": -20.7812,
        "longitude": -42.0357,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3125408,
        "nome": "Felício dos Santos",
        "latitude": -18.1332,
        "longitude": -43.2389,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3125507,
        "nome": "São Gonçalo do Rio Preto",
        "latitude": -18.0763,
        "longitude": -43.3585,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3125606,
        "nome": "Felisburgo",
        "latitude": -16.6361,
        "longitude": -40.7331,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3125705,
        "nome": "Felixlândia",
        "latitude": -18.7031,
        "longitude": -44.9582,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3125804,
        "nome": "Fernandes Tourinho",
        "latitude": -19.1019,
        "longitude": -42.0965,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3125903,
        "nome": "Ferros",
        "latitude": -19.2455,
        "longitude": -42.9402,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3125952,
        "nome": "Fervedouro",
        "latitude": -20.6807,
        "longitude": -42.3469,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3126000,
        "nome": "Florestal",
        "latitude": -19.8685,
        "longitude": -44.4421,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3126109,
        "nome": "Formiga",
        "latitude": -20.5537,
        "longitude": -45.5164,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3126208,
        "nome": "Formoso",
        "latitude": -15.1297,
        "longitude": -46.1585,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3126307,
        "nome": "Fortaleza de Minas",
        "latitude": -20.8879,
        "longitude": -46.7713,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3126406,
        "nome": "Fortuna de Minas",
        "latitude": -19.5576,
        "longitude": -44.5043,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3126505,
        "nome": "Francisco Badaró",
        "latitude": -16.9776,
        "longitude": -42.3098,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3126604,
        "nome": "Francisco Dumont",
        "latitude": -17.4698,
        "longitude": -44.2699,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3126703,
        "nome": "Francisco Sá",
        "latitude": -16.3937,
        "longitude": -43.479,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3126752,
        "nome": "Franciscópolis",
        "latitude": -17.9933,
        "longitude": -41.9679,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3126802,
        "nome": "Frei Gaspar",
        "latitude": -18.1397,
        "longitude": -41.5107,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3126901,
        "nome": "Frei Inocêncio",
        "latitude": -18.5197,
        "longitude": -41.8792,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3126950,
        "nome": "Frei Lagonegro",
        "latitude": -18.1434,
        "longitude": -42.7559,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127008,
        "nome": "Fronteira",
        "latitude": -20.2285,
        "longitude": -49.1589,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127057,
        "nome": "Fronteira dos Vales",
        "latitude": -16.8939,
        "longitude": -40.8354,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127073,
        "nome": "Fruta de Leite",
        "latitude": -16.1256,
        "longitude": -42.5199,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127107,
        "nome": "Frutal",
        "latitude": -20.0357,
        "longitude": -49.0005,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127206,
        "nome": "Funilândia",
        "latitude": -19.3611,
        "longitude": -44.0741,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127305,
        "nome": "Galiléia",
        "latitude": -18.8802,
        "longitude": -41.5451,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127339,
        "nome": "Gameleiras",
        "latitude": -14.971,
        "longitude": -43.2597,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127354,
        "nome": "Glaucilândia",
        "latitude": -16.9039,
        "longitude": -43.6393,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127370,
        "nome": "Goiabeira",
        "latitude": -19.0219,
        "longitude": -41.2361,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127388,
        "nome": "Goianá",
        "latitude": -21.5555,
        "longitude": -43.1893,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127404,
        "nome": "Gonçalves",
        "latitude": -22.673,
        "longitude": -45.8249,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127503,
        "nome": "Gonzaga",
        "latitude": -18.8739,
        "longitude": -42.5051,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127602,
        "nome": "Gouveia",
        "latitude": -18.5235,
        "longitude": -43.8335,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127701,
        "nome": "Governador Valadares",
        "latitude": -18.7834,
        "longitude": -41.9636,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127800,
        "nome": "Grão Mogol",
        "latitude": -16.4639,
        "longitude": -42.994,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3127909,
        "nome": "Grupiara",
        "latitude": -18.4881,
        "longitude": -47.7604,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3128006,
        "nome": "Guanhães",
        "latitude": -18.8337,
        "longitude": -42.8532,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3128105,
        "nome": "Guapé",
        "latitude": -20.7643,
        "longitude": -45.921,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3128204,
        "nome": "Guaraciaba",
        "latitude": -20.5552,
        "longitude": -43.0207,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3128253,
        "nome": "Guaraciama",
        "latitude": -17.0785,
        "longitude": -43.6206,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3128303,
        "nome": "Guaranésia",
        "latitude": -21.2774,
        "longitude": -46.8073,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3128402,
        "nome": "Guarani",
        "latitude": -21.357,
        "longitude": -43.0577,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3128501,
        "nome": "Guarará",
        "latitude": -21.7547,
        "longitude": -43.0221,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3128600,
        "nome": "Guarda-Mor",
        "latitude": -17.7318,
        "longitude": -47.1262,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3128709,
        "nome": "Guaxupé",
        "latitude": -21.2906,
        "longitude": -46.6829,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3128808,
        "nome": "Guidoval",
        "latitude": -21.1668,
        "longitude": -42.7857,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3128907,
        "nome": "Guimarânia",
        "latitude": -18.816,
        "longitude": -46.7529,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3129004,
        "nome": "Guiricema",
        "latitude": -21.0149,
        "longitude": -42.6997,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3129103,
        "nome": "Gurinhatã",
        "latitude": -19.0984,
        "longitude": -49.8701,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3129202,
        "nome": "Heliodora",
        "latitude": -22.0491,
        "longitude": -45.5406,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3129301,
        "nome": "Iapu",
        "latitude": -19.3471,
        "longitude": -42.2428,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3129400,
        "nome": "Ibertioga",
        "latitude": -21.4497,
        "longitude": -43.959,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3129509,
        "nome": "Ibiá",
        "latitude": -19.5579,
        "longitude": -46.5958,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3129608,
        "nome": "Ibiaí",
        "latitude": -16.8288,
        "longitude": -44.7902,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3129657,
        "nome": "Ibiracatu",
        "latitude": -15.6969,
        "longitude": -44.1449,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3129707,
        "nome": "Ibiraci",
        "latitude": -20.3933,
        "longitude": -47.1116,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3129806,
        "nome": "Ibirité",
        "latitude": -20.0236,
        "longitude": -44.0685,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3129905,
        "nome": "Ibitiúra de Minas",
        "latitude": -22.0674,
        "longitude": -46.4077,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3130002,
        "nome": "Ibituruna",
        "latitude": -21.1671,
        "longitude": -44.783,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3130051,
        "nome": "Icaraí de Minas",
        "latitude": -16.2251,
        "longitude": -44.9164,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3130101,
        "nome": "Igarapé",
        "latitude": -20.0594,
        "longitude": -44.322,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3130200,
        "nome": "Igaratinga",
        "latitude": -19.9511,
        "longitude": -44.7184,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3130309,
        "nome": "Iguatama",
        "latitude": -20.1562,
        "longitude": -45.7527,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3130408,
        "nome": "Ijaci",
        "latitude": -21.1782,
        "longitude": -44.9338,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3130507,
        "nome": "Ilicínea",
        "latitude": -20.9315,
        "longitude": -45.8016,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3130556,
        "nome": "Imbé de Minas",
        "latitude": -19.6186,
        "longitude": -41.9677,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3130606,
        "nome": "Inconfidentes",
        "latitude": -22.3366,
        "longitude": -46.2817,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3130655,
        "nome": "Indaiabira",
        "latitude": -15.5622,
        "longitude": -42.143,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3130705,
        "nome": "Indianópolis",
        "latitude": -18.9523,
        "longitude": -47.8496,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3130804,
        "nome": "Ingaí",
        "latitude": -21.4106,
        "longitude": -44.9246,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3130903,
        "nome": "Inhapim",
        "latitude": -19.4986,
        "longitude": -41.9669,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3131000,
        "nome": "Inhaúma",
        "latitude": -19.4979,
        "longitude": -44.4091,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3131109,
        "nome": "Inimutaba",
        "latitude": -18.7303,
        "longitude": -44.2919,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3131158,
        "nome": "Ipaba",
        "latitude": -19.4088,
        "longitude": -42.3708,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3131208,
        "nome": "Ipanema",
        "latitude": -19.7578,
        "longitude": -41.7494,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3131307,
        "nome": "Ipatinga",
        "latitude": -19.439,
        "longitude": -42.6009,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3131406,
        "nome": "Ipiaçu",
        "latitude": -18.6982,
        "longitude": -49.9321,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3131505,
        "nome": "Ipuiúna",
        "latitude": -22.028,
        "longitude": -46.1306,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3131604,
        "nome": "Iraí de Minas",
        "latitude": -19.0439,
        "longitude": -47.4575,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3131703,
        "nome": "Itabira",
        "latitude": -19.6007,
        "longitude": -43.2998,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3131802,
        "nome": "Itabirinha",
        "latitude": -18.5492,
        "longitude": -41.2446,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3131901,
        "nome": "Itabirito",
        "latitude": -20.2532,
        "longitude": -43.8095,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3132008,
        "nome": "Itacambira",
        "latitude": -16.935,
        "longitude": -43.3288,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3132107,
        "nome": "Itacarambi",
        "latitude": -15.1773,
        "longitude": -44.125,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3132206,
        "nome": "Itaguara",
        "latitude": -20.3719,
        "longitude": -44.5318,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3132305,
        "nome": "Itaipé",
        "latitude": -17.4094,
        "longitude": -41.6594,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3132404,
        "nome": "Itajubá",
        "latitude": -22.422,
        "longitude": -45.4144,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3132503,
        "nome": "Itamarandiba",
        "latitude": -17.8565,
        "longitude": -42.877,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3132602,
        "nome": "Itamarati de Minas",
        "latitude": -21.424,
        "longitude": -42.8479,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3132701,
        "nome": "Itambacuri",
        "latitude": -18.1591,
        "longitude": -41.8462,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3132800,
        "nome": "Itambé do Mato Dentro",
        "latitude": -19.3964,
        "longitude": -43.3513,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3132909,
        "nome": "Itamogi",
        "latitude": -21.0742,
        "longitude": -47.0501,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3133006,
        "nome": "Itamonte",
        "latitude": -22.2893,
        "longitude": -44.7577,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3133105,
        "nome": "Itanhandu",
        "latitude": -22.3201,
        "longitude": -44.921,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3133204,
        "nome": "Itanhomi",
        "latitude": -19.161,
        "longitude": -41.8203,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3133303,
        "nome": "Itaobim",
        "latitude": -16.583,
        "longitude": -41.5344,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3133402,
        "nome": "Itapagipe",
        "latitude": -19.7949,
        "longitude": -49.4235,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3133501,
        "nome": "Itapecerica",
        "latitude": -20.4585,
        "longitude": -45.1079,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3133600,
        "nome": "Itapeva",
        "latitude": -22.6998,
        "longitude": -46.2098,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3133709,
        "nome": "Itatiaiuçu",
        "latitude": -20.2094,
        "longitude": -44.4531,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3133758,
        "nome": "Itaú de Minas",
        "latitude": -20.7369,
        "longitude": -46.7716,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3133808,
        "nome": "Itaúna",
        "latitude": -20.0781,
        "longitude": -44.5889,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3133907,
        "nome": "Itaverava",
        "latitude": -20.6852,
        "longitude": -43.6129,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3134004,
        "nome": "Itinga",
        "latitude": -16.5866,
        "longitude": -41.8355,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3134103,
        "nome": "Itueta",
        "latitude": -19.3727,
        "longitude": -41.1039,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3134202,
        "nome": "Ituiutaba",
        "latitude": -18.9926,
        "longitude": -49.5442,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3134301,
        "nome": "Itumirim",
        "latitude": -21.2898,
        "longitude": -44.8241,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3134400,
        "nome": "Iturama",
        "latitude": -19.7163,
        "longitude": -50.345,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3134509,
        "nome": "Itutinga",
        "latitude": -21.3513,
        "longitude": -44.7102,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3134608,
        "nome": "Jaboticatubas",
        "latitude": -19.4408,
        "longitude": -43.7182,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3134707,
        "nome": "Jacinto",
        "latitude": -16.1825,
        "longitude": -40.3137,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3134806,
        "nome": "Jacuí",
        "latitude": -21.0244,
        "longitude": -46.7356,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3134905,
        "nome": "Jacutinga",
        "latitude": -22.2878,
        "longitude": -46.601,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135001,
        "nome": "Jaguaraçu",
        "latitude": -19.6376,
        "longitude": -42.7182,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135050,
        "nome": "Jaíba",
        "latitude": -15.2326,
        "longitude": -43.6759,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135076,
        "nome": "Jampruca",
        "latitude": -18.464,
        "longitude": -41.7403,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135100,
        "nome": "Janaúba",
        "latitude": -15.799,
        "longitude": -43.3967,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135209,
        "nome": "Januária",
        "latitude": -15.32,
        "longitude": -44.8495,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135308,
        "nome": "Japaraíba",
        "latitude": -20.1328,
        "longitude": -45.5291,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135357,
        "nome": "Japonvar",
        "latitude": -15.9445,
        "longitude": -44.3293,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135407,
        "nome": "Jeceaba",
        "latitude": -20.5524,
        "longitude": -44.0471,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135456,
        "nome": "Jenipapo de Minas",
        "latitude": -17.1683,
        "longitude": -42.2153,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135506,
        "nome": "Jequeri",
        "latitude": -20.4742,
        "longitude": -42.6196,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135605,
        "nome": "Jequitaí",
        "latitude": -17.2099,
        "longitude": -44.4758,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135704,
        "nome": "Jequitibá",
        "latitude": -19.2116,
        "longitude": -44.0012,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135803,
        "nome": "Jequitinhonha",
        "latitude": -16.3888,
        "longitude": -41.083,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3135902,
        "nome": "Jesuânia",
        "latitude": -22.0099,
        "longitude": -45.2754,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136009,
        "nome": "Joaíma",
        "latitude": -16.7707,
        "longitude": -41.0154,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136108,
        "nome": "Joanésia",
        "latitude": -19.2096,
        "longitude": -42.7044,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136207,
        "nome": "João Monlevade",
        "latitude": -19.8383,
        "longitude": -43.1616,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136306,
        "nome": "João Pinheiro",
        "latitude": -17.6049,
        "longitude": -45.9343,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136405,
        "nome": "Joaquim Felício",
        "latitude": -17.676,
        "longitude": -44.1116,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136504,
        "nome": "Jordânia",
        "latitude": -15.8833,
        "longitude": -40.3139,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136520,
        "nome": "José Gonçalves de Minas",
        "latitude": -16.9002,
        "longitude": -42.6561,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136553,
        "nome": "José Raydan",
        "latitude": -18.2472,
        "longitude": -42.4801,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136579,
        "nome": "Josenópolis",
        "latitude": -16.5417,
        "longitude": -42.5507,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136603,
        "nome": "Nova União",
        "latitude": -19.6353,
        "longitude": -43.572,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136652,
        "nome": "Juatuba",
        "latitude": -19.9563,
        "longitude": -44.3543,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136702,
        "nome": "Juiz de Fora",
        "latitude": -21.7455,
        "longitude": -43.4647,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136801,
        "nome": "Juramento",
        "latitude": -16.8401,
        "longitude": -43.5645,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136900,
        "nome": "Juruaia",
        "latitude": -21.2208,
        "longitude": -46.5265,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3136959,
        "nome": "Juvenília",
        "latitude": -14.3857,
        "longitude": -44.0841,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3137007,
        "nome": "Ladainha",
        "latitude": -17.6264,
        "longitude": -41.8226,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3137106,
        "nome": "Lagamar",
        "latitude": -18.1035,
        "longitude": -46.7346,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3137205,
        "nome": "Lagoa da Prata",
        "latitude": -20.011,
        "longitude": -45.494,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3137304,
        "nome": "Lagoa dos Patos",
        "latitude": -17.0078,
        "longitude": -44.6464,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3137403,
        "nome": "Lagoa Dourada",
        "latitude": -20.8923,
        "longitude": -44.0747,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3137502,
        "nome": "Lagoa Formosa",
        "latitude": -18.7695,
        "longitude": -46.3368,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3137536,
        "nome": "Lagoa Grande",
        "latitude": -17.7664,
        "longitude": -46.5016,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3137601,
        "nome": "Lagoa Santa",
        "latitude": -19.6285,
        "longitude": -43.8858,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3137700,
        "nome": "Lajinha",
        "latitude": -20.1437,
        "longitude": -41.5879,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3137809,
        "nome": "Lambari",
        "latitude": -22.0009,
        "longitude": -45.3777,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3137908,
        "nome": "Lamim",
        "latitude": -20.7797,
        "longitude": -43.4745,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138005,
        "nome": "Laranjal",
        "latitude": -21.3566,
        "longitude": -42.4508,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138104,
        "nome": "Lassance",
        "latitude": -17.8808,
        "longitude": -44.6956,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138203,
        "nome": "Lavras",
        "latitude": -21.2647,
        "longitude": -45.0385,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138302,
        "nome": "Leandro Ferreira",
        "latitude": -19.6795,
        "longitude": -45.0408,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138351,
        "nome": "Leme do Prado",
        "latitude": -17.0698,
        "longitude": -42.7445,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138401,
        "nome": "Leopoldina",
        "latitude": -21.5486,
        "longitude": -42.6441,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138500,
        "nome": "Liberdade",
        "latitude": -22.0158,
        "longitude": -44.3331,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138609,
        "nome": "Lima Duarte",
        "latitude": -21.7994,
        "longitude": -43.8869,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138625,
        "nome": "Limeira do Oeste",
        "latitude": -19.4074,
        "longitude": -50.6476,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138658,
        "nome": "Lontra",
        "latitude": -15.8563,
        "longitude": -44.2696,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138674,
        "nome": "Luisburgo",
        "latitude": -20.4363,
        "longitude": -42.0745,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138682,
        "nome": "Luislândia",
        "latitude": -16.1963,
        "longitude": -44.5965,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138708,
        "nome": "Luminárias",
        "latitude": -21.538,
        "longitude": -44.9231,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138807,
        "nome": "Luz",
        "latitude": -19.8273,
        "longitude": -45.6788,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3138906,
        "nome": "Machacalis",
        "latitude": -17.0839,
        "longitude": -40.7197,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3139003,
        "nome": "Machado",
        "latitude": -21.6659,
        "longitude": -45.9201,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3139102,
        "nome": "Madre de Deus de Minas",
        "latitude": -21.485,
        "longitude": -44.3321,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3139201,
        "nome": "Malacacheta",
        "latitude": -17.8434,
        "longitude": -42.1102,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3139250,
        "nome": "Mamonas",
        "latitude": -15.0128,
        "longitude": -42.9539,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3139300,
        "nome": "Manga",
        "latitude": -14.6481,
        "longitude": -44.0925,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3139409,
        "nome": "Manhuaçu",
        "latitude": -20.1953,
        "longitude": -42.1068,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3139508,
        "nome": "Manhumirim",
        "latitude": -20.3473,
        "longitude": -41.9394,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3139607,
        "nome": "Mantena",
        "latitude": -18.6849,
        "longitude": -41.0809,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3139706,
        "nome": "Maravilhas",
        "latitude": -19.5012,
        "longitude": -44.6713,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3139805,
        "nome": "Mar de Espanha",
        "latitude": -21.8777,
        "longitude": -43.0186,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3139904,
        "nome": "Maria da Fé",
        "latitude": -22.3225,
        "longitude": -45.3135,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140001,
        "nome": "Mariana",
        "latitude": -20.3291,
        "longitude": -43.3313,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140100,
        "nome": "Marilac",
        "latitude": -18.494,
        "longitude": -42.074,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140159,
        "nome": "Mário Campos",
        "latitude": -20.0767,
        "longitude": -44.1761,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140209,
        "nome": "Maripá de Minas",
        "latitude": -21.6943,
        "longitude": -42.9565,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140308,
        "nome": "Marliéria",
        "latitude": -19.7058,
        "longitude": -42.6148,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140407,
        "nome": "Marmelópolis",
        "latitude": -22.4636,
        "longitude": -45.1722,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140506,
        "nome": "Martinho Campos",
        "latitude": -19.4123,
        "longitude": -45.1905,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140530,
        "nome": "Martins Soares",
        "latitude": -20.2589,
        "longitude": -41.8427,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140555,
        "nome": "Mata Verde",
        "latitude": -15.7615,
        "longitude": -40.7023,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140605,
        "nome": "Materlândia",
        "latitude": -18.4613,
        "longitude": -43.0469,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140704,
        "nome": "Mateus Leme",
        "latitude": -20.0275,
        "longitude": -44.4374,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140803,
        "nome": "Matias Barbosa",
        "latitude": -21.871,
        "longitude": -43.308,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140852,
        "nome": "Matias Cardoso",
        "latitude": -14.9028,
        "longitude": -43.761,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3140902,
        "nome": "Matipó",
        "latitude": -20.3085,
        "longitude": -42.3157,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3141009,
        "nome": "Mato Verde",
        "latitude": -15.4253,
        "longitude": -42.8642,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3141108,
        "nome": "Matozinhos",
        "latitude": -19.5238,
        "longitude": -44.0515,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3141207,
        "nome": "Matutina",
        "latitude": -19.1936,
        "longitude": -45.9955,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3141306,
        "nome": "Medeiros",
        "latitude": -19.9892,
        "longitude": -46.3397,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3141405,
        "nome": "Medina",
        "latitude": -16.2705,
        "longitude": -41.5101,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3141504,
        "nome": "Mendes Pimentel",
        "latitude": -18.6293,
        "longitude": -41.3558,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3141603,
        "nome": "Mercês",
        "latitude": -21.1883,
        "longitude": -43.3328,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3141702,
        "nome": "Mesquita",
        "latitude": -19.248,
        "longitude": -42.6121,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3141801,
        "nome": "Minas Novas",
        "latitude": -17.3615,
        "longitude": -42.436,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3141900,
        "nome": "Minduri",
        "latitude": -21.6749,
        "longitude": -44.6139,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3142007,
        "nome": "Mirabela",
        "latitude": -16.2594,
        "longitude": -44.1577,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3142106,
        "nome": "Miradouro",
        "latitude": -20.8495,
        "longitude": -42.3997,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3142205,
        "nome": "Miraí",
        "latitude": -21.1501,
        "longitude": -42.6179,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3142254,
        "nome": "Miravânia",
        "latitude": -14.753,
        "longitude": -44.4216,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3142304,
        "nome": "Moeda",
        "latitude": -20.3301,
        "longitude": -43.9921,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3142403,
        "nome": "Moema",
        "latitude": -19.8412,
        "longitude": -45.4072,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3142502,
        "nome": "Monjolos",
        "latitude": -18.3879,
        "longitude": -44.0231,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3142601,
        "nome": "Monsenhor Paulo",
        "latitude": -21.7331,
        "longitude": -45.4819,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3142700,
        "nome": "Montalvânia",
        "latitude": -14.4732,
        "longitude": -44.5015,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3142809,
        "nome": "Monte Alegre de Minas",
        "latitude": -18.8445,
        "longitude": -48.8868,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3142908,
        "nome": "Monte Azul",
        "latitude": -15.2067,
        "longitude": -42.9687,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3143005,
        "nome": "Monte Belo",
        "latitude": -21.3148,
        "longitude": -46.3264,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3143104,
        "nome": "Monte Carmelo",
        "latitude": -18.7092,
        "longitude": -47.461,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3143153,
        "nome": "Monte Formoso",
        "latitude": -16.8774,
        "longitude": -41.2663,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3143203,
        "nome": "Monte Santo de Minas",
        "latitude": -21.1884,
        "longitude": -46.9467,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3143302,
        "nome": "Montes Claros",
        "latitude": -16.6207,
        "longitude": -43.9288,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3143401,
        "nome": "Monte Sião",
        "latitude": -22.4203,
        "longitude": -46.5193,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3143450,
        "nome": "Montezuma",
        "latitude": -15.1913,
        "longitude": -42.4695,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3143500,
        "nome": "Morada Nova de Minas",
        "latitude": -18.5782,
        "longitude": -45.4025,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3143609,
        "nome": "Morro da Garça",
        "latitude": -18.63,
        "longitude": -44.6331,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3143708,
        "nome": "Morro do Pilar",
        "latitude": -19.2351,
        "longitude": -43.4025,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3143807,
        "nome": "Munhoz",
        "latitude": -22.632,
        "longitude": -46.3043,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3143906,
        "nome": "Muriaé",
        "latitude": -21.0914,
        "longitude": -42.4215,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144003,
        "nome": "Mutum",
        "latitude": -19.9192,
        "longitude": -41.4469,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144102,
        "nome": "Muzambinho",
        "latitude": -21.3556,
        "longitude": -46.5165,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144201,
        "nome": "Nacip Raydan",
        "latitude": -18.4806,
        "longitude": -42.188,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144300,
        "nome": "Nanuque",
        "latitude": -17.7793,
        "longitude": -40.4969,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144359,
        "nome": "Naque",
        "latitude": -19.1811,
        "longitude": -42.3244,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144375,
        "nome": "Natalândia",
        "latitude": -16.5452,
        "longitude": -46.4748,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144409,
        "nome": "Natércia",
        "latitude": -22.1301,
        "longitude": -45.5121,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144508,
        "nome": "Nazareno",
        "latitude": -21.2042,
        "longitude": -44.6151,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144607,
        "nome": "Nepomuceno",
        "latitude": -21.2276,
        "longitude": -45.2608,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144656,
        "nome": "Ninheira",
        "latitude": -15.3681,
        "longitude": -41.6599,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144672,
        "nome": "Nova Belém",
        "latitude": -18.4882,
        "longitude": -41.102,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144706,
        "nome": "Nova Era",
        "latitude": -19.7188,
        "longitude": -43.0137,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144805,
        "nome": "Nova Lima",
        "latitude": -20.0741,
        "longitude": -43.904,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3144904,
        "nome": "Nova Módica",
        "latitude": -18.4526,
        "longitude": -41.5224,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145000,
        "nome": "Nova Ponte",
        "latitude": -19.2612,
        "longitude": -47.7069,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145059,
        "nome": "Nova Porteirinha",
        "latitude": -15.7346,
        "longitude": -43.275,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145109,
        "nome": "Nova Resende",
        "latitude": -21.098,
        "longitude": -46.4156,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145208,
        "nome": "Nova Serrana",
        "latitude": -19.8523,
        "longitude": -44.974,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145307,
        "nome": "Novo Cruzeiro",
        "latitude": -17.3708,
        "longitude": -41.9552,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145356,
        "nome": "Novo Oriente de Minas",
        "latitude": -17.2292,
        "longitude": -41.2276,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145372,
        "nome": "Novorizonte",
        "latitude": -16.011,
        "longitude": -42.3977,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145406,
        "nome": "Olaria",
        "latitude": -21.9071,
        "longitude": -43.9661,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145455,
        "nome": "Olhos-d'Água",
        "latitude": -17.478,
        "longitude": -43.5949,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145505,
        "nome": "Olímpio Noronha",
        "latitude": -22.0905,
        "longitude": -45.2854,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145604,
        "nome": "Oliveira",
        "latitude": -20.7498,
        "longitude": -44.736,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145703,
        "nome": "Oliveira Fortes",
        "latitude": -21.3358,
        "longitude": -43.5149,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145802,
        "nome": "Onça de Pitangui",
        "latitude": -19.7082,
        "longitude": -44.7355,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145851,
        "nome": "Oratórios",
        "latitude": -20.4264,
        "longitude": -42.7937,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145877,
        "nome": "Orizânia",
        "latitude": -20.5146,
        "longitude": -42.2128,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3145901,
        "nome": "Ouro Branco",
        "latitude": -20.5247,
        "longitude": -43.6753,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3146008,
        "nome": "Ouro Fino",
        "latitude": -22.2548,
        "longitude": -46.384,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3146107,
        "nome": "Ouro Preto",
        "latitude": -20.3911,
        "longitude": -43.6104,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3146206,
        "nome": "Ouro Verde de Minas",
        "latitude": -18.0485,
        "longitude": -41.2963,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3146255,
        "nome": "Padre Carvalho",
        "latitude": -16.3012,
        "longitude": -42.5863,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3146305,
        "nome": "Padre Paraíso",
        "latitude": -17.038,
        "longitude": -41.552,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3146404,
        "nome": "Paineiras",
        "latitude": -18.9188,
        "longitude": -45.491,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3146503,
        "nome": "Pains",
        "latitude": -20.3815,
        "longitude": -45.6939,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3146552,
        "nome": "Pai Pedro",
        "latitude": -15.4191,
        "longitude": -43.1496,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3146602,
        "nome": "Paiva",
        "latitude": -21.2868,
        "longitude": -43.4239,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3146701,
        "nome": "Palma",
        "latitude": -21.4191,
        "longitude": -42.3289,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3146750,
        "nome": "Palmópolis",
        "latitude": -16.7885,
        "longitude": -40.3711,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3146909,
        "nome": "Papagaios",
        "latitude": -19.3765,
        "longitude": -44.6913,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3147006,
        "nome": "Paracatu",
        "latitude": -17.173,
        "longitude": -46.8842,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3147105,
        "nome": "Pará de Minas",
        "latitude": -19.8343,
        "longitude": -44.6079,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3147204,
        "nome": "Paraguaçu",
        "latitude": -21.5668,
        "longitude": -45.7499,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3147303,
        "nome": "Paraisópolis",
        "latitude": -22.5715,
        "longitude": -45.817,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3147402,
        "nome": "Paraopeba",
        "latitude": -19.2722,
        "longitude": -44.4527,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3147501,
        "nome": "Passabém",
        "latitude": -19.3603,
        "longitude": -43.1753,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3147600,
        "nome": "Passa Quatro",
        "latitude": -22.4058,
        "longitude": -44.9683,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3147709,
        "nome": "Passa Tempo",
        "latitude": -20.6489,
        "longitude": -44.4911,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3147808,
        "nome": "Passa Vinte",
        "latitude": -22.1829,
        "longitude": -44.2615,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3147907,
        "nome": "Passos",
        "latitude": -20.7186,
        "longitude": -46.622,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3147956,
        "nome": "Patis",
        "latitude": -16.0806,
        "longitude": -44.1014,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3148004,
        "nome": "Patos de Minas",
        "latitude": -18.597,
        "longitude": -46.5077,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3148103,
        "nome": "Patrocínio",
        "latitude": -18.9705,
        "longitude": -47.0513,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3148202,
        "nome": "Patrocínio do Muriaé",
        "latitude": -21.1672,
        "longitude": -42.253,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3148301,
        "nome": "Paula Cândido",
        "latitude": -20.8559,
        "longitude": -42.985,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3148400,
        "nome": "Paulistas",
        "latitude": -18.4582,
        "longitude": -42.8653,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3148509,
        "nome": "Pavão",
        "latitude": -17.4715,
        "longitude": -41.0616,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3148608,
        "nome": "Peçanha",
        "latitude": -18.5571,
        "longitude": -42.5104,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3148707,
        "nome": "Pedra Azul",
        "latitude": -15.9551,
        "longitude": -41.1842,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3148756,
        "nome": "Pedra Bonita",
        "latitude": -20.4766,
        "longitude": -42.3753,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3148806,
        "nome": "Pedra do Anta",
        "latitude": -20.593,
        "longitude": -42.7213,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3148905,
        "nome": "Pedra do Indaiá",
        "latitude": -20.2869,
        "longitude": -45.2293,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3149002,
        "nome": "Pedra Dourada",
        "latitude": -20.8277,
        "longitude": -42.1549,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3149101,
        "nome": "Pedralva",
        "latitude": -22.2496,
        "longitude": -45.4539,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3149150,
        "nome": "Pedras de Maria da Cruz",
        "latitude": -15.6257,
        "longitude": -44.3236,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3149200,
        "nome": "Pedrinópolis",
        "latitude": -19.1923,
        "longitude": -47.5103,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3149309,
        "nome": "Pedro Leopoldo",
        "latitude": -19.6399,
        "longitude": -44.0527,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3149408,
        "nome": "Pedro Teixeira",
        "latitude": -21.7253,
        "longitude": -43.7291,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3149507,
        "nome": "Pequeri",
        "latitude": -21.8259,
        "longitude": -43.1321,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3149606,
        "nome": "Pequi",
        "latitude": -19.6048,
        "longitude": -44.6358,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3149705,
        "nome": "Perdigão",
        "latitude": -19.9402,
        "longitude": -45.0579,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3149804,
        "nome": "Perdizes",
        "latitude": -19.4002,
        "longitude": -47.196,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3149903,
        "nome": "Perdões",
        "latitude": -21.0759,
        "longitude": -45.0648,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3149952,
        "nome": "Periquito",
        "latitude": -19.0842,
        "longitude": -42.2318,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3150000,
        "nome": "Pescador",
        "latitude": -18.3311,
        "longitude": -41.5601,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3150109,
        "nome": "Piau",
        "latitude": -21.5024,
        "longitude": -43.3167,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3150158,
        "nome": "Piedade de Caratinga",
        "latitude": -19.763,
        "longitude": -42.0447,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3150208,
        "nome": "Piedade de Ponte Nova",
        "latitude": -20.2417,
        "longitude": -42.7181,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3150307,
        "nome": "Piedade do Rio Grande",
        "latitude": -21.484,
        "longitude": -44.1555,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3150406,
        "nome": "Piedade dos Gerais",
        "latitude": -20.4741,
        "longitude": -44.2464,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3150505,
        "nome": "Pimenta",
        "latitude": -20.5305,
        "longitude": -45.8313,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3150539,
        "nome": "Pingo-d'Água",
        "latitude": -19.7434,
        "longitude": -42.4218,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3150570,
        "nome": "Pintópolis",
        "latitude": -16.0494,
        "longitude": -45.2472,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3150604,
        "nome": "Piracema",
        "latitude": -20.5222,
        "longitude": -44.4227,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3150703,
        "nome": "Pirajuba",
        "latitude": -19.9403,
        "longitude": -48.6578,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3150802,
        "nome": "Piranga",
        "latitude": -20.6333,
        "longitude": -43.299,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3150901,
        "nome": "Piranguçu",
        "latitude": -22.5566,
        "longitude": -45.5155,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3151008,
        "nome": "Piranguinho",
        "latitude": -22.363,
        "longitude": -45.5866,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3151107,
        "nome": "Pirapetinga",
        "latitude": -21.6791,
        "longitude": -42.3639,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3151206,
        "nome": "Pirapora",
        "latitude": -17.3933,
        "longitude": -44.8674,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3151305,
        "nome": "Piraúba",
        "latitude": -21.2638,
        "longitude": -43.0297,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3151404,
        "nome": "Pitangui",
        "latitude": -19.5878,
        "longitude": -44.8865,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3151503,
        "nome": "Piumhi",
        "latitude": -20.4414,
        "longitude": -46.0504,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3151602,
        "nome": "Planura",
        "latitude": -20.0813,
        "longitude": -48.6463,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3151701,
        "nome": "Poço Fundo",
        "latitude": -21.8063,
        "longitude": -45.9933,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3151800,
        "nome": "Poços de Caldas",
        "latitude": -21.8081,
        "longitude": -46.5633,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3151909,
        "nome": "Pocrane",
        "latitude": -19.5849,
        "longitude": -41.5572,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3152006,
        "nome": "Pompéu",
        "latitude": -19.1311,
        "longitude": -44.9236,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3152105,
        "nome": "Ponte Nova",
        "latitude": -20.4121,
        "longitude": -42.9174,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3152131,
        "nome": "Ponto Chique",
        "latitude": -16.6088,
        "longitude": -44.9736,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3152170,
        "nome": "Ponto dos Volantes",
        "latitude": -16.8342,
        "longitude": -41.4744,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3152204,
        "nome": "Porteirinha",
        "latitude": -15.7166,
        "longitude": -43.0758,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3152303,
        "nome": "Porto Firme",
        "latitude": -20.6636,
        "longitude": -43.0804,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3152402,
        "nome": "Poté",
        "latitude": -17.815,
        "longitude": -41.7693,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3152501,
        "nome": "Pouso Alegre",
        "latitude": -22.2649,
        "longitude": -45.94,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3152600,
        "nome": "Pouso Alto",
        "latitude": -22.1754,
        "longitude": -44.9326,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3152709,
        "nome": "Prados",
        "latitude": -21.0986,
        "longitude": -44.0635,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3152808,
        "nome": "Prata",
        "latitude": -19.3299,
        "longitude": -48.9542,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3152907,
        "nome": "Pratápolis",
        "latitude": -20.7873,
        "longitude": -46.8627,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3153004,
        "nome": "Pratinha",
        "latitude": -19.7598,
        "longitude": -46.4026,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3153103,
        "nome": "Presidente Bernardes",
        "latitude": -20.7704,
        "longitude": -43.1548,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3153202,
        "nome": "Presidente Juscelino",
        "latitude": -18.7261,
        "longitude": -44.0833,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3153301,
        "nome": "Presidente Kubitschek",
        "latitude": -18.6339,
        "longitude": -43.5781,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3153400,
        "nome": "Presidente Olegário",
        "latitude": -18.2392,
        "longitude": -46.3362,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3153509,
        "nome": "Alto Jequitibá",
        "latitude": -20.4372,
        "longitude": -41.9488,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3153608,
        "nome": "Prudente de Morais",
        "latitude": -19.4645,
        "longitude": -44.1114,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3153707,
        "nome": "Quartel Geral",
        "latitude": -19.2798,
        "longitude": -45.6031,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3153806,
        "nome": "Queluzito",
        "latitude": -20.7321,
        "longitude": -43.8908,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3153905,
        "nome": "Raposos",
        "latitude": -19.9809,
        "longitude": -43.7832,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3154002,
        "nome": "Raul Soares",
        "latitude": -20.0132,
        "longitude": -42.3902,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3154101,
        "nome": "Recreio",
        "latitude": -21.5198,
        "longitude": -42.4378,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3154150,
        "nome": "Reduto",
        "latitude": -20.2378,
        "longitude": -41.9403,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3154200,
        "nome": "Resende Costa",
        "latitude": -20.8375,
        "longitude": -44.292,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3154309,
        "nome": "Resplendor",
        "latitude": -19.2119,
        "longitude": -41.1531,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3154408,
        "nome": "Ressaquinha",
        "latitude": -21.0854,
        "longitude": -43.7532,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3154457,
        "nome": "Riachinho",
        "latitude": -16.2767,
        "longitude": -45.9279,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3154507,
        "nome": "Riacho dos Machados",
        "latitude": -16.0545,
        "longitude": -42.9934,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3154606,
        "nome": "Ribeirão das Neves",
        "latitude": -19.7795,
        "longitude": -44.0719,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3154705,
        "nome": "Ribeirão Vermelho",
        "latitude": -21.1479,
        "longitude": -45.0731,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3154804,
        "nome": "Rio Acima",
        "latitude": -20.1058,
        "longitude": -43.7729,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3154903,
        "nome": "Rio Casca",
        "latitude": -20.1409,
        "longitude": -42.6606,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3155009,
        "nome": "Rio Doce",
        "latitude": -20.2156,
        "longitude": -42.9065,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3155108,
        "nome": "Rio do Prado",
        "latitude": -16.6766,
        "longitude": -40.5558,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3155207,
        "nome": "Rio Espera",
        "latitude": -20.8679,
        "longitude": -43.4921,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3155306,
        "nome": "Rio Manso",
        "latitude": -20.2671,
        "longitude": -44.345,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3155405,
        "nome": "Rio Novo",
        "latitude": -21.4686,
        "longitude": -43.1439,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3155504,
        "nome": "Rio Paranaíba",
        "latitude": -19.24,
        "longitude": -46.2989,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3155603,
        "nome": "Rio Pardo de Minas",
        "latitude": -15.709,
        "longitude": -42.5514,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3155702,
        "nome": "Rio Piracicaba",
        "latitude": -19.9708,
        "longitude": -43.1492,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3155801,
        "nome": "Rio Pomba",
        "latitude": -21.2484,
        "longitude": -43.1718,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3155900,
        "nome": "Rio Preto",
        "latitude": -22.041,
        "longitude": -43.8786,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3156007,
        "nome": "Rio Vermelho",
        "latitude": -18.2547,
        "longitude": -43.0551,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3156106,
        "nome": "Ritápolis",
        "latitude": -20.9823,
        "longitude": -44.3764,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3156205,
        "nome": "Rochedo de Minas",
        "latitude": -21.641,
        "longitude": -43.0286,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3156304,
        "nome": "Rodeiro",
        "latitude": -21.2107,
        "longitude": -42.8413,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3156403,
        "nome": "Romaria",
        "latitude": -18.9035,
        "longitude": -47.5626,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3156452,
        "nome": "Rosário da Limeira",
        "latitude": -20.9794,
        "longitude": -42.5114,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3156502,
        "nome": "Rubelita",
        "latitude": -16.3677,
        "longitude": -42.234,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3156601,
        "nome": "Rubim",
        "latitude": -16.4639,
        "longitude": -40.4942,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3156700,
        "nome": "Sabará",
        "latitude": -19.8513,
        "longitude": -43.7792,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3156809,
        "nome": "Sabinópolis",
        "latitude": -18.6509,
        "longitude": -43.0635,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3156908,
        "nome": "Sacramento",
        "latitude": -19.9045,
        "longitude": -47.2664,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157005,
        "nome": "Salinas",
        "latitude": -16.1111,
        "longitude": -42.1521,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157104,
        "nome": "Salto da Divisa",
        "latitude": -16.1105,
        "longitude": -40.0292,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157203,
        "nome": "Santa Bárbara",
        "latitude": -20.0289,
        "longitude": -43.4751,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157252,
        "nome": "Santa Bárbara do Leste",
        "latitude": -19.9451,
        "longitude": -42.1066,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157278,
        "nome": "Santa Bárbara do Monte Verde",
        "latitude": -21.9639,
        "longitude": -43.6945,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157302,
        "nome": "Santa Bárbara do Tugúrio",
        "latitude": -21.2451,
        "longitude": -43.5315,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157336,
        "nome": "Santa Cruz de Minas",
        "latitude": -21.1203,
        "longitude": -44.2173,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157377,
        "nome": "Santa Cruz de Salinas",
        "latitude": -16.0507,
        "longitude": -41.7899,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157401,
        "nome": "Santa Cruz do Escalvado",
        "latitude": -20.2306,
        "longitude": -42.814,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157500,
        "nome": "Santa Efigênia de Minas",
        "latitude": -18.8628,
        "longitude": -42.4043,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157609,
        "nome": "Santa Fé de Minas",
        "latitude": -16.7015,
        "longitude": -45.5571,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157658,
        "nome": "Santa Helena de Minas",
        "latitude": -16.902,
        "longitude": -40.6588,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157708,
        "nome": "Santa Juliana",
        "latitude": -19.3803,
        "longitude": -47.5091,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157807,
        "nome": "Santa Luzia",
        "latitude": -19.7449,
        "longitude": -43.8366,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3157906,
        "nome": "Santa Margarida",
        "latitude": -20.4281,
        "longitude": -42.2662,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3158003,
        "nome": "Santa Maria de Itabira",
        "latitude": -19.4353,
        "longitude": -43.0449,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3158102,
        "nome": "Santa Maria do Salto",
        "latitude": -16.3073,
        "longitude": -40.1164,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3158201,
        "nome": "Santa Maria do Suaçuí",
        "latitude": -18.2585,
        "longitude": -42.3243,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3158300,
        "nome": "Santana da Vargem",
        "latitude": -21.2706,
        "longitude": -45.5054,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3158409,
        "nome": "Santana de Cataguases",
        "latitude": -21.2821,
        "longitude": -42.5561,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3158508,
        "nome": "Santana de Pirapama",
        "latitude": -18.9158,
        "longitude": -43.9011,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3158607,
        "nome": "Santana do Deserto",
        "latitude": -21.946,
        "longitude": -43.1828,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3158706,
        "nome": "Santana do Garambéu",
        "latitude": -21.6369,
        "longitude": -44.0661,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3158805,
        "nome": "Santana do Jacaré",
        "latitude": -20.8831,
        "longitude": -45.0621,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3158904,
        "nome": "Santana do Manhuaçu",
        "latitude": -20.056,
        "longitude": -41.8923,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3158953,
        "nome": "Santana do Paraíso",
        "latitude": -19.3851,
        "longitude": -42.5205,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3159001,
        "nome": "Santana do Riacho",
        "latitude": -19.1887,
        "longitude": -43.6447,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3159100,
        "nome": "Santana dos Montes",
        "latitude": -20.7969,
        "longitude": -43.6698,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3159209,
        "nome": "Santa Rita de Caldas",
        "latitude": -22.0237,
        "longitude": -46.2714,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3159308,
        "nome": "Santa Rita de Jacutinga",
        "latitude": -22.1015,
        "longitude": -44.0918,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3159357,
        "nome": "Santa Rita de Minas",
        "latitude": -19.875,
        "longitude": -42.1233,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3159407,
        "nome": "Santa Rita de Ibitipoca",
        "latitude": -21.5772,
        "longitude": -43.9302,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3159506,
        "nome": "Santa Rita do Itueto",
        "latitude": -19.4128,
        "longitude": -41.3887,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3159605,
        "nome": "Santa Rita do Sapucaí",
        "latitude": -22.237,
        "longitude": -45.6828,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3159704,
        "nome": "Santa Rosa da Serra",
        "latitude": -19.562,
        "longitude": -45.9998,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3159803,
        "nome": "Santa Vitória",
        "latitude": -18.9895,
        "longitude": -50.2752,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3159902,
        "nome": "Santo Antônio do Amparo",
        "latitude": -20.9162,
        "longitude": -44.9428,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3160009,
        "nome": "Santo Antônio do Aventureiro",
        "latitude": -21.7514,
        "longitude": -42.8115,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3160108,
        "nome": "Santo Antônio do Grama",
        "latitude": -20.3222,
        "longitude": -42.6039,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3160207,
        "nome": "Santo Antônio do Itambé",
        "latitude": -18.4784,
        "longitude": -43.2667,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3160306,
        "nome": "Santo Antônio do Jacinto",
        "latitude": -16.5036,
        "longitude": -40.2775,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3160405,
        "nome": "Santo Antônio do Monte",
        "latitude": -20.083,
        "longitude": -45.2923,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3160454,
        "nome": "Santo Antônio do Retiro",
        "latitude": -15.2881,
        "longitude": -42.661,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3160504,
        "nome": "Santo Antônio do Rio Abaixo",
        "latitude": -19.2414,
        "longitude": -43.249,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3160603,
        "nome": "Santo Hipólito",
        "latitude": -18.3902,
        "longitude": -44.1724,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3160702,
        "nome": "Santos Dumont",
        "latitude": -21.4577,
        "longitude": -43.5257,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3160801,
        "nome": "São Bento Abade",
        "latitude": -21.5701,
        "longitude": -45.0723,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3160900,
        "nome": "São Brás do Suaçuí",
        "latitude": -20.6275,
        "longitude": -43.9724,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3160959,
        "nome": "São Domingos das Dores",
        "latitude": -19.5246,
        "longitude": -42.0309,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3161007,
        "nome": "São Domingos do Prata",
        "latitude": -19.903,
        "longitude": -42.9032,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3161056,
        "nome": "São Félix de Minas",
        "latitude": -18.5686,
        "longitude": -41.4486,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3161106,
        "nome": "São Francisco",
        "latitude": -15.8965,
        "longitude": -44.8613,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3161205,
        "nome": "São Francisco de Paula",
        "latitude": -20.7165,
        "longitude": -44.9954,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3161304,
        "nome": "São Francisco de Sales",
        "latitude": -19.7968,
        "longitude": -49.8594,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3161403,
        "nome": "São Francisco do Glória",
        "latitude": -20.7919,
        "longitude": -42.2823,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3161502,
        "nome": "São Geraldo",
        "latitude": -20.9106,
        "longitude": -42.8291,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3161601,
        "nome": "São Geraldo da Piedade",
        "latitude": -18.8963,
        "longitude": -42.3104,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3161650,
        "nome": "São Geraldo do Baixio",
        "latitude": -18.9168,
        "longitude": -41.3669,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3161700,
        "nome": "São Gonçalo do Abaeté",
        "latitude": -18.1767,
        "longitude": -45.5459,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3161809,
        "nome": "São Gonçalo do Pará",
        "latitude": -19.9839,
        "longitude": -44.8284,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3161908,
        "nome": "São Gonçalo do Rio Abaixo",
        "latitude": -19.8172,
        "longitude": -43.3214,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162005,
        "nome": "São Gonçalo do Sapucaí",
        "latitude": -21.911,
        "longitude": -45.5944,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162104,
        "nome": "São Gotardo",
        "latitude": -19.3599,
        "longitude": -45.9995,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162203,
        "nome": "São João Batista do Glória",
        "latitude": -20.5772,
        "longitude": -46.4386,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162252,
        "nome": "São João da Lagoa",
        "latitude": -16.8598,
        "longitude": -44.3348,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162302,
        "nome": "São João da Mata",
        "latitude": -21.9426,
        "longitude": -45.9232,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162401,
        "nome": "São João da Ponte",
        "latitude": -15.9084,
        "longitude": -43.8953,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162450,
        "nome": "São João das Missões",
        "latitude": -14.8919,
        "longitude": -44.2277,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162500,
        "nome": "São João del Rei",
        "latitude": -21.2631,
        "longitude": -44.2744,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162559,
        "nome": "São João do Manhuaçu",
        "latitude": -20.37,
        "longitude": -42.1535,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162575,
        "nome": "São João do Manteninha",
        "latitude": -18.7526,
        "longitude": -41.1644,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162609,
        "nome": "São João do Oriente",
        "latitude": -19.354,
        "longitude": -42.1703,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162658,
        "nome": "São João do Pacuí",
        "latitude": -16.5553,
        "longitude": -44.5244,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162708,
        "nome": "São João do Paraíso",
        "latitude": -15.3428,
        "longitude": -41.9769,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162807,
        "nome": "São João Evangelista",
        "latitude": -18.5136,
        "longitude": -42.7756,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162906,
        "nome": "São João Nepomuceno",
        "latitude": -21.583,
        "longitude": -43.0032,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162922,
        "nome": "São Joaquim de Bicas",
        "latitude": -20.0709,
        "longitude": -44.249,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162948,
        "nome": "São José da Barra",
        "latitude": -20.7474,
        "longitude": -46.2437,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3162955,
        "nome": "São José da Lapa",
        "latitude": -19.6969,
        "longitude": -43.9903,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3163003,
        "nome": "São José da Safira",
        "latitude": -18.3175,
        "longitude": -42.1234,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3163102,
        "nome": "São José da Varginha",
        "latitude": -19.6961,
        "longitude": -44.5615,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3163201,
        "nome": "São José do Alegre",
        "latitude": -22.3304,
        "longitude": -45.5178,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3163300,
        "nome": "São José do Divino",
        "latitude": -18.3983,
        "longitude": -41.376,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3163409,
        "nome": "São José do Goiabal",
        "latitude": -19.9312,
        "longitude": -42.6933,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3163508,
        "nome": "São José do Jacuri",
        "latitude": -18.2429,
        "longitude": -42.6683,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3163607,
        "nome": "São José do Mantimento",
        "latitude": -20.0201,
        "longitude": -41.77,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3163706,
        "nome": "São Lourenço",
        "latitude": -22.1171,
        "longitude": -45.0343,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3163805,
        "nome": "São Miguel do Anta",
        "latitude": -20.7268,
        "longitude": -42.7108,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3163904,
        "nome": "São Pedro da União",
        "latitude": -21.1268,
        "longitude": -46.6419,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3164001,
        "nome": "São Pedro dos Ferros",
        "latitude": -20.0542,
        "longitude": -42.5698,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3164100,
        "nome": "São Pedro do Suaçuí",
        "latitude": -18.3479,
        "longitude": -42.5926,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3164209,
        "nome": "São Romão",
        "latitude": -16.3894,
        "longitude": -45.4063,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3164308,
        "nome": "São Roque de Minas",
        "latitude": -20.187,
        "longitude": -46.5135,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3164407,
        "nome": "São Sebastião da Bela Vista",
        "latitude": -22.1613,
        "longitude": -45.7759,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3164431,
        "nome": "São Sebastião da Vargem Alegre",
        "latitude": -21.0243,
        "longitude": -42.5992,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3164472,
        "nome": "São Sebastião do Anta",
        "latitude": -19.5072,
        "longitude": -41.9573,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3164506,
        "nome": "São Sebastião do Maranhão",
        "latitude": -18.0597,
        "longitude": -42.5412,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3164605,
        "nome": "São Sebastião do Oeste",
        "latitude": -20.2516,
        "longitude": -45.0442,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3164704,
        "nome": "São Sebastião do Paraíso",
        "latitude": -20.9224,
        "longitude": -47.0064,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3164803,
        "nome": "São Sebastião do Rio Preto",
        "latitude": -19.3005,
        "longitude": -43.2195,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3164902,
        "nome": "São Sebastião do Rio Verde",
        "latitude": -22.2194,
        "longitude": -45.0248,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165008,
        "nome": "São Tiago",
        "latitude": -20.9385,
        "longitude": -44.5604,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165107,
        "nome": "São Tomás de Aquino",
        "latitude": -20.7862,
        "longitude": -47.1272,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165206,
        "nome": "São Tomé das Letras",
        "latitude": -21.7333,
        "longitude": -44.9638,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165305,
        "nome": "São Vicente de Minas",
        "latitude": -21.6671,
        "longitude": -44.4743,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165404,
        "nome": "Sapucaí-Mirim",
        "latitude": -22.7863,
        "longitude": -45.8486,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165503,
        "nome": "Sardoá",
        "latitude": -18.7755,
        "longitude": -42.407,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165537,
        "nome": "Sarzedo",
        "latitude": -20.0591,
        "longitude": -44.121,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165552,
        "nome": "Setubinha",
        "latitude": -17.6225,
        "longitude": -42.1568,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165560,
        "nome": "Sem-Peixe",
        "latitude": -20.0801,
        "longitude": -42.8251,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165578,
        "nome": "Senador Amaral",
        "latitude": -22.5577,
        "longitude": -46.2171,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165602,
        "nome": "Senador Cortes",
        "latitude": -21.7704,
        "longitude": -42.9092,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165701,
        "nome": "Senador Firmino",
        "latitude": -20.9043,
        "longitude": -43.1045,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165800,
        "nome": "Senador José Bento",
        "latitude": -22.1568,
        "longitude": -46.1411,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3165909,
        "nome": "Senador Modestino Gonçalves",
        "latitude": -17.8552,
        "longitude": -43.241,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3166006,
        "nome": "Senhora de Oliveira",
        "latitude": -20.801,
        "longitude": -43.3494,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3166105,
        "nome": "Senhora do Porto",
        "latitude": -18.9132,
        "longitude": -43.0805,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3166204,
        "nome": "Senhora dos Remédios",
        "latitude": -21.0312,
        "longitude": -43.6002,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3166303,
        "nome": "Sericita",
        "latitude": -20.4923,
        "longitude": -42.4587,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3166402,
        "nome": "Seritinga",
        "latitude": -21.9165,
        "longitude": -44.4596,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3166501,
        "nome": "Serra Azul de Minas",
        "latitude": -18.3906,
        "longitude": -43.2073,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3166600,
        "nome": "Serra da Saudade",
        "latitude": -19.3855,
        "longitude": -45.7772,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3166709,
        "nome": "Serra dos Aimorés",
        "latitude": -17.7841,
        "longitude": -40.2644,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3166808,
        "nome": "Serra do Salitre",
        "latitude": -19.1591,
        "longitude": -46.6545,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3166907,
        "nome": "Serrania",
        "latitude": -21.554,
        "longitude": -46.0928,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3166956,
        "nome": "Serranópolis de Minas",
        "latitude": -15.8568,
        "longitude": -42.8609,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3167004,
        "nome": "Serranos",
        "latitude": -21.831,
        "longitude": -44.5369,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3167103,
        "nome": "Serro",
        "latitude": -18.5364,
        "longitude": -43.4018,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3167202,
        "nome": "Sete Lagoas",
        "latitude": -19.4373,
        "longitude": -44.2535,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3167301,
        "nome": "Silveirânia",
        "latitude": -21.1434,
        "longitude": -43.203,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3167400,
        "nome": "Silvianópolis",
        "latitude": -22.0369,
        "longitude": -45.8056,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3167509,
        "nome": "Simão Pereira",
        "latitude": -21.9642,
        "longitude": -43.293,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3167608,
        "nome": "Simonésia",
        "latitude": -19.999,
        "longitude": -41.9873,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3167707,
        "nome": "Sobrália",
        "latitude": -19.2182,
        "longitude": -42.1459,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3167806,
        "nome": "Soledade de Minas",
        "latitude": -22.027,
        "longitude": -45.0276,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3167905,
        "nome": "Tabuleiro",
        "latitude": -21.3634,
        "longitude": -43.2562,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3168002,
        "nome": "Taiobeiras",
        "latitude": -15.8245,
        "longitude": -42.0561,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3168051,
        "nome": "Taparuba",
        "latitude": -19.7386,
        "longitude": -41.6116,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3168101,
        "nome": "Tapira",
        "latitude": -19.9158,
        "longitude": -46.8683,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3168200,
        "nome": "Tapiraí",
        "latitude": -19.8762,
        "longitude": -46.1607,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3168309,
        "nome": "Taquaraçu de Minas",
        "latitude": -19.634,
        "longitude": -43.6856,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3168408,
        "nome": "Tarumirim",
        "latitude": -19.3015,
        "longitude": -41.9019,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3168507,
        "nome": "Teixeiras",
        "latitude": -20.6321,
        "longitude": -42.8625,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3168606,
        "nome": "Teófilo Otoni",
        "latitude": -17.7146,
        "longitude": -41.3837,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3168705,
        "nome": "Timóteo",
        "latitude": -19.558,
        "longitude": -42.6026,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3168804,
        "nome": "Tiradentes",
        "latitude": -21.1164,
        "longitude": -44.1546,
        "mesorregiaoNome": "Campo das Vertentes",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3168903,
        "nome": "Tiros",
        "latitude": -18.8601,
        "longitude": -45.8241,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3169000,
        "nome": "Tocantins",
        "latitude": -21.1775,
        "longitude": -43.0265,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3169059,
        "nome": "Tocos do Moji",
        "latitude": -22.3587,
        "longitude": -46.1465,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3169109,
        "nome": "Toledo",
        "latitude": -22.7057,
        "longitude": -46.3832,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3169208,
        "nome": "Tombos",
        "latitude": -20.8819,
        "longitude": -42.0642,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3169307,
        "nome": "Três Corações",
        "latitude": -21.6864,
        "longitude": -45.2049,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3169356,
        "nome": "Três Marias",
        "latitude": -18.2978,
        "longitude": -45.0692,
        "mesorregiaoNome": "Central Mineira",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3169406,
        "nome": "Três Pontas",
        "latitude": -21.3935,
        "longitude": -45.4982,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3169505,
        "nome": "Tumiritinga",
        "latitude": -19.015,
        "longitude": -41.7055,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3169604,
        "nome": "Tupaciguara",
        "latitude": -18.535,
        "longitude": -48.7553,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3169703,
        "nome": "Turmalina",
        "latitude": -17.2445,
        "longitude": -42.8399,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3169802,
        "nome": "Turvolândia",
        "latitude": -21.885,
        "longitude": -45.7997,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3169901,
        "nome": "Ubá",
        "latitude": -21.1053,
        "longitude": -42.9653,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170008,
        "nome": "Ubaí",
        "latitude": -16.364,
        "longitude": -44.8477,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170057,
        "nome": "Ubaporanga",
        "latitude": -19.6605,
        "longitude": -42.0699,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170107,
        "nome": "Uberaba",
        "latitude": -19.5809,
        "longitude": -47.9772,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170206,
        "nome": "Uberlândia",
        "latitude": -19.0278,
        "longitude": -48.3317,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170305,
        "nome": "Umburatiba",
        "latitude": -17.2724,
        "longitude": -40.6669,
        "mesorregiaoNome": "Vale do Mucuri",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170404,
        "nome": "Unaí",
        "latitude": -16.3758,
        "longitude": -46.8196,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170438,
        "nome": "União de Minas",
        "latitude": -19.4084,
        "longitude": -50.343,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170479,
        "nome": "Uruana de Minas",
        "latitude": -16.0926,
        "longitude": -46.3196,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170503,
        "nome": "Urucânia",
        "latitude": -20.3253,
        "longitude": -42.7298,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170529,
        "nome": "Urucuia",
        "latitude": -16.0286,
        "longitude": -45.5729,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170578,
        "nome": "Vargem Alegre",
        "latitude": -19.6037,
        "longitude": -42.3213,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170602,
        "nome": "Vargem Bonita",
        "latitude": -20.4313,
        "longitude": -46.3362,
        "mesorregiaoNome": "Oeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170651,
        "nome": "Vargem Grande do Rio Pardo",
        "latitude": -15.3407,
        "longitude": -42.2989,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170701,
        "nome": "Varginha",
        "latitude": -21.5575,
        "longitude": -45.4091,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170750,
        "nome": "Varjão de Minas",
        "latitude": -18.4666,
        "longitude": -45.9352,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170800,
        "nome": "Várzea da Palma",
        "latitude": -17.4957,
        "longitude": -44.7273,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3170909,
        "nome": "Varzelândia",
        "latitude": -15.6415,
        "longitude": -43.9344,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3171006,
        "nome": "Vazante",
        "latitude": -17.8692,
        "longitude": -46.8676,
        "mesorregiaoNome": "Noroeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3171030,
        "nome": "Verdelândia",
        "latitude": -15.5402,
        "longitude": -43.6283,
        "mesorregiaoNome": "Norte de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3171071,
        "nome": "Veredinha",
        "latitude": -17.4877,
        "longitude": -42.7252,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3171105,
        "nome": "Veríssimo",
        "latitude": -19.6025,
        "longitude": -48.3409,
        "mesorregiaoNome": "Triângulo Mineiro/Alto Paranaíba",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3171154,
        "nome": "Vermelho Novo",
        "latitude": -20.034,
        "longitude": -42.2543,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3171204,
        "nome": "Vespasiano",
        "latitude": -19.7312,
        "longitude": -43.9448,
        "mesorregiaoNome": "Metropolitana de Belo Horizonte",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3171303,
        "nome": "Viçosa",
        "latitude": -20.7404,
        "longitude": -42.8855,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3171402,
        "nome": "Vieiras",
        "latitude": -20.9126,
        "longitude": -42.282,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3171501,
        "nome": "Mathias Lobato",
        "latitude": -18.6111,
        "longitude": -41.9272,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3171600,
        "nome": "Virgem da Lapa",
        "latitude": -16.7155,
        "longitude": -42.3396,
        "mesorregiaoNome": "Jequitinhonha",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3171709,
        "nome": "Virgínia",
        "latitude": -22.3419,
        "longitude": -45.1085,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3171808,
        "nome": "Virginópolis",
        "latitude": -18.7919,
        "longitude": -42.6703,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3171907,
        "nome": "Virgolândia",
        "latitude": -18.4517,
        "longitude": -42.3175,
        "mesorregiaoNome": "Vale do Rio Doce",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3172004,
        "nome": "Visconde do Rio Branco",
        "latitude": -21.0116,
        "longitude": -42.84,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3172103,
        "nome": "Volta Grande",
        "latitude": -21.758,
        "longitude": -42.5574,
        "mesorregiaoNome": "Zona da Mata",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3172202,
        "nome": "Wenceslau Braz",
        "latitude": -22.5547,
        "longitude": -45.4014,
        "mesorregiaoNome": "Sul/Sudoeste de Minas",
        "UFSigla": "MG",
        "UFNome": "Minas Gerais"
    },
    {
        "ibgeId": 3200102,
        "nome": "Afonso Cláudio",
        "latitude": -20.0894,
        "longitude": -41.1265,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3200136,
        "nome": "Águia Branca",
        "latitude": -18.9703,
        "longitude": -40.7495,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3200169,
        "nome": "Água Doce do Norte",
        "latitude": -18.5166,
        "longitude": -40.9968,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3200201,
        "nome": "Alegre",
        "latitude": -20.7195,
        "longitude": -41.5149,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3200300,
        "nome": "Alfredo Chaves",
        "latitude": -20.5639,
        "longitude": -40.8271,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3200359,
        "nome": "Alto Rio Novo",
        "latitude": -19.0221,
        "longitude": -40.9872,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3200409,
        "nome": "Anchieta",
        "latitude": -20.7187,
        "longitude": -40.6863,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3200508,
        "nome": "Apiacá",
        "latitude": -21.0721,
        "longitude": -41.5541,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3200607,
        "nome": "Aracruz",
        "latitude": -19.7656,
        "longitude": -40.1761,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3200706,
        "nome": "Atílio Vivácqua",
        "latitude": -20.9622,
        "longitude": -41.184,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3200805,
        "nome": "Baixo Guandu",
        "latitude": -19.5724,
        "longitude": -40.9838,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3200904,
        "nome": "Barra de São Francisco",
        "latitude": -18.6661,
        "longitude": -40.8312,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3201001,
        "nome": "Boa Esperança",
        "latitude": -18.4848,
        "longitude": -40.3291,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3201100,
        "nome": "Bom Jesus do Norte",
        "latitude": -21.0845,
        "longitude": -41.6338,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3201159,
        "nome": "Brejetuba",
        "latitude": -20.1254,
        "longitude": -41.2969,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3201209,
        "nome": "Cachoeiro de Itapemirim",
        "latitude": -20.7661,
        "longitude": -41.191,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3201308,
        "nome": "Cariacica",
        "latitude": -20.2907,
        "longitude": -40.442,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3201407,
        "nome": "Castelo",
        "latitude": -20.5517,
        "longitude": -41.204,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3201506,
        "nome": "Colatina",
        "latitude": -19.4882,
        "longitude": -40.6568,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3201605,
        "nome": "Conceição da Barra",
        "latitude": -18.4451,
        "longitude": -39.8334,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3201704,
        "nome": "Conceição do Castelo",
        "latitude": -20.3709,
        "longitude": -41.2659,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3201803,
        "nome": "Divino de São Lourenço",
        "latitude": -20.5868,
        "longitude": -41.7245,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3201902,
        "nome": "Domingos Martins",
        "latitude": -20.3078,
        "longitude": -40.849,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202009,
        "nome": "Dores do Rio Preto",
        "latitude": -20.635,
        "longitude": -41.8121,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202108,
        "nome": "Ecoporanga",
        "latitude": -18.2656,
        "longitude": -40.8077,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202207,
        "nome": "Fundão",
        "latitude": -19.9683,
        "longitude": -40.3568,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202256,
        "nome": "Governador Lindenberg",
        "latitude": -19.2054,
        "longitude": -40.5,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202306,
        "nome": "Guaçuí",
        "latitude": -20.7634,
        "longitude": -41.7052,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202405,
        "nome": "Guarapari",
        "latitude": -20.5851,
        "longitude": -40.5463,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202454,
        "nome": "Ibatiba",
        "latitude": -20.2507,
        "longitude": -41.5502,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202504,
        "nome": "Ibiraçu",
        "latitude": -19.8348,
        "longitude": -40.4179,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202553,
        "nome": "Ibitirama",
        "latitude": -20.486,
        "longitude": -41.6926,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202603,
        "nome": "Iconha",
        "latitude": -20.7549,
        "longitude": -40.8575,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202652,
        "nome": "Irupi",
        "latitude": -20.3312,
        "longitude": -41.6368,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202702,
        "nome": "Itaguaçu",
        "latitude": -19.7286,
        "longitude": -40.8646,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202801,
        "nome": "Itapemirim",
        "latitude": -20.9658,
        "longitude": -40.9447,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3202900,
        "nome": "Itarana",
        "latitude": -19.95,
        "longitude": -40.8889,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203007,
        "nome": "Iúna",
        "latitude": -20.3485,
        "longitude": -41.6565,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203056,
        "nome": "Jaguaré",
        "latitude": -18.9497,
        "longitude": -40.0041,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203106,
        "nome": "Jerônimo Monteiro",
        "latitude": -20.8046,
        "longitude": -41.3922,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203130,
        "nome": "João Neiva",
        "latitude": -19.7154,
        "longitude": -40.4369,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203163,
        "nome": "Laranja da Terra",
        "latitude": -19.8726,
        "longitude": -41.0577,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203205,
        "nome": "Linhares",
        "latitude": -19.3827,
        "longitude": -40.0294,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203304,
        "nome": "Mantenópolis",
        "latitude": -18.8764,
        "longitude": -41.0717,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203320,
        "nome": "Marataízes",
        "latitude": -21.1001,
        "longitude": -40.8936,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203346,
        "nome": "Marechal Floriano",
        "latitude": -20.4313,
        "longitude": -40.7739,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203353,
        "nome": "Marilândia",
        "latitude": -19.4297,
        "longitude": -40.5207,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203403,
        "nome": "Mimoso do Sul",
        "latitude": -21.0886,
        "longitude": -41.3768,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203502,
        "nome": "Montanha",
        "latitude": -18.1389,
        "longitude": -40.2752,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203601,
        "nome": "Mucurici",
        "latitude": -18.0148,
        "longitude": -40.5125,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203700,
        "nome": "Muniz Freire",
        "latitude": -20.4268,
        "longitude": -41.435,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203809,
        "nome": "Muqui",
        "latitude": -20.9383,
        "longitude": -41.3439,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3203908,
        "nome": "Nova Venécia",
        "latitude": -18.6984,
        "longitude": -40.5224,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204005,
        "nome": "Pancas",
        "latitude": -19.1468,
        "longitude": -40.8178,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204054,
        "nome": "Pedro Canário",
        "latitude": -18.1824,
        "longitude": -40.0371,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204104,
        "nome": "Pinheiros",
        "latitude": -18.3699,
        "longitude": -40.1982,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204203,
        "nome": "Piúma",
        "latitude": -20.8377,
        "longitude": -40.7725,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204252,
        "nome": "Ponto Belo",
        "latitude": -18.2508,
        "longitude": -40.5143,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204302,
        "nome": "Presidente Kennedy",
        "latitude": -21.1407,
        "longitude": -41.0721,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204351,
        "nome": "Rio Bananal",
        "latitude": -19.2305,
        "longitude": -40.3082,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204401,
        "nome": "Rio Novo do Sul",
        "latitude": -20.8181,
        "longitude": -40.9187,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204500,
        "nome": "Santa Leopoldina",
        "latitude": -20.1232,
        "longitude": -40.5393,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204559,
        "nome": "Santa Maria de Jetibá",
        "latitude": -20.0851,
        "longitude": -40.8064,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204609,
        "nome": "Santa Teresa",
        "latitude": -19.8792,
        "longitude": -40.6349,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204658,
        "nome": "São Domingos do Norte",
        "latitude": -19.1224,
        "longitude": -40.5667,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204708,
        "nome": "São Gabriel da Palha",
        "latitude": -18.9527,
        "longitude": -40.5085,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204807,
        "nome": "São José do Calçado",
        "latitude": -20.9828,
        "longitude": -41.6557,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204906,
        "nome": "São Mateus",
        "latitude": -18.7496,
        "longitude": -40.0203,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3204955,
        "nome": "São Roque do Canaã",
        "latitude": -19.7197,
        "longitude": -40.6795,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3205002,
        "nome": "Serra",
        "latitude": -20.1281,
        "longitude": -40.3016,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3205010,
        "nome": "Sooretama",
        "latitude": -19.0726,
        "longitude": -40.1466,
        "mesorregiaoNome": "Litoral Norte Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3205036,
        "nome": "Vargem Alta",
        "latitude": -20.6471,
        "longitude": -41.0049,
        "mesorregiaoNome": "Sul Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3205069,
        "nome": "Venda Nova do Imigrante",
        "latitude": -20.3704,
        "longitude": -41.1402,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3205101,
        "nome": "Viana",
        "latitude": -20.4011,
        "longitude": -40.5127,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3205150,
        "nome": "Vila Pavão",
        "latitude": -18.6142,
        "longitude": -40.6272,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3205176,
        "nome": "Vila Valério",
        "latitude": -18.9666,
        "longitude": -40.3295,
        "mesorregiaoNome": "Noroeste Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3205200,
        "nome": "Vila Velha",
        "latitude": -20.4342,
        "longitude": -40.3784,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3205309,
        "nome": "Vitória",
        "latitude": -20.2787,
        "longitude": -40.2973,
        "mesorregiaoNome": "Central Espírito-santense",
        "UFSigla": "ES",
        "UFNome": "Espírito Santo"
    },
    {
        "ibgeId": 3300100,
        "nome": "Angra dos Reis",
        "latitude": -22.9364,
        "longitude": -44.3856,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300159,
        "nome": "Aperibé",
        "latitude": -21.6523,
        "longitude": -42.1347,
        "mesorregiaoNome": "Noroeste Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300209,
        "nome": "Araruama",
        "latitude": -22.7553,
        "longitude": -42.2929,
        "mesorregiaoNome": "Baixadas",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300225,
        "nome": "Areal",
        "latitude": -22.2354,
        "longitude": -43.1215,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300233,
        "nome": "Armação dos Búzios",
        "latitude": -22.7764,
        "longitude": -41.9507,
        "mesorregiaoNome": "Baixadas",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300258,
        "nome": "Arraial do Cabo",
        "latitude": -22.9215,
        "longitude": -42.1685,
        "mesorregiaoNome": "Baixadas",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300308,
        "nome": "Barra do Piraí",
        "latitude": -22.4257,
        "longitude": -43.913,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300407,
        "nome": "Barra Mansa",
        "latitude": -22.5058,
        "longitude": -44.1883,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300456,
        "nome": "Belford Roxo",
        "latitude": -22.7287,
        "longitude": -43.3776,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300506,
        "nome": "Bom Jardim",
        "latitude": -22.1997,
        "longitude": -42.3717,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300605,
        "nome": "Bom Jesus do Itabapoana",
        "latitude": -21.1235,
        "longitude": -41.6832,
        "mesorregiaoNome": "Noroeste Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300704,
        "nome": "Cabo Frio",
        "latitude": -22.7108,
        "longitude": -42.0577,
        "mesorregiaoNome": "Baixadas",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300803,
        "nome": "Cachoeiras de Macacu",
        "latitude": -22.5161,
        "longitude": -42.7284,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300902,
        "nome": "Cambuci",
        "latitude": -21.4969,
        "longitude": -41.9147,
        "mesorregiaoNome": "Noroeste Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300936,
        "nome": "Carapebus",
        "latitude": -22.196,
        "longitude": -41.6509,
        "mesorregiaoNome": "Norte Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3300951,
        "nome": "Comendador Levy Gasparian",
        "latitude": -22.0438,
        "longitude": -43.2557,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3301009,
        "nome": "Campos dos Goytacazes",
        "latitude": -21.7477,
        "longitude": -41.4041,
        "mesorregiaoNome": "Norte Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3301108,
        "nome": "Cantagalo",
        "latitude": -21.8684,
        "longitude": -42.3339,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3301157,
        "nome": "Cardoso Moreira",
        "latitude": -21.5255,
        "longitude": -41.5003,
        "mesorregiaoNome": "Norte Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3301207,
        "nome": "Carmo",
        "latitude": -21.8954,
        "longitude": -42.5664,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3301306,
        "nome": "Casimiro de Abreu",
        "latitude": -22.4819,
        "longitude": -42.1442,
        "mesorregiaoNome": "Baixadas",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3301405,
        "nome": "Conceição de Macabu",
        "latitude": -22.1366,
        "longitude": -41.8466,
        "mesorregiaoNome": "Norte Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3301504,
        "nome": "Cordeiro",
        "latitude": -22.0588,
        "longitude": -42.3422,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3301603,
        "nome": "Duas Barras",
        "latitude": -22.0556,
        "longitude": -42.498,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3301702,
        "nome": "Duque de Caxias",
        "latitude": -22.6325,
        "longitude": -43.2996,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3301801,
        "nome": "Engenheiro Paulo de Frontin",
        "latitude": -22.5083,
        "longitude": -43.6361,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3301850,
        "nome": "Guapimirim",
        "latitude": -22.5835,
        "longitude": -42.964,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3301876,
        "nome": "Iguaba Grande",
        "latitude": -22.8275,
        "longitude": -42.218,
        "mesorregiaoNome": "Baixadas",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3301900,
        "nome": "Itaboraí",
        "latitude": -22.75,
        "longitude": -42.8543,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302007,
        "nome": "Itaguaí",
        "latitude": -22.8301,
        "longitude": -43.8133,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302056,
        "nome": "Italva",
        "latitude": -21.4239,
        "longitude": -41.6538,
        "mesorregiaoNome": "Noroeste Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302106,
        "nome": "Itaocara",
        "latitude": -21.7269,
        "longitude": -42.0822,
        "mesorregiaoNome": "Noroeste Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302205,
        "nome": "Itaperuna",
        "latitude": -21.2251,
        "longitude": -41.894,
        "mesorregiaoNome": "Noroeste Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302254,
        "nome": "Itatiaia",
        "latitude": -22.4417,
        "longitude": -44.5878,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302270,
        "nome": "Japeri",
        "latitude": -22.6619,
        "longitude": -43.6058,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302304,
        "nome": "Laje do Muriaé",
        "latitude": -21.2501,
        "longitude": -42.1351,
        "mesorregiaoNome": "Noroeste Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302403,
        "nome": "Macaé",
        "latitude": -22.2956,
        "longitude": -41.9771,
        "mesorregiaoNome": "Norte Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302452,
        "nome": "Macuco",
        "latitude": -22.024,
        "longitude": -42.2735,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302502,
        "nome": "Magé",
        "latitude": -22.6126,
        "longitude": -43.113,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302601,
        "nome": "Mangaratiba",
        "latitude": -22.9308,
        "longitude": -44.0644,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302700,
        "nome": "Maricá",
        "latitude": -22.9152,
        "longitude": -42.8168,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302809,
        "nome": "Mendes",
        "latitude": -22.5215,
        "longitude": -43.7398,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302858,
        "nome": "Mesquita",
        "latitude": -22.7993,
        "longitude": -43.4523,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3302908,
        "nome": "Miguel Pereira",
        "latitude": -22.5065,
        "longitude": -43.4692,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3303005,
        "nome": "Miracema",
        "latitude": -21.3956,
        "longitude": -42.1522,
        "mesorregiaoNome": "Noroeste Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3303104,
        "nome": "Natividade",
        "latitude": -21.0416,
        "longitude": -41.9313,
        "mesorregiaoNome": "Noroeste Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3303203,
        "nome": "Nilópolis",
        "latitude": -22.8211,
        "longitude": -43.429,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3303302,
        "nome": "Niterói",
        "latitude": -22.9151,
        "longitude": -43.0547,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3303401,
        "nome": "Nova Friburgo",
        "latitude": -22.3191,
        "longitude": -42.501,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3303500,
        "nome": "Nova Iguaçu",
        "latitude": -22.6868,
        "longitude": -43.5018,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3303609,
        "nome": "Paracambi",
        "latitude": -22.6179,
        "longitude": -43.7215,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3303708,
        "nome": "Paraíba do Sul",
        "latitude": -22.182,
        "longitude": -43.3043,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3303807,
        "nome": "Paraty",
        "latitude": -23.1481,
        "longitude": -44.707,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3303856,
        "nome": "Paty do Alferes",
        "latitude": -22.367,
        "longitude": -43.404,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3303906,
        "nome": "Petrópolis",
        "latitude": -22.398,
        "longitude": -43.1568,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3303955,
        "nome": "Pinheiral",
        "latitude": -22.5433,
        "longitude": -43.9975,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304003,
        "nome": "Piraí",
        "latitude": -22.6336,
        "longitude": -43.9017,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304102,
        "nome": "Porciúncula",
        "latitude": -20.9066,
        "longitude": -41.9696,
        "mesorregiaoNome": "Noroeste Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304110,
        "nome": "Porto Real",
        "latitude": -22.4411,
        "longitude": -44.326,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304128,
        "nome": "Quatis",
        "latitude": -22.3552,
        "longitude": -44.2371,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304144,
        "nome": "Queimados",
        "latitude": -22.7254,
        "longitude": -43.5849,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304151,
        "nome": "Quissamã",
        "latitude": -22.1048,
        "longitude": -41.4444,
        "mesorregiaoNome": "Norte Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304201,
        "nome": "Resende",
        "latitude": -22.4406,
        "longitude": -44.4853,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304300,
        "nome": "Rio Bonito",
        "latitude": -22.735,
        "longitude": -42.5881,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304409,
        "nome": "Rio Claro",
        "latitude": -22.7805,
        "longitude": -44.0784,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304508,
        "nome": "Rio das Flores",
        "latitude": -22.1599,
        "longitude": -43.5387,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304524,
        "nome": "Rio das Ostras",
        "latitude": -22.4542,
        "longitude": -41.9465,
        "mesorregiaoNome": "Baixadas",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304557,
        "nome": "Rio de Janeiro",
        "latitude": -22.9255,
        "longitude": -43.458,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304607,
        "nome": "Santa Maria Madalena",
        "latitude": -21.9696,
        "longitude": -41.9135,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304706,
        "nome": "Santo Antônio de Pádua",
        "latitude": -21.5556,
        "longitude": -42.1929,
        "mesorregiaoNome": "Noroeste Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304755,
        "nome": "São Francisco de Itabapoana",
        "latitude": -21.4167,
        "longitude": -41.1357,
        "mesorregiaoNome": "Norte Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304805,
        "nome": "São Fidélis",
        "latitude": -21.6599,
        "longitude": -41.787,
        "mesorregiaoNome": "Norte Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3304904,
        "nome": "São Gonçalo",
        "latitude": -22.8256,
        "longitude": -42.9965,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305000,
        "nome": "São João da Barra",
        "latitude": -21.7823,
        "longitude": -41.0808,
        "mesorregiaoNome": "Norte Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305109,
        "nome": "São João de Meriti",
        "latitude": -22.7851,
        "longitude": -43.3653,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305133,
        "nome": "São José de Ubá",
        "latitude": -21.3708,
        "longitude": -41.9493,
        "mesorregiaoNome": "Noroeste Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305158,
        "nome": "São José do Vale do Rio Preto",
        "latitude": -22.1697,
        "longitude": -42.9325,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305208,
        "nome": "São Pedro da Aldeia",
        "latitude": -22.7884,
        "longitude": -42.1261,
        "mesorregiaoNome": "Baixadas",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305307,
        "nome": "São Sebastião do Alto",
        "latitude": -21.8834,
        "longitude": -42.1022,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305406,
        "nome": "Sapucaia",
        "latitude": -22.0241,
        "longitude": -42.8228,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305505,
        "nome": "Saquarema",
        "latitude": -22.8781,
        "longitude": -42.5188,
        "mesorregiaoNome": "Baixadas",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305554,
        "nome": "Seropédica",
        "latitude": -22.7555,
        "longitude": -43.6986,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305604,
        "nome": "Silva Jardim",
        "latitude": -22.5676,
        "longitude": -42.4134,
        "mesorregiaoNome": "Baixadas",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305703,
        "nome": "Sumidouro",
        "latitude": -22.1071,
        "longitude": -42.6642,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305752,
        "nome": "Tanguá",
        "latitude": -22.7822,
        "longitude": -42.7254,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305802,
        "nome": "Teresópolis",
        "latitude": -22.3141,
        "longitude": -42.8734,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3305901,
        "nome": "Trajano de Moraes",
        "latitude": -22.1297,
        "longitude": -42.155,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3306008,
        "nome": "Três Rios",
        "latitude": -22.1247,
        "longitude": -43.1122,
        "mesorregiaoNome": "Centro Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3306107,
        "nome": "Valença",
        "latitude": -22.2342,
        "longitude": -43.8575,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3306156,
        "nome": "Varre-Sai",
        "latitude": -20.8929,
        "longitude": -41.8297,
        "mesorregiaoNome": "Noroeste Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3306206,
        "nome": "Vassouras",
        "latitude": -22.3586,
        "longitude": -43.5697,
        "mesorregiaoNome": "Metropolitana do Rio de Janeiro",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3306305,
        "nome": "Volta Redonda",
        "latitude": -22.4909,
        "longitude": -44.0889,
        "mesorregiaoNome": "Sul Fluminense",
        "UFSigla": "RJ",
        "UFNome": "Rio de Janeiro"
    },
    {
        "ibgeId": 3500105,
        "nome": "Adamantina",
        "latitude": -21.5767,
        "longitude": -51.0568,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3500204,
        "nome": "Adolfo",
        "latitude": -21.2887,
        "longitude": -49.6533,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3500303,
        "nome": "Aguaí",
        "latitude": -22.05,
        "longitude": -47.0403,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3500402,
        "nome": "Águas da Prata",
        "latitude": -21.9137,
        "longitude": -46.6917,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3500501,
        "nome": "Águas de Lindóia",
        "latitude": -22.4748,
        "longitude": -46.6037,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3500550,
        "nome": "Águas de Santa Bárbara",
        "latitude": -22.858,
        "longitude": -49.261,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3500600,
        "nome": "Águas de São Pedro",
        "latitude": -22.5986,
        "longitude": -47.8761,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3500709,
        "nome": "Agudos",
        "latitude": -22.5719,
        "longitude": -49.1088,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3500758,
        "nome": "Alambari",
        "latitude": -23.5489,
        "longitude": -47.8691,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3500808,
        "nome": "Alfredo Marcondes",
        "latitude": -21.935,
        "longitude": -51.3957,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3500907,
        "nome": "Altair",
        "latitude": -20.5333,
        "longitude": -49.0939,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3501004,
        "nome": "Altinópolis",
        "latitude": -21.018,
        "longitude": -47.3862,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3501103,
        "nome": "Alto Alegre",
        "latitude": -21.6125,
        "longitude": -50.1921,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3501152,
        "nome": "Alumínio",
        "latitude": -23.533,
        "longitude": -47.2812,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3501202,
        "nome": "Álvares Florence",
        "latitude": -20.2896,
        "longitude": -49.9203,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3501301,
        "nome": "Álvares Machado",
        "latitude": -22.1315,
        "longitude": -51.5149,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3501400,
        "nome": "Álvaro de Carvalho",
        "latitude": -22.0865,
        "longitude": -49.734,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3501509,
        "nome": "Alvinlândia",
        "latitude": -22.4526,
        "longitude": -49.7585,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3501608,
        "nome": "Americana",
        "latitude": -22.7232,
        "longitude": -47.2891,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3501707,
        "nome": "Américo Brasiliense",
        "latitude": -21.7223,
        "longitude": -48.0324,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3501806,
        "nome": "Américo de Campos",
        "latitude": -20.2894,
        "longitude": -49.768,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3501905,
        "nome": "Amparo",
        "latitude": -22.6991,
        "longitude": -46.7987,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3502002,
        "nome": "Analândia",
        "latitude": -22.1211,
        "longitude": -47.678,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3502101,
        "nome": "Andradina",
        "latitude": -20.8356,
        "longitude": -51.3297,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3502200,
        "nome": "Angatuba",
        "latitude": -23.4368,
        "longitude": -48.4593,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3502309,
        "nome": "Anhembi",
        "latitude": -22.8001,
        "longitude": -48.1747,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3502408,
        "nome": "Anhumas",
        "latitude": -22.362,
        "longitude": -51.4278,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3502507,
        "nome": "Aparecida",
        "latitude": -22.9142,
        "longitude": -45.2372,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3502606,
        "nome": "Aparecida d'Oeste",
        "latitude": -20.4788,
        "longitude": -50.922,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3502705,
        "nome": "Apiaí",
        "latitude": -24.4215,
        "longitude": -48.8174,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3502754,
        "nome": "Araçariguama",
        "latitude": -23.4344,
        "longitude": -47.0724,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3502804,
        "nome": "Araçatuba",
        "latitude": -21.1139,
        "longitude": -50.5745,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3502903,
        "nome": "Araçoiaba da Serra",
        "latitude": -23.5439,
        "longitude": -47.6515,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3503000,
        "nome": "Aramina",
        "latitude": -20.145,
        "longitude": -47.8206,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3503109,
        "nome": "Arandu",
        "latitude": -23.1777,
        "longitude": -49.064,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3503158,
        "nome": "Arapeí",
        "latitude": -22.6729,
        "longitude": -44.4386,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3503208,
        "nome": "Araraquara",
        "latitude": -21.7916,
        "longitude": -48.1813,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3503307,
        "nome": "Araras",
        "latitude": -22.3462,
        "longitude": -47.3239,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3503356,
        "nome": "Arco-Íris",
        "latitude": -21.7663,
        "longitude": -50.4309,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3503406,
        "nome": "Arealva",
        "latitude": -22.0763,
        "longitude": -48.9819,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3503505,
        "nome": "Areias",
        "latitude": -22.6731,
        "longitude": -44.7124,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3503604,
        "nome": "Areiópolis",
        "latitude": -22.6318,
        "longitude": -48.6528,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3503703,
        "nome": "Ariranha",
        "latitude": -21.1857,
        "longitude": -48.7792,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3503802,
        "nome": "Artur Nogueira",
        "latitude": -22.5612,
        "longitude": -47.1322,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3503901,
        "nome": "Arujá",
        "latitude": -23.386,
        "longitude": -46.3191,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3503950,
        "nome": "Aspásia",
        "latitude": -20.1836,
        "longitude": -50.728,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3504008,
        "nome": "Assis",
        "latitude": -22.6017,
        "longitude": -50.4208,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3504107,
        "nome": "Atibaia",
        "latitude": -23.1233,
        "longitude": -46.5868,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3504206,
        "nome": "Auriflama",
        "latitude": -20.6441,
        "longitude": -50.58,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3504305,
        "nome": "Avaí",
        "latitude": -22.1872,
        "longitude": -49.3162,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3504404,
        "nome": "Avanhandava",
        "latitude": -21.4605,
        "longitude": -49.9474,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3504503,
        "nome": "Avaré",
        "latitude": -23.0752,
        "longitude": -48.894,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3504602,
        "nome": "Bady Bassitt",
        "latitude": -20.9315,
        "longitude": -49.4376,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3504701,
        "nome": "Balbinos",
        "latitude": -21.8924,
        "longitude": -49.3331,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3504800,
        "nome": "Bálsamo",
        "latitude": -20.7096,
        "longitude": -49.5518,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3504909,
        "nome": "Bananal",
        "latitude": -22.7338,
        "longitude": -44.3345,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3505005,
        "nome": "Barão de Antonina",
        "latitude": -23.5829,
        "longitude": -49.572,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3505104,
        "nome": "Barbosa",
        "latitude": -21.2907,
        "longitude": -49.9222,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3505203,
        "nome": "Bariri",
        "latitude": -22.0668,
        "longitude": -48.7188,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3505302,
        "nome": "Barra Bonita",
        "latitude": -22.4795,
        "longitude": -48.5417,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3505351,
        "nome": "Barra do Chapéu",
        "latitude": -24.4438,
        "longitude": -49.0853,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3505401,
        "nome": "Barra do Turvo",
        "latitude": -24.8887,
        "longitude": -48.427,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3505500,
        "nome": "Barretos",
        "latitude": -20.5142,
        "longitude": -48.6519,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3505609,
        "nome": "Barrinha",
        "latitude": -21.2325,
        "longitude": -48.0951,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3505708,
        "nome": "Barueri",
        "latitude": -23.5053,
        "longitude": -46.8772,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3505807,
        "nome": "Bastos",
        "latitude": -21.9502,
        "longitude": -50.744,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3505906,
        "nome": "Batatais",
        "latitude": -20.8678,
        "longitude": -47.5748,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3506003,
        "nome": "Bauru",
        "latitude": -22.254,
        "longitude": -49.1261,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3506102,
        "nome": "Bebedouro",
        "latitude": -20.9405,
        "longitude": -48.5107,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3506201,
        "nome": "Bento de Abreu",
        "latitude": -21.3318,
        "longitude": -50.862,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3506300,
        "nome": "Bernardino de Campos",
        "latitude": -23.0308,
        "longitude": -49.4919,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3506359,
        "nome": "Bertioga",
        "latitude": -23.7598,
        "longitude": -46.03,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3506409,
        "nome": "Bilac",
        "latitude": -21.4278,
        "longitude": -50.4793,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3506508,
        "nome": "Birigui",
        "latitude": -21.2616,
        "longitude": -50.351,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3506607,
        "nome": "Biritiba Mirim",
        "latitude": -23.6242,
        "longitude": -46.0213,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3506706,
        "nome": "Boa Esperança do Sul",
        "latitude": -21.935,
        "longitude": -48.4636,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3506805,
        "nome": "Bocaina",
        "latitude": -22.1054,
        "longitude": -48.5291,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3506904,
        "nome": "Bofete",
        "latitude": -23.129,
        "longitude": -48.2859,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3507001,
        "nome": "Boituva",
        "latitude": -23.2876,
        "longitude": -47.675,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3507100,
        "nome": "Bom Jesus dos Perdões",
        "latitude": -23.1725,
        "longitude": -46.479,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3507159,
        "nome": "Bom Sucesso de Itararé",
        "latitude": -24.3159,
        "longitude": -49.1646,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3507209,
        "nome": "Borá",
        "latitude": -22.2442,
        "longitude": -50.5021,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3507308,
        "nome": "Boracéia",
        "latitude": -22.1701,
        "longitude": -48.7883,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3507407,
        "nome": "Borborema",
        "latitude": -21.6108,
        "longitude": -49.072,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3507456,
        "nome": "Borebi",
        "latitude": -22.6807,
        "longitude": -48.9923,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3507506,
        "nome": "Botucatu",
        "latitude": -22.8634,
        "longitude": -48.4683,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3507605,
        "nome": "Bragança Paulista",
        "latitude": -22.9384,
        "longitude": -46.5559,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3507704,
        "nome": "Braúna",
        "latitude": -21.5531,
        "longitude": -50.3394,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3507753,
        "nome": "Brejo Alegre",
        "latitude": -21.1766,
        "longitude": -50.2098,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3507803,
        "nome": "Brodowski",
        "latitude": -21.0495,
        "longitude": -47.6278,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3507902,
        "nome": "Brotas",
        "latitude": -22.2733,
        "longitude": -48.0812,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3508009,
        "nome": "Buri",
        "latitude": -23.752,
        "longitude": -48.5753,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3508108,
        "nome": "Buritama",
        "latitude": -21.0491,
        "longitude": -50.2002,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3508207,
        "nome": "Buritizal",
        "latitude": -20.2093,
        "longitude": -47.6929,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3508306,
        "nome": "Cabrália Paulista",
        "latitude": -22.4895,
        "longitude": -49.373,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3508405,
        "nome": "Cabreúva",
        "latitude": -23.3013,
        "longitude": -47.0802,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3508504,
        "nome": "Caçapava",
        "latitude": -23.1037,
        "longitude": -45.7133,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3508603,
        "nome": "Cachoeira Paulista",
        "latitude": -22.7024,
        "longitude": -44.9917,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3508702,
        "nome": "Caconde",
        "latitude": -21.5395,
        "longitude": -46.617,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3508801,
        "nome": "Cafelândia",
        "latitude": -21.7311,
        "longitude": -49.5487,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3508900,
        "nome": "Caiabu",
        "latitude": -21.9498,
        "longitude": -51.2239,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3509007,
        "nome": "Caieiras",
        "latitude": -23.3759,
        "longitude": -46.7452,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3509106,
        "nome": "Caiuá",
        "latitude": -21.8015,
        "longitude": -51.9866,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3509205,
        "nome": "Cajamar",
        "latitude": -23.3514,
        "longitude": -46.872,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3509254,
        "nome": "Cajati",
        "latitude": -24.772,
        "longitude": -48.195,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3509304,
        "nome": "Cajobi",
        "latitude": -20.8737,
        "longitude": -48.8388,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3509403,
        "nome": "Cajuru",
        "latitude": -21.276,
        "longitude": -47.3103,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3509452,
        "nome": "Campina do Monte Alegre",
        "latitude": -23.6068,
        "longitude": -48.442,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3509502,
        "nome": "Campinas",
        "latitude": -22.8838,
        "longitude": -47.0438,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3509601,
        "nome": "Campo Limpo Paulista",
        "latitude": -23.2179,
        "longitude": -46.7601,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3509700,
        "nome": "Campos do Jordão",
        "latitude": -22.7016,
        "longitude": -45.5331,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3509809,
        "nome": "Campos Novos Paulista",
        "latitude": -22.6109,
        "longitude": -50.0103,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3509908,
        "nome": "Cananéia",
        "latitude": -25.0183,
        "longitude": -48.0087,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3509957,
        "nome": "Canas",
        "latitude": -22.7301,
        "longitude": -45.0414,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3510005,
        "nome": "Cândido Mota",
        "latitude": -22.8087,
        "longitude": -50.4217,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3510104,
        "nome": "Cândido Rodrigues",
        "latitude": -21.3428,
        "longitude": -48.6286,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3510153,
        "nome": "Canitar",
        "latitude": -23.0187,
        "longitude": -49.7919,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3510203,
        "nome": "Capão Bonito",
        "latitude": -24.0392,
        "longitude": -48.2898,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3510302,
        "nome": "Capela do Alto",
        "latitude": -23.4674,
        "longitude": -47.731,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3510401,
        "nome": "Capivari",
        "latitude": -22.9807,
        "longitude": -47.478,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3510500,
        "nome": "Caraguatatuba",
        "latitude": -23.6398,
        "longitude": -45.4886,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3510609,
        "nome": "Carapicuíba",
        "latitude": -23.55,
        "longitude": -46.8419,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3510708,
        "nome": "Cardoso",
        "latitude": -20.0672,
        "longitude": -49.9476,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3510807,
        "nome": "Casa Branca",
        "latitude": -21.8005,
        "longitude": -47.0881,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3510906,
        "nome": "Cássia dos Coqueiros",
        "latitude": -21.2633,
        "longitude": -47.1441,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3511003,
        "nome": "Castilho",
        "latitude": -20.8976,
        "longitude": -51.5703,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3511102,
        "nome": "Catanduva",
        "latitude": -21.1338,
        "longitude": -48.9637,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3511201,
        "nome": "Catiguá",
        "latitude": -21.0628,
        "longitude": -49.0528,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3511300,
        "nome": "Cedral",
        "latitude": -20.9139,
        "longitude": -49.2639,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3511409,
        "nome": "Cerqueira César",
        "latitude": -23.0593,
        "longitude": -49.1438,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3511508,
        "nome": "Cerquilho",
        "latitude": -23.1871,
        "longitude": -47.7571,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3511607,
        "nome": "Cesário Lange",
        "latitude": -23.2165,
        "longitude": -47.9039,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3511706,
        "nome": "Charqueada",
        "latitude": -22.5302,
        "longitude": -47.7462,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3511904,
        "nome": "Clementina",
        "latitude": -21.5703,
        "longitude": -50.4601,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3512001,
        "nome": "Colina",
        "latitude": -20.7462,
        "longitude": -48.5889,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3512100,
        "nome": "Colômbia",
        "latitude": -20.2669,
        "longitude": -48.7217,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3512209,
        "nome": "Conchal",
        "latitude": -22.3693,
        "longitude": -47.1411,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3512308,
        "nome": "Conchas",
        "latitude": -22.9656,
        "longitude": -48.0471,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3512407,
        "nome": "Cordeirópolis",
        "latitude": -22.4796,
        "longitude": -47.4147,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3512506,
        "nome": "Coroados",
        "latitude": -21.3756,
        "longitude": -50.3034,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3512605,
        "nome": "Coronel Macedo",
        "latitude": -23.6301,
        "longitude": -49.3069,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3512704,
        "nome": "Corumbataí",
        "latitude": -22.2364,
        "longitude": -47.6111,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3512803,
        "nome": "Cosmópolis",
        "latitude": -22.6516,
        "longitude": -47.1864,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3512902,
        "nome": "Cosmorama",
        "latitude": -20.4425,
        "longitude": -49.7746,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3513009,
        "nome": "Cotia",
        "latitude": -23.6752,
        "longitude": -46.9605,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3513108,
        "nome": "Cravinhos",
        "latitude": -21.3397,
        "longitude": -47.7446,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3513207,
        "nome": "Cristais Paulista",
        "latitude": -20.3713,
        "longitude": -47.4009,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3513306,
        "nome": "Cruzália",
        "latitude": -22.738,
        "longitude": -50.7691,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3513405,
        "nome": "Cruzeiro",
        "latitude": -22.5514,
        "longitude": -45.0063,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3513504,
        "nome": "Cubatão",
        "latitude": -23.8659,
        "longitude": -46.4082,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3513603,
        "nome": "Cunha",
        "latitude": -23.0529,
        "longitude": -44.9421,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3513702,
        "nome": "Descalvado",
        "latitude": -21.8812,
        "longitude": -47.6546,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3513801,
        "nome": "Diadema",
        "latitude": -23.6972,
        "longitude": -46.6114,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3513850,
        "nome": "Dirce Reis",
        "latitude": -20.4485,
        "longitude": -50.6281,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3513900,
        "nome": "Divinolândia",
        "latitude": -21.6617,
        "longitude": -46.6974,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3514007,
        "nome": "Dobrada",
        "latitude": -21.5161,
        "longitude": -48.3573,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3514106,
        "nome": "Dois Córregos",
        "latitude": -22.3959,
        "longitude": -48.3405,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3514205,
        "nome": "Dolcinópolis",
        "latitude": -20.1172,
        "longitude": -50.5283,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3514304,
        "nome": "Dourado",
        "latitude": -22.1173,
        "longitude": -48.3335,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3514403,
        "nome": "Dracena",
        "latitude": -21.5567,
        "longitude": -51.584,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3514502,
        "nome": "Duartina",
        "latitude": -22.3933,
        "longitude": -49.4134,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3514601,
        "nome": "Dumont",
        "latitude": -21.2471,
        "longitude": -47.9798,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3514700,
        "nome": "Echaporã",
        "latitude": -22.4482,
        "longitude": -50.2006,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3514809,
        "nome": "Eldorado",
        "latitude": -24.495,
        "longitude": -48.2336,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3514908,
        "nome": "Elias Fausto",
        "latitude": -23.0706,
        "longitude": -47.3707,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3514924,
        "nome": "Elisiário",
        "latitude": -21.1613,
        "longitude": -49.0921,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3514957,
        "nome": "Embaúba",
        "latitude": -20.9529,
        "longitude": -48.8475,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515004,
        "nome": "Embu das Artes",
        "latitude": -23.6513,
        "longitude": -46.8515,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515103,
        "nome": "Embu-Guaçu",
        "latitude": -23.8543,
        "longitude": -46.8307,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515129,
        "nome": "Emilianópolis",
        "latitude": -21.801,
        "longitude": -51.4722,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515152,
        "nome": "Engenheiro Coelho",
        "latitude": -22.4871,
        "longitude": -47.1748,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515186,
        "nome": "Espírito Santo do Pinhal",
        "latitude": -22.1925,
        "longitude": -46.7933,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515194,
        "nome": "Espírito Santo do Turvo",
        "latitude": -22.6709,
        "longitude": -49.4329,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515202,
        "nome": "Estrela d'Oeste",
        "latitude": -20.2657,
        "longitude": -50.4115,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515301,
        "nome": "Estrela do Norte",
        "latitude": -22.4856,
        "longitude": -51.6691,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515350,
        "nome": "Euclides da Cunha Paulista",
        "latitude": -22.519,
        "longitude": -52.5886,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515400,
        "nome": "Fartura",
        "latitude": -23.3902,
        "longitude": -49.5197,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515509,
        "nome": "Fernandópolis",
        "latitude": -20.2718,
        "longitude": -50.283,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515608,
        "nome": "Fernando Prestes",
        "latitude": -21.3103,
        "longitude": -48.6957,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515657,
        "nome": "Fernão",
        "latitude": -22.3658,
        "longitude": -49.5424,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515707,
        "nome": "Ferraz de Vasconcelos",
        "latitude": -23.561,
        "longitude": -46.3739,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515806,
        "nome": "Flora Rica",
        "latitude": -21.6984,
        "longitude": -51.3743,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3515905,
        "nome": "Floreal",
        "latitude": -20.6696,
        "longitude": -50.1548,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3516002,
        "nome": "Flórida Paulista",
        "latitude": -21.54,
        "longitude": -51.1707,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3516101,
        "nome": "Florínea",
        "latitude": -22.8812,
        "longitude": -50.6953,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3516200,
        "nome": "Franca",
        "latitude": -20.5552,
        "longitude": -47.3811,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3516309,
        "nome": "Francisco Morato",
        "latitude": -23.2737,
        "longitude": -46.7235,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3516408,
        "nome": "Franco da Rocha",
        "latitude": -23.3142,
        "longitude": -46.7358,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3516507,
        "nome": "Gabriel Monteiro",
        "latitude": -21.4996,
        "longitude": -50.5647,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3516606,
        "nome": "Gália",
        "latitude": -22.3205,
        "longitude": -49.5778,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3516705,
        "nome": "Garça",
        "latitude": -22.231,
        "longitude": -49.6896,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3516804,
        "nome": "Gastão Vidigal",
        "latitude": -20.8043,
        "longitude": -50.2028,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3516853,
        "nome": "Gavião Peixoto",
        "latitude": -21.7916,
        "longitude": -48.4479,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3516903,
        "nome": "General Salgado",
        "latitude": -20.6383,
        "longitude": -50.4158,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3517000,
        "nome": "Getulina",
        "latitude": -21.7833,
        "longitude": -50.0279,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3517109,
        "nome": "Glicério",
        "latitude": -21.3403,
        "longitude": -50.1989,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3517208,
        "nome": "Guaiçara",
        "latitude": -21.5695,
        "longitude": -49.7628,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3517307,
        "nome": "Guaimbê",
        "latitude": -21.8785,
        "longitude": -49.8606,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3517406,
        "nome": "Guaíra",
        "latitude": -20.314,
        "longitude": -48.3641,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3517505,
        "nome": "Guapiaçu",
        "latitude": -20.7429,
        "longitude": -49.1899,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3517604,
        "nome": "Guapiara",
        "latitude": -24.2125,
        "longitude": -48.5558,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3517703,
        "nome": "Guará",
        "latitude": -20.4826,
        "longitude": -47.7752,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3517802,
        "nome": "Guaraçaí",
        "latitude": -21.0864,
        "longitude": -51.2795,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3517901,
        "nome": "Guaraci",
        "latitude": -20.3748,
        "longitude": -49.0027,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3518008,
        "nome": "Guarani d'Oeste",
        "latitude": -20.0668,
        "longitude": -50.3446,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3518107,
        "nome": "Guarantã",
        "latitude": -21.9161,
        "longitude": -49.5884,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3518206,
        "nome": "Guararapes",
        "latitude": -21.2852,
        "longitude": -50.6951,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3518305,
        "nome": "Guararema",
        "latitude": -23.4276,
        "longitude": -46.0586,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3518404,
        "nome": "Guaratinguetá",
        "latitude": -22.7935,
        "longitude": -45.2328,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3518503,
        "nome": "Guareí",
        "latitude": -23.3705,
        "longitude": -48.2191,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3518602,
        "nome": "Guariba",
        "latitude": -21.3959,
        "longitude": -48.2266,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3518701,
        "nome": "Guarujá",
        "latitude": -23.951,
        "longitude": -46.2353,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3518800,
        "nome": "Guarulhos",
        "latitude": -23.4027,
        "longitude": -46.4549,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3518859,
        "nome": "Guatapará",
        "latitude": -21.4533,
        "longitude": -47.9799,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3518909,
        "nome": "Guzolândia",
        "latitude": -20.6285,
        "longitude": -50.7136,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3519006,
        "nome": "Herculândia",
        "latitude": -21.9623,
        "longitude": -50.3731,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3519055,
        "nome": "Holambra",
        "latitude": -22.6303,
        "longitude": -47.065,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3519071,
        "nome": "Hortolândia",
        "latitude": -22.8784,
        "longitude": -47.2077,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3519105,
        "nome": "Iacanga",
        "latitude": -21.8909,
        "longitude": -49.0396,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3519204,
        "nome": "Iacri",
        "latitude": -21.7999,
        "longitude": -50.6195,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3519253,
        "nome": "Iaras",
        "latitude": -22.8191,
        "longitude": -49.1068,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3519303,
        "nome": "Ibaté",
        "latitude": -21.9509,
        "longitude": -48.0273,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3519402,
        "nome": "Ibirá",
        "latitude": -21.0747,
        "longitude": -49.2203,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3519501,
        "nome": "Ibirarema",
        "latitude": -22.8133,
        "longitude": -50.0769,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3519600,
        "nome": "Ibitinga",
        "latitude": -21.7929,
        "longitude": -48.8478,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3519709,
        "nome": "Ibiúna",
        "latitude": -23.8024,
        "longitude": -47.2152,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3519808,
        "nome": "Icém",
        "latitude": -20.3672,
        "longitude": -49.1853,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3519907,
        "nome": "Iepê",
        "latitude": -22.6486,
        "longitude": -51.0572,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3520004,
        "nome": "Igaraçu do Tietê",
        "latitude": -22.5417,
        "longitude": -48.5746,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3520103,
        "nome": "Igarapava",
        "latitude": -20.0637,
        "longitude": -47.6825,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3520202,
        "nome": "Igaratá",
        "latitude": -23.1348,
        "longitude": -46.1504,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3520301,
        "nome": "Iguape",
        "latitude": -24.5495,
        "longitude": -47.4744,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3520400,
        "nome": "Ilhabela",
        "latitude": -23.8501,
        "longitude": -45.3292,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3520426,
        "nome": "Ilha Comprida",
        "latitude": -24.859,
        "longitude": -47.7154,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3520442,
        "nome": "Ilha Solteira",
        "latitude": -20.4314,
        "longitude": -51.259,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3520509,
        "nome": "Indaiatuba",
        "latitude": -23.1061,
        "longitude": -47.2025,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3520608,
        "nome": "Indiana",
        "latitude": -22.1332,
        "longitude": -51.2626,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3520707,
        "nome": "Indiaporã",
        "latitude": -19.9479,
        "longitude": -50.2637,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3520806,
        "nome": "Inúbia Paulista",
        "latitude": -21.739,
        "longitude": -50.9574,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3520905,
        "nome": "Ipaussu",
        "latitude": -23.0651,
        "longitude": -49.6081,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3521002,
        "nome": "Iperó",
        "latitude": -23.4045,
        "longitude": -47.6291,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3521101,
        "nome": "Ipeúna",
        "latitude": -22.4239,
        "longitude": -47.716,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3521150,
        "nome": "Ipiguá",
        "latitude": -20.648,
        "longitude": -49.4035,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3521200,
        "nome": "Iporanga",
        "latitude": -24.5127,
        "longitude": -48.5463,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3521309,
        "nome": "Ipuã",
        "latitude": -20.4175,
        "longitude": -48.0665,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3521408,
        "nome": "Iracemápolis",
        "latitude": -22.5937,
        "longitude": -47.5242,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3521507,
        "nome": "Irapuã",
        "latitude": -21.2677,
        "longitude": -49.3974,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3521606,
        "nome": "Irapuru",
        "latitude": -21.4842,
        "longitude": -51.3465,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3521705,
        "nome": "Itaberá",
        "latitude": -23.8713,
        "longitude": -49.1425,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3521804,
        "nome": "Itaí",
        "latitude": -23.4715,
        "longitude": -49.0542,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3521903,
        "nome": "Itajobi",
        "latitude": -21.3555,
        "longitude": -49.0537,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3522000,
        "nome": "Itaju",
        "latitude": -21.9516,
        "longitude": -48.794,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3522109,
        "nome": "Itanhaém",
        "latitude": -24.0919,
        "longitude": -46.8347,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3522158,
        "nome": "Itaoca",
        "latitude": -24.6179,
        "longitude": -48.839,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3522208,
        "nome": "Itapecerica da Serra",
        "latitude": -23.7372,
        "longitude": -46.8588,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3522307,
        "nome": "Itapetininga",
        "latitude": -23.6455,
        "longitude": -48.1233,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3522406,
        "nome": "Itapeva",
        "latitude": -23.9141,
        "longitude": -48.8717,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3522505,
        "nome": "Itapevi",
        "latitude": -23.5509,
        "longitude": -46.9677,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3522604,
        "nome": "Itapira",
        "latitude": -22.432,
        "longitude": -46.7721,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3522653,
        "nome": "Itapirapuã Paulista",
        "latitude": -24.569,
        "longitude": -49.2229,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3522703,
        "nome": "Itápolis",
        "latitude": -21.5481,
        "longitude": -48.8155,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3522802,
        "nome": "Itaporanga",
        "latitude": -23.6729,
        "longitude": -49.4585,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3522901,
        "nome": "Itapuí",
        "latitude": -22.2508,
        "longitude": -48.7014,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3523008,
        "nome": "Itapura",
        "latitude": -20.5951,
        "longitude": -51.4406,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3523107,
        "nome": "Itaquaquecetuba",
        "latitude": -23.4615,
        "longitude": -46.3339,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3523206,
        "nome": "Itararé",
        "latitude": -24.0805,
        "longitude": -49.3035,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3523305,
        "nome": "Itariri",
        "latitude": -24.2927,
        "longitude": -47.1281,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3523404,
        "nome": "Itatiba",
        "latitude": -23.0067,
        "longitude": -46.8143,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3523503,
        "nome": "Itatinga",
        "latitude": -23.1537,
        "longitude": -48.6294,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3523602,
        "nome": "Itirapina",
        "latitude": -22.2946,
        "longitude": -47.8341,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3523701,
        "nome": "Itirapuã",
        "latitude": -20.6576,
        "longitude": -47.1694,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3523800,
        "nome": "Itobi",
        "latitude": -21.749,
        "longitude": -46.922,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3523909,
        "nome": "Itu",
        "latitude": -23.3071,
        "longitude": -47.2846,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3524006,
        "nome": "Itupeva",
        "latitude": -23.1465,
        "longitude": -47.0684,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3524105,
        "nome": "Ituverava",
        "latitude": -20.3295,
        "longitude": -47.8096,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3524204,
        "nome": "Jaborandi",
        "latitude": -20.65,
        "longitude": -48.416,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3524303,
        "nome": "Jaboticabal",
        "latitude": -21.2183,
        "longitude": -48.2879,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3524402,
        "nome": "Jacareí",
        "latitude": -23.2989,
        "longitude": -45.9905,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3524501,
        "nome": "Jaci",
        "latitude": -20.945,
        "longitude": -49.5812,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3524600,
        "nome": "Jacupiranga",
        "latitude": -24.7774,
        "longitude": -48.0539,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3524709,
        "nome": "Jaguariúna",
        "latitude": -22.692,
        "longitude": -47.0128,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3524808,
        "nome": "Jales",
        "latitude": -20.2858,
        "longitude": -50.5541,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3524907,
        "nome": "Jambeiro",
        "latitude": -23.2793,
        "longitude": -45.7106,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3525003,
        "nome": "Jandira",
        "latitude": -23.5441,
        "longitude": -46.8997,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3525102,
        "nome": "Jardinópolis",
        "latitude": -20.9921,
        "longitude": -47.826,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3525201,
        "nome": "Jarinu",
        "latitude": -23.112,
        "longitude": -46.7213,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3525300,
        "nome": "Jaú",
        "latitude": -22.2961,
        "longitude": -48.556,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3525409,
        "nome": "Jeriquara",
        "latitude": -20.3401,
        "longitude": -47.5742,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3525508,
        "nome": "Joanópolis",
        "latitude": -22.9388,
        "longitude": -46.2092,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3525607,
        "nome": "João Ramalho",
        "latitude": -22.2779,
        "longitude": -50.7991,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3525706,
        "nome": "José Bonifácio",
        "latitude": -21.0894,
        "longitude": -49.7793,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3525805,
        "nome": "Júlio Mesquita",
        "latitude": -21.9729,
        "longitude": -49.7934,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3525854,
        "nome": "Jumirim",
        "latitude": -23.0996,
        "longitude": -47.7881,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3525904,
        "nome": "Jundiaí",
        "latitude": -23.1946,
        "longitude": -46.913,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3526001,
        "nome": "Junqueirópolis",
        "latitude": -21.4489,
        "longitude": -51.4351,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3526100,
        "nome": "Juquiá",
        "latitude": -24.2137,
        "longitude": -47.6523,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3526209,
        "nome": "Juquitiba",
        "latitude": -23.9552,
        "longitude": -47.0246,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3526308,
        "nome": "Lagoinha",
        "latitude": -23.0858,
        "longitude": -45.2068,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3526407,
        "nome": "Laranjal Paulista",
        "latitude": -23.0122,
        "longitude": -47.8657,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3526506,
        "nome": "Lavínia",
        "latitude": -21.1508,
        "longitude": -51.0326,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3526605,
        "nome": "Lavrinhas",
        "latitude": -22.5203,
        "longitude": -44.8889,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3526704,
        "nome": "Leme",
        "latitude": -22.1722,
        "longitude": -47.3376,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3526803,
        "nome": "Lençóis Paulista",
        "latitude": -22.6761,
        "longitude": -48.825,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3526902,
        "nome": "Limeira",
        "latitude": -22.5985,
        "longitude": -47.3637,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3527009,
        "nome": "Lindóia",
        "latitude": -22.5134,
        "longitude": -46.655,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3527108,
        "nome": "Lins",
        "latitude": -21.6498,
        "longitude": -49.6829,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3527207,
        "nome": "Lorena",
        "latitude": -22.794,
        "longitude": -45.06,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3527256,
        "nome": "Lourdes",
        "latitude": -20.9491,
        "longitude": -50.234,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3527306,
        "nome": "Louveira",
        "latitude": -23.084,
        "longitude": -46.9376,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3527405,
        "nome": "Lucélia",
        "latitude": -21.6441,
        "longitude": -50.9917,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3527504,
        "nome": "Lucianópolis",
        "latitude": -22.4734,
        "longitude": -49.5503,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3527603,
        "nome": "Luís Antônio",
        "latitude": -21.5527,
        "longitude": -47.7819,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3527702,
        "nome": "Luiziânia",
        "latitude": -21.6726,
        "longitude": -50.3508,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3527801,
        "nome": "Lupércio",
        "latitude": -22.4272,
        "longitude": -49.817,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3527900,
        "nome": "Lutécia",
        "latitude": -22.3253,
        "longitude": -50.3855,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3528007,
        "nome": "Macatuba",
        "latitude": -22.4871,
        "longitude": -48.7194,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3528106,
        "nome": "Macaubal",
        "latitude": -20.8379,
        "longitude": -49.975,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3528205,
        "nome": "Macedônia",
        "latitude": -20.0981,
        "longitude": -50.1815,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3528304,
        "nome": "Magda",
        "latitude": -20.5965,
        "longitude": -50.23,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3528403,
        "nome": "Mairinque",
        "latitude": -23.508,
        "longitude": -47.2293,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3528502,
        "nome": "Mairiporã",
        "latitude": -23.3173,
        "longitude": -46.5613,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3528601,
        "nome": "Manduri",
        "latitude": -23.047,
        "longitude": -49.3036,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3528700,
        "nome": "Marabá Paulista",
        "latitude": -22.1277,
        "longitude": -52.0566,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3528809,
        "nome": "Maracaí",
        "latitude": -22.6523,
        "longitude": -50.7454,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3528858,
        "nome": "Marapoama",
        "latitude": -21.2555,
        "longitude": -49.1378,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3528908,
        "nome": "Mariápolis",
        "latitude": -21.7792,
        "longitude": -51.1718,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3529005,
        "nome": "Marília",
        "latitude": -22.1778,
        "longitude": -49.9831,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3529104,
        "nome": "Marinópolis",
        "latitude": -20.4799,
        "longitude": -50.8323,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3529203,
        "nome": "Martinópolis",
        "latitude": -22.1725,
        "longitude": -51.1235,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3529302,
        "nome": "Matão",
        "latitude": -21.6101,
        "longitude": -48.4301,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3529401,
        "nome": "Mauá",
        "latitude": -23.6662,
        "longitude": -46.4464,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3529500,
        "nome": "Mendonça",
        "latitude": -21.194,
        "longitude": -49.5702,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3529609,
        "nome": "Meridiano",
        "latitude": -20.3982,
        "longitude": -50.1867,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3529658,
        "nome": "Mesópolis",
        "latitude": -19.9575,
        "longitude": -50.6154,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3529708,
        "nome": "Miguelópolis",
        "latitude": -20.1847,
        "longitude": -48.1055,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3529807,
        "nome": "Mineiros do Tietê",
        "latitude": -22.4633,
        "longitude": -48.4332,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3529906,
        "nome": "Miracatu",
        "latitude": -24.1951,
        "longitude": -47.3947,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3530003,
        "nome": "Mira Estrela",
        "latitude": -19.9518,
        "longitude": -50.1243,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3530102,
        "nome": "Mirandópolis",
        "latitude": -21.0811,
        "longitude": -51.1305,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3530201,
        "nome": "Mirante do Paranapanema",
        "latitude": -22.3492,
        "longitude": -51.998,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3530300,
        "nome": "Mirassol",
        "latitude": -20.8277,
        "longitude": -49.5043,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3530409,
        "nome": "Mirassolândia",
        "latitude": -20.595,
        "longitude": -49.487,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3530508,
        "nome": "Mococa",
        "latitude": -21.4495,
        "longitude": -47.033,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3530607,
        "nome": "Mogi das Cruzes",
        "latitude": -23.5696,
        "longitude": -46.1861,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3530706,
        "nome": "Mogi Guaçu",
        "latitude": -22.2321,
        "longitude": -47.029,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3530805,
        "nome": "Mogi Mirim",
        "latitude": -22.4513,
        "longitude": -46.9884,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3530904,
        "nome": "Mombuca",
        "latitude": -22.9427,
        "longitude": -47.602,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3531001,
        "nome": "Monções",
        "latitude": -20.8631,
        "longitude": -50.0795,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3531100,
        "nome": "Mongaguá",
        "latitude": -24.0702,
        "longitude": -46.6681,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3531209,
        "nome": "Monte Alegre do Sul",
        "latitude": -22.7043,
        "longitude": -46.6677,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3531308,
        "nome": "Monte Alto",
        "latitude": -21.2593,
        "longitude": -48.533,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3531407,
        "nome": "Monte Aprazível",
        "latitude": -20.7375,
        "longitude": -49.7658,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3531506,
        "nome": "Monte Azul Paulista",
        "latitude": -20.9089,
        "longitude": -48.6813,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3531605,
        "nome": "Monte Castelo",
        "latitude": -21.2549,
        "longitude": -51.5714,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3531704,
        "nome": "Monteiro Lobato",
        "latitude": -22.9366,
        "longitude": -45.8043,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3531803,
        "nome": "Monte Mor",
        "latitude": -22.9532,
        "longitude": -47.3073,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3531902,
        "nome": "Morro Agudo",
        "latitude": -20.6887,
        "longitude": -48.1533,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532009,
        "nome": "Morungaba",
        "latitude": -22.8939,
        "longitude": -46.7825,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532058,
        "nome": "Motuca",
        "latitude": -21.5138,
        "longitude": -48.1703,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532108,
        "nome": "Murutinga do Sul",
        "latitude": -20.9968,
        "longitude": -51.3014,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532157,
        "nome": "Nantes",
        "latitude": -22.5969,
        "longitude": -51.2009,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532207,
        "nome": "Narandiba",
        "latitude": -22.5637,
        "longitude": -51.5217,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532306,
        "nome": "Natividade da Serra",
        "latitude": -23.4151,
        "longitude": -45.3814,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532405,
        "nome": "Nazaré Paulista",
        "latitude": -23.1914,
        "longitude": -46.3665,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532504,
        "nome": "Neves Paulista",
        "latitude": -20.8705,
        "longitude": -49.6465,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532603,
        "nome": "Nhandeara",
        "latitude": -20.6731,
        "longitude": -50.0468,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532702,
        "nome": "Nipoã",
        "latitude": -20.8916,
        "longitude": -49.7782,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532801,
        "nome": "Nova Aliança",
        "latitude": -21.0626,
        "longitude": -49.516,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532827,
        "nome": "Nova Campina",
        "latitude": -24.1906,
        "longitude": -48.9729,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532843,
        "nome": "Nova Canaã Paulista",
        "latitude": -20.3721,
        "longitude": -50.9106,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532868,
        "nome": "Nova Castilho",
        "latitude": -20.7778,
        "longitude": -50.3458,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3532900,
        "nome": "Nova Europa",
        "latitude": -21.7743,
        "longitude": -48.5497,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3533007,
        "nome": "Nova Granada",
        "latitude": -20.476,
        "longitude": -49.3311,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3533106,
        "nome": "Nova Guataporanga",
        "latitude": -21.3224,
        "longitude": -51.6454,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3533205,
        "nome": "Nova Independência",
        "latitude": -21.1353,
        "longitude": -51.5052,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3533254,
        "nome": "Novais",
        "latitude": -20.9886,
        "longitude": -48.918,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3533304,
        "nome": "Nova Luzitânia",
        "latitude": -20.8687,
        "longitude": -50.2494,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3533403,
        "nome": "Nova Odessa",
        "latitude": -22.7841,
        "longitude": -47.2852,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3533502,
        "nome": "Novo Horizonte",
        "latitude": -21.4692,
        "longitude": -49.2838,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3533601,
        "nome": "Nuporanga",
        "latitude": -20.7049,
        "longitude": -47.7291,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3533700,
        "nome": "Ocauçu",
        "latitude": -22.4381,
        "longitude": -49.9379,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3533809,
        "nome": "Óleo",
        "latitude": -22.9537,
        "longitude": -49.383,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3533908,
        "nome": "Olímpia",
        "latitude": -20.7052,
        "longitude": -48.9596,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3534005,
        "nome": "Onda Verde",
        "latitude": -20.6174,
        "longitude": -49.2436,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3534104,
        "nome": "Oriente",
        "latitude": -22.1419,
        "longitude": -50.0937,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3534203,
        "nome": "Orindiúva",
        "latitude": -20.2016,
        "longitude": -49.3555,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3534302,
        "nome": "Orlândia",
        "latitude": -20.6979,
        "longitude": -47.9058,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3534401,
        "nome": "Osasco",
        "latitude": -23.5287,
        "longitude": -46.7893,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3534500,
        "nome": "Oscar Bressane",
        "latitude": -22.2954,
        "longitude": -50.2574,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3534609,
        "nome": "Osvaldo Cruz",
        "latitude": -21.7327,
        "longitude": -50.8739,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3534708,
        "nome": "Ourinhos",
        "latitude": -22.9527,
        "longitude": -49.8524,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3534757,
        "nome": "Ouroeste",
        "latitude": -19.9225,
        "longitude": -50.402,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3534807,
        "nome": "Ouro Verde",
        "latitude": -21.5104,
        "longitude": -51.7378,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3534906,
        "nome": "Pacaembu",
        "latitude": -21.4956,
        "longitude": -51.2742,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3535002,
        "nome": "Palestina",
        "latitude": -20.3212,
        "longitude": -49.4976,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3535101,
        "nome": "Palmares Paulista",
        "latitude": -21.1047,
        "longitude": -48.8267,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3535200,
        "nome": "Palmeira d'Oeste",
        "latitude": -20.439,
        "longitude": -50.7488,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3535309,
        "nome": "Palmital",
        "latitude": -22.8288,
        "longitude": -50.2209,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3535408,
        "nome": "Panorama",
        "latitude": -21.4633,
        "longitude": -51.8581,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3535507,
        "nome": "Paraguaçu Paulista",
        "latitude": -22.4591,
        "longitude": -50.6266,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3535606,
        "nome": "Paraibuna",
        "latitude": -23.4784,
        "longitude": -45.6418,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3535705,
        "nome": "Paraíso",
        "latitude": -21.0196,
        "longitude": -48.7647,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3535804,
        "nome": "Paranapanema",
        "latitude": -23.4385,
        "longitude": -48.7952,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3535903,
        "nome": "Paranapuã",
        "latitude": -20.0638,
        "longitude": -50.594,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3536000,
        "nome": "Parapuã",
        "latitude": -21.8529,
        "longitude": -50.8217,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3536109,
        "nome": "Pardinho",
        "latitude": -23.1022,
        "longitude": -48.4018,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3536208,
        "nome": "Pariquera-Açu",
        "latitude": -24.6783,
        "longitude": -47.8501,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3536257,
        "nome": "Parisi",
        "latitude": -20.2716,
        "longitude": -50.0374,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3536307,
        "nome": "Patrocínio Paulista",
        "latitude": -20.7042,
        "longitude": -47.2894,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3536406,
        "nome": "Paulicéia",
        "latitude": -21.1983,
        "longitude": -51.7907,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3536505,
        "nome": "Paulínia",
        "latitude": -22.7484,
        "longitude": -47.1451,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3536570,
        "nome": "Paulistânia",
        "latitude": -22.5684,
        "longitude": -49.3056,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3536604,
        "nome": "Paulo de Faria",
        "latitude": -20.0666,
        "longitude": -49.4634,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3536703,
        "nome": "Pederneiras",
        "latitude": -22.3014,
        "longitude": -48.8611,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3536802,
        "nome": "Pedra Bela",
        "latitude": -22.7758,
        "longitude": -46.4418,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3536901,
        "nome": "Pedranópolis",
        "latitude": -20.2101,
        "longitude": -50.107,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3537008,
        "nome": "Pedregulho",
        "latitude": -20.2056,
        "longitude": -47.4391,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3537107,
        "nome": "Pedreira",
        "latitude": -22.7547,
        "longitude": -46.8886,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3537156,
        "nome": "Pedrinhas Paulista",
        "latitude": -22.8169,
        "longitude": -50.8024,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3537206,
        "nome": "Pedro de Toledo",
        "latitude": -24.1637,
        "longitude": -47.1635,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3537305,
        "nome": "Penápolis",
        "latitude": -21.4054,
        "longitude": -50.0957,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3537404,
        "nome": "Pereira Barreto",
        "latitude": -20.6777,
        "longitude": -51.1065,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3537503,
        "nome": "Pereiras",
        "latitude": -23.1205,
        "longitude": -47.9788,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3537602,
        "nome": "Peruíbe",
        "latitude": -24.2793,
        "longitude": -47.013,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3537701,
        "nome": "Piacatu",
        "latitude": -21.5713,
        "longitude": -50.6436,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3537800,
        "nome": "Piedade",
        "latitude": -23.787,
        "longitude": -47.4381,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3537909,
        "nome": "Pilar do Sul",
        "latitude": -23.8564,
        "longitude": -47.7281,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3538006,
        "nome": "Pindamonhangaba",
        "latitude": -22.88,
        "longitude": -45.4593,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3538105,
        "nome": "Pindorama",
        "latitude": -21.2098,
        "longitude": -48.9116,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3538204,
        "nome": "Pinhalzinho",
        "latitude": -22.7787,
        "longitude": -46.5734,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3538303,
        "nome": "Piquerobi",
        "latitude": -21.8527,
        "longitude": -51.7316,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3538501,
        "nome": "Piquete",
        "latitude": -22.5903,
        "longitude": -45.1738,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3538600,
        "nome": "Piracaia",
        "latitude": -23.0469,
        "longitude": -46.3023,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3538709,
        "nome": "Piracicaba",
        "latitude": -22.7265,
        "longitude": -47.784,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3538808,
        "nome": "Piraju",
        "latitude": -23.1869,
        "longitude": -49.3661,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3538907,
        "nome": "Pirajuí",
        "latitude": -21.9576,
        "longitude": -49.4136,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3539004,
        "nome": "Pirangi",
        "latitude": -21.0939,
        "longitude": -48.6694,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3539103,
        "nome": "Pirapora do Bom Jesus",
        "latitude": -23.3784,
        "longitude": -46.9849,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3539202,
        "nome": "Pirapozinho",
        "latitude": -22.4792,
        "longitude": -51.6198,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3539301,
        "nome": "Pirassununga",
        "latitude": -21.9959,
        "longitude": -47.3899,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3539400,
        "nome": "Piratininga",
        "latitude": -22.425,
        "longitude": -49.1918,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3539509,
        "nome": "Pitangueiras",
        "latitude": -21.0062,
        "longitude": -48.2494,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3539608,
        "nome": "Planalto",
        "latitude": -21.0012,
        "longitude": -49.936,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3539707,
        "nome": "Platina",
        "latitude": -22.6252,
        "longitude": -50.2127,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3539806,
        "nome": "Poá",
        "latitude": -23.5305,
        "longitude": -46.3468,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3539905,
        "nome": "Poloni",
        "latitude": -20.7525,
        "longitude": -49.82,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3540002,
        "nome": "Pompéia",
        "latitude": -22.0292,
        "longitude": -50.1877,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3540101,
        "nome": "Pongaí",
        "latitude": -21.7302,
        "longitude": -49.3589,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3540200,
        "nome": "Pontal",
        "latitude": -20.9846,
        "longitude": -48.0644,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3540259,
        "nome": "Pontalinda",
        "latitude": -20.4507,
        "longitude": -50.5251,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3540309,
        "nome": "Pontes Gestal",
        "latitude": -20.1748,
        "longitude": -49.7574,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3540408,
        "nome": "Populina",
        "latitude": -19.9073,
        "longitude": -50.5173,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3540507,
        "nome": "Porangaba",
        "latitude": -23.1739,
        "longitude": -48.1174,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3540606,
        "nome": "Porto Feliz",
        "latitude": -23.2303,
        "longitude": -47.5169,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3540705,
        "nome": "Porto Ferreira",
        "latitude": -21.8426,
        "longitude": -47.4472,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3540754,
        "nome": "Potim",
        "latitude": -22.8253,
        "longitude": -45.3032,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3540804,
        "nome": "Potirendaba",
        "latitude": -21.0755,
        "longitude": -49.3917,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3540853,
        "nome": "Pracinha",
        "latitude": -21.8375,
        "longitude": -51.0752,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3540903,
        "nome": "Pradópolis",
        "latitude": -21.3444,
        "longitude": -48.0861,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3541000,
        "nome": "Praia Grande",
        "latitude": -24.0156,
        "longitude": -46.5227,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3541059,
        "nome": "Pratânia",
        "latitude": -22.8185,
        "longitude": -48.6969,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3541109,
        "nome": "Presidente Alves",
        "latitude": -22.1222,
        "longitude": -49.4318,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3541208,
        "nome": "Presidente Bernardes",
        "latitude": -22.1073,
        "longitude": -51.6203,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3541307,
        "nome": "Presidente Epitácio",
        "latitude": -21.9107,
        "longitude": -52.1749,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3541406,
        "nome": "Presidente Prudente",
        "latitude": -21.9932,
        "longitude": -51.3431,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3541505,
        "nome": "Presidente Venceslau",
        "latitude": -21.793,
        "longitude": -51.8383,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3541604,
        "nome": "Promissão",
        "latitude": -21.5245,
        "longitude": -49.8705,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3541653,
        "nome": "Quadra",
        "latitude": -23.301,
        "longitude": -48.0386,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3541703,
        "nome": "Quatá",
        "latitude": -22.2059,
        "longitude": -50.6453,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3541802,
        "nome": "Queiroz",
        "latitude": -21.8006,
        "longitude": -50.2453,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3541901,
        "nome": "Queluz",
        "latitude": -22.5043,
        "longitude": -44.7853,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3542008,
        "nome": "Quintana",
        "latitude": -22.1002,
        "longitude": -50.3693,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3542107,
        "nome": "Rafard",
        "latitude": -23.0452,
        "longitude": -47.5838,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3542206,
        "nome": "Rancharia",
        "latitude": -22.2828,
        "longitude": -50.9283,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3542305,
        "nome": "Redenção da Serra",
        "latitude": -23.2537,
        "longitude": -45.5261,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3542404,
        "nome": "Regente Feijó",
        "latitude": -22.2525,
        "longitude": -51.294,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3542503,
        "nome": "Reginópolis",
        "latitude": -21.8832,
        "longitude": -49.1805,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3542602,
        "nome": "Registro",
        "latitude": -24.504,
        "longitude": -47.8208,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3542701,
        "nome": "Restinga",
        "latitude": -20.6482,
        "longitude": -47.5059,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3542800,
        "nome": "Ribeira",
        "latitude": -24.6073,
        "longitude": -49.0366,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3542909,
        "nome": "Ribeirão Bonito",
        "latitude": -22.0601,
        "longitude": -48.1853,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3543006,
        "nome": "Ribeirão Branco",
        "latitude": -24.2562,
        "longitude": -48.7781,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3543105,
        "nome": "Ribeirão Corrente",
        "latitude": -20.4489,
        "longitude": -47.5733,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3543204,
        "nome": "Ribeirão do Sul",
        "latitude": -22.7517,
        "longitude": -49.9227,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3543238,
        "nome": "Ribeirão dos Índios",
        "latitude": -21.7843,
        "longitude": -51.5833,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3543253,
        "nome": "Ribeirão Grande",
        "latitude": -24.1886,
        "longitude": -48.3588,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3543303,
        "nome": "Ribeirão Pires",
        "latitude": -23.7011,
        "longitude": -46.4028,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3543402,
        "nome": "Ribeirão Preto",
        "latitude": -21.2108,
        "longitude": -47.8213,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3543501,
        "nome": "Riversul",
        "latitude": -23.8469,
        "longitude": -49.4478,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3543600,
        "nome": "Rifaina",
        "latitude": -20.0608,
        "longitude": -47.4409,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3543709,
        "nome": "Rincão",
        "latitude": -21.5939,
        "longitude": -48.032,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3543808,
        "nome": "Rinópolis",
        "latitude": -21.6812,
        "longitude": -50.7174,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3543907,
        "nome": "Rio Claro",
        "latitude": -22.3739,
        "longitude": -47.5799,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3544004,
        "nome": "Rio das Pedras",
        "latitude": -22.8503,
        "longitude": -47.5984,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3544103,
        "nome": "Rio Grande da Serra",
        "latitude": -23.7379,
        "longitude": -46.3795,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3544202,
        "nome": "Riolândia",
        "latitude": -20.0235,
        "longitude": -49.7092,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3544251,
        "nome": "Rosana",
        "latitude": -22.4891,
        "longitude": -52.8369,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3544301,
        "nome": "Roseira",
        "latitude": -22.933,
        "longitude": -45.3025,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3544400,
        "nome": "Rubiácea",
        "latitude": -21.3609,
        "longitude": -50.7858,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3544509,
        "nome": "Rubinéia",
        "latitude": -20.2497,
        "longitude": -51.0183,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3544608,
        "nome": "Sabino",
        "latitude": -21.4708,
        "longitude": -49.5756,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3544707,
        "nome": "Sagres",
        "latitude": -21.8678,
        "longitude": -50.9903,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3544806,
        "nome": "Sales",
        "latitude": -21.3472,
        "longitude": -49.5027,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3544905,
        "nome": "Sales Oliveira",
        "latitude": -20.8315,
        "longitude": -47.8546,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3545001,
        "nome": "Salesópolis",
        "latitude": -23.5802,
        "longitude": -45.8426,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3545100,
        "nome": "Salmourão",
        "latitude": -21.588,
        "longitude": -50.8763,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3545159,
        "nome": "Saltinho",
        "latitude": -22.8712,
        "longitude": -47.7318,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3545209,
        "nome": "Salto",
        "latitude": -23.1805,
        "longitude": -47.3026,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3545308,
        "nome": "Salto de Pirapora",
        "latitude": -23.6528,
        "longitude": -47.5806,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3545407,
        "nome": "Salto Grande",
        "latitude": -22.8709,
        "longitude": -49.9608,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3545506,
        "nome": "Sandovalina",
        "latitude": -22.4779,
        "longitude": -51.8421,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3545605,
        "nome": "Santa Adélia",
        "latitude": -21.3178,
        "longitude": -48.819,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3545704,
        "nome": "Santa Albertina",
        "latitude": -20.0142,
        "longitude": -50.7277,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3545803,
        "nome": "Santa Bárbara d'Oeste",
        "latitude": -22.8006,
        "longitude": -47.4281,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3546009,
        "nome": "Santa Branca",
        "latitude": -23.4264,
        "longitude": -45.8633,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3546108,
        "nome": "Santa Clara d'Oeste",
        "latitude": -20.0669,
        "longitude": -50.9084,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3546207,
        "nome": "Santa Cruz da Conceição",
        "latitude": -22.1213,
        "longitude": -47.4856,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3546256,
        "nome": "Santa Cruz da Esperança",
        "latitude": -21.2748,
        "longitude": -47.4396,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3546306,
        "nome": "Santa Cruz das Palmeiras",
        "latitude": -21.8555,
        "longitude": -47.2501,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3546405,
        "nome": "Santa Cruz do Rio Pardo",
        "latitude": -22.8093,
        "longitude": -49.569,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3546504,
        "nome": "Santa Ernestina",
        "latitude": -21.4525,
        "longitude": -48.3668,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3546603,
        "nome": "Santa Fé do Sul",
        "latitude": -20.2419,
        "longitude": -50.9502,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3546702,
        "nome": "Santa Gertrudes",
        "latitude": -22.4751,
        "longitude": -47.5213,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3546801,
        "nome": "Santa Isabel",
        "latitude": -23.2889,
        "longitude": -46.2424,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3546900,
        "nome": "Santa Lúcia",
        "latitude": -21.6708,
        "longitude": -48.0574,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3547007,
        "nome": "Santa Maria da Serra",
        "latitude": -22.5646,
        "longitude": -48.1543,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3547106,
        "nome": "Santa Mercedes",
        "latitude": -21.3168,
        "longitude": -51.7371,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3547205,
        "nome": "Santana da Ponte Pensa",
        "latitude": -20.2607,
        "longitude": -50.7971,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3547304,
        "nome": "Santana de Parnaíba",
        "latitude": -23.4494,
        "longitude": -46.9168,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3547403,
        "nome": "Santa Rita d'Oeste",
        "latitude": -20.0972,
        "longitude": -50.8127,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3547502,
        "nome": "Santa Rita do Passa Quatro",
        "latitude": -21.6825,
        "longitude": -47.5079,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3547601,
        "nome": "Santa Rosa de Viterbo",
        "latitude": -21.5038,
        "longitude": -47.3662,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3547650,
        "nome": "Santa Salete",
        "latitude": -20.2587,
        "longitude": -50.7201,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3547700,
        "nome": "Santo Anastácio",
        "latitude": -22.0377,
        "longitude": -51.7225,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3547809,
        "nome": "Santo André",
        "latitude": -23.728,
        "longitude": -46.4416,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3547908,
        "nome": "Santo Antônio da Alegria",
        "latitude": -21.0923,
        "longitude": -47.1958,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3548005,
        "nome": "Santo Antônio de Posse",
        "latitude": -22.6033,
        "longitude": -46.9499,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3548054,
        "nome": "Santo Antônio do Aracanguá",
        "latitude": -20.873,
        "longitude": -50.5543,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3548104,
        "nome": "Santo Antônio do Jardim",
        "latitude": -22.1303,
        "longitude": -46.6835,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3548203,
        "nome": "Santo Antônio do Pinhal",
        "latitude": -22.8318,
        "longitude": -45.6981,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3548302,
        "nome": "Santo Expedito",
        "latitude": -21.8249,
        "longitude": -51.3702,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3548401,
        "nome": "Santópolis do Aguapeí",
        "latitude": -21.6602,
        "longitude": -50.518,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3548500,
        "nome": "Santos",
        "latitude": -23.8689,
        "longitude": -46.2916,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3548609,
        "nome": "São Bento do Sapucaí",
        "latitude": -22.6814,
        "longitude": -45.6868,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3548708,
        "nome": "São Bernardo do Campo",
        "latitude": -23.813,
        "longitude": -46.5508,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3548807,
        "nome": "São Caetano do Sul",
        "latitude": -23.6261,
        "longitude": -46.5661,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3548906,
        "nome": "São Carlos",
        "latitude": -21.9189,
        "longitude": -47.8672,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3549003,
        "nome": "São Francisco",
        "latitude": -20.3658,
        "longitude": -50.6759,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3549102,
        "nome": "São João da Boa Vista",
        "latitude": -21.978,
        "longitude": -46.8022,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3549201,
        "nome": "São João das Duas Pontes",
        "latitude": -20.4084,
        "longitude": -50.3835,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3549250,
        "nome": "São João de Iracema",
        "latitude": -20.5208,
        "longitude": -50.3563,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3549300,
        "nome": "São João do Pau d'Alho",
        "latitude": -21.2234,
        "longitude": -51.673,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3549409,
        "nome": "São Joaquim da Barra",
        "latitude": -20.5505,
        "longitude": -47.9385,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3549508,
        "nome": "São José da Bela Vista",
        "latitude": -20.5875,
        "longitude": -47.6272,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3549607,
        "nome": "São José do Barreiro",
        "latitude": -22.7489,
        "longitude": -44.5873,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3549706,
        "nome": "São José do Rio Pardo",
        "latitude": -21.6037,
        "longitude": -46.8795,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3549805,
        "nome": "São José do Rio Preto",
        "latitude": -20.7972,
        "longitude": -49.3581,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3549904,
        "nome": "São José dos Campos",
        "latitude": -23.0906,
        "longitude": -45.9285,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3549953,
        "nome": "São Lourenço da Serra",
        "latitude": -23.8524,
        "longitude": -46.9364,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3550001,
        "nome": "São Luiz do Paraitinga",
        "latitude": -23.2401,
        "longitude": -45.2538,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3550100,
        "nome": "São Manuel",
        "latitude": -22.6823,
        "longitude": -48.5404,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3550209,
        "nome": "São Miguel Arcanjo",
        "latitude": -23.9139,
        "longitude": -47.9933,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3550308,
        "nome": "São Paulo",
        "latitude": -23.6501,
        "longitude": -46.6481,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3550407,
        "nome": "São Pedro",
        "latitude": -22.5584,
        "longitude": -47.9244,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3550506,
        "nome": "São Pedro do Turvo",
        "latitude": -22.6789,
        "longitude": -49.7723,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3550605,
        "nome": "São Roque",
        "latitude": -23.549,
        "longitude": -47.1096,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3550704,
        "nome": "São Sebastião",
        "latitude": -23.7522,
        "longitude": -45.6056,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3550803,
        "nome": "São Sebastião da Grama",
        "latitude": -21.7541,
        "longitude": -46.753,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3550902,
        "nome": "São Simão",
        "latitude": -21.4615,
        "longitude": -47.5683,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3551009,
        "nome": "São Vicente",
        "latitude": -23.9592,
        "longitude": -46.4882,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3551108,
        "nome": "Sarapuí",
        "latitude": -23.6643,
        "longitude": -47.7858,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3551207,
        "nome": "Sarutaiá",
        "latitude": -23.2575,
        "longitude": -49.4817,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3551306,
        "nome": "Sebastianópolis do Sul",
        "latitude": -20.6292,
        "longitude": -49.9159,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3551405,
        "nome": "Serra Azul",
        "latitude": -21.3161,
        "longitude": -47.5497,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3551504,
        "nome": "Serrana",
        "latitude": -21.2169,
        "longitude": -47.6123,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3551603,
        "nome": "Serra Negra",
        "latitude": -22.5891,
        "longitude": -46.6873,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3551702,
        "nome": "Sertãozinho",
        "latitude": -21.1229,
        "longitude": -48.0089,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3551801,
        "nome": "Sete Barras",
        "latitude": -24.2739,
        "longitude": -47.9341,
        "mesorregiaoNome": "Litoral Sul Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3551900,
        "nome": "Severínia",
        "latitude": -20.7931,
        "longitude": -48.7938,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3552007,
        "nome": "Silveiras",
        "latitude": -22.7347,
        "longitude": -44.8409,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3552106,
        "nome": "Socorro",
        "latitude": -22.6112,
        "longitude": -46.5244,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3552205,
        "nome": "Sorocaba",
        "latitude": -23.4646,
        "longitude": -47.4468,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3552304,
        "nome": "Sud Mennucci",
        "latitude": -20.6676,
        "longitude": -50.9009,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3552403,
        "nome": "Sumaré",
        "latitude": -22.8419,
        "longitude": -47.263,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3552502,
        "nome": "Suzano",
        "latitude": -23.6084,
        "longitude": -46.3104,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3552551,
        "nome": "Suzanápolis",
        "latitude": -20.4729,
        "longitude": -51.0756,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3552601,
        "nome": "Tabapuã",
        "latitude": -20.9319,
        "longitude": -49.0289,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3552700,
        "nome": "Tabatinga",
        "latitude": -21.7125,
        "longitude": -48.6291,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3552809,
        "nome": "Taboão da Serra",
        "latitude": -23.6205,
        "longitude": -46.7864,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3552908,
        "nome": "Taciba",
        "latitude": -22.5049,
        "longitude": -51.3424,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3553005,
        "nome": "Taguaí",
        "latitude": -23.4745,
        "longitude": -49.3974,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3553104,
        "nome": "Taiaçu",
        "latitude": -21.1322,
        "longitude": -48.5303,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3553203,
        "nome": "Taiúva",
        "latitude": -21.1327,
        "longitude": -48.4282,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3553302,
        "nome": "Tambaú",
        "latitude": -21.6018,
        "longitude": -47.239,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3553401,
        "nome": "Tanabi",
        "latitude": -20.5312,
        "longitude": -49.6465,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3553500,
        "nome": "Tapiraí",
        "latitude": -24.0087,
        "longitude": -47.6194,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3553609,
        "nome": "Tapiratiba",
        "latitude": -21.4508,
        "longitude": -46.7419,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3553658,
        "nome": "Taquaral",
        "latitude": -21.0693,
        "longitude": -48.3994,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3553708,
        "nome": "Taquaritinga",
        "latitude": -21.4256,
        "longitude": -48.5379,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3553807,
        "nome": "Taquarituba",
        "latitude": -23.5302,
        "longitude": -49.2346,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3553856,
        "nome": "Taquarivaí",
        "latitude": -23.9433,
        "longitude": -48.6879,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3553906,
        "nome": "Tarabai",
        "latitude": -22.358,
        "longitude": -51.6258,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3553955,
        "nome": "Tarumã",
        "latitude": -22.7635,
        "longitude": -50.6014,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3554003,
        "nome": "Tatuí",
        "latitude": -23.3621,
        "longitude": -47.8695,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3554102,
        "nome": "Taubaté",
        "latitude": -23.0871,
        "longitude": -45.5024,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3554201,
        "nome": "Tejupá",
        "latitude": -23.3425,
        "longitude": -49.3066,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3554300,
        "nome": "Teodoro Sampaio",
        "latitude": -22.4166,
        "longitude": -52.374,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3554409,
        "nome": "Terra Roxa",
        "latitude": -20.7788,
        "longitude": -48.3458,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3554508,
        "nome": "Tietê",
        "latitude": -23.0494,
        "longitude": -47.7077,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3554607,
        "nome": "Timburi",
        "latitude": -23.1958,
        "longitude": -49.6104,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3554656,
        "nome": "Torre de Pedra",
        "latitude": -23.2501,
        "longitude": -48.2127,
        "mesorregiaoNome": "Itapetininga",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3554706,
        "nome": "Torrinha",
        "latitude": -22.4446,
        "longitude": -48.1644,
        "mesorregiaoNome": "Piracicaba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3554755,
        "nome": "Trabiju",
        "latitude": -22.0323,
        "longitude": -48.3452,
        "mesorregiaoNome": "Araraquara",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3554805,
        "nome": "Tremembé",
        "latitude": -22.9408,
        "longitude": -45.6042,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3554904,
        "nome": "Três Fronteiras",
        "latitude": -20.2737,
        "longitude": -50.8696,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3554953,
        "nome": "Tuiuti",
        "latitude": -22.8303,
        "longitude": -46.6876,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3555000,
        "nome": "Tupã",
        "latitude": -21.9473,
        "longitude": -50.5346,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3555109,
        "nome": "Tupi Paulista",
        "latitude": -21.3904,
        "longitude": -51.5872,
        "mesorregiaoNome": "Presidente Prudente",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3555208,
        "nome": "Turiúba",
        "latitude": -20.9405,
        "longitude": -50.1113,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3555307,
        "nome": "Turmalina",
        "latitude": -20.0835,
        "longitude": -50.4568,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3555356,
        "nome": "Ubarana",
        "latitude": -21.2198,
        "longitude": -49.7482,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3555406,
        "nome": "Ubatuba",
        "latitude": -23.3788,
        "longitude": -45.0237,
        "mesorregiaoNome": "Vale do Paraíba Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3555505,
        "nome": "Ubirajara",
        "latitude": -22.5443,
        "longitude": -49.6659,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3555604,
        "nome": "Uchoa",
        "latitude": -20.9369,
        "longitude": -49.1577,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3555703,
        "nome": "União Paulista",
        "latitude": -20.8905,
        "longitude": -49.8873,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3555802,
        "nome": "Urânia",
        "latitude": -20.2089,
        "longitude": -50.6525,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3555901,
        "nome": "Uru",
        "latitude": -21.766,
        "longitude": -49.2963,
        "mesorregiaoNome": "Bauru",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3556008,
        "nome": "Urupês",
        "latitude": -21.2052,
        "longitude": -49.2652,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3556107,
        "nome": "Valentim Gentil",
        "latitude": -20.4205,
        "longitude": -50.1017,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3556206,
        "nome": "Valinhos",
        "latitude": -22.9751,
        "longitude": -46.9813,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3556305,
        "nome": "Valparaíso",
        "latitude": -21.2031,
        "longitude": -50.9239,
        "mesorregiaoNome": "Araçatuba",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3556354,
        "nome": "Vargem",
        "latitude": -22.8902,
        "longitude": -46.4145,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3556404,
        "nome": "Vargem Grande do Sul",
        "latitude": -21.8607,
        "longitude": -46.899,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3556453,
        "nome": "Vargem Grande Paulista",
        "latitude": -23.6209,
        "longitude": -47.0147,
        "mesorregiaoNome": "Metropolitana de São Paulo",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3556503,
        "nome": "Várzea Paulista",
        "latitude": -23.2193,
        "longitude": -46.8249,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3556602,
        "nome": "Vera Cruz",
        "latitude": -22.2341,
        "longitude": -49.8262,
        "mesorregiaoNome": "Marília",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3556701,
        "nome": "Vinhedo",
        "latitude": -23.0465,
        "longitude": -46.9792,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3556800,
        "nome": "Viradouro",
        "latitude": -20.8844,
        "longitude": -48.3099,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3556909,
        "nome": "Vista Alegre do Alto",
        "latitude": -21.1767,
        "longitude": -48.6494,
        "mesorregiaoNome": "Ribeirão Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3556958,
        "nome": "Vitória Brasil",
        "latitude": -20.1984,
        "longitude": -50.4855,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3557006,
        "nome": "Votorantim",
        "latitude": -23.5799,
        "longitude": -47.4065,
        "mesorregiaoNome": "Macro Metropolitana Paulista",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3557105,
        "nome": "Votuporanga",
        "latitude": -20.4578,
        "longitude": -49.9891,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3557154,
        "nome": "Zacarias",
        "latitude": -21.1255,
        "longitude": -50.0494,
        "mesorregiaoNome": "São José do Rio Preto",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3557204,
        "nome": "Chavantes",
        "latitude": -23.0463,
        "longitude": -49.7265,
        "mesorregiaoNome": "Assis",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 3557303,
        "nome": "Estiva Gerbi",
        "latitude": -22.2361,
        "longitude": -46.9431,
        "mesorregiaoNome": "Campinas",
        "UFSigla": "SP",
        "UFNome": "São Paulo"
    },
    {
        "ibgeId": 4100103,
        "nome": "Abatiá",
        "latitude": -23.3072,
        "longitude": -50.3096,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4100202,
        "nome": "Adrianópolis",
        "latitude": -24.7835,
        "longitude": -48.8212,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4100301,
        "nome": "Agudos do Sul",
        "latitude": -26.0278,
        "longitude": -49.3112,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4100400,
        "nome": "Almirante Tamandaré",
        "latitude": -25.2968,
        "longitude": -49.3235,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4100459,
        "nome": "Altamira do Paraná",
        "latitude": -24.8134,
        "longitude": -52.6923,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4100509,
        "nome": "Altônia",
        "latitude": -23.9026,
        "longitude": -53.9488,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4100608,
        "nome": "Alto Paraná",
        "latitude": -23.0761,
        "longitude": -52.3236,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4100707,
        "nome": "Alto Piquiri",
        "latitude": -24.0983,
        "longitude": -53.402,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4100806,
        "nome": "Alvorada do Sul",
        "latitude": -22.8106,
        "longitude": -51.2551,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4100905,
        "nome": "Amaporã",
        "latitude": -23.1288,
        "longitude": -52.8349,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101002,
        "nome": "Ampére",
        "latitude": -25.9167,
        "longitude": -53.4832,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101051,
        "nome": "Anahy",
        "latitude": -24.6441,
        "longitude": -53.1438,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101101,
        "nome": "Andirá",
        "latitude": -23.0179,
        "longitude": -50.2716,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101150,
        "nome": "Ângulo",
        "latitude": -23.1916,
        "longitude": -51.9183,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101200,
        "nome": "Antonina",
        "latitude": -25.306,
        "longitude": -48.7209,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101309,
        "nome": "Antônio Olinto",
        "latitude": -25.96,
        "longitude": -50.1284,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101408,
        "nome": "Apucarana",
        "latitude": -23.572,
        "longitude": -51.446,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101507,
        "nome": "Arapongas",
        "latitude": -23.4408,
        "longitude": -51.4282,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101606,
        "nome": "Arapoti",
        "latitude": -24.0928,
        "longitude": -49.9757,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101655,
        "nome": "Arapuã",
        "latitude": -24.344,
        "longitude": -51.8153,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101705,
        "nome": "Araruna",
        "latitude": -23.9551,
        "longitude": -52.5766,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101804,
        "nome": "Araucária",
        "latitude": -25.6086,
        "longitude": -49.4415,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101853,
        "nome": "Ariranha do Ivaí",
        "latitude": -24.3779,
        "longitude": -51.538,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4101903,
        "nome": "Assaí",
        "latitude": -23.4054,
        "longitude": -50.8756,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4102000,
        "nome": "Assis Chateaubriand",
        "latitude": -24.426,
        "longitude": -53.5846,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4102109,
        "nome": "Astorga",
        "latitude": -23.25,
        "longitude": -51.6997,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4102208,
        "nome": "Atalaia",
        "latitude": -23.1286,
        "longitude": -52.0649,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4102307,
        "nome": "Balsa Nova",
        "latitude": -25.5218,
        "longitude": -49.6887,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4102406,
        "nome": "Bandeirantes",
        "latitude": -23.1609,
        "longitude": -50.3464,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4102505,
        "nome": "Barbosa Ferraz",
        "latitude": -24.0824,
        "longitude": -52.0467,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4102604,
        "nome": "Barracão",
        "latitude": -26.2465,
        "longitude": -53.5321,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4102703,
        "nome": "Barra do Jacaré",
        "latitude": -23.1058,
        "longitude": -50.1592,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4102752,
        "nome": "Bela Vista da Caroba",
        "latitude": -25.881,
        "longitude": -53.6343,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4102802,
        "nome": "Bela Vista do Paraíso",
        "latitude": -23.0051,
        "longitude": -51.2358,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4102901,
        "nome": "Bituruna",
        "latitude": -26.1711,
        "longitude": -51.5361,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103008,
        "nome": "Boa Esperança",
        "latitude": -24.2569,
        "longitude": -52.7512,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103024,
        "nome": "Boa Esperança do Iguaçu",
        "latitude": -25.6402,
        "longitude": -53.2261,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103040,
        "nome": "Boa Ventura de São Roque",
        "latitude": -24.8559,
        "longitude": -51.5648,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103057,
        "nome": "Boa Vista da Aparecida",
        "latitude": -25.432,
        "longitude": -53.4218,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103107,
        "nome": "Bocaiúva do Sul",
        "latitude": -25.1163,
        "longitude": -48.9364,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103156,
        "nome": "Bom Jesus do Sul",
        "latitude": -26.1631,
        "longitude": -53.553,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103206,
        "nome": "Bom Sucesso",
        "latitude": -23.7131,
        "longitude": -51.8243,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103222,
        "nome": "Bom Sucesso do Sul",
        "latitude": -26.0861,
        "longitude": -52.8388,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103305,
        "nome": "Borrazópolis",
        "latitude": -23.9392,
        "longitude": -51.592,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103354,
        "nome": "Braganey",
        "latitude": -24.8013,
        "longitude": -53.0905,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103370,
        "nome": "Brasilândia do Sul",
        "latitude": -24.1661,
        "longitude": -53.5417,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103404,
        "nome": "Cafeara",
        "latitude": -22.8131,
        "longitude": -51.7112,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103453,
        "nome": "Cafelândia",
        "latitude": -24.6919,
        "longitude": -53.3644,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103479,
        "nome": "Cafezal do Sul",
        "latitude": -23.9394,
        "longitude": -53.5616,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103503,
        "nome": "Califórnia",
        "latitude": -23.6688,
        "longitude": -51.3338,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103602,
        "nome": "Cambará",
        "latitude": -22.997,
        "longitude": -50.0828,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103701,
        "nome": "Cambé",
        "latitude": -23.1798,
        "longitude": -51.2843,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103800,
        "nome": "Cambira",
        "latitude": -23.6306,
        "longitude": -51.5667,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103909,
        "nome": "Campina da Lagoa",
        "latitude": -24.6166,
        "longitude": -52.7883,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4103958,
        "nome": "Campina do Simão",
        "latitude": -25.1308,
        "longitude": -51.782,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104006,
        "nome": "Campina Grande do Sul",
        "latitude": -25.1865,
        "longitude": -48.8445,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104055,
        "nome": "Campo Bonito",
        "latitude": -24.9312,
        "longitude": -53.0139,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104105,
        "nome": "Campo do Tenente",
        "latitude": -25.9778,
        "longitude": -49.6564,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104204,
        "nome": "Campo Largo",
        "latitude": -25.2924,
        "longitude": -49.6188,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104253,
        "nome": "Campo Magro",
        "latitude": -25.2897,
        "longitude": -49.4627,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104303,
        "nome": "Campo Mourão",
        "latitude": -24.1025,
        "longitude": -52.3807,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104402,
        "nome": "Cândido de Abreu",
        "latitude": -24.6455,
        "longitude": -51.2533,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104428,
        "nome": "Candói",
        "latitude": -25.5243,
        "longitude": -52.0209,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104451,
        "nome": "Cantagalo",
        "latitude": -25.2903,
        "longitude": -52.1283,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104501,
        "nome": "Capanema",
        "latitude": -25.6108,
        "longitude": -53.7631,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104600,
        "nome": "Capitão Leônidas Marques",
        "latitude": -25.4695,
        "longitude": -53.5928,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104659,
        "nome": "Carambeí",
        "latitude": -24.8936,
        "longitude": -50.1516,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104709,
        "nome": "Carlópolis",
        "latitude": -23.4597,
        "longitude": -49.7128,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104808,
        "nome": "Cascavel",
        "latitude": -25.0278,
        "longitude": -53.3796,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4104907,
        "nome": "Castro",
        "latitude": -24.7996,
        "longitude": -49.8417,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4105003,
        "nome": "Catanduvas",
        "latitude": -25.2414,
        "longitude": -53.1557,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4105102,
        "nome": "Centenário do Sul",
        "latitude": -22.8054,
        "longitude": -51.5606,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4105201,
        "nome": "Cerro Azul",
        "latitude": -24.8754,
        "longitude": -49.2797,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4105300,
        "nome": "Céu Azul",
        "latitude": -25.2464,
        "longitude": -53.7618,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4105409,
        "nome": "Chopinzinho",
        "latitude": -25.812,
        "longitude": -52.451,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4105508,
        "nome": "Cianorte",
        "latitude": -23.7275,
        "longitude": -52.627,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4105607,
        "nome": "Cidade Gaúcha",
        "latitude": -23.3828,
        "longitude": -52.9585,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4105706,
        "nome": "Clevelândia",
        "latitude": -26.3446,
        "longitude": -52.3579,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4105805,
        "nome": "Colombo",
        "latitude": -25.3063,
        "longitude": -49.188,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4105904,
        "nome": "Colorado",
        "latitude": -22.8361,
        "longitude": -51.9718,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106001,
        "nome": "Congonhinhas",
        "latitude": -23.6057,
        "longitude": -50.5039,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106100,
        "nome": "Conselheiro Mairinck",
        "latitude": -23.5974,
        "longitude": -50.1297,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106209,
        "nome": "Contenda",
        "latitude": -25.7191,
        "longitude": -49.5261,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106308,
        "nome": "Corbélia",
        "latitude": -24.7425,
        "longitude": -53.237,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106407,
        "nome": "Cornélio Procópio",
        "latitude": -23.2258,
        "longitude": -50.6235,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106456,
        "nome": "Coronel Domingos Soares",
        "latitude": -26.1824,
        "longitude": -51.9302,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106506,
        "nome": "Coronel Vivida",
        "latitude": -25.9925,
        "longitude": -52.5644,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106555,
        "nome": "Corumbataí do Sul",
        "latitude": -24.1237,
        "longitude": -52.1421,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106571,
        "nome": "Cruzeiro do Iguaçu",
        "latitude": -25.5954,
        "longitude": -53.1298,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106605,
        "nome": "Cruzeiro do Oeste",
        "latitude": -23.7587,
        "longitude": -53.0834,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106704,
        "nome": "Cruzeiro do Sul",
        "latitude": -22.988,
        "longitude": -52.1625,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106803,
        "nome": "Cruz Machado",
        "latitude": -25.9224,
        "longitude": -51.2322,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106852,
        "nome": "Cruzmaltina",
        "latitude": -24.02,
        "longitude": -51.4754,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4106902,
        "nome": "Curitiba",
        "latitude": -25.4779,
        "longitude": -49.2881,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107009,
        "nome": "Curiúva",
        "latitude": -24.0132,
        "longitude": -50.4656,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107108,
        "nome": "Diamante do Norte",
        "latitude": -22.635,
        "longitude": -52.8928,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107124,
        "nome": "Diamante do Sul",
        "latitude": -24.9905,
        "longitude": -52.7041,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107157,
        "nome": "Diamante D'Oeste",
        "latitude": -24.9542,
        "longitude": -54.1003,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107207,
        "nome": "Dois Vizinhos",
        "latitude": -25.7502,
        "longitude": -53.0754,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107256,
        "nome": "Douradina",
        "latitude": -23.3474,
        "longitude": -53.2902,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107306,
        "nome": "Doutor Camargo",
        "latitude": -23.5612,
        "longitude": -52.2148,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107405,
        "nome": "Enéas Marques",
        "latitude": -25.9066,
        "longitude": -53.1538,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107504,
        "nome": "Engenheiro Beltrão",
        "latitude": -23.7598,
        "longitude": -52.2697,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107520,
        "nome": "Esperança Nova",
        "latitude": -23.7142,
        "longitude": -53.7975,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107538,
        "nome": "Entre Rios do Oeste",
        "latitude": -24.7131,
        "longitude": -54.2221,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107546,
        "nome": "Espigão Alto do Iguaçu",
        "latitude": -25.3527,
        "longitude": -52.7871,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107553,
        "nome": "Farol",
        "latitude": -24.1233,
        "longitude": -52.6288,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107603,
        "nome": "Faxinal",
        "latitude": -24.0033,
        "longitude": -51.2849,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107652,
        "nome": "Fazenda Rio Grande",
        "latitude": -25.6764,
        "longitude": -49.2974,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107702,
        "nome": "Fênix",
        "latitude": -23.9011,
        "longitude": -52.0298,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107736,
        "nome": "Fernandes Pinheiro",
        "latitude": -25.5166,
        "longitude": -50.5103,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107751,
        "nome": "Figueira",
        "latitude": -23.8762,
        "longitude": -50.4303,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107801,
        "nome": "Floraí",
        "latitude": -23.3327,
        "longitude": -52.3484,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107850,
        "nome": "Flor da Serra do Sul",
        "latitude": -26.2372,
        "longitude": -53.2932,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4107900,
        "nome": "Floresta",
        "latitude": -23.6071,
        "longitude": -52.0901,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108007,
        "nome": "Florestópolis",
        "latitude": -22.8934,
        "longitude": -51.4027,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108106,
        "nome": "Flórida",
        "latitude": -23.1056,
        "longitude": -51.9565,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108205,
        "nome": "Formosa do Oeste",
        "latitude": -24.2927,
        "longitude": -53.3316,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108304,
        "nome": "Foz do Iguaçu",
        "latitude": -25.468,
        "longitude": -54.4832,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108320,
        "nome": "Francisco Alves",
        "latitude": -24.0948,
        "longitude": -53.8723,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108403,
        "nome": "Francisco Beltrão",
        "latitude": -26.0477,
        "longitude": -53.1326,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108452,
        "nome": "Foz do Jordão",
        "latitude": -25.6996,
        "longitude": -52.0909,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108502,
        "nome": "General Carneiro",
        "latitude": -26.4726,
        "longitude": -51.3919,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108551,
        "nome": "Godoy Moreira",
        "latitude": -24.1603,
        "longitude": -51.908,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108601,
        "nome": "Goioerê",
        "latitude": -24.1726,
        "longitude": -53.052,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108650,
        "nome": "Goioxim",
        "latitude": -25.1299,
        "longitude": -51.9946,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108700,
        "nome": "Grandes Rios",
        "latitude": -24.1904,
        "longitude": -51.4476,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108809,
        "nome": "Guaíra",
        "latitude": -24.1906,
        "longitude": -54.2312,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108908,
        "nome": "Guairaçá",
        "latitude": -22.9229,
        "longitude": -52.7401,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4108957,
        "nome": "Guamiranga",
        "latitude": -25.1707,
        "longitude": -50.8397,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4109005,
        "nome": "Guapirama",
        "latitude": -23.468,
        "longitude": -50.0769,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4109104,
        "nome": "Guaporema",
        "latitude": -23.3252,
        "longitude": -52.8261,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4109203,
        "nome": "Guaraci",
        "latitude": -22.9567,
        "longitude": -51.6789,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4109302,
        "nome": "Guaraniaçu",
        "latitude": -25.0551,
        "longitude": -52.8633,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4109401,
        "nome": "Guarapuava",
        "latitude": -25.3713,
        "longitude": -51.4911,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4109500,
        "nome": "Guaraqueçaba",
        "latitude": -25.2337,
        "longitude": -48.3667,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4109609,
        "nome": "Guaratuba",
        "latitude": -25.8176,
        "longitude": -48.7687,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4109658,
        "nome": "Honório Serpa",
        "latitude": -26.1628,
        "longitude": -52.3726,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4109708,
        "nome": "Ibaiti",
        "latitude": -23.7782,
        "longitude": -50.2874,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4109757,
        "nome": "Ibema",
        "latitude": -25.152,
        "longitude": -53.024,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4109807,
        "nome": "Ibiporã",
        "latitude": -23.2364,
        "longitude": -51.0378,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4109906,
        "nome": "Icaraíma",
        "latitude": -23.3736,
        "longitude": -53.5856,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110003,
        "nome": "Iguaraçu",
        "latitude": -23.2268,
        "longitude": -51.8469,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110052,
        "nome": "Iguatu",
        "latitude": -24.6878,
        "longitude": -53.0869,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110078,
        "nome": "Imbaú",
        "latitude": -24.4385,
        "longitude": -50.7419,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110102,
        "nome": "Imbituva",
        "latitude": -25.226,
        "longitude": -50.6554,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110201,
        "nome": "Inácio Martins",
        "latitude": -25.6342,
        "longitude": -51.1975,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110300,
        "nome": "Inajá",
        "latitude": -22.7186,
        "longitude": -52.2254,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110409,
        "nome": "Indianópolis",
        "latitude": -23.4869,
        "longitude": -52.6732,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110508,
        "nome": "Ipiranga",
        "latitude": -24.9926,
        "longitude": -50.5888,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110607,
        "nome": "Iporã",
        "latitude": -24.0451,
        "longitude": -53.7198,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110656,
        "nome": "Iracema do Oeste",
        "latitude": -24.4385,
        "longitude": -53.3518,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110706,
        "nome": "Irati",
        "latitude": -25.4886,
        "longitude": -50.8256,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110805,
        "nome": "Iretama",
        "latitude": -24.3523,
        "longitude": -52.111,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110904,
        "nome": "Itaguajé",
        "latitude": -22.6597,
        "longitude": -51.9677,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4110953,
        "nome": "Itaipulândia",
        "latitude": -25.1561,
        "longitude": -54.3582,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4111001,
        "nome": "Itambaracá",
        "latitude": -22.9828,
        "longitude": -50.414,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4111100,
        "nome": "Itambé",
        "latitude": -23.7065,
        "longitude": -52.0083,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4111209,
        "nome": "Itapejara d'Oeste",
        "latitude": -25.9862,
        "longitude": -52.8239,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4111258,
        "nome": "Itaperuçu",
        "latitude": -25.1252,
        "longitude": -49.4901,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4111308,
        "nome": "Itaúna do Sul",
        "latitude": -22.7287,
        "longitude": -52.8985,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4111407,
        "nome": "Ivaí",
        "latitude": -24.9872,
        "longitude": -50.8599,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4111506,
        "nome": "Ivaiporã",
        "latitude": -24.2835,
        "longitude": -51.6292,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4111555,
        "nome": "Ivaté",
        "latitude": -23.354,
        "longitude": -53.4244,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4111605,
        "nome": "Ivatuba",
        "latitude": -23.5993,
        "longitude": -52.1774,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4111704,
        "nome": "Jaboti",
        "latitude": -23.7181,
        "longitude": -50.0798,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4111803,
        "nome": "Jacarezinho",
        "latitude": -23.1507,
        "longitude": -49.9474,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4111902,
        "nome": "Jaguapitã",
        "latitude": -23.0653,
        "longitude": -51.5564,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4112009,
        "nome": "Jaguariaíva",
        "latitude": -24.3306,
        "longitude": -49.7051,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4112108,
        "nome": "Jandaia do Sul",
        "latitude": -23.6279,
        "longitude": -51.6846,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4112207,
        "nome": "Janiópolis",
        "latitude": -24.1283,
        "longitude": -52.8114,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4112306,
        "nome": "Japira",
        "latitude": -23.7332,
        "longitude": -50.163,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4112405,
        "nome": "Japurá",
        "latitude": -23.4388,
        "longitude": -52.5412,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4112504,
        "nome": "Jardim Alegre",
        "latitude": -24.2056,
        "longitude": -51.7674,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4112603,
        "nome": "Jardim Olinda",
        "latitude": -22.5738,
        "longitude": -52.0793,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4112702,
        "nome": "Jataizinho",
        "latitude": -23.2512,
        "longitude": -50.9242,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4112751,
        "nome": "Jesuítas",
        "latitude": -24.414,
        "longitude": -53.4106,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4112801,
        "nome": "Joaquim Távora",
        "latitude": -23.4568,
        "longitude": -49.9103,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4112900,
        "nome": "Jundiaí do Sul",
        "latitude": -23.4735,
        "longitude": -50.2322,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4112959,
        "nome": "Juranda",
        "latitude": -24.3975,
        "longitude": -52.8347,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113007,
        "nome": "Jussara",
        "latitude": -23.637,
        "longitude": -52.4478,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113106,
        "nome": "Kaloré",
        "latitude": -23.8571,
        "longitude": -51.6899,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113205,
        "nome": "Lapa",
        "latitude": -25.7705,
        "longitude": -49.8711,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113254,
        "nome": "Laranjal",
        "latitude": -24.9021,
        "longitude": -52.4906,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113304,
        "nome": "Laranjeiras do Sul",
        "latitude": -25.3453,
        "longitude": -52.3824,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113403,
        "nome": "Leópolis",
        "latitude": -23.0266,
        "longitude": -50.7113,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113429,
        "nome": "Lidianópolis",
        "latitude": -24.0862,
        "longitude": -51.639,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113452,
        "nome": "Lindoeste",
        "latitude": -25.258,
        "longitude": -53.558,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113502,
        "nome": "Loanda",
        "latitude": -22.9491,
        "longitude": -53.0713,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113601,
        "nome": "Lobato",
        "latitude": -22.9818,
        "longitude": -51.9872,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113700,
        "nome": "Londrina",
        "latitude": -23.5143,
        "longitude": -51.1104,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113734,
        "nome": "Luiziana",
        "latitude": -24.3474,
        "longitude": -52.3308,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113759,
        "nome": "Lunardelli",
        "latitude": -24.0802,
        "longitude": -51.771,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113809,
        "nome": "Lupionópolis",
        "latitude": -22.728,
        "longitude": -51.6645,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4113908,
        "nome": "Mallet",
        "latitude": -25.8817,
        "longitude": -50.857,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4114005,
        "nome": "Mamborê",
        "latitude": -24.3611,
        "longitude": -52.5891,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4114104,
        "nome": "Mandaguaçu",
        "latitude": -23.2787,
        "longitude": -52.0558,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4114203,
        "nome": "Mandaguari",
        "latitude": -23.482,
        "longitude": -51.7067,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4114302,
        "nome": "Mandirituba",
        "latitude": -25.8424,
        "longitude": -49.3223,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4114351,
        "nome": "Manfrinópolis",
        "latitude": -26.0951,
        "longitude": -53.3454,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4114401,
        "nome": "Mangueirinha",
        "latitude": -26.0334,
        "longitude": -52.2093,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4114500,
        "nome": "Manoel Ribas",
        "latitude": -24.4893,
        "longitude": -51.6404,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4114609,
        "nome": "Marechal Cândido Rondon",
        "latitude": -24.5715,
        "longitude": -54.1369,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4114708,
        "nome": "Maria Helena",
        "latitude": -23.5824,
        "longitude": -53.2215,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4114807,
        "nome": "Marialva",
        "latitude": -23.5306,
        "longitude": -51.8678,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4114906,
        "nome": "Marilândia do Sul",
        "latitude": -23.7733,
        "longitude": -51.2836,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115002,
        "nome": "Marilena",
        "latitude": -22.7328,
        "longitude": -53.0645,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115101,
        "nome": "Mariluz",
        "latitude": -24.0537,
        "longitude": -53.2107,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115200,
        "nome": "Maringá",
        "latitude": -23.401,
        "longitude": -51.9678,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115309,
        "nome": "Mariópolis",
        "latitude": -26.3361,
        "longitude": -52.5808,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115358,
        "nome": "Maripá",
        "latitude": -24.4449,
        "longitude": -53.7917,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115408,
        "nome": "Marmeleiro",
        "latitude": -26.2465,
        "longitude": -53.0931,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115457,
        "nome": "Marquinho",
        "latitude": -25.1009,
        "longitude": -52.2527,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115507,
        "nome": "Marumbi",
        "latitude": -23.7543,
        "longitude": -51.6596,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115606,
        "nome": "Matelândia",
        "latitude": -25.351,
        "longitude": -53.9061,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115705,
        "nome": "Matinhos",
        "latitude": -25.7618,
        "longitude": -48.5548,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115739,
        "nome": "Mato Rico",
        "latitude": -24.7015,
        "longitude": -52.2119,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115754,
        "nome": "Mauá da Serra",
        "latitude": -23.9111,
        "longitude": -51.1803,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115804,
        "nome": "Medianeira",
        "latitude": -25.2632,
        "longitude": -54.0919,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115853,
        "nome": "Mercedes",
        "latitude": -24.4334,
        "longitude": -54.1862,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4115903,
        "nome": "Mirador",
        "latitude": -23.2024,
        "longitude": -52.7461,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4116000,
        "nome": "Miraselva",
        "latitude": -22.9731,
        "longitude": -51.4852,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4116059,
        "nome": "Missal",
        "latitude": -25.0956,
        "longitude": -54.2413,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4116109,
        "nome": "Moreira Sales",
        "latitude": -24.0244,
        "longitude": -53.0057,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4116208,
        "nome": "Morretes",
        "latitude": -25.5183,
        "longitude": -48.856,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4116307,
        "nome": "Munhoz de Melo",
        "latitude": -23.1303,
        "longitude": -51.7349,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4116406,
        "nome": "Nossa Senhora das Graças",
        "latitude": -22.9141,
        "longitude": -51.7981,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4116505,
        "nome": "Nova Aliança do Ivaí",
        "latitude": -23.1696,
        "longitude": -52.6106,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4116604,
        "nome": "Nova América da Colina",
        "latitude": -23.3454,
        "longitude": -50.7063,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4116703,
        "nome": "Nova Aurora",
        "latitude": -24.5018,
        "longitude": -53.2761,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4116802,
        "nome": "Nova Cantu",
        "latitude": -24.6592,
        "longitude": -52.5585,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4116901,
        "nome": "Nova Esperança",
        "latitude": -23.1914,
        "longitude": -52.2509,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4116950,
        "nome": "Nova Esperança do Sudoeste",
        "latitude": -25.8984,
        "longitude": -53.2576,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117008,
        "nome": "Nova Fátima",
        "latitude": -23.4185,
        "longitude": -50.5385,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117057,
        "nome": "Nova Laranjeiras",
        "latitude": -25.2259,
        "longitude": -52.5749,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117107,
        "nome": "Nova Londrina",
        "latitude": -22.7869,
        "longitude": -52.9548,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117206,
        "nome": "Nova Olímpia",
        "latitude": -23.4267,
        "longitude": -53.0722,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117214,
        "nome": "Nova Santa Bárbara",
        "latitude": -23.5923,
        "longitude": -50.7433,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117222,
        "nome": "Nova Santa Rosa",
        "latitude": -24.4404,
        "longitude": -53.9585,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117255,
        "nome": "Nova Prata do Iguaçu",
        "latitude": -25.5908,
        "longitude": -53.3783,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117271,
        "nome": "Nova Tebas",
        "latitude": -24.4599,
        "longitude": -51.9445,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117297,
        "nome": "Novo Itacolomi",
        "latitude": -23.7809,
        "longitude": -51.5328,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117305,
        "nome": "Ortigueira",
        "latitude": -24.1351,
        "longitude": -50.947,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117404,
        "nome": "Ourizona",
        "latitude": -23.4597,
        "longitude": -52.2313,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117453,
        "nome": "Ouro Verde do Oeste",
        "latitude": -24.7938,
        "longitude": -53.9097,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117503,
        "nome": "Paiçandu",
        "latitude": -23.4651,
        "longitude": -52.1222,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117602,
        "nome": "Palmas",
        "latitude": -26.451,
        "longitude": -51.8148,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117701,
        "nome": "Palmeira",
        "latitude": -25.4425,
        "longitude": -50.0579,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117800,
        "nome": "Palmital",
        "latitude": -24.8757,
        "longitude": -52.2657,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4117909,
        "nome": "Palotina",
        "latitude": -24.2746,
        "longitude": -53.824,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4118006,
        "nome": "Paraíso do Norte",
        "latitude": -23.2681,
        "longitude": -52.6355,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4118105,
        "nome": "Paranacity",
        "latitude": -22.8473,
        "longitude": -52.1446,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4118204,
        "nome": "Paranaguá",
        "latitude": -25.5272,
        "longitude": -48.5177,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4118303,
        "nome": "Paranapoema",
        "latitude": -22.6605,
        "longitude": -52.1027,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4118402,
        "nome": "Paranavaí",
        "latitude": -22.9213,
        "longitude": -52.5106,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4118451,
        "nome": "Pato Bragado",
        "latitude": -24.6342,
        "longitude": -54.2483,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4118501,
        "nome": "Pato Branco",
        "latitude": -26.169,
        "longitude": -52.6632,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4118600,
        "nome": "Paula Freitas",
        "latitude": -26.1774,
        "longitude": -50.8608,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4118709,
        "nome": "Paulo Frontin",
        "latitude": -26.0624,
        "longitude": -50.7497,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4118808,
        "nome": "Peabiru",
        "latitude": -23.9312,
        "longitude": -52.3267,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4118857,
        "nome": "Perobal",
        "latitude": -23.923,
        "longitude": -53.365,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4118907,
        "nome": "Pérola",
        "latitude": -23.8325,
        "longitude": -53.7063,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119004,
        "nome": "Pérola d'Oeste",
        "latitude": -25.8499,
        "longitude": -53.7589,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119103,
        "nome": "Piên",
        "latitude": -26.0907,
        "longitude": -49.4532,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119152,
        "nome": "Pinhais",
        "latitude": -25.4199,
        "longitude": -49.1556,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119202,
        "nome": "Pinhalão",
        "latitude": -23.9035,
        "longitude": -50.0613,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119251,
        "nome": "Pinhal de São Bento",
        "latitude": -26.016,
        "longitude": -53.478,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119301,
        "nome": "Pinhão",
        "latitude": -25.7854,
        "longitude": -51.6324,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119400,
        "nome": "Piraí do Sul",
        "latitude": -24.4748,
        "longitude": -49.9273,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119509,
        "nome": "Piraquara",
        "latitude": -25.4724,
        "longitude": -49.0523,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119608,
        "nome": "Pitanga",
        "latitude": -24.6931,
        "longitude": -51.7823,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119657,
        "nome": "Pitangueiras",
        "latitude": -23.2092,
        "longitude": -51.5724,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119707,
        "nome": "Planaltina do Paraná",
        "latitude": -23.0917,
        "longitude": -52.9345,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119806,
        "nome": "Planalto",
        "latitude": -25.7372,
        "longitude": -53.7078,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119905,
        "nome": "Ponta Grossa",
        "latitude": -25.1396,
        "longitude": -50.0807,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4119954,
        "nome": "Pontal do Paraná",
        "latitude": -25.6367,
        "longitude": -48.4749,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120002,
        "nome": "Porecatu",
        "latitude": -22.7427,
        "longitude": -51.4099,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120101,
        "nome": "Porto Amazonas",
        "latitude": -25.5298,
        "longitude": -49.8953,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120150,
        "nome": "Porto Barreiro",
        "latitude": -25.5846,
        "longitude": -52.3822,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120200,
        "nome": "Porto Rico",
        "latitude": -22.8331,
        "longitude": -53.3138,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120309,
        "nome": "Porto Vitória",
        "latitude": -26.2277,
        "longitude": -51.2223,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120333,
        "nome": "Prado Ferreira",
        "latitude": -23.0257,
        "longitude": -51.4004,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120358,
        "nome": "Pranchita",
        "latitude": -25.9663,
        "longitude": -53.7212,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120408,
        "nome": "Presidente Castelo Branco",
        "latitude": -23.2638,
        "longitude": -52.1494,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120507,
        "nome": "Primeiro de Maio",
        "latitude": -22.8622,
        "longitude": -51.0741,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120606,
        "nome": "Prudentópolis",
        "latitude": -25.1307,
        "longitude": -51.0978,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120655,
        "nome": "Quarto Centenário",
        "latitude": -24.303,
        "longitude": -53.1556,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120705,
        "nome": "Quatiguá",
        "latitude": -23.5621,
        "longitude": -49.9319,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120804,
        "nome": "Quatro Barras",
        "latitude": -25.3687,
        "longitude": -48.9944,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120853,
        "nome": "Quatro Pontes",
        "latitude": -24.5717,
        "longitude": -53.9765,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4120903,
        "nome": "Quedas do Iguaçu",
        "latitude": -25.4574,
        "longitude": -52.955,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4121000,
        "nome": "Querência do Norte",
        "latitude": -23.0424,
        "longitude": -53.5215,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4121109,
        "nome": "Quinta do Sol",
        "latitude": -23.8297,
        "longitude": -52.1404,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4121208,
        "nome": "Quitandinha",
        "latitude": -25.9105,
        "longitude": -49.4815,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4121257,
        "nome": "Ramilândia",
        "latitude": -25.0944,
        "longitude": -54.0761,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4121307,
        "nome": "Rancho Alegre",
        "latitude": -23.08,
        "longitude": -50.9194,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4121356,
        "nome": "Rancho Alegre D'Oeste",
        "latitude": -24.2912,
        "longitude": -52.962,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4121406,
        "nome": "Realeza",
        "latitude": -25.6744,
        "longitude": -53.5435,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4121505,
        "nome": "Rebouças",
        "latitude": -25.6585,
        "longitude": -50.6209,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4121604,
        "nome": "Renascença",
        "latitude": -26.2251,
        "longitude": -52.9509,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4121703,
        "nome": "Reserva",
        "latitude": -24.5955,
        "longitude": -50.9565,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4121752,
        "nome": "Reserva do Iguaçu",
        "latitude": -25.8678,
        "longitude": -51.9637,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4121802,
        "nome": "Ribeirão Claro",
        "latitude": -23.2617,
        "longitude": -49.7628,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4121901,
        "nome": "Ribeirão do Pinhal",
        "latitude": -23.4483,
        "longitude": -50.3743,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4122008,
        "nome": "Rio Azul",
        "latitude": -25.7209,
        "longitude": -50.7926,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4122107,
        "nome": "Rio Bom",
        "latitude": -23.7974,
        "longitude": -51.4334,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4122156,
        "nome": "Rio Bonito do Iguaçu",
        "latitude": -25.5466,
        "longitude": -52.6085,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4122172,
        "nome": "Rio Branco do Ivaí",
        "latitude": -24.346,
        "longitude": -51.3367,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4122206,
        "nome": "Rio Branco do Sul",
        "latitude": -25.0765,
        "longitude": -49.3472,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4122305,
        "nome": "Rio Negro",
        "latitude": -26.0948,
        "longitude": -49.6835,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4122404,
        "nome": "Rolândia",
        "latitude": -23.2713,
        "longitude": -51.4092,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4122503,
        "nome": "Roncador",
        "latitude": -24.5659,
        "longitude": -52.2613,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4122602,
        "nome": "Rondon",
        "latitude": -23.4777,
        "longitude": -52.8045,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4122651,
        "nome": "Rosário do Ivaí",
        "latitude": -24.3163,
        "longitude": -51.2031,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4122701,
        "nome": "Sabáudia",
        "latitude": -23.3487,
        "longitude": -51.5845,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4122800,
        "nome": "Salgado Filho",
        "latitude": -26.1382,
        "longitude": -53.4183,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4122909,
        "nome": "Salto do Itararé",
        "latitude": -23.6308,
        "longitude": -49.683,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4123006,
        "nome": "Salto do Lontra",
        "latitude": -25.7754,
        "longitude": -53.2871,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4123105,
        "nome": "Santa Amélia",
        "latitude": -23.2591,
        "longitude": -50.4101,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4123204,
        "nome": "Santa Cecília do Pavão",
        "latitude": -23.543,
        "longitude": -50.7994,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4123303,
        "nome": "Santa Cruz de Monte Castelo",
        "latitude": -23.0849,
        "longitude": -53.3629,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4123402,
        "nome": "Santa Fé",
        "latitude": -23.0631,
        "longitude": -51.8388,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4123501,
        "nome": "Santa Helena",
        "latitude": -24.8889,
        "longitude": -54.3056,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4123600,
        "nome": "Santa Inês",
        "latitude": -22.713,
        "longitude": -51.8978,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4123709,
        "nome": "Santa Isabel do Ivaí",
        "latitude": -23.1145,
        "longitude": -53.2407,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4123808,
        "nome": "Santa Izabel do Oeste",
        "latitude": -25.7836,
        "longitude": -53.423,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4123824,
        "nome": "Santa Lúcia",
        "latitude": -25.3831,
        "longitude": -53.553,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4123857,
        "nome": "Santa Maria do Oeste",
        "latitude": -24.9128,
        "longitude": -51.9286,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4123907,
        "nome": "Santa Mariana",
        "latitude": -23.0606,
        "longitude": -50.5388,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4123956,
        "nome": "Santa Mônica",
        "latitude": -23.1544,
        "longitude": -53.1092,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4124004,
        "nome": "Santana do Itararé",
        "latitude": -23.7508,
        "longitude": -49.6324,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4124020,
        "nome": "Santa Tereza do Oeste",
        "latitude": -25.0366,
        "longitude": -53.606,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4124053,
        "nome": "Santa Terezinha de Itaipu",
        "latitude": -25.4539,
        "longitude": -54.4296,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4124103,
        "nome": "Santo Antônio da Platina",
        "latitude": -23.2967,
        "longitude": -50.0856,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4124202,
        "nome": "Santo Antônio do Caiuá",
        "latitude": -22.699,
        "longitude": -52.3561,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4124301,
        "nome": "Santo Antônio do Paraíso",
        "latitude": -23.5803,
        "longitude": -50.6306,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4124400,
        "nome": "Santo Antônio do Sudoeste",
        "latitude": -26.0666,
        "longitude": -53.6332,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4124509,
        "nome": "Santo Inácio",
        "latitude": -22.7187,
        "longitude": -51.802,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4124608,
        "nome": "São Carlos do Ivaí",
        "latitude": -23.3422,
        "longitude": -52.4805,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4124707,
        "nome": "São Jerônimo da Serra",
        "latitude": -23.7162,
        "longitude": -50.7784,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4124806,
        "nome": "São João",
        "latitude": -25.774,
        "longitude": -52.7931,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4124905,
        "nome": "São João do Caiuá",
        "latitude": -22.8382,
        "longitude": -52.3307,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125001,
        "nome": "São João do Ivaí",
        "latitude": -23.9926,
        "longitude": -51.8481,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125100,
        "nome": "São João do Triunfo",
        "latitude": -25.67,
        "longitude": -50.2867,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125209,
        "nome": "São Jorge d'Oeste",
        "latitude": -25.6559,
        "longitude": -52.9401,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125308,
        "nome": "São Jorge do Ivaí",
        "latitude": -23.435,
        "longitude": -52.3169,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125357,
        "nome": "São Jorge do Patrocínio",
        "latitude": -23.7389,
        "longitude": -53.947,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125407,
        "nome": "São José da Boa Vista",
        "latitude": -23.9587,
        "longitude": -49.6712,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125456,
        "nome": "São José das Palmeiras",
        "latitude": -24.8155,
        "longitude": -54.1196,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125506,
        "nome": "São José dos Pinhais",
        "latitude": -25.6645,
        "longitude": -49.0949,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125555,
        "nome": "São Manoel do Paraná",
        "latitude": -23.3723,
        "longitude": -52.6124,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125605,
        "nome": "São Mateus do Sul",
        "latitude": -25.9082,
        "longitude": -50.442,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125704,
        "nome": "São Miguel do Iguaçu",
        "latitude": -25.3875,
        "longitude": -54.262,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125753,
        "nome": "São Pedro do Iguaçu",
        "latitude": -24.9065,
        "longitude": -53.8907,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125803,
        "nome": "São Pedro do Ivaí",
        "latitude": -23.8455,
        "longitude": -51.8718,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4125902,
        "nome": "São Pedro do Paraná",
        "latitude": -22.785,
        "longitude": -53.1813,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126009,
        "nome": "São Sebastião da Amoreira",
        "latitude": -23.4548,
        "longitude": -50.7227,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126108,
        "nome": "São Tomé",
        "latitude": -23.5245,
        "longitude": -52.5388,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126207,
        "nome": "Sapopema",
        "latitude": -23.8752,
        "longitude": -50.6046,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126256,
        "nome": "Sarandi",
        "latitude": -23.4682,
        "longitude": -51.8671,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126272,
        "nome": "Saudade do Iguaçu",
        "latitude": -25.7132,
        "longitude": -52.6044,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126306,
        "nome": "Sengés",
        "latitude": -24.2495,
        "longitude": -49.456,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126355,
        "nome": "Serranópolis do Iguaçu",
        "latitude": -25.477,
        "longitude": -54.0276,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126405,
        "nome": "Sertaneja",
        "latitude": -22.9342,
        "longitude": -50.875,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126504,
        "nome": "Sertanópolis",
        "latitude": -23.0573,
        "longitude": -51.072,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126603,
        "nome": "Siqueira Campos",
        "latitude": -23.6392,
        "longitude": -49.7929,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126652,
        "nome": "Sulina",
        "latitude": -25.6934,
        "longitude": -52.7185,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126678,
        "nome": "Tamarana",
        "latitude": -23.8222,
        "longitude": -51.052,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126702,
        "nome": "Tamboara",
        "latitude": -23.1985,
        "longitude": -52.4838,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126801,
        "nome": "Tapejara",
        "latitude": -23.6585,
        "longitude": -52.8903,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4126900,
        "nome": "Tapira",
        "latitude": -23.3291,
        "longitude": -53.1341,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127007,
        "nome": "Teixeira Soares",
        "latitude": -25.3134,
        "longitude": -50.4085,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127106,
        "nome": "Telêmaco Borba",
        "latitude": -24.25,
        "longitude": -50.5225,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127205,
        "nome": "Terra Boa",
        "latitude": -23.6967,
        "longitude": -52.3881,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127304,
        "nome": "Terra Rica",
        "latitude": -22.7294,
        "longitude": -52.6817,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127403,
        "nome": "Terra Roxa",
        "latitude": -24.2087,
        "longitude": -54.0628,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127502,
        "nome": "Tibagi",
        "latitude": -24.6575,
        "longitude": -50.4687,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127601,
        "nome": "Tijucas do Sul",
        "latitude": -25.9015,
        "longitude": -49.1122,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127700,
        "nome": "Toledo",
        "latitude": -24.7049,
        "longitude": -53.7779,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127809,
        "nome": "Tomazina",
        "latitude": -23.7254,
        "longitude": -49.9627,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127858,
        "nome": "Três Barras do Paraná",
        "latitude": -25.4387,
        "longitude": -53.2248,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127882,
        "nome": "Tunas do Paraná",
        "latitude": -24.9526,
        "longitude": -48.9026,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127908,
        "nome": "Tuneiras do Oeste",
        "latitude": -23.8792,
        "longitude": -52.8435,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127957,
        "nome": "Tupãssi",
        "latitude": -24.646,
        "longitude": -53.5093,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4127965,
        "nome": "Turvo",
        "latitude": -25.012,
        "longitude": -51.4804,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128005,
        "nome": "Ubiratã",
        "latitude": -24.5049,
        "longitude": -53.0217,
        "mesorregiaoNome": "Centro Ocidental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128104,
        "nome": "Umuarama",
        "latitude": -23.6798,
        "longitude": -53.4141,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128203,
        "nome": "União da Vitória",
        "latitude": -26.1094,
        "longitude": -51.0749,
        "mesorregiaoNome": "Sudeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128302,
        "nome": "Uniflor",
        "latitude": -23.067,
        "longitude": -52.1091,
        "mesorregiaoNome": "Norte Central Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128401,
        "nome": "Uraí",
        "latitude": -23.2163,
        "longitude": -50.8299,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128500,
        "nome": "Wenceslau Braz",
        "latitude": -23.8551,
        "longitude": -49.7845,
        "mesorregiaoNome": "Norte Pioneiro Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128534,
        "nome": "Ventania",
        "latitude": -24.1899,
        "longitude": -50.2399,
        "mesorregiaoNome": "Centro Oriental Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128559,
        "nome": "Vera Cruz do Oeste",
        "latitude": -25.0073,
        "longitude": -53.9204,
        "mesorregiaoNome": "Oeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128609,
        "nome": "Verê",
        "latitude": -25.8751,
        "longitude": -52.9584,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128625,
        "nome": "Alto Paraíso",
        "latitude": -23.5388,
        "longitude": -53.8246,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128633,
        "nome": "Doutor Ulysses",
        "latitude": -24.6264,
        "longitude": -49.393,
        "mesorregiaoNome": "Metropolitana de Curitiba",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128658,
        "nome": "Virmond",
        "latitude": -25.4067,
        "longitude": -52.2368,
        "mesorregiaoNome": "Centro-Sul Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128708,
        "nome": "Vitorino",
        "latitude": -26.2812,
        "longitude": -52.8078,
        "mesorregiaoNome": "Sudoeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4128807,
        "nome": "Xambrê",
        "latitude": -23.7357,
        "longitude": -53.592,
        "mesorregiaoNome": "Noroeste Paranaense",
        "UFSigla": "PR",
        "UFNome": "Paraná"
    },
    {
        "ibgeId": 4200051,
        "nome": "Abdon Batista",
        "latitude": -27.5838,
        "longitude": -51.0563,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4200101,
        "nome": "Abelardo Luz",
        "latitude": -26.5624,
        "longitude": -52.2557,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4200200,
        "nome": "Agrolândia",
        "latitude": -27.4551,
        "longitude": -49.8248,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4200309,
        "nome": "Agronômica",
        "latitude": -27.3276,
        "longitude": -49.7207,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4200408,
        "nome": "Água Doce",
        "latitude": -26.7656,
        "longitude": -51.6118,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4200507,
        "nome": "Águas de Chapecó",
        "latitude": -27.0544,
        "longitude": -52.9567,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4200556,
        "nome": "Águas Frias",
        "latitude": -26.8516,
        "longitude": -52.8523,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4200606,
        "nome": "Águas Mornas",
        "latitude": -27.7335,
        "longitude": -48.936,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4200705,
        "nome": "Alfredo Wagner",
        "latitude": -27.7059,
        "longitude": -49.3308,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4200754,
        "nome": "Alto Bela Vista",
        "latitude": -27.4215,
        "longitude": -51.9259,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4200804,
        "nome": "Anchieta",
        "latitude": -26.5329,
        "longitude": -53.3331,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4200903,
        "nome": "Angelina",
        "latitude": -27.543,
        "longitude": -49.0672,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201000,
        "nome": "Anita Garibaldi",
        "latitude": -27.7303,
        "longitude": -51.0796,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201109,
        "nome": "Anitápolis",
        "latitude": -27.8798,
        "longitude": -49.1388,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201208,
        "nome": "Antônio Carlos",
        "latitude": -27.4975,
        "longitude": -48.831,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201257,
        "nome": "Apiúna",
        "latitude": -27.1245,
        "longitude": -49.3642,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201273,
        "nome": "Arabutã",
        "latitude": -27.1409,
        "longitude": -52.1816,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201307,
        "nome": "Araquari",
        "latitude": -26.4617,
        "longitude": -48.7578,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201406,
        "nome": "Araranguá",
        "latitude": -28.9423,
        "longitude": -49.4712,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201505,
        "nome": "Armazém",
        "latitude": -28.2379,
        "longitude": -49.0147,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201604,
        "nome": "Arroio Trinta",
        "latitude": -26.9215,
        "longitude": -51.3367,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201653,
        "nome": "Arvoredo",
        "latitude": -27.0709,
        "longitude": -52.442,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201703,
        "nome": "Ascurra",
        "latitude": -26.9736,
        "longitude": -49.396,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201802,
        "nome": "Atalanta",
        "latitude": -27.4373,
        "longitude": -49.7426,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201901,
        "nome": "Aurora",
        "latitude": -27.3296,
        "longitude": -49.5903,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4201950,
        "nome": "Balneário Arroio do Silva",
        "latitude": -29.0196,
        "longitude": -49.4752,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202008,
        "nome": "Balneário Camboriú",
        "latitude": -27.0047,
        "longitude": -48.6217,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202057,
        "nome": "Balneário Barra do Sul",
        "latitude": -26.4464,
        "longitude": -48.6529,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202073,
        "nome": "Balneário Gaivota",
        "latitude": -29.1535,
        "longitude": -49.6154,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202081,
        "nome": "Bandeirante",
        "latitude": -26.7686,
        "longitude": -53.6482,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202099,
        "nome": "Barra Bonita",
        "latitude": -26.6685,
        "longitude": -53.4251,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202107,
        "nome": "Barra Velha",
        "latitude": -26.6624,
        "longitude": -48.7274,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202131,
        "nome": "Bela Vista do Toldo",
        "latitude": -26.4181,
        "longitude": -50.4868,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202156,
        "nome": "Belmonte",
        "latitude": -26.8571,
        "longitude": -53.6181,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202206,
        "nome": "Benedito Novo",
        "latitude": -26.8009,
        "longitude": -49.4354,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202305,
        "nome": "Biguaçu",
        "latitude": -27.4335,
        "longitude": -48.6939,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202404,
        "nome": "Blumenau",
        "latitude": -26.8858,
        "longitude": -49.0973,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202438,
        "nome": "Bocaina do Sul",
        "latitude": -27.7631,
        "longitude": -49.9092,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202453,
        "nome": "Bombinhas",
        "latitude": -27.1727,
        "longitude": -48.52,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202503,
        "nome": "Bom Jardim da Serra",
        "latitude": -28.361,
        "longitude": -49.6525,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202537,
        "nome": "Bom Jesus",
        "latitude": -26.739,
        "longitude": -52.39,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202578,
        "nome": "Bom Jesus do Oeste",
        "latitude": -26.684,
        "longitude": -53.0953,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202602,
        "nome": "Bom Retiro",
        "latitude": -27.7854,
        "longitude": -49.563,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202701,
        "nome": "Botuverá",
        "latitude": -27.2186,
        "longitude": -49.1235,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202800,
        "nome": "Braço do Norte",
        "latitude": -28.2409,
        "longitude": -49.1424,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202859,
        "nome": "Braço do Trombudo",
        "latitude": -27.3686,
        "longitude": -49.9036,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202875,
        "nome": "Brunópolis",
        "latitude": -27.347,
        "longitude": -50.845,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4202909,
        "nome": "Brusque",
        "latitude": -27.125,
        "longitude": -48.9097,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4203006,
        "nome": "Caçador",
        "latitude": -26.763,
        "longitude": -51.0847,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4203105,
        "nome": "Caibi",
        "latitude": -27.0252,
        "longitude": -53.2631,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4203154,
        "nome": "Calmon",
        "latitude": -26.6222,
        "longitude": -51.0069,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4203204,
        "nome": "Camboriú",
        "latitude": -27.0709,
        "longitude": -48.709,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4203253,
        "nome": "Capão Alto",
        "latitude": -28.0622,
        "longitude": -50.6069,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4203303,
        "nome": "Campo Alegre",
        "latitude": -26.1208,
        "longitude": -49.2176,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4203402,
        "nome": "Campo Belo do Sul",
        "latitude": -27.847,
        "longitude": -50.7711,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4203501,
        "nome": "Campo Erê",
        "latitude": -26.4504,
        "longitude": -53.1303,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4203600,
        "nome": "Campos Novos",
        "latitude": -27.413,
        "longitude": -51.2446,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4203709,
        "nome": "Canelinha",
        "latitude": -27.2346,
        "longitude": -48.8024,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4203808,
        "nome": "Canoinhas",
        "latitude": -26.25,
        "longitude": -50.5334,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4203907,
        "nome": "Capinzal",
        "latitude": -27.4119,
        "longitude": -51.6307,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4203956,
        "nome": "Capivari de Baixo",
        "latitude": -28.4556,
        "longitude": -48.9434,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204004,
        "nome": "Catanduvas",
        "latitude": -27.045,
        "longitude": -51.6964,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204103,
        "nome": "Caxambu do Sul",
        "latitude": -27.1467,
        "longitude": -52.9202,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204152,
        "nome": "Celso Ramos",
        "latitude": -27.652,
        "longitude": -51.3082,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204178,
        "nome": "Cerro Negro",
        "latitude": -27.7764,
        "longitude": -50.9319,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204194,
        "nome": "Chapadão do Lageado",
        "latitude": -27.5827,
        "longitude": -49.5564,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204202,
        "nome": "Chapecó",
        "latitude": -27.1252,
        "longitude": -52.6504,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204251,
        "nome": "Cocal do Sul",
        "latitude": -28.5987,
        "longitude": -49.3339,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204301,
        "nome": "Concórdia",
        "latitude": -27.2391,
        "longitude": -52.0074,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204350,
        "nome": "Cordilheira Alta",
        "latitude": -26.9754,
        "longitude": -52.6416,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204400,
        "nome": "Coronel Freitas",
        "latitude": -26.8829,
        "longitude": -52.7255,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204459,
        "nome": "Coronel Martins",
        "latitude": -26.5346,
        "longitude": -52.6719,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204509,
        "nome": "Corupá",
        "latitude": -26.4399,
        "longitude": -49.3267,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204558,
        "nome": "Correia Pinto",
        "latitude": -27.5968,
        "longitude": -50.3781,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204608,
        "nome": "Criciúma",
        "latitude": -28.7157,
        "longitude": -49.3797,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204707,
        "nome": "Cunha Porã",
        "latitude": -26.8792,
        "longitude": -53.1907,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204756,
        "nome": "Cunhataí",
        "latitude": -26.9751,
        "longitude": -53.1009,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204806,
        "nome": "Curitibanos",
        "latitude": -27.2929,
        "longitude": -50.6175,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4204905,
        "nome": "Descanso",
        "latitude": -26.8584,
        "longitude": -53.4793,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205001,
        "nome": "Dionísio Cerqueira",
        "latitude": -26.3298,
        "longitude": -53.5331,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205100,
        "nome": "Dona Emma",
        "latitude": -26.9887,
        "longitude": -49.7781,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205159,
        "nome": "Doutor Pedrinho",
        "latitude": -26.7056,
        "longitude": -49.5538,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205175,
        "nome": "Entre Rios",
        "latitude": -26.7397,
        "longitude": -52.5784,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205191,
        "nome": "Ermo",
        "latitude": -28.9903,
        "longitude": -49.6529,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205209,
        "nome": "Erval Velho",
        "latitude": -27.2844,
        "longitude": -51.4219,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205308,
        "nome": "Faxinal dos Guedes",
        "latitude": -26.8467,
        "longitude": -52.2443,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205357,
        "nome": "Flor do Sertão",
        "latitude": -26.7638,
        "longitude": -53.3373,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205407,
        "nome": "Florianópolis",
        "latitude": -27.5788,
        "longitude": -48.5091,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205431,
        "nome": "Formosa do Sul",
        "latitude": -26.6342,
        "longitude": -52.7938,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205456,
        "nome": "Forquilhinha",
        "latitude": -28.7817,
        "longitude": -49.4933,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205506,
        "nome": "Fraiburgo",
        "latitude": -27.0378,
        "longitude": -50.8724,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205555,
        "nome": "Frei Rogério",
        "latitude": -27.1917,
        "longitude": -50.7656,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205605,
        "nome": "Galvão",
        "latitude": -26.4494,
        "longitude": -52.659,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205704,
        "nome": "Garopaba",
        "latitude": -28.0467,
        "longitude": -48.6589,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205803,
        "nome": "Garuva",
        "latitude": -26.0571,
        "longitude": -48.8673,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4205902,
        "nome": "Gaspar",
        "latitude": -26.9313,
        "longitude": -48.966,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4206009,
        "nome": "Governador Celso Ramos",
        "latitude": -27.3767,
        "longitude": -48.5773,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4206108,
        "nome": "Grão-Pará",
        "latitude": -28.155,
        "longitude": -49.314,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4206207,
        "nome": "Gravatal",
        "latitude": -28.354,
        "longitude": -49.0195,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4206306,
        "nome": "Guabiruba",
        "latitude": -27.1033,
        "longitude": -49.0208,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4206405,
        "nome": "Guaraciaba",
        "latitude": -26.5801,
        "longitude": -53.5711,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4206504,
        "nome": "Guaramirim",
        "latitude": -26.4766,
        "longitude": -48.9449,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4206603,
        "nome": "Guarujá do Sul",
        "latitude": -26.3983,
        "longitude": -53.484,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4206652,
        "nome": "Guatambú",
        "latitude": -27.1165,
        "longitude": -52.7834,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4206702,
        "nome": "Herval d'Oeste",
        "latitude": -27.1954,
        "longitude": -51.4107,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4206751,
        "nome": "Ibiam",
        "latitude": -27.2084,
        "longitude": -51.2155,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4206801,
        "nome": "Ibicaré",
        "latitude": -27.0926,
        "longitude": -51.3699,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4206900,
        "nome": "Ibirama",
        "latitude": -27.0182,
        "longitude": -49.5285,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207007,
        "nome": "Içara",
        "latitude": -28.7517,
        "longitude": -49.2774,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207106,
        "nome": "Ilhota",
        "latitude": -26.859,
        "longitude": -48.8574,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207205,
        "nome": "Imaruí",
        "latitude": -28.2315,
        "longitude": -48.8344,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207304,
        "nome": "Imbituba",
        "latitude": -28.1942,
        "longitude": -48.7028,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207403,
        "nome": "Imbuia",
        "latitude": -27.5029,
        "longitude": -49.4065,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207502,
        "nome": "Indaial",
        "latitude": -26.995,
        "longitude": -49.2242,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207577,
        "nome": "Iomerê",
        "latitude": -26.9877,
        "longitude": -51.2755,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207601,
        "nome": "Ipira",
        "latitude": -27.3707,
        "longitude": -51.7988,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207650,
        "nome": "Iporã do Oeste",
        "latitude": -27.0005,
        "longitude": -53.4894,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207684,
        "nome": "Ipuaçu",
        "latitude": -26.6787,
        "longitude": -52.476,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207700,
        "nome": "Ipumirim",
        "latitude": -27.0404,
        "longitude": -52.1529,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207759,
        "nome": "Iraceminha",
        "latitude": -26.8453,
        "longitude": -53.3245,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207809,
        "nome": "Irani",
        "latitude": -27.0252,
        "longitude": -51.9179,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207858,
        "nome": "Irati",
        "latitude": -26.6276,
        "longitude": -52.8901,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4207908,
        "nome": "Irineópolis",
        "latitude": -26.3571,
        "longitude": -50.7607,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4208005,
        "nome": "Itá",
        "latitude": -27.244,
        "longitude": -52.3322,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4208104,
        "nome": "Itaiópolis",
        "latitude": -26.4721,
        "longitude": -49.8912,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4208203,
        "nome": "Itajaí",
        "latitude": -26.969,
        "longitude": -48.7534,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4208302,
        "nome": "Itapema",
        "latitude": -27.1086,
        "longitude": -48.6344,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4208401,
        "nome": "Itapiranga",
        "latitude": -27.1122,
        "longitude": -53.7117,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4208450,
        "nome": "Itapoá",
        "latitude": -26.0825,
        "longitude": -48.6524,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4208500,
        "nome": "Ituporanga",
        "latitude": -27.4534,
        "longitude": -49.5389,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4208609,
        "nome": "Jaborá",
        "latitude": -27.1415,
        "longitude": -51.7727,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4208708,
        "nome": "Jacinto Machado",
        "latitude": -28.9948,
        "longitude": -49.8481,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4208807,
        "nome": "Jaguaruna",
        "latitude": -28.6579,
        "longitude": -49.0447,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4208906,
        "nome": "Jaraguá do Sul",
        "latitude": -26.4819,
        "longitude": -49.16,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4208955,
        "nome": "Jardinópolis",
        "latitude": -26.7172,
        "longitude": -52.8713,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209003,
        "nome": "Joaçaba",
        "latitude": -27.1518,
        "longitude": -51.5929,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209102,
        "nome": "Joinville",
        "latitude": -26.2443,
        "longitude": -48.9514,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209151,
        "nome": "José Boiteux",
        "latitude": -26.8595,
        "longitude": -49.6463,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209177,
        "nome": "Jupiá",
        "latitude": -26.3941,
        "longitude": -52.7209,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209201,
        "nome": "Lacerdópolis",
        "latitude": -27.2509,
        "longitude": -51.5903,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209300,
        "nome": "Lages",
        "latitude": -28.0205,
        "longitude": -50.3406,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209409,
        "nome": "Laguna",
        "latitude": -28.4864,
        "longitude": -48.826,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209458,
        "nome": "Lajeado Grande",
        "latitude": -26.8549,
        "longitude": -52.5521,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209508,
        "nome": "Laurentino",
        "latitude": -27.208,
        "longitude": -49.7336,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209607,
        "nome": "Lauro Müller",
        "latitude": -28.3846,
        "longitude": -49.4519,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209706,
        "nome": "Lebon Régis",
        "latitude": -26.8584,
        "longitude": -50.7026,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209805,
        "nome": "Leoberto Leal",
        "latitude": -27.4721,
        "longitude": -49.2572,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209854,
        "nome": "Lindóia do Sul",
        "latitude": -27.0315,
        "longitude": -52.0525,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4209904,
        "nome": "Lontras",
        "latitude": -27.1894,
        "longitude": -49.5073,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210001,
        "nome": "Luiz Alves",
        "latitude": -26.7274,
        "longitude": -48.8911,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210035,
        "nome": "Luzerna",
        "latitude": -27.0904,
        "longitude": -51.5056,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210050,
        "nome": "Macieira",
        "latitude": -26.8035,
        "longitude": -51.3531,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210100,
        "nome": "Mafra",
        "latitude": -26.2008,
        "longitude": -49.8896,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210209,
        "nome": "Major Gercino",
        "latitude": -27.4279,
        "longitude": -49.0526,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210308,
        "nome": "Major Vieira",
        "latitude": -26.4812,
        "longitude": -50.3616,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210407,
        "nome": "Maracajá",
        "latitude": -28.864,
        "longitude": -49.4555,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210506,
        "nome": "Maravilha",
        "latitude": -26.76,
        "longitude": -53.1981,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210555,
        "nome": "Marema",
        "latitude": -26.8124,
        "longitude": -52.6301,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210605,
        "nome": "Massaranduba",
        "latitude": -26.6269,
        "longitude": -48.9882,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210704,
        "nome": "Matos Costa",
        "latitude": -26.4813,
        "longitude": -51.1418,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210803,
        "nome": "Meleiro",
        "latitude": -28.8418,
        "longitude": -49.6018,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210852,
        "nome": "Mirim Doce",
        "latitude": -27.1856,
        "longitude": -50.1751,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4210902,
        "nome": "Modelo",
        "latitude": -26.7748,
        "longitude": -53.0511,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211009,
        "nome": "Mondaí",
        "latitude": -27.0993,
        "longitude": -53.4465,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211058,
        "nome": "Monte Carlo",
        "latitude": -27.1937,
        "longitude": -50.9275,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211108,
        "nome": "Monte Castelo",
        "latitude": -26.6607,
        "longitude": -50.2915,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211207,
        "nome": "Morro da Fumaça",
        "latitude": -28.6377,
        "longitude": -49.243,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211256,
        "nome": "Morro Grande",
        "latitude": -28.7221,
        "longitude": -49.7405,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211306,
        "nome": "Navegantes",
        "latitude": -26.8287,
        "longitude": -48.7274,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211405,
        "nome": "Nova Erechim",
        "latitude": -26.9082,
        "longitude": -52.9067,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211454,
        "nome": "Nova Itaberaba",
        "latitude": -26.9611,
        "longitude": -52.8333,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211504,
        "nome": "Nova Trento",
        "latitude": -27.3133,
        "longitude": -49.0414,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211603,
        "nome": "Nova Veneza",
        "latitude": -28.6847,
        "longitude": -49.5849,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211652,
        "nome": "Novo Horizonte",
        "latitude": -26.495,
        "longitude": -52.7964,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211702,
        "nome": "Orleans",
        "latitude": -28.2799,
        "longitude": -49.3719,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211751,
        "nome": "Otacílio Costa",
        "latitude": -27.5172,
        "longitude": -49.9716,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211801,
        "nome": "Ouro",
        "latitude": -27.2834,
        "longitude": -51.6819,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211850,
        "nome": "Ouro Verde",
        "latitude": -26.7115,
        "longitude": -52.2788,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211876,
        "nome": "Paial",
        "latitude": -27.213,
        "longitude": -52.4879,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211892,
        "nome": "Painel",
        "latitude": -27.9636,
        "longitude": -50.0721,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4211900,
        "nome": "Palhoça",
        "latitude": -27.7718,
        "longitude": -48.6617,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212007,
        "nome": "Palma Sola",
        "latitude": -26.3735,
        "longitude": -53.3145,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212056,
        "nome": "Palmeira",
        "latitude": -27.5626,
        "longitude": -50.1616,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212106,
        "nome": "Palmitos",
        "latitude": -27.0926,
        "longitude": -53.1798,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212205,
        "nome": "Papanduva",
        "latitude": -26.5024,
        "longitude": -50.1724,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212239,
        "nome": "Paraíso",
        "latitude": -26.6628,
        "longitude": -53.6783,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212254,
        "nome": "Passo de Torres",
        "latitude": -29.2672,
        "longitude": -49.7219,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212270,
        "nome": "Passos Maia",
        "latitude": -26.7061,
        "longitude": -51.9611,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212304,
        "nome": "Paulo Lopes",
        "latitude": -27.9649,
        "longitude": -48.7603,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212403,
        "nome": "Pedras Grandes",
        "latitude": -28.4794,
        "longitude": -49.2045,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212502,
        "nome": "Penha",
        "latitude": -26.8079,
        "longitude": -48.6508,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212601,
        "nome": "Peritiba",
        "latitude": -27.3514,
        "longitude": -51.8754,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212650,
        "nome": "Pescaria Brava",
        "latitude": -28.4018,
        "longitude": -48.8836,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212700,
        "nome": "Petrolândia",
        "latitude": -27.5457,
        "longitude": -49.6827,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212809,
        "nome": "Balneário Piçarras",
        "latitude": -26.7595,
        "longitude": -48.7333,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4212908,
        "nome": "Pinhalzinho",
        "latitude": -26.8294,
        "longitude": -52.9766,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4213005,
        "nome": "Pinheiro Preto",
        "latitude": -27.0494,
        "longitude": -51.2361,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4213104,
        "nome": "Piratuba",
        "latitude": -27.4612,
        "longitude": -51.7728,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4213153,
        "nome": "Planalto Alegre",
        "latitude": -27.052,
        "longitude": -52.869,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4213203,
        "nome": "Pomerode",
        "latitude": -26.7282,
        "longitude": -49.1733,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4213302,
        "nome": "Ponte Alta",
        "latitude": -27.4102,
        "longitude": -50.2987,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4213351,
        "nome": "Ponte Alta do Norte",
        "latitude": -27.1803,
        "longitude": -50.4186,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4213401,
        "nome": "Ponte Serrada",
        "latitude": -26.8618,
        "longitude": -51.9282,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4213500,
        "nome": "Porto Belo",
        "latitude": -27.1749,
        "longitude": -48.6167,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4213609,
        "nome": "Porto União",
        "latitude": -26.3836,
        "longitude": -51.0078,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4213708,
        "nome": "Pouso Redondo",
        "latitude": -27.2862,
        "longitude": -49.9773,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4213807,
        "nome": "Praia Grande",
        "latitude": -29.1819,
        "longitude": -49.9895,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4213906,
        "nome": "Presidente Castello Branco",
        "latitude": -27.2333,
        "longitude": -51.7809,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4214003,
        "nome": "Presidente Getúlio",
        "latitude": -27.0626,
        "longitude": -49.7144,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4214102,
        "nome": "Presidente Nereu",
        "latitude": -27.2683,
        "longitude": -49.355,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4214151,
        "nome": "Princesa",
        "latitude": -26.4329,
        "longitude": -53.6118,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4214201,
        "nome": "Quilombo",
        "latitude": -26.7292,
        "longitude": -52.718,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4214300,
        "nome": "Rancho Queimado",
        "latitude": -27.6739,
        "longitude": -49.0899,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4214409,
        "nome": "Rio das Antas",
        "latitude": -26.9091,
        "longitude": -51.0634,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4214508,
        "nome": "Rio do Campo",
        "latitude": -26.8923,
        "longitude": -50.1314,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4214607,
        "nome": "Rio do Oeste",
        "latitude": -27.159,
        "longitude": -49.8417,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4214706,
        "nome": "Rio dos Cedros",
        "latitude": -26.6179,
        "longitude": -49.3684,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4214805,
        "nome": "Rio do Sul",
        "latitude": -27.1961,
        "longitude": -49.63,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4214904,
        "nome": "Rio Fortuna",
        "latitude": -28.0934,
        "longitude": -49.1906,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215000,
        "nome": "Rio Negrinho",
        "latitude": -26.4427,
        "longitude": -49.5962,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215059,
        "nome": "Rio Rufino",
        "latitude": -27.9142,
        "longitude": -49.7534,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215075,
        "nome": "Riqueza",
        "latitude": -26.9785,
        "longitude": -53.3444,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215109,
        "nome": "Rodeio",
        "latitude": -26.8951,
        "longitude": -49.351,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215208,
        "nome": "Romelândia",
        "latitude": -26.6484,
        "longitude": -53.3171,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215307,
        "nome": "Salete",
        "latitude": -26.9696,
        "longitude": -50.0107,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215356,
        "nome": "Saltinho",
        "latitude": -26.5905,
        "longitude": -53.0223,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215406,
        "nome": "Salto Veloso",
        "latitude": -26.8957,
        "longitude": -51.4282,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215455,
        "nome": "Sangão",
        "latitude": -28.6513,
        "longitude": -49.1258,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215505,
        "nome": "Santa Cecília",
        "latitude": -26.926,
        "longitude": -50.4462,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215554,
        "nome": "Santa Helena",
        "latitude": -26.922,
        "longitude": -53.6197,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215604,
        "nome": "Santa Rosa de Lima",
        "latitude": -28.0119,
        "longitude": -49.1819,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215653,
        "nome": "Santa Rosa do Sul",
        "latitude": -29.1215,
        "longitude": -49.7438,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215679,
        "nome": "Santa Terezinha",
        "latitude": -26.6676,
        "longitude": -50.0053,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215687,
        "nome": "Santa Terezinha do Progresso",
        "latitude": -26.5927,
        "longitude": -53.1699,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215695,
        "nome": "Santiago do Sul",
        "latitude": -26.6309,
        "longitude": -52.6973,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215703,
        "nome": "Santo Amaro da Imperatriz",
        "latitude": -27.7418,
        "longitude": -48.7966,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215752,
        "nome": "São Bernardino",
        "latitude": -26.4877,
        "longitude": -52.9876,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215802,
        "nome": "São Bento do Sul",
        "latitude": -26.295,
        "longitude": -49.3501,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4215901,
        "nome": "São Bonifácio",
        "latitude": -27.9566,
        "longitude": -48.9391,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4216008,
        "nome": "São Carlos",
        "latitude": -27.0301,
        "longitude": -53.0314,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4216057,
        "nome": "São Cristóvão do Sul",
        "latitude": -27.2952,
        "longitude": -50.3495,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4216107,
        "nome": "São Domingos",
        "latitude": -26.5394,
        "longitude": -52.5546,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4216206,
        "nome": "São Francisco do Sul",
        "latitude": -26.2616,
        "longitude": -48.6405,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4216255,
        "nome": "São João do Oeste",
        "latitude": -27.0916,
        "longitude": -53.5917,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4216305,
        "nome": "São João Batista",
        "latitude": -27.3289,
        "longitude": -48.859,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4216354,
        "nome": "São João do Itaperiú",
        "latitude": -26.5911,
        "longitude": -48.7977,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4216404,
        "nome": "São João do Sul",
        "latitude": -29.2056,
        "longitude": -49.8135,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4216503,
        "nome": "São Joaquim",
        "latitude": -28.2983,
        "longitude": -50.014,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4216602,
        "nome": "São José",
        "latitude": -27.5785,
        "longitude": -48.6563,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4216701,
        "nome": "São José do Cedro",
        "latitude": -26.4809,
        "longitude": -53.5337,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4216800,
        "nome": "São José do Cerrito",
        "latitude": -27.5983,
        "longitude": -50.6503,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4216909,
        "nome": "São Lourenço do Oeste",
        "latitude": -26.4655,
        "longitude": -52.8598,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217006,
        "nome": "São Ludgero",
        "latitude": -28.3531,
        "longitude": -49.1682,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217105,
        "nome": "São Martinho",
        "latitude": -28.1246,
        "longitude": -48.9719,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217154,
        "nome": "São Miguel da Boa Vista",
        "latitude": -26.6896,
        "longitude": -53.24,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217204,
        "nome": "São Miguel do Oeste",
        "latitude": -26.7273,
        "longitude": -53.5122,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217253,
        "nome": "São Pedro de Alcântara",
        "latitude": -27.5916,
        "longitude": -48.8371,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217303,
        "nome": "Saudades",
        "latitude": -26.8972,
        "longitude": -53.04,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217402,
        "nome": "Schroeder",
        "latitude": -26.368,
        "longitude": -49.0605,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217501,
        "nome": "Seara",
        "latitude": -27.1478,
        "longitude": -52.3407,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217550,
        "nome": "Serra Alta",
        "latitude": -26.6926,
        "longitude": -53.0252,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217600,
        "nome": "Siderópolis",
        "latitude": -28.5833,
        "longitude": -49.5267,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217709,
        "nome": "Sombrio",
        "latitude": -29.0702,
        "longitude": -49.6559,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217758,
        "nome": "Sul Brasil",
        "latitude": -26.6953,
        "longitude": -52.9468,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217808,
        "nome": "Taió",
        "latitude": -27.0785,
        "longitude": -50.0924,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217907,
        "nome": "Tangará",
        "latitude": -27.147,
        "longitude": -51.1471,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4217956,
        "nome": "Tigrinhos",
        "latitude": -26.6761,
        "longitude": -53.1565,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218004,
        "nome": "Tijucas",
        "latitude": -27.2476,
        "longitude": -48.7009,
        "mesorregiaoNome": "Grande Florianópolis",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218103,
        "nome": "Timbé do Sul",
        "latitude": -28.8074,
        "longitude": -49.8685,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218202,
        "nome": "Timbó",
        "latitude": -26.8082,
        "longitude": -49.2688,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218251,
        "nome": "Timbó Grande",
        "latitude": -26.6243,
        "longitude": -50.6656,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218301,
        "nome": "Três Barras",
        "latitude": -26.1699,
        "longitude": -50.2552,
        "mesorregiaoNome": "Norte Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218350,
        "nome": "Treviso",
        "latitude": -28.4992,
        "longitude": -49.4898,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218400,
        "nome": "Treze de Maio",
        "latitude": -28.5662,
        "longitude": -49.1542,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218509,
        "nome": "Treze Tílias",
        "latitude": -26.9663,
        "longitude": -51.4455,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218608,
        "nome": "Trombudo Central",
        "latitude": -27.3121,
        "longitude": -49.8114,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218707,
        "nome": "Tubarão",
        "latitude": -28.4816,
        "longitude": -49.0372,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218756,
        "nome": "Tunápolis",
        "latitude": -26.9881,
        "longitude": -53.6499,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218806,
        "nome": "Turvo",
        "latitude": -28.9031,
        "longitude": -49.7034,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218855,
        "nome": "União do Oeste",
        "latitude": -26.7867,
        "longitude": -52.856,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218905,
        "nome": "Urubici",
        "latitude": -28.0389,
        "longitude": -49.5775,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4218954,
        "nome": "Urupema",
        "latitude": -28.0237,
        "longitude": -49.9009,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4219002,
        "nome": "Urussanga",
        "latitude": -28.4927,
        "longitude": -49.3283,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4219101,
        "nome": "Vargeão",
        "latitude": -26.7787,
        "longitude": -52.1242,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4219150,
        "nome": "Vargem",
        "latitude": -27.4669,
        "longitude": -50.9505,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4219176,
        "nome": "Vargem Bonita",
        "latitude": -26.945,
        "longitude": -51.7566,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4219200,
        "nome": "Vidal Ramos",
        "latitude": -27.3879,
        "longitude": -49.3478,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4219309,
        "nome": "Videira",
        "latitude": -27.0066,
        "longitude": -51.1268,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4219358,
        "nome": "Vitor Meireles",
        "latitude": -26.8264,
        "longitude": -49.8452,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4219408,
        "nome": "Witmarsum",
        "latitude": -26.9373,
        "longitude": -49.8418,
        "mesorregiaoNome": "Vale do Itajaí",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4219507,
        "nome": "Xanxerê",
        "latitude": -26.8723,
        "longitude": -52.4098,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4219606,
        "nome": "Xavantina",
        "latitude": -27.0212,
        "longitude": -52.3219,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4219705,
        "nome": "Xaxim",
        "latitude": -26.9703,
        "longitude": -52.5291,
        "mesorregiaoNome": "Oeste Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4219853,
        "nome": "Zortéa",
        "latitude": -27.477,
        "longitude": -51.5356,
        "mesorregiaoNome": "Serrana",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4220000,
        "nome": "Balneário Rincão",
        "latitude": -28.8267,
        "longitude": -49.2542,
        "mesorregiaoNome": "Sul Catarinense",
        "UFSigla": "SC",
        "UFNome": "Santa Catarina"
    },
    {
        "ibgeId": 4300034,
        "nome": "Aceguá",
        "latitude": -31.6906,
        "longitude": -54.1392,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300059,
        "nome": "Água Santa",
        "latitude": -28.2139,
        "longitude": -52.0517,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300109,
        "nome": "Agudo",
        "latitude": -29.6081,
        "longitude": -53.2266,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300208,
        "nome": "Ajuricaba",
        "latitude": -28.2099,
        "longitude": -53.7372,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300307,
        "nome": "Alecrim",
        "latitude": -27.6518,
        "longitude": -54.7832,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300406,
        "nome": "Alegrete",
        "latitude": -29.7639,
        "longitude": -55.8358,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300455,
        "nome": "Alegria",
        "latitude": -27.8135,
        "longitude": -54.0562,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300471,
        "nome": "Almirante Tamandaré do Sul",
        "latitude": -28.13,
        "longitude": -52.9076,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300505,
        "nome": "Alpestre",
        "latitude": -27.2173,
        "longitude": -53.0635,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300554,
        "nome": "Alto Alegre",
        "latitude": -28.8043,
        "longitude": -52.9889,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300570,
        "nome": "Alto Feliz",
        "latitude": -29.3631,
        "longitude": -51.3045,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300604,
        "nome": "Alvorada",
        "latitude": -29.995,
        "longitude": -51.0374,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300638,
        "nome": "Amaral Ferrador",
        "latitude": -30.8102,
        "longitude": -52.3174,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300646,
        "nome": "Ametista do Sul",
        "latitude": -27.3656,
        "longitude": -53.1925,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300661,
        "nome": "André da Rocha",
        "latitude": -28.5943,
        "longitude": -51.5042,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300703,
        "nome": "Anta Gorda",
        "latitude": -28.9702,
        "longitude": -51.9946,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300802,
        "nome": "Antônio Prado",
        "latitude": -28.8823,
        "longitude": -51.3163,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300851,
        "nome": "Arambaré",
        "latitude": -30.9186,
        "longitude": -51.5786,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300877,
        "nome": "Araricá",
        "latitude": -29.6346,
        "longitude": -50.9345,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4300901,
        "nome": "Aratiba",
        "latitude": -27.3875,
        "longitude": -52.3024,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301008,
        "nome": "Arroio do Meio",
        "latitude": -29.3621,
        "longitude": -51.965,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301057,
        "nome": "Arroio do Sal",
        "latitude": -29.5204,
        "longitude": -49.8931,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301073,
        "nome": "Arroio do Padre",
        "latitude": -31.4404,
        "longitude": -52.3975,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301107,
        "nome": "Arroio dos Ratos",
        "latitude": -30.1929,
        "longitude": -51.752,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301206,
        "nome": "Arroio do Tigre",
        "latitude": -29.2589,
        "longitude": -53.0523,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301305,
        "nome": "Arroio Grande",
        "latitude": -32.1884,
        "longitude": -52.9199,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301404,
        "nome": "Arvorezinha",
        "latitude": -28.864,
        "longitude": -52.1871,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301503,
        "nome": "Augusto Pestana",
        "latitude": -28.5339,
        "longitude": -54.0073,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301552,
        "nome": "Áurea",
        "latitude": -27.7085,
        "longitude": -52.0765,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301602,
        "nome": "Bagé",
        "latitude": -31.2365,
        "longitude": -54.0166,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301636,
        "nome": "Balneário Pinhal",
        "latitude": -30.2112,
        "longitude": -50.2938,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301651,
        "nome": "Barão",
        "latitude": -29.3847,
        "longitude": -51.4877,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301701,
        "nome": "Barão de Cotegipe",
        "latitude": -27.5677,
        "longitude": -52.4172,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301750,
        "nome": "Barão do Triunfo",
        "latitude": -30.4174,
        "longitude": -51.7985,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301800,
        "nome": "Barracão",
        "latitude": -27.7231,
        "longitude": -51.4386,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301859,
        "nome": "Barra do Guarita",
        "latitude": -27.2053,
        "longitude": -53.7637,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301875,
        "nome": "Barra do Quaraí",
        "latitude": -30.1514,
        "longitude": -57.3353,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301909,
        "nome": "Barra do Ribeiro",
        "latitude": -30.3739,
        "longitude": -51.3576,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301925,
        "nome": "Barra do Rio Azul",
        "latitude": -27.403,
        "longitude": -52.4067,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4301958,
        "nome": "Barra Funda",
        "latitude": -27.9217,
        "longitude": -53.0167,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302006,
        "nome": "Barros Cassal",
        "latitude": -29.1134,
        "longitude": -52.5887,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302055,
        "nome": "Benjamin Constant do Sul",
        "latitude": -27.4848,
        "longitude": -52.6426,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302105,
        "nome": "Bento Gonçalves",
        "latitude": -29.1253,
        "longitude": -51.5515,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302154,
        "nome": "Boa Vista das Missões",
        "latitude": -27.7016,
        "longitude": -53.3415,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302204,
        "nome": "Boa Vista do Buricá",
        "latitude": -27.6748,
        "longitude": -54.0998,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302220,
        "nome": "Boa Vista do Cadeado",
        "latitude": -28.6561,
        "longitude": -53.8376,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302238,
        "nome": "Boa Vista do Incra",
        "latitude": -28.8652,
        "longitude": -53.4615,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302253,
        "nome": "Boa Vista do Sul",
        "latitude": -29.3509,
        "longitude": -51.6713,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302303,
        "nome": "Bom Jesus",
        "latitude": -28.5982,
        "longitude": -50.4233,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302352,
        "nome": "Bom Princípio",
        "latitude": -29.4711,
        "longitude": -51.3631,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302378,
        "nome": "Bom Progresso",
        "latitude": -27.5453,
        "longitude": -53.8489,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302402,
        "nome": "Bom Retiro do Sul",
        "latitude": -29.6377,
        "longitude": -51.9226,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302451,
        "nome": "Boqueirão do Leão",
        "latitude": -29.3036,
        "longitude": -52.4166,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302501,
        "nome": "Bossoroca",
        "latitude": -28.6617,
        "longitude": -54.9714,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302584,
        "nome": "Bozano",
        "latitude": -28.3543,
        "longitude": -53.7518,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302600,
        "nome": "Braga",
        "latitude": -27.5812,
        "longitude": -53.7422,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302659,
        "nome": "Brochier",
        "latitude": -29.537,
        "longitude": -51.6223,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302709,
        "nome": "Butiá",
        "latitude": -30.1836,
        "longitude": -52.0048,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302808,
        "nome": "Caçapava do Sul",
        "latitude": -30.5934,
        "longitude": -53.4778,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4302907,
        "nome": "Cacequi",
        "latitude": -29.9204,
        "longitude": -54.8028,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4303004,
        "nome": "Cachoeira do Sul",
        "latitude": -30.2062,
        "longitude": -52.9865,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4303103,
        "nome": "Cachoeirinha",
        "latitude": -29.9209,
        "longitude": -51.0953,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4303202,
        "nome": "Cacique Doble",
        "latitude": -27.814,
        "longitude": -51.677,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4303301,
        "nome": "Caibaté",
        "latitude": -28.3353,
        "longitude": -54.6553,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4303400,
        "nome": "Caiçara",
        "latitude": -27.2465,
        "longitude": -53.4666,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4303509,
        "nome": "Camaquã",
        "latitude": -30.9227,
        "longitude": -51.7884,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4303558,
        "nome": "Camargo",
        "latitude": -28.6164,
        "longitude": -52.2213,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4303608,
        "nome": "Cambará do Sul",
        "latitude": -29.0582,
        "longitude": -50.1353,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4303673,
        "nome": "Campestre da Serra",
        "latitude": -28.7262,
        "longitude": -51.0988,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4303707,
        "nome": "Campina das Missões",
        "latitude": -27.963,
        "longitude": -54.8341,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4303806,
        "nome": "Campinas do Sul",
        "latitude": -27.7363,
        "longitude": -52.6575,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4303905,
        "nome": "Campo Bom",
        "latitude": -29.6727,
        "longitude": -51.0485,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304002,
        "nome": "Campo Novo",
        "latitude": -27.6683,
        "longitude": -53.8246,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304101,
        "nome": "Campos Borges",
        "latitude": -28.9056,
        "longitude": -53.0577,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304200,
        "nome": "Candelária",
        "latitude": -29.7004,
        "longitude": -52.8132,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304309,
        "nome": "Cândido Godói",
        "latitude": -27.9337,
        "longitude": -54.7195,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304358,
        "nome": "Candiota",
        "latitude": -31.5544,
        "longitude": -53.7457,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304408,
        "nome": "Canela",
        "latitude": -29.3514,
        "longitude": -50.7752,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304507,
        "nome": "Canguçu",
        "latitude": -31.2174,
        "longitude": -52.6695,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304606,
        "nome": "Canoas",
        "latitude": -29.9122,
        "longitude": -51.1796,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304614,
        "nome": "Canudos do Vale",
        "latitude": -29.327,
        "longitude": -52.2342,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304622,
        "nome": "Capão Bonito do Sul",
        "latitude": -28.1524,
        "longitude": -51.3892,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304630,
        "nome": "Capão da Canoa",
        "latitude": -29.6798,
        "longitude": -49.9998,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304655,
        "nome": "Capão do Cipó",
        "latitude": -28.9593,
        "longitude": -54.5824,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304663,
        "nome": "Capão do Leão",
        "latitude": -31.8333,
        "longitude": -52.5383,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304671,
        "nome": "Capivari do Sul",
        "latitude": -30.1348,
        "longitude": -50.5118,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304689,
        "nome": "Capela de Santana",
        "latitude": -29.7059,
        "longitude": -51.3574,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304697,
        "nome": "Capitão",
        "latitude": -29.2832,
        "longitude": -51.9843,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304705,
        "nome": "Carazinho",
        "latitude": -28.2779,
        "longitude": -52.8636,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304713,
        "nome": "Caraá",
        "latitude": -29.7722,
        "longitude": -50.3418,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304804,
        "nome": "Carlos Barbosa",
        "latitude": -29.3214,
        "longitude": -51.5032,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304853,
        "nome": "Carlos Gomes",
        "latitude": -27.7033,
        "longitude": -51.9299,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304903,
        "nome": "Casca",
        "latitude": -28.5944,
        "longitude": -51.9672,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4304952,
        "nome": "Caseiros",
        "latitude": -28.2484,
        "longitude": -51.737,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305009,
        "nome": "Catuípe",
        "latitude": -28.1685,
        "longitude": -54.0344,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305108,
        "nome": "Caxias do Sul",
        "latitude": -29.1022,
        "longitude": -51.0237,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305116,
        "nome": "Centenário",
        "latitude": -27.7753,
        "longitude": -52.0029,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305124,
        "nome": "Cerrito",
        "latitude": -31.7297,
        "longitude": -52.796,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305132,
        "nome": "Cerro Branco",
        "latitude": -29.6271,
        "longitude": -52.9955,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305157,
        "nome": "Cerro Grande",
        "latitude": -27.6285,
        "longitude": -53.1631,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305173,
        "nome": "Cerro Grande do Sul",
        "latitude": -30.5839,
        "longitude": -51.7602,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305207,
        "nome": "Cerro Largo",
        "latitude": -28.131,
        "longitude": -54.7394,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305306,
        "nome": "Chapada",
        "latitude": -28.0969,
        "longitude": -53.1151,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305355,
        "nome": "Charqueadas",
        "latitude": -29.9902,
        "longitude": -51.5562,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305371,
        "nome": "Charrua",
        "latitude": -27.945,
        "longitude": -52.0004,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305405,
        "nome": "Chiapetta",
        "latitude": -27.9865,
        "longitude": -53.9098,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305439,
        "nome": "Chuí",
        "latitude": -33.6525,
        "longitude": -53.4127,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305447,
        "nome": "Chuvisca",
        "latitude": -30.782,
        "longitude": -52.0048,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305454,
        "nome": "Cidreira",
        "latitude": -30.121,
        "longitude": -50.2722,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305504,
        "nome": "Ciríaco",
        "latitude": -28.3462,
        "longitude": -51.9176,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305587,
        "nome": "Colinas",
        "latitude": -29.3918,
        "longitude": -51.8656,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305603,
        "nome": "Colorado",
        "latitude": -28.4724,
        "longitude": -52.9914,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305702,
        "nome": "Condor",
        "latitude": -28.1655,
        "longitude": -53.4939,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305801,
        "nome": "Constantina",
        "latitude": -27.6893,
        "longitude": -52.9903,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305835,
        "nome": "Coqueiro Baixo",
        "latitude": -29.1681,
        "longitude": -52.1264,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305850,
        "nome": "Coqueiros do Sul",
        "latitude": -28.1308,
        "longitude": -52.7592,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305871,
        "nome": "Coronel Barros",
        "latitude": -28.4039,
        "longitude": -54.0603,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305900,
        "nome": "Coronel Bicaco",
        "latitude": -27.7977,
        "longitude": -53.6464,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305934,
        "nome": "Coronel Pilar",
        "latitude": -29.2626,
        "longitude": -51.7204,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305959,
        "nome": "Cotiporã",
        "latitude": -28.9954,
        "longitude": -51.6892,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4305975,
        "nome": "Coxilha",
        "latitude": -28.1217,
        "longitude": -52.3326,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306007,
        "nome": "Crissiumal",
        "latitude": -27.4875,
        "longitude": -54.1366,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306056,
        "nome": "Cristal",
        "latitude": -31.0087,
        "longitude": -52.0305,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306072,
        "nome": "Cristal do Sul",
        "latitude": -27.4324,
        "longitude": -53.2486,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306106,
        "nome": "Cruz Alta",
        "latitude": -28.703,
        "longitude": -53.5626,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306130,
        "nome": "Cruzaltense",
        "latitude": -27.6273,
        "longitude": -52.644,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306205,
        "nome": "Cruzeiro do Sul",
        "latitude": -29.5404,
        "longitude": -52.0335,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306304,
        "nome": "David Canabarro",
        "latitude": -28.4163,
        "longitude": -51.8126,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306320,
        "nome": "Derrubadas",
        "latitude": -27.2403,
        "longitude": -53.8934,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306353,
        "nome": "Dezesseis de Novembro",
        "latitude": -28.2048,
        "longitude": -55.0797,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306379,
        "nome": "Dilermando de Aguiar",
        "latitude": -29.8134,
        "longitude": -54.1632,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306403,
        "nome": "Dois Irmãos",
        "latitude": -29.599,
        "longitude": -51.0895,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306429,
        "nome": "Dois Irmãos das Missões",
        "latitude": -27.6762,
        "longitude": -53.496,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306452,
        "nome": "Dois Lajeados",
        "latitude": -28.9766,
        "longitude": -51.8432,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306502,
        "nome": "Dom Feliciano",
        "latitude": -30.6044,
        "longitude": -52.2015,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306551,
        "nome": "Dom Pedro de Alcântara",
        "latitude": -29.3676,
        "longitude": -49.8554,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306601,
        "nome": "Dom Pedrito",
        "latitude": -31.0571,
        "longitude": -54.6651,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306700,
        "nome": "Dona Francisca",
        "latitude": -29.5605,
        "longitude": -53.3464,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306734,
        "nome": "Doutor Maurício Cardoso",
        "latitude": -27.4869,
        "longitude": -54.3675,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306759,
        "nome": "Doutor Ricardo",
        "latitude": -29.0919,
        "longitude": -51.9767,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306767,
        "nome": "Eldorado do Sul",
        "latitude": -30.0781,
        "longitude": -51.4992,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306809,
        "nome": "Encantado",
        "latitude": -29.213,
        "longitude": -51.9218,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306908,
        "nome": "Encruzilhada do Sul",
        "latitude": -30.63,
        "longitude": -52.6722,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306924,
        "nome": "Engenho Velho",
        "latitude": -27.6848,
        "longitude": -52.9087,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306932,
        "nome": "Entre-Ijuís",
        "latitude": -28.4595,
        "longitude": -54.302,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306957,
        "nome": "Entre Rios do Sul",
        "latitude": -27.519,
        "longitude": -52.7269,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4306973,
        "nome": "Erebango",
        "latitude": -27.8292,
        "longitude": -52.3185,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307005,
        "nome": "Erechim",
        "latitude": -27.6432,
        "longitude": -52.2575,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307054,
        "nome": "Ernestina",
        "latitude": -28.4207,
        "longitude": -52.5544,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307104,
        "nome": "Herval",
        "latitude": -32.0209,
        "longitude": -53.4015,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307203,
        "nome": "Erval Grande",
        "latitude": -27.3514,
        "longitude": -52.5809,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307302,
        "nome": "Erval Seco",
        "latitude": -27.5141,
        "longitude": -53.5187,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307401,
        "nome": "Esmeralda",
        "latitude": -28.0376,
        "longitude": -51.17,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307450,
        "nome": "Esperança do Sul",
        "latitude": -27.3282,
        "longitude": -54.0091,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307500,
        "nome": "Espumoso",
        "latitude": -28.8641,
        "longitude": -52.8272,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307559,
        "nome": "Estação",
        "latitude": -27.9285,
        "longitude": -52.2902,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307609,
        "nome": "Estância Velha",
        "latitude": -29.6476,
        "longitude": -51.1882,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307708,
        "nome": "Esteio",
        "latitude": -29.8517,
        "longitude": -51.1768,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307807,
        "nome": "Estrela",
        "latitude": -29.5088,
        "longitude": -51.9199,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307815,
        "nome": "Estrela Velha",
        "latitude": -29.224,
        "longitude": -53.1783,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307831,
        "nome": "Eugênio de Castro",
        "latitude": -28.5656,
        "longitude": -54.2449,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307864,
        "nome": "Fagundes Varela",
        "latitude": -28.8866,
        "longitude": -51.7175,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4307906,
        "nome": "Farroupilha",
        "latitude": -29.2099,
        "longitude": -51.3659,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308003,
        "nome": "Faxinal do Soturno",
        "latitude": -29.5579,
        "longitude": -53.4629,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308052,
        "nome": "Faxinalzinho",
        "latitude": -27.3753,
        "longitude": -52.6762,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308078,
        "nome": "Fazenda Vilanova",
        "latitude": -29.5891,
        "longitude": -51.8385,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308102,
        "nome": "Feliz",
        "latitude": -29.4551,
        "longitude": -51.2847,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308201,
        "nome": "Flores da Cunha",
        "latitude": -29.0315,
        "longitude": -51.2211,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308250,
        "nome": "Floriano Peixoto",
        "latitude": -27.8578,
        "longitude": -52.0453,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308300,
        "nome": "Fontoura Xavier",
        "latitude": -29.0086,
        "longitude": -52.378,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308409,
        "nome": "Formigueiro",
        "latitude": -29.9755,
        "longitude": -53.5062,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308433,
        "nome": "Forquetinha",
        "latitude": -29.3885,
        "longitude": -52.1258,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308458,
        "nome": "Fortaleza dos Valos",
        "latitude": -28.8951,
        "longitude": -53.2759,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308508,
        "nome": "Frederico Westphalen",
        "latitude": -27.3405,
        "longitude": -53.3598,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308607,
        "nome": "Garibaldi",
        "latitude": -29.2408,
        "longitude": -51.5823,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308656,
        "nome": "Garruchos",
        "latitude": -28.2338,
        "longitude": -55.5386,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308706,
        "nome": "Gaurama",
        "latitude": -27.5987,
        "longitude": -52.1155,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308805,
        "nome": "General Câmara",
        "latitude": -29.8654,
        "longitude": -51.9163,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308854,
        "nome": "Gentil",
        "latitude": -28.3862,
        "longitude": -52.0396,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4308904,
        "nome": "Getúlio Vargas",
        "latitude": -27.8521,
        "longitude": -52.1805,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309001,
        "nome": "Giruá",
        "latitude": -28.0299,
        "longitude": -54.2988,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309050,
        "nome": "Glorinha",
        "latitude": -29.8865,
        "longitude": -50.7707,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309100,
        "nome": "Gramado",
        "latitude": -29.386,
        "longitude": -50.8969,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309126,
        "nome": "Gramado dos Loureiros",
        "latitude": -27.4457,
        "longitude": -52.9149,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309159,
        "nome": "Gramado Xavier",
        "latitude": -29.2888,
        "longitude": -52.6006,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309209,
        "nome": "Gravataí",
        "latitude": -29.8895,
        "longitude": -50.947,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309258,
        "nome": "Guabiju",
        "latitude": -28.5776,
        "longitude": -51.6598,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309308,
        "nome": "Guaíba",
        "latitude": -30.1773,
        "longitude": -51.4337,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309407,
        "nome": "Guaporé",
        "latitude": -28.855,
        "longitude": -51.9044,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309506,
        "nome": "Guarani das Missões",
        "latitude": -28.1678,
        "longitude": -54.5867,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309555,
        "nome": "Harmonia",
        "latitude": -29.5457,
        "longitude": -51.4263,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309571,
        "nome": "Herveiras",
        "latitude": -29.4411,
        "longitude": -52.6692,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309605,
        "nome": "Horizontina",
        "latitude": -27.5903,
        "longitude": -54.2987,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309654,
        "nome": "Hulha Negra",
        "latitude": -31.4477,
        "longitude": -53.8895,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309704,
        "nome": "Humaitá",
        "latitude": -27.5742,
        "longitude": -53.9799,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309753,
        "nome": "Ibarama",
        "latitude": -29.4183,
        "longitude": -53.1661,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309803,
        "nome": "Ibiaçá",
        "latitude": -28.1021,
        "longitude": -51.7875,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309902,
        "nome": "Ibiraiaras",
        "latitude": -28.3816,
        "longitude": -51.6307,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4309951,
        "nome": "Ibirapuitã",
        "latitude": -28.6252,
        "longitude": -52.4428,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310009,
        "nome": "Ibirubá",
        "latitude": -28.595,
        "longitude": -53.1723,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310108,
        "nome": "Igrejinha",
        "latitude": -29.5617,
        "longitude": -50.7955,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310207,
        "nome": "Ijuí",
        "latitude": -28.3204,
        "longitude": -53.8949,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310306,
        "nome": "Ilópolis",
        "latitude": -28.9324,
        "longitude": -52.1324,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310330,
        "nome": "Imbé",
        "latitude": -29.9306,
        "longitude": -50.1177,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310363,
        "nome": "Imigrante",
        "latitude": -29.3448,
        "longitude": -51.7742,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310405,
        "nome": "Independência",
        "latitude": -27.9012,
        "longitude": -54.1804,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310413,
        "nome": "Inhacorá",
        "latitude": -27.9025,
        "longitude": -54.0306,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310439,
        "nome": "Ipê",
        "latitude": -28.7173,
        "longitude": -51.2993,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310462,
        "nome": "Ipiranga do Sul",
        "latitude": -27.9312,
        "longitude": -52.4186,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310504,
        "nome": "Iraí",
        "latitude": -27.2494,
        "longitude": -53.2416,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310538,
        "nome": "Itaara",
        "latitude": -29.5769,
        "longitude": -53.762,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310553,
        "nome": "Itacurubi",
        "latitude": -28.8099,
        "longitude": -55.2674,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310579,
        "nome": "Itapuca",
        "latitude": -28.7757,
        "longitude": -52.1956,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310603,
        "nome": "Itaqui",
        "latitude": -29.2137,
        "longitude": -56.1757,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310652,
        "nome": "Itati",
        "latitude": -29.4622,
        "longitude": -50.1643,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310702,
        "nome": "Itatiba do Sul",
        "latitude": -27.3562,
        "longitude": -52.4775,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310751,
        "nome": "Ivorá",
        "latitude": -29.5136,
        "longitude": -53.5836,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310801,
        "nome": "Ivoti",
        "latitude": -29.5806,
        "longitude": -51.157,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310850,
        "nome": "Jaboticaba",
        "latitude": -27.6295,
        "longitude": -53.2641,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310876,
        "nome": "Jacuizinho",
        "latitude": -29.0351,
        "longitude": -53.0143,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4310900,
        "nome": "Jacutinga",
        "latitude": -27.7867,
        "longitude": -52.5472,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311007,
        "nome": "Jaguarão",
        "latitude": -32.41,
        "longitude": -53.3359,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311106,
        "nome": "Jaguari",
        "latitude": -29.4584,
        "longitude": -54.6478,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311122,
        "nome": "Jaquirana",
        "latitude": -28.9482,
        "longitude": -50.3612,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311130,
        "nome": "Jari",
        "latitude": -29.2915,
        "longitude": -54.298,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311155,
        "nome": "Jóia",
        "latitude": -28.7666,
        "longitude": -54.1548,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311205,
        "nome": "Júlio de Castilhos",
        "latitude": -29.2584,
        "longitude": -53.6524,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311239,
        "nome": "Lagoa Bonita do Sul",
        "latitude": -29.5025,
        "longitude": -53.0417,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311254,
        "nome": "Lagoão",
        "latitude": -29.2381,
        "longitude": -52.7875,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311270,
        "nome": "Lagoa dos Três Cantos",
        "latitude": -28.5709,
        "longitude": -52.8341,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311304,
        "nome": "Lagoa Vermelha",
        "latitude": -28.2274,
        "longitude": -51.5022,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311403,
        "nome": "Lajeado",
        "latitude": -29.4433,
        "longitude": -52.0074,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311429,
        "nome": "Lajeado do Bugre",
        "latitude": -27.7033,
        "longitude": -53.206,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311502,
        "nome": "Lavras do Sul",
        "latitude": -30.7721,
        "longitude": -54.1536,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311601,
        "nome": "Liberato Salzano",
        "latitude": -27.5495,
        "longitude": -53.0639,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311627,
        "nome": "Lindolfo Collor",
        "latitude": -29.5826,
        "longitude": -51.2196,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311643,
        "nome": "Linha Nova",
        "latitude": -29.4597,
        "longitude": -51.2155,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311700,
        "nome": "Machadinho",
        "latitude": -27.587,
        "longitude": -51.674,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311718,
        "nome": "Maçambará",
        "latitude": -29.0662,
        "longitude": -55.775,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311734,
        "nome": "Mampituba",
        "latitude": -29.2624,
        "longitude": -50.0031,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311759,
        "nome": "Manoel Viana",
        "latitude": -29.4297,
        "longitude": -55.5582,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311775,
        "nome": "Maquiné",
        "latitude": -29.6356,
        "longitude": -50.2084,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311791,
        "nome": "Maratá",
        "latitude": -29.5482,
        "longitude": -51.5503,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311809,
        "nome": "Marau",
        "latitude": -28.4552,
        "longitude": -52.2687,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311908,
        "nome": "Marcelino Ramos",
        "latitude": -27.4784,
        "longitude": -51.9507,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4311981,
        "nome": "Mariana Pimentel",
        "latitude": -30.314,
        "longitude": -51.5843,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312005,
        "nome": "Mariano Moro",
        "latitude": -27.3425,
        "longitude": -52.1684,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312054,
        "nome": "Marques de Souza",
        "latitude": -29.2893,
        "longitude": -52.1488,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312104,
        "nome": "Mata",
        "latitude": -29.5375,
        "longitude": -54.4679,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312138,
        "nome": "Mato Castelhano",
        "latitude": -28.2776,
        "longitude": -52.1989,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312153,
        "nome": "Mato Leitão",
        "latitude": -29.5248,
        "longitude": -52.1362,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312179,
        "nome": "Mato Queimado",
        "latitude": -28.243,
        "longitude": -54.6566,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312203,
        "nome": "Maximiliano de Almeida",
        "latitude": -27.604,
        "longitude": -51.8158,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312252,
        "nome": "Minas do Leão",
        "latitude": -30.0747,
        "longitude": -52.0779,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312302,
        "nome": "Miraguaí",
        "latitude": -27.4904,
        "longitude": -53.7456,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312351,
        "nome": "Montauri",
        "latitude": -28.6698,
        "longitude": -52.0502,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312377,
        "nome": "Monte Alegre dos Campos",
        "latitude": -28.7002,
        "longitude": -50.8051,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312385,
        "nome": "Monte Belo do Sul",
        "latitude": -29.1404,
        "longitude": -51.6517,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312401,
        "nome": "Montenegro",
        "latitude": -29.7101,
        "longitude": -51.503,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312427,
        "nome": "Mormaço",
        "latitude": -28.6938,
        "longitude": -52.6619,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312443,
        "nome": "Morrinhos do Sul",
        "latitude": -29.3376,
        "longitude": -49.9542,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312450,
        "nome": "Morro Redondo",
        "latitude": -31.6371,
        "longitude": -52.6377,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312476,
        "nome": "Morro Reuter",
        "latitude": -29.5215,
        "longitude": -51.052,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312500,
        "nome": "Mostardas",
        "latitude": -30.8543,
        "longitude": -50.7291,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312609,
        "nome": "Muçum",
        "latitude": -29.1404,
        "longitude": -51.8156,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312617,
        "nome": "Muitos Capões",
        "latitude": -28.385,
        "longitude": -51.2296,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312625,
        "nome": "Muliterno",
        "latitude": -28.3269,
        "longitude": -51.777,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312658,
        "nome": "Não-Me-Toque",
        "latitude": -28.4594,
        "longitude": -52.8249,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312674,
        "nome": "Nicolau Vergueiro",
        "latitude": -28.5208,
        "longitude": -52.4484,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312708,
        "nome": "Nonoai",
        "latitude": -27.3695,
        "longitude": -52.8573,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312757,
        "nome": "Nova Alvorada",
        "latitude": -28.708,
        "longitude": -52.1714,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312807,
        "nome": "Nova Araçá",
        "latitude": -28.6512,
        "longitude": -51.7463,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312906,
        "nome": "Nova Bassano",
        "latitude": -28.726,
        "longitude": -51.7541,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4312955,
        "nome": "Nova Boa Vista",
        "latitude": -27.9968,
        "longitude": -52.9795,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313003,
        "nome": "Nova Bréscia",
        "latitude": -29.2221,
        "longitude": -52.0353,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313011,
        "nome": "Nova Candelária",
        "latitude": -27.5953,
        "longitude": -54.1255,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313037,
        "nome": "Nova Esperança do Sul",
        "latitude": -29.4034,
        "longitude": -54.8217,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313060,
        "nome": "Nova Hartz",
        "latitude": -29.5855,
        "longitude": -50.8991,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313086,
        "nome": "Nova Pádua",
        "latitude": -29.001,
        "longitude": -51.3159,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313102,
        "nome": "Nova Palma",
        "latitude": -29.4333,
        "longitude": -53.4162,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313201,
        "nome": "Nova Petrópolis",
        "latitude": -29.3721,
        "longitude": -51.0851,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313300,
        "nome": "Nova Prata",
        "latitude": -28.7607,
        "longitude": -51.6082,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313334,
        "nome": "Nova Ramada",
        "latitude": -28.0762,
        "longitude": -53.7037,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313359,
        "nome": "Nova Roma do Sul",
        "latitude": -28.9889,
        "longitude": -51.4086,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313375,
        "nome": "Nova Santa Rita",
        "latitude": -29.8443,
        "longitude": -51.2886,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313391,
        "nome": "Novo Cabrais",
        "latitude": -29.7601,
        "longitude": -52.9955,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313409,
        "nome": "Novo Hamburgo",
        "latitude": -29.7347,
        "longitude": -51.049,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313425,
        "nome": "Novo Machado",
        "latitude": -27.5449,
        "longitude": -54.5373,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313441,
        "nome": "Novo Tiradentes",
        "latitude": -27.5618,
        "longitude": -53.1671,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313466,
        "nome": "Novo Xingu",
        "latitude": -27.7443,
        "longitude": -53.0585,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313490,
        "nome": "Novo Barreiro",
        "latitude": -27.8995,
        "longitude": -53.116,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313508,
        "nome": "Osório",
        "latitude": -29.9159,
        "longitude": -50.2675,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313607,
        "nome": "Paim Filho",
        "latitude": -27.7221,
        "longitude": -51.7803,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313656,
        "nome": "Palmares do Sul",
        "latitude": -30.3624,
        "longitude": -50.4492,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313706,
        "nome": "Palmeira das Missões",
        "latitude": -27.94,
        "longitude": -53.3823,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313805,
        "nome": "Palmitinho",
        "latitude": -27.3278,
        "longitude": -53.5878,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313904,
        "nome": "Panambi",
        "latitude": -28.3296,
        "longitude": -53.5074,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4313953,
        "nome": "Pantano Grande",
        "latitude": -30.2578,
        "longitude": -52.371,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314001,
        "nome": "Paraí",
        "latitude": -28.6003,
        "longitude": -51.7884,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314027,
        "nome": "Paraíso do Sul",
        "latitude": -29.6963,
        "longitude": -53.1213,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314035,
        "nome": "Pareci Novo",
        "latitude": -29.6102,
        "longitude": -51.4231,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314050,
        "nome": "Parobé",
        "latitude": -29.6593,
        "longitude": -50.8562,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314068,
        "nome": "Passa Sete",
        "latitude": -29.4389,
        "longitude": -52.8696,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314076,
        "nome": "Passo do Sobrado",
        "latitude": -29.7593,
        "longitude": -52.2451,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314100,
        "nome": "Passo Fundo",
        "latitude": -28.2689,
        "longitude": -52.4525,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314134,
        "nome": "Paulo Bento",
        "latitude": -27.7096,
        "longitude": -52.3947,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314159,
        "nome": "Paverama",
        "latitude": -29.5693,
        "longitude": -51.7284,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314175,
        "nome": "Pedras Altas",
        "latitude": -31.839,
        "longitude": -53.6913,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314209,
        "nome": "Pedro Osório",
        "latitude": -31.9597,
        "longitude": -52.8725,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314308,
        "nome": "Pejuçara",
        "latitude": -28.4538,
        "longitude": -53.5937,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314407,
        "nome": "Pelotas",
        "latitude": -31.571,
        "longitude": -52.3452,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314423,
        "nome": "Picada Café",
        "latitude": -29.4607,
        "longitude": -51.1091,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314456,
        "nome": "Pinhal",
        "latitude": -27.529,
        "longitude": -53.2351,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314464,
        "nome": "Pinhal da Serra",
        "latitude": -27.8536,
        "longitude": -51.2194,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314472,
        "nome": "Pinhal Grande",
        "latitude": -29.2915,
        "longitude": -53.3356,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314498,
        "nome": "Pinheirinho do Vale",
        "latitude": -27.2217,
        "longitude": -53.6343,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314506,
        "nome": "Pinheiro Machado",
        "latitude": -31.4049,
        "longitude": -53.4134,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314548,
        "nome": "Pinto Bandeira",
        "latitude": -29.0929,
        "longitude": -51.4617,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314555,
        "nome": "Pirapó",
        "latitude": -28.0635,
        "longitude": -55.2431,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314605,
        "nome": "Piratini",
        "latitude": -31.4386,
        "longitude": -53.1032,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314704,
        "nome": "Planalto",
        "latitude": -27.3357,
        "longitude": -53.078,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314753,
        "nome": "Poço das Antas",
        "latitude": -29.4461,
        "longitude": -51.6408,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314779,
        "nome": "Pontão",
        "latitude": -28.0363,
        "longitude": -52.6413,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314787,
        "nome": "Ponte Preta",
        "latitude": -27.6548,
        "longitude": -52.5062,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314803,
        "nome": "Portão",
        "latitude": -29.701,
        "longitude": -51.2487,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4314902,
        "nome": "Porto Alegre",
        "latitude": -30.0954,
        "longitude": -51.1643,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315008,
        "nome": "Porto Lucena",
        "latitude": -27.8507,
        "longitude": -54.9592,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315057,
        "nome": "Porto Mauá",
        "latitude": -27.5919,
        "longitude": -54.6572,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315073,
        "nome": "Porto Vera Cruz",
        "latitude": -27.7546,
        "longitude": -54.8911,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315107,
        "nome": "Porto Xavier",
        "latitude": -27.932,
        "longitude": -55.1432,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315131,
        "nome": "Pouso Novo",
        "latitude": -29.158,
        "longitude": -52.2287,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315149,
        "nome": "Presidente Lucena",
        "latitude": -29.5243,
        "longitude": -51.1743,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315156,
        "nome": "Progresso",
        "latitude": -29.2243,
        "longitude": -52.3189,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315172,
        "nome": "Protásio Alves",
        "latitude": -28.7369,
        "longitude": -51.4873,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315206,
        "nome": "Putinga",
        "latitude": -29.0337,
        "longitude": -52.1429,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315305,
        "nome": "Quaraí",
        "latitude": -30.2795,
        "longitude": -56.153,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315313,
        "nome": "Quatro Irmãos",
        "latitude": -27.8427,
        "longitude": -52.4713,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315321,
        "nome": "Quevedos",
        "latitude": -29.3096,
        "longitude": -54.0655,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315354,
        "nome": "Quinze de Novembro",
        "latitude": -28.7569,
        "longitude": -53.1169,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315404,
        "nome": "Redentora",
        "latitude": -27.5701,
        "longitude": -53.6317,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315453,
        "nome": "Relvado",
        "latitude": -29.1233,
        "longitude": -52.0653,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315503,
        "nome": "Restinga Sêca",
        "latitude": -29.8174,
        "longitude": -53.3439,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315552,
        "nome": "Rio dos Índios",
        "latitude": -27.2528,
        "longitude": -52.8797,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315602,
        "nome": "Rio Grande",
        "latitude": -32.2175,
        "longitude": -52.4035,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315701,
        "nome": "Rio Pardo",
        "latitude": -30.0228,
        "longitude": -52.4369,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315750,
        "nome": "Riozinho",
        "latitude": -29.6158,
        "longitude": -50.3999,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315800,
        "nome": "Roca Sales",
        "latitude": -29.2567,
        "longitude": -51.8293,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315909,
        "nome": "Rodeio Bonito",
        "latitude": -27.4634,
        "longitude": -53.1706,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4315958,
        "nome": "Rolador",
        "latitude": -28.2549,
        "longitude": -54.8344,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316006,
        "nome": "Rolante",
        "latitude": -29.629,
        "longitude": -50.55,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316105,
        "nome": "Ronda Alta",
        "latitude": -27.811,
        "longitude": -52.7496,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316204,
        "nome": "Rondinha",
        "latitude": -27.8325,
        "longitude": -52.8931,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316303,
        "nome": "Roque Gonzales",
        "latitude": -28.0596,
        "longitude": -55.088,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316402,
        "nome": "Rosário do Sul",
        "latitude": -30.3259,
        "longitude": -55.113,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316428,
        "nome": "Sagrada Família",
        "latitude": -27.7079,
        "longitude": -53.132,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316436,
        "nome": "Saldanha Marinho",
        "latitude": -28.3868,
        "longitude": -53.0944,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316451,
        "nome": "Salto do Jacuí",
        "latitude": -29.0682,
        "longitude": -53.2542,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316477,
        "nome": "Salvador das Missões",
        "latitude": -28.0989,
        "longitude": -54.8322,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316501,
        "nome": "Salvador do Sul",
        "latitude": -29.4578,
        "longitude": -51.5354,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316600,
        "nome": "Sananduva",
        "latitude": -27.9572,
        "longitude": -51.8003,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316709,
        "nome": "Santa Bárbara do Sul",
        "latitude": -28.3739,
        "longitude": -53.2846,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316733,
        "nome": "Santa Cecília do Sul",
        "latitude": -28.1813,
        "longitude": -51.8985,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316758,
        "nome": "Santa Clara do Sul",
        "latitude": -29.4533,
        "longitude": -52.1323,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316808,
        "nome": "Santa Cruz do Sul",
        "latitude": -29.6462,
        "longitude": -52.4073,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316907,
        "nome": "Santa Maria",
        "latitude": -29.7849,
        "longitude": -53.825,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316956,
        "nome": "Santa Maria do Herval",
        "latitude": -29.4759,
        "longitude": -50.9691,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4316972,
        "nome": "Santa Margarida do Sul",
        "latitude": -30.3711,
        "longitude": -54.0977,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317004,
        "nome": "Santana da Boa Vista",
        "latitude": -30.8171,
        "longitude": -53.1769,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317103,
        "nome": "Sant'Ana do Livramento",
        "latitude": -30.7384,
        "longitude": -55.5623,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317202,
        "nome": "Santa Rosa",
        "latitude": -27.8644,
        "longitude": -54.497,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317251,
        "nome": "Santa Tereza",
        "latitude": -29.1637,
        "longitude": -51.711,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317301,
        "nome": "Santa Vitória do Palmar",
        "latitude": -33.1631,
        "longitude": -53.0066,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317400,
        "nome": "Santiago",
        "latitude": -29.1272,
        "longitude": -54.7962,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317509,
        "nome": "Santo Ângelo",
        "latitude": -28.2505,
        "longitude": -54.2976,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317558,
        "nome": "Santo Antônio do Palma",
        "latitude": -28.4956,
        "longitude": -52.0086,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317608,
        "nome": "Santo Antônio da Patrulha",
        "latitude": -29.8728,
        "longitude": -50.5592,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317707,
        "nome": "Santo Antônio das Missões",
        "latitude": -28.494,
        "longitude": -55.4261,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317756,
        "nome": "Santo Antônio do Planalto",
        "latitude": -28.3651,
        "longitude": -52.6815,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317806,
        "nome": "Santo Augusto",
        "latitude": -27.9031,
        "longitude": -53.7558,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317905,
        "nome": "Santo Cristo",
        "latitude": -27.7984,
        "longitude": -54.711,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4317954,
        "nome": "Santo Expedito do Sul",
        "latitude": -27.9227,
        "longitude": -51.6615,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318002,
        "nome": "São Borja",
        "latitude": -28.7467,
        "longitude": -55.7966,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318051,
        "nome": "São Domingos do Sul",
        "latitude": -28.5383,
        "longitude": -51.8678,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318101,
        "nome": "São Francisco de Assis",
        "latitude": -29.4468,
        "longitude": -55.1349,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318200,
        "nome": "São Francisco de Paula",
        "latitude": -29.2023,
        "longitude": -50.5565,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318309,
        "nome": "São Gabriel",
        "latitude": -30.3053,
        "longitude": -54.3654,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318408,
        "nome": "São Jerônimo",
        "latitude": -30.2906,
        "longitude": -51.9119,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318424,
        "nome": "São João da Urtiga",
        "latitude": -27.7975,
        "longitude": -51.8349,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318432,
        "nome": "São João do Polêsine",
        "latitude": -29.6421,
        "longitude": -53.4705,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318440,
        "nome": "São Jorge",
        "latitude": -28.4983,
        "longitude": -51.7156,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318457,
        "nome": "São José das Missões",
        "latitude": -27.7948,
        "longitude": -53.1317,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318465,
        "nome": "São José do Herval",
        "latitude": -29.065,
        "longitude": -52.2747,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318481,
        "nome": "São José do Hortêncio",
        "latitude": -29.5356,
        "longitude": -51.2576,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318499,
        "nome": "São José do Inhacorá",
        "latitude": -27.7384,
        "longitude": -54.1241,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318507,
        "nome": "São José do Norte",
        "latitude": -31.7638,
        "longitude": -51.6655,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318606,
        "nome": "São José do Ouro",
        "latitude": -27.7724,
        "longitude": -51.5603,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318614,
        "nome": "São José do Sul",
        "latitude": -29.548,
        "longitude": -51.4861,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318622,
        "nome": "São José dos Ausentes",
        "latitude": -28.6486,
        "longitude": -49.9617,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318705,
        "nome": "São Leopoldo",
        "latitude": -29.7553,
        "longitude": -51.1449,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318804,
        "nome": "São Lourenço do Sul",
        "latitude": -31.2342,
        "longitude": -52.1223,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4318903,
        "nome": "São Luiz Gonzaga",
        "latitude": -28.4184,
        "longitude": -54.8911,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319000,
        "nome": "São Marcos",
        "latitude": -28.963,
        "longitude": -51.0651,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319109,
        "nome": "São Martinho",
        "latitude": -27.729,
        "longitude": -53.9532,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319125,
        "nome": "São Martinho da Serra",
        "latitude": -29.4748,
        "longitude": -53.8863,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319158,
        "nome": "São Miguel das Missões",
        "latitude": -28.6728,
        "longitude": -54.5216,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319208,
        "nome": "São Nicolau",
        "latitude": -28.2005,
        "longitude": -55.2489,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319307,
        "nome": "São Paulo das Missões",
        "latitude": -27.9885,
        "longitude": -54.9759,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319356,
        "nome": "São Pedro da Serra",
        "latitude": -29.4186,
        "longitude": -51.5092,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319364,
        "nome": "São Pedro das Missões",
        "latitude": -27.7797,
        "longitude": -53.2377,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319372,
        "nome": "São Pedro do Butiá",
        "latitude": -28.1233,
        "longitude": -54.8951,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319406,
        "nome": "São Pedro do Sul",
        "latitude": -29.6114,
        "longitude": -54.238,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319505,
        "nome": "São Sebastião do Caí",
        "latitude": -29.5902,
        "longitude": -51.3372,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319604,
        "nome": "São Sepé",
        "latitude": -30.1757,
        "longitude": -53.6198,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319703,
        "nome": "São Valentim",
        "latitude": -27.5538,
        "longitude": -52.5595,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319711,
        "nome": "São Valentim do Sul",
        "latitude": -29.0568,
        "longitude": -51.761,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319737,
        "nome": "São Valério do Sul",
        "latitude": -27.8211,
        "longitude": -53.9087,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319752,
        "nome": "São Vendelino",
        "latitude": -29.3824,
        "longitude": -51.3725,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319802,
        "nome": "São Vicente do Sul",
        "latitude": -29.7096,
        "longitude": -54.754,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4319901,
        "nome": "Sapiranga",
        "latitude": -29.6134,
        "longitude": -50.9957,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320008,
        "nome": "Sapucaia do Sul",
        "latitude": -29.8234,
        "longitude": -51.1337,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320107,
        "nome": "Sarandi",
        "latitude": -27.9413,
        "longitude": -52.8963,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320206,
        "nome": "Seberi",
        "latitude": -27.501,
        "longitude": -53.3627,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320230,
        "nome": "Sede Nova",
        "latitude": -27.6411,
        "longitude": -53.9532,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320263,
        "nome": "Segredo",
        "latitude": -29.3122,
        "longitude": -52.9296,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320305,
        "nome": "Selbach",
        "latitude": -28.6686,
        "longitude": -52.9786,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320321,
        "nome": "Senador Salgado Filho",
        "latitude": -28.0288,
        "longitude": -54.5368,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320354,
        "nome": "Sentinela do Sul",
        "latitude": -30.6253,
        "longitude": -51.6077,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320404,
        "nome": "Serafina Corrêa",
        "latitude": -28.7016,
        "longitude": -51.9337,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320453,
        "nome": "Sério",
        "latitude": -29.3937,
        "longitude": -52.2487,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320503,
        "nome": "Sertão",
        "latitude": -28.0099,
        "longitude": -52.3141,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320552,
        "nome": "Sertão Santana",
        "latitude": -30.4668,
        "longitude": -51.63,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320578,
        "nome": "Sete de Setembro",
        "latitude": -28.1446,
        "longitude": -54.4605,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320602,
        "nome": "Severiano de Almeida",
        "latitude": -27.4155,
        "longitude": -52.1114,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320651,
        "nome": "Silveira Martins",
        "latitude": -29.6334,
        "longitude": -53.5702,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320677,
        "nome": "Sinimbu",
        "latitude": -29.4444,
        "longitude": -52.5688,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320701,
        "nome": "Sobradinho",
        "latitude": -29.4056,
        "longitude": -53.026,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320800,
        "nome": "Soledade",
        "latitude": -28.8392,
        "longitude": -52.5371,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320859,
        "nome": "Tabaí",
        "latitude": -29.6671,
        "longitude": -51.731,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4320909,
        "nome": "Tapejara",
        "latitude": -28.0585,
        "longitude": -52.0108,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321006,
        "nome": "Tapera",
        "latitude": -28.6614,
        "longitude": -52.8616,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321105,
        "nome": "Tapes",
        "latitude": -30.6638,
        "longitude": -51.4413,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321204,
        "nome": "Taquara",
        "latitude": -29.6706,
        "longitude": -50.7621,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321303,
        "nome": "Taquari",
        "latitude": -29.7448,
        "longitude": -51.8315,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321329,
        "nome": "Taquaruçu do Sul",
        "latitude": -27.4084,
        "longitude": -53.4858,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321352,
        "nome": "Tavares",
        "latitude": -31.2886,
        "longitude": -51.0748,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321402,
        "nome": "Tenente Portela",
        "latitude": -27.3726,
        "longitude": -53.7641,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321436,
        "nome": "Terra de Areia",
        "latitude": -29.602,
        "longitude": -50.0664,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321451,
        "nome": "Teutônia",
        "latitude": -29.4724,
        "longitude": -51.7781,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321469,
        "nome": "Tio Hugo",
        "latitude": -28.582,
        "longitude": -52.5983,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321477,
        "nome": "Tiradentes do Sul",
        "latitude": -27.3683,
        "longitude": -54.121,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321493,
        "nome": "Toropi",
        "latitude": -29.4704,
        "longitude": -54.2988,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321501,
        "nome": "Torres",
        "latitude": -29.3283,
        "longitude": -49.8097,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321600,
        "nome": "Tramandaí",
        "latitude": -30.0282,
        "longitude": -50.222,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321626,
        "nome": "Travesseiro",
        "latitude": -29.2827,
        "longitude": -52.0876,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321634,
        "nome": "Três Arroios",
        "latitude": -27.4926,
        "longitude": -52.1802,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321667,
        "nome": "Três Cachoeiras",
        "latitude": -29.4744,
        "longitude": -49.9632,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321709,
        "nome": "Três Coroas",
        "latitude": -29.4834,
        "longitude": -50.7778,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321808,
        "nome": "Três de Maio",
        "latitude": -27.7316,
        "longitude": -54.2654,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321832,
        "nome": "Três Forquilhas",
        "latitude": -29.4285,
        "longitude": -50.0854,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321857,
        "nome": "Três Palmeiras",
        "latitude": -27.6171,
        "longitude": -52.8374,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321907,
        "nome": "Três Passos",
        "latitude": -27.441,
        "longitude": -53.9293,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4321956,
        "nome": "Trindade do Sul",
        "latitude": -27.5277,
        "longitude": -52.899,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322004,
        "nome": "Triunfo",
        "latitude": -29.8447,
        "longitude": -51.571,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322103,
        "nome": "Tucunduva",
        "latitude": -27.6394,
        "longitude": -54.431,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322152,
        "nome": "Tunas",
        "latitude": -29.1141,
        "longitude": -52.8928,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322186,
        "nome": "Tupanci do Sul",
        "latitude": -27.9302,
        "longitude": -51.5378,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322202,
        "nome": "Tupanciretã",
        "latitude": -29.0205,
        "longitude": -54.0035,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322251,
        "nome": "Tupandi",
        "latitude": -29.4741,
        "longitude": -51.4269,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322301,
        "nome": "Tuparendi",
        "latitude": -27.7065,
        "longitude": -54.5546,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322327,
        "nome": "Turuçu",
        "latitude": -31.4751,
        "longitude": -52.1561,
        "mesorregiaoNome": "Sudeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322343,
        "nome": "Ubiretama",
        "latitude": -28.0382,
        "longitude": -54.6465,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322350,
        "nome": "União da Serra",
        "latitude": -28.7725,
        "longitude": -52.0215,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322376,
        "nome": "Unistalda",
        "latitude": -29.0682,
        "longitude": -55.1588,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322400,
        "nome": "Uruguaiana",
        "latitude": -29.8406,
        "longitude": -56.7294,
        "mesorregiaoNome": "Sudoeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322509,
        "nome": "Vacaria",
        "latitude": -28.3704,
        "longitude": -50.9238,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322525,
        "nome": "Vale Verde",
        "latitude": -29.8308,
        "longitude": -52.1124,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322533,
        "nome": "Vale do Sol",
        "latitude": -29.5833,
        "longitude": -52.6895,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322541,
        "nome": "Vale Real",
        "latitude": -29.3628,
        "longitude": -51.2484,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322558,
        "nome": "Vanini",
        "latitude": -28.4903,
        "longitude": -51.8351,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322608,
        "nome": "Venâncio Aires",
        "latitude": -29.5786,
        "longitude": -52.195,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322707,
        "nome": "Vera Cruz",
        "latitude": -29.713,
        "longitude": -52.5387,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322806,
        "nome": "Veranópolis",
        "latitude": -28.9634,
        "longitude": -51.5516,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322855,
        "nome": "Vespasiano Corrêa",
        "latitude": -29.0668,
        "longitude": -51.8605,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4322905,
        "nome": "Viadutos",
        "latitude": -27.5718,
        "longitude": -51.9941,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4323002,
        "nome": "Viamão",
        "latitude": -30.167,
        "longitude": -50.8693,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4323101,
        "nome": "Vicente Dutra",
        "latitude": -27.1711,
        "longitude": -53.3879,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4323200,
        "nome": "Victor Graeff",
        "latitude": -28.5501,
        "longitude": -52.6853,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4323309,
        "nome": "Vila Flores",
        "latitude": -28.8589,
        "longitude": -51.5529,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4323358,
        "nome": "Vila Lângaro",
        "latitude": -28.1282,
        "longitude": -52.1424,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4323408,
        "nome": "Vila Maria",
        "latitude": -28.5578,
        "longitude": -52.1518,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4323457,
        "nome": "Vila Nova do Sul",
        "latitude": -30.346,
        "longitude": -53.8789,
        "mesorregiaoNome": "Centro Ocidental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4323507,
        "nome": "Vista Alegre",
        "latitude": -27.3248,
        "longitude": -53.5103,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4323606,
        "nome": "Vista Alegre do Prata",
        "latitude": -28.8208,
        "longitude": -51.7822,
        "mesorregiaoNome": "Nordeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4323705,
        "nome": "Vista Gaúcha",
        "latitude": -27.2658,
        "longitude": -53.7008,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4323754,
        "nome": "Vitória das Missões",
        "latitude": -28.3812,
        "longitude": -54.4638,
        "mesorregiaoNome": "Noroeste Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4323770,
        "nome": "Westfália",
        "latitude": -29.4061,
        "longitude": -51.7432,
        "mesorregiaoNome": "Centro Oriental Rio-grandense",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 4323804,
        "nome": "Xangri-lá",
        "latitude": -29.8079,
        "longitude": -50.0697,
        "mesorregiaoNome": "Metropolitana de Porto Alegre",
        "UFSigla": "RS",
        "UFNome": "Rio Grande do Sul"
    },
    {
        "ibgeId": 5000203,
        "nome": "Água Clara",
        "latitude": -19.9628,
        "longitude": -52.9267,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5000252,
        "nome": "Alcinópolis",
        "latitude": -18.2092,
        "longitude": -53.7492,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5000609,
        "nome": "Amambai",
        "latitude": -23.1578,
        "longitude": -54.9682,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5000708,
        "nome": "Anastácio",
        "latitude": -20.6962,
        "longitude": -55.7721,
        "mesorregiaoNome": "Pantanais Sul Mato-grossense",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5000807,
        "nome": "Anaurilândia",
        "latitude": -22.1115,
        "longitude": -52.8048,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5000856,
        "nome": "Angélica",
        "latitude": -22.0624,
        "longitude": -53.8658,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5000906,
        "nome": "Antônio João",
        "latitude": -22.2089,
        "longitude": -55.9615,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5001003,
        "nome": "Aparecida do Taboado",
        "latitude": -20.0756,
        "longitude": -51.2902,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5001102,
        "nome": "Aquidauana",
        "latitude": -19.7463,
        "longitude": -55.877,
        "mesorregiaoNome": "Pantanais Sul Mato-grossense",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5001243,
        "nome": "Aral Moreira",
        "latitude": -22.9077,
        "longitude": -55.4502,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5001508,
        "nome": "Bandeirantes",
        "latitude": -19.8059,
        "longitude": -54.3058,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5001904,
        "nome": "Bataguassu",
        "latitude": -21.8057,
        "longitude": -52.5724,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5002001,
        "nome": "Batayporã",
        "latitude": -22.3908,
        "longitude": -53.1776,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5002100,
        "nome": "Bela Vista",
        "latitude": -21.9359,
        "longitude": -56.5353,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5002159,
        "nome": "Bodoquena",
        "latitude": -20.5487,
        "longitude": -56.6997,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5002209,
        "nome": "Bonito",
        "latitude": -21.0332,
        "longitude": -56.4828,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5002308,
        "nome": "Brasilândia",
        "latitude": -21.0759,
        "longitude": -52.434,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5002407,
        "nome": "Caarapó",
        "latitude": -22.5883,
        "longitude": -54.8028,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5002605,
        "nome": "Camapuã",
        "latitude": -19.3419,
        "longitude": -53.8695,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5002704,
        "nome": "Campo Grande",
        "latitude": -20.9136,
        "longitude": -54.2495,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5002803,
        "nome": "Caracol",
        "latitude": -21.9426,
        "longitude": -57.091,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5002902,
        "nome": "Cassilândia",
        "latitude": -19.0976,
        "longitude": -52.1735,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5002951,
        "nome": "Chapadão do Sul",
        "latitude": -18.9945,
        "longitude": -52.698,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5003108,
        "nome": "Corguinho",
        "latitude": -19.8076,
        "longitude": -55.0574,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5003157,
        "nome": "Coronel Sapucaia",
        "latitude": -23.3477,
        "longitude": -55.3831,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5003207,
        "nome": "Corumbá",
        "latitude": -18.7245,
        "longitude": -56.7269,
        "mesorregiaoNome": "Pantanais Sul Mato-grossense",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5003256,
        "nome": "Costa Rica",
        "latitude": -18.5188,
        "longitude": -53.2031,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5003306,
        "nome": "Coxim",
        "latitude": -18.2809,
        "longitude": -54.6741,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5003454,
        "nome": "Deodápolis",
        "latitude": -22.1561,
        "longitude": -54.1521,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5003488,
        "nome": "Dois Irmãos do Buriti",
        "latitude": -20.6005,
        "longitude": -55.3623,
        "mesorregiaoNome": "Pantanais Sul Mato-grossense",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5003504,
        "nome": "Douradina",
        "latitude": -22.0139,
        "longitude": -54.5877,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5003702,
        "nome": "Dourados",
        "latitude": -22.1449,
        "longitude": -54.8389,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5003751,
        "nome": "Eldorado",
        "latitude": -23.7382,
        "longitude": -54.2251,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5003801,
        "nome": "Fátima do Sul",
        "latitude": -22.3393,
        "longitude": -54.4408,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5003900,
        "nome": "Figueirão",
        "latitude": -18.7444,
        "longitude": -53.8624,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5004007,
        "nome": "Glória de Dourados",
        "latitude": -22.4273,
        "longitude": -54.1924,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5004106,
        "nome": "Guia Lopes da Laguna",
        "latitude": -21.5416,
        "longitude": -55.9961,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5004304,
        "nome": "Iguatemi",
        "latitude": -23.4342,
        "longitude": -54.5383,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5004403,
        "nome": "Inocência",
        "latitude": -19.6576,
        "longitude": -52.0218,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5004502,
        "nome": "Itaporã",
        "latitude": -22.0053,
        "longitude": -54.8735,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5004601,
        "nome": "Itaquiraí",
        "latitude": -23.3416,
        "longitude": -54.1192,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5004700,
        "nome": "Ivinhema",
        "latitude": -22.3715,
        "longitude": -53.7991,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5004809,
        "nome": "Japorã",
        "latitude": -23.8108,
        "longitude": -54.5381,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5004908,
        "nome": "Jaraguari",
        "latitude": -20.2273,
        "longitude": -54.3483,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5005004,
        "nome": "Jardim",
        "latitude": -21.5821,
        "longitude": -56.3535,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5005103,
        "nome": "Jateí",
        "latitude": -22.7067,
        "longitude": -53.9573,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5005152,
        "nome": "Juti",
        "latitude": -22.7763,
        "longitude": -54.4889,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5005202,
        "nome": "Ladário",
        "latitude": -19.1031,
        "longitude": -57.5688,
        "mesorregiaoNome": "Pantanais Sul Mato-grossense",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5005251,
        "nome": "Laguna Carapã",
        "latitude": -22.6775,
        "longitude": -55.1321,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5005400,
        "nome": "Maracaju",
        "latitude": -21.5434,
        "longitude": -55.3968,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5005608,
        "nome": "Miranda",
        "latitude": -20.1212,
        "longitude": -56.5962,
        "mesorregiaoNome": "Pantanais Sul Mato-grossense",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5005681,
        "nome": "Mundo Novo",
        "latitude": -23.9427,
        "longitude": -54.2742,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5005707,
        "nome": "Naviraí",
        "latitude": -23.0225,
        "longitude": -54.0257,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5005806,
        "nome": "Nioaque",
        "latitude": -21.1008,
        "longitude": -55.9015,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5006002,
        "nome": "Nova Alvorada do Sul",
        "latitude": -21.4912,
        "longitude": -54.2161,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5006200,
        "nome": "Nova Andradina",
        "latitude": -21.9257,
        "longitude": -53.4218,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5006259,
        "nome": "Novo Horizonte do Sul",
        "latitude": -22.603,
        "longitude": -53.7819,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5006275,
        "nome": "Paraíso das Águas",
        "latitude": -19.2282,
        "longitude": -53.1303,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5006309,
        "nome": "Paranaíba",
        "latitude": -19.5302,
        "longitude": -51.3928,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5006358,
        "nome": "Paranhos",
        "latitude": -23.7112,
        "longitude": -55.356,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5006408,
        "nome": "Pedro Gomes",
        "latitude": -17.9143,
        "longitude": -54.3392,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5006606,
        "nome": "Ponta Porã",
        "latitude": -22.2023,
        "longitude": -55.5835,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5006903,
        "nome": "Porto Murtinho",
        "latitude": -21.2259,
        "longitude": -57.3842,
        "mesorregiaoNome": "Pantanais Sul Mato-grossense",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5007109,
        "nome": "Ribas do Rio Pardo",
        "latitude": -20.5966,
        "longitude": -53.5442,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5007208,
        "nome": "Rio Brilhante",
        "latitude": -21.6961,
        "longitude": -54.5578,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5007307,
        "nome": "Rio Negro",
        "latitude": -19.4469,
        "longitude": -54.963,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5007406,
        "nome": "Rio Verde de Mato Grosso",
        "latitude": -18.8136,
        "longitude": -55.0428,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5007505,
        "nome": "Rochedo",
        "latitude": -19.9786,
        "longitude": -54.7368,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5007554,
        "nome": "Santa Rita do Pardo",
        "latitude": -21.3191,
        "longitude": -52.7745,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5007695,
        "nome": "São Gabriel do Oeste",
        "latitude": -19.1691,
        "longitude": -54.4827,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5007703,
        "nome": "Sete Quedas",
        "latitude": -23.8806,
        "longitude": -55.0279,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5007802,
        "nome": "Selvíria",
        "latitude": -20.2821,
        "longitude": -51.7582,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5007901,
        "nome": "Sidrolândia",
        "latitude": -21.0939,
        "longitude": -54.9421,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5007935,
        "nome": "Sonora",
        "latitude": -17.6486,
        "longitude": -54.4324,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5007950,
        "nome": "Tacuru",
        "latitude": -23.6493,
        "longitude": -54.9904,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5007976,
        "nome": "Taquarussu",
        "latitude": -22.6678,
        "longitude": -53.4311,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5008008,
        "nome": "Terenos",
        "latitude": -20.4474,
        "longitude": -55.0241,
        "mesorregiaoNome": "Centro Norte de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5008305,
        "nome": "Três Lagoas",
        "latitude": -20.4389,
        "longitude": -52.2112,
        "mesorregiaoNome": "Leste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5008404,
        "nome": "Vicentina",
        "latitude": -22.4693,
        "longitude": -54.423,
        "mesorregiaoNome": "Sudoeste de Mato Grosso do Sul",
        "UFSigla": "MS",
        "UFNome": "Mato Grosso do Sul"
    },
    {
        "ibgeId": 5100102,
        "nome": "Acorizal",
        "latitude": -15.1773,
        "longitude": -56.318,
        "mesorregiaoNome": "Centro-Sul Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5100201,
        "nome": "Água Boa",
        "latitude": -13.9776,
        "longitude": -52.5003,
        "mesorregiaoNome": "Nordeste Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5100250,
        "nome": "Alta Floresta",
        "latitude": -10.0558,
        "longitude": -56.3677,
        "mesorregiaoNome": "Norte Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5100300,
        "nome": "Alto Araguaia",
        "latitude": -17.4456,
        "longitude": -53.4669,
        "mesorregiaoNome": "Sudeste Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5100359,
        "nome": "Alto Boa Vista",
        "latitude": -11.8115,
        "longitude": -51.7502,
        "mesorregiaoNome": "Nordeste Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5100409,
        "nome": "Alto Garças",
        "latitude": -16.8883,
        "longitude": -53.581,
        "mesorregiaoNome": "Sudeste Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5100508,
        "nome": "Alto Paraguai",
        "latitude": -14.7598,
        "longitude": -56.6612,
        "mesorregiaoNome": "Centro-Sul Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5100607,
        "nome": "Alto Taquari",
        "latitude": -17.8198,
        "longitude": -53.3065,
        "mesorregiaoNome": "Sudeste Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5100805,
        "nome": "Apiacás",
        "latitude": -8.7586,
        "longitude": -57.826,
        "mesorregiaoNome": "Norte Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5101001,
        "nome": "Araguaiana",
        "latitude": -15.1303,
        "longitude": -51.8067,
        "mesorregiaoNome": "Nordeste Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5101209,
        "nome": "Araguainha",
        "latitude": -16.7505,
        "longitude": -53.1213,
        "mesorregiaoNome": "Sudeste Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5101258,
        "nome": "Araputanga",
        "latitude": -15.253,
        "longitude": -58.4591,
        "mesorregiaoNome": "Sudoeste Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5101308,
        "nome": "Arenápolis",
        "latitude": -14.5071,
        "longitude": -56.8593,
        "mesorregiaoNome": "Centro-Sul Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5101407,
        "nome": "Aripuanã",
        "latitude": -10.1797,
        "longitude": -59.8563,
        "mesorregiaoNome": "Norte Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5101605,
        "nome": "Barão de Melgaço",
        "latitude": -16.8104,
        "longitude": -56.0295,
        "mesorregiaoNome": "Centro-Sul Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    },
    {
        "ibgeId": 5101704,
        "nome": "Barra do Bugres",
        "latitude": -15.0926,
        "longitude": -57.4259,
        "mesorregiaoNome": "Sudoeste Mato-grossense",
        "UFSigla": "MT",
        "UFNome": "Mato Grosso"
    }
]